(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clean-bulk-gifting-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeBulkGiftingBanner = (section) => {
      if (section.dataset.cleanBulkGiftingInitialized === 'true') return;

      const form = section.querySelector('[data-clean-bulk-gifting-form]');
      const countrySelect = section.querySelector('[data-clean-bulk-gifting-country]');
      const phoneInput = section.querySelector('[data-clean-bulk-gifting-phone]');
      const submitButton = section.querySelector('[data-clean-bulk-gifting-submit]');
      const status = section.querySelector('[data-clean-bulk-gifting-status]');
      const originalSubmitLabel = submitButton?.textContent || 'Submit';
      const thankYouModal = document.querySelector('[data-clean-bulk-gifting-thank-you-modal]');
      const thankYouDialog = thankYouModal?.querySelector('.clean-bulk-gifting-thank-you__dialog');

      if (!form || !submitButton) return;

      let isSubmitting = false;
      let lastFocusedElement = null;

      const getInput = (key) => section.querySelector(`[data-clean-bulk-gifting-${key}]`);
      const getError = (key) => section.querySelector(`[data-clean-bulk-gifting-error-for="${key}"]`);
      const getValue = (key) => (getInput(key)?.value || '').trim();

      const getPhoneMeta = () => {
        const selectedOption = countrySelect?.options[countrySelect.selectedIndex];

        return {
          country: selectedOption?.value || 'IN',
          dial: selectedOption?.dataset.dial || '',
          min: Number(selectedOption?.dataset.min || 7),
          max: Number(selectedOption?.dataset.max || 15),
        };
      };

      const setFieldError = (key, message) => {
        const input = getInput(key);
        const error = getError(key);

        input?.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = message;
      };

      const clearFieldError = (key) => {
        const input = getInput(key);
        const error = getError(key);

        input?.removeAttribute('aria-invalid');
        if (error) error.textContent = '';
      };

      const applyPhoneLimits = () => {
        if (!phoneInput) return;

        const meta = getPhoneMeta();
        const hint = meta.min === meta.max ? meta.min : `${meta.min}-${meta.max}`;
        phoneInput.maxLength = meta.max;
        phoneInput.placeholder = `Mobile (${hint} digits)`;
        phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(0, meta.max);
      };

      const validateName = () => {
        if (!getValue('name')) {
          setFieldError('name', 'Full Name is required.');
          return false;
        }

        clearFieldError('name');
        return true;
      };

      const validateCompany = () => {
        if (!getValue('company')) {
          setFieldError('company', 'Company Name is required.');
          return false;
        }

        clearFieldError('company');
        return true;
      };

      const validateEmail = () => {
        const email = getValue('email').toLowerCase();

        if (!email) {
          setFieldError('email', 'Email ID is required.');
          return false;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          setFieldError('email', 'Please enter a valid email address.');
          return false;
        }

        clearFieldError('email');
        return true;
      };

      const validatePhone = () => {
        const meta = getPhoneMeta();
        const digits = getValue('phone').replace(/\D/g, '');

        if (!digits) {
          setFieldError('phone', 'Phone Number is required.');
          return false;
        }

        if (digits.length < meta.min || digits.length > meta.max) {
          const range = meta.min === meta.max ? `${meta.min} digits` : `${meta.min}-${meta.max} digits`;
          setFieldError('phone', `Please enter a valid phone number (${range}).`);
          return false;
        }

        clearFieldError('phone');
        return true;
      };

      const sanitizePhoneInput = () => {
        if (!phoneInput) return;

        const meta = getPhoneMeta();
        const digits = phoneInput.value.replace(/\D/g, '').slice(0, meta.max);
        if (phoneInput.value !== digits) phoneInput.value = digits;
      };

      const updateThankYouUrl = () => {
        if (section.dataset.cleanBulkGiftingThankYouEnabled !== 'true') return;
        if (!section.dataset.cleanBulkGiftingThankYouUrl || !window.history?.pushState) return;

        window.history.pushState({ cleanBulkGiftingThankYou: true }, '', section.dataset.cleanBulkGiftingThankYouUrl);
      };

      const publishThankYouEvent = () => {
        if (section.dataset.cleanBulkGiftingThankYouEnabled !== 'true') return;

        try {
          window.GiftechGoogleTracking?.trackCorporateLead?.();
        } catch (error) {
          // Analytics must never interrupt the form's success state.
        }

        if (typeof window.Shopify?.analytics?.publish !== 'function') return;

        try {
          window.Shopify.analytics.publish('giftech:corporate_gifts_lead_generated', {});
        } catch (error) {
          // Keep publishing to Shopify during the custom-pixel cutover window.
        }
      };

      const openThankYouModal = () => {
        if (!thankYouModal || section.dataset.cleanBulkGiftingThankYouEnabled !== 'true') return;

        lastFocusedElement = document.activeElement;
        thankYouModal.hidden = false;
        document.documentElement.classList.add('clean-bulk-gifting-thank-you-open');
        document.body.classList.add('clean-bulk-gifting-thank-you-open');
        thankYouDialog?.focus();
      };

      const closeThankYouModal = () => {
        if (!thankYouModal) return;

        thankYouModal.hidden = true;
        document.documentElement.classList.remove('clean-bulk-gifting-thank-you-open');
        document.body.classList.remove('clean-bulk-gifting-thank-you-open');

        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        }
      };

      thankYouModal?.querySelectorAll('[data-clean-bulk-gifting-thank-you-close]').forEach((control) => {
        control.addEventListener('click', closeThankYouModal);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && thankYouModal && !thankYouModal.hidden) {
          closeThankYouModal();
        }
      });

      countrySelect?.addEventListener('change', applyPhoneLimits);
      phoneInput?.addEventListener('input', sanitizePhoneInput);
      phoneInput?.addEventListener('keypress', (event) => {
        if (!/[0-9]/.test(event.key) && event.key.length === 1) event.preventDefault();
      });
      phoneInput?.addEventListener('paste', (event) => {
        event.preventDefault();

        const meta = getPhoneMeta();
        const pastedText = (event.clipboardData || window.clipboardData)?.getData('text') || '';
        const digits = pastedText.replace(/\D/g, '').slice(0, meta.max);
        const start = phoneInput.selectionStart || 0;
        const end = phoneInput.selectionEnd || 0;
        const currentValue = phoneInput.value || '';
        phoneInput.value = `${currentValue.slice(0, start)}${digits}${currentValue.slice(end)}`.slice(0, meta.max);
      });

      ['name', 'email', 'phone', 'company'].forEach((key) => {
        const input = getInput(key);
        input?.addEventListener('input', () => clearFieldError(key));
        input?.addEventListener('change', () => clearFieldError(key));
      });

      const handleFormSubmit = async (event) => {
        event.preventDefault();
        if (isSubmitting) return;

        const isValid = [validateName(), validatePhone(), validateEmail(), validateCompany()].every(Boolean);
        if (!isValid) return;

        const meta = getPhoneMeta();
        const phone = getValue('phone').replace(/\D/g, '');
        const name = getValue('name');
        const email = getValue('email');
        const company = getValue('company');
        const message = getValue('message') || '-';

        isSubmitting = true;
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';
        if (status) status.hidden = true;

        const showSuccessState = () => {
          submitButton.hidden = true;
          if (status) {
            status.textContent =
              status.dataset.cleanBulkGiftingSuccessMessage || "Thank you! We'll get back to you shortly.";
            status.hidden = false;
          }
          updateThankYouUrl();
          publishThankYouEvent();
          openThankYouModal();
        };

        const showErrorState = () => {
          if (status) {
            status.textContent = 'Sorry, something went wrong. Please try again.';
            status.hidden = false;
          }
          submitButton.disabled = false;
          submitButton.textContent = originalSubmitLabel;
          isSubmitting = false;
        };

        try {
          const response = await fetch(section.dataset.cleanBulkGiftingEndpoint, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            body: new URLSearchParams({
              name,
              email,
              phone,
              company,
              country: meta.country,
              message,
              website: form.elements.website?.value || '',
            }),
          });
          const result = await response.json().catch(() => null);
          if (!response.ok || result?.success !== true) throw new Error('submission_failed');

          showSuccessState();
        } catch (error) {
          showErrorState();
        }
      };

      form.addEventListener('submit', handleFormSubmit);

      applyPhoneLimits();
      section.dataset.cleanBulkGiftingInitialized = 'true';
    };

    const initializeAllBulkGiftingBanners = (container = document) => {
      container.querySelectorAll('[data-clean-bulk-gifting-banner]').forEach(initializeBulkGiftingBanner);
    };

    initializeAllBulkGiftingBanners();
    document.addEventListener('shopify:section:load', (event) => initializeAllBulkGiftingBanners(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-bulk-gifting-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeBulkGiftingPopup = (section) => {
      if (section.dataset.cleanBulkGiftingPopupInitialized === 'true') return;

      const openButton = section.querySelector('[data-clean-bulk-gifting-popup-open]');
      const modal = section.querySelector('[data-clean-bulk-gifting-popup-modal]');
      const closeButtons = section.querySelectorAll('[data-clean-bulk-gifting-popup-close]');
      const form = section.querySelector('[data-clean-bulk-gifting-popup-form]');
      const countrySelect = section.querySelector('[data-clean-bulk-gifting-popup-country]');
      const phoneInput = section.querySelector('[data-clean-bulk-gifting-popup-phone]');
      const submitButton = section.querySelector('[data-clean-bulk-gifting-popup-submit]');
      const status = section.querySelector('[data-clean-bulk-gifting-popup-status]');

      if (!openButton || !modal || !form || !submitButton) return;

      let previousFocus;
      let isSubmitting = false;

      const getInput = (key) => section.querySelector(`[data-clean-bulk-gifting-popup-${key}]`);
      const getError = (key) => section.querySelector(`[data-clean-bulk-gifting-popup-error-for="${key}"]`);
      const getValue = (key) => (getInput(key)?.value || '').trim();

      const getPhoneMeta = () => {
        const selectedOption = countrySelect?.options[countrySelect.selectedIndex];

        return {
          country: selectedOption?.value || 'IN',
          dial: selectedOption?.dataset.dial || '',
          min: Number(selectedOption?.dataset.min || 7),
          max: Number(selectedOption?.dataset.max || 15),
        };
      };

      const setFieldError = (key, message) => {
        const input = getInput(key);
        const error = getError(key);

        input?.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = message;
      };

      const clearFieldError = (key) => {
        const input = getInput(key);
        const error = getError(key);

        input?.removeAttribute('aria-invalid');
        if (error) error.textContent = '';
      };

      const applyPhoneLimits = () => {
        if (!phoneInput) return;

        const meta = getPhoneMeta();
        const hint = meta.min === meta.max ? meta.min : `${meta.min}-${meta.max}`;
        phoneInput.maxLength = meta.max;
        phoneInput.placeholder = `Mobile (${hint} digits)`;
        phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(0, meta.max);
      };

      const openModal = () => {
        previousFocus = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('clean-bulk-gifting-popup-open');
        window.setTimeout(() => getInput('name')?.focus(), 60);
      };

      const closeModal = () => {
        modal.hidden = true;
        document.body.classList.remove('clean-bulk-gifting-popup-open');
        if (previousFocus instanceof HTMLElement) previousFocus.focus();
      };

      const validateName = () => {
        if (!getValue('name')) {
          setFieldError('name', 'Full Name is required.');
          return false;
        }

        clearFieldError('name');
        return true;
      };

      const validateCompany = () => {
        if (!getValue('company')) {
          setFieldError('company', 'Company Name is required.');
          return false;
        }

        clearFieldError('company');
        return true;
      };

      const validateEmail = () => {
        const email = getValue('email').toLowerCase();

        if (!email) {
          setFieldError('email', 'Email ID is required.');
          return false;
        }

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          setFieldError('email', 'Please enter a valid email address.');
          return false;
        }

        clearFieldError('email');
        return true;
      };

      const validatePhone = () => {
        const meta = getPhoneMeta();
        const digits = getValue('phone').replace(/\D/g, '');

        if (!digits) {
          setFieldError('phone', 'Mobile is required.');
          return false;
        }

        if (digits.length < meta.min || digits.length > meta.max) {
          const range = meta.min === meta.max ? `${meta.min} digits` : `${meta.min}-${meta.max} digits`;
          setFieldError('phone', `Please enter a valid phone number (${range}).`);
          return false;
        }

        clearFieldError('phone');
        return true;
      };

      const sanitizePhoneInput = () => {
        if (!phoneInput) return;

        const meta = getPhoneMeta();
        const digits = phoneInput.value.replace(/\D/g, '').slice(0, meta.max);
        if (phoneInput.value !== digits) phoneInput.value = digits;
      };

      openButton.addEventListener('click', openModal);
      closeButtons.forEach((button) => button.addEventListener('click', closeModal));

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) closeModal();
      });

      countrySelect?.addEventListener('change', applyPhoneLimits);
      phoneInput?.addEventListener('input', sanitizePhoneInput);
      phoneInput?.addEventListener('keypress', (event) => {
        if (!/[0-9]/.test(event.key) && event.key.length === 1) event.preventDefault();
      });
      phoneInput?.addEventListener('paste', (event) => {
        event.preventDefault();

        const meta = getPhoneMeta();
        const pastedText = (event.clipboardData || window.clipboardData)?.getData('text') || '';
        const digits = pastedText.replace(/\D/g, '').slice(0, meta.max);
        const start = phoneInput.selectionStart || 0;
        const end = phoneInput.selectionEnd || 0;
        const currentValue = phoneInput.value || '';
        phoneInput.value = `${currentValue.slice(0, start)}${digits}${currentValue.slice(end)}`.slice(0, meta.max);
      });

      ['name', 'email', 'phone', 'company'].forEach((key) => {
        const input = getInput(key);
        input?.addEventListener('input', () => clearFieldError(key));
        input?.addEventListener('change', () => clearFieldError(key));
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (isSubmitting) return;

        const isValid = [validateName(), validatePhone(), validateEmail(), validateCompany()].every(Boolean);
        if (!isValid) return;

        const meta = getPhoneMeta();
        const phone = getValue('phone').replace(/\D/g, '');
        const name = getValue('name');
        const email = getValue('email');
        const company = getValue('company');
        const message = getValue('message') || '-';
        isSubmitting = true;
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';

        try {
          const response = await fetch(section.dataset.cleanBulkGiftingPopupEndpoint, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            body: new URLSearchParams({
              name,
              email,
              phone,
              company,
              country: meta.country,
              message,
              website: form.elements.website?.value || '',
            }),
          });
          const result = await response.json().catch(() => null);
          if (!response.ok || result?.success !== true) throw new Error('submission_failed');

          submitButton.hidden = true;
          if (status) {
            status.textContent =
              status.dataset.cleanBulkGiftingPopupSuccessMessage || "Thank you! We'll get back to you shortly.";
            status.hidden = false;
          }
        } catch {
          if (status) {
            status.textContent = 'Sorry, something went wrong. Please try again.';
            status.hidden = false;
          }
          submitButton.disabled = false;
          submitButton.textContent = 'Submit';
          isSubmitting = false;
        }
      });

      applyPhoneLimits();
      section.dataset.cleanBulkGiftingPopupInitialized = 'true';
    };

    const initializeAllBulkGiftingPopups = (container = document) => {
      container.querySelectorAll('[data-clean-bulk-gifting-popup]').forEach(initializeBulkGiftingPopup);
    };

    initializeAllBulkGiftingPopups();
    document.addEventListener('shopify:section:load', (event) => initializeAllBulkGiftingPopups(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-bulk-order-enquiry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCleanBulkOrderEnquiry = (root = document) => {
      root.querySelectorAll('[data-clean-bulk-order-enquiry]').forEach((section) => {
        if (section.dataset.cleanBulkOrderReady === 'true') return;
        section.dataset.cleanBulkOrderReady = 'true';

        const form = section.querySelector('[data-clean-bulk-order-form]');
        const status = section.querySelector('[data-clean-bulk-order-status]');
        const submitButton = section.querySelector('[data-clean-bulk-order-submit]');
        const endpoint = section.dataset.cleanBulkOrderEndpoint || '';
        let isSubmitting = false;

        if (!form) return;

        const getRequiredFields = () =>
          Array.from(section.querySelectorAll('.clean-bulk-order-page__field')).filter((field) =>
            (field.getAttribute('placeholder') || '').trim().endsWith('*'),
          );

        const setStatus = (message = '', type = 'error') => {
          if (!status) return;
          status.textContent = message;
          status.classList.toggle('clean-bulk-order-page__status--success', type === 'success');
          status.hidden = !message;
        };

        const clearFieldError = (field) => {
          field.removeAttribute('aria-invalid');
          if (getRequiredFields().every((requiredField) => requiredField.getAttribute('aria-invalid') !== 'true')) {
            setStatus();
          }
        };

        const validateRequiredFields = ({ focusFirstInvalid = true } = {}) => {
          let firstInvalid = null;
          let hasInvalidEmail = false;

          getRequiredFields().forEach((field) => {
            field.required = true;

            const isEmpty = !String(field.value || '').trim();
            const isInvalidEmail = !isEmpty && field.type === 'email' && !field.validity.valid;
            const isInvalid = isEmpty || isInvalidEmail;

            field.setAttribute('aria-invalid', String(isInvalid));

            if (isInvalid && !firstInvalid) firstInvalid = field;
            if (isInvalidEmail) hasInvalidEmail = true;
          });

          if (!firstInvalid) {
            setStatus();
            return true;
          }

          setStatus(hasInvalidEmail ? 'Please enter a valid email address.' : 'Please fill all required fields.');

          if (focusFirstInvalid) {
            firstInvalid.focus();
          }

          return false;
        };

        const getFieldValue = (fieldName) => String(form.elements?.[fieldName]?.value || '').trim();

        const getBulkEnquiryPayload = () => {
          const customMessage = getFieldValue('clean_bulk_message');

          return new URLSearchParams({
            name: getFieldValue('clean_bulk_name'),
            email: getFieldValue('clean_bulk_email'),
            phone: getFieldValue('clean_bulk_phone'),
            countryDial: getFieldValue('clean_bulk_country_code'),
            company: getFieldValue('clean_bulk_company'),
            message: customMessage || '-',
            website: getFieldValue('website'),
          });
        };

        getRequiredFields().forEach((field) => {
          field.required = true;
          field.addEventListener('input', () => clearFieldError(field));
          field.addEventListener('change', () => clearFieldError(field));
        });

        const submitCleanBulkOrderEnquiry = async () => {
          if (isSubmitting) return;

          if (!validateRequiredFields()) return;

          if (!endpoint) {
            setStatus('Unable to submit right now. Please try again.');
            return;
          }

          isSubmitting = true;

          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';
          }

          try {
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: getBulkEnquiryPayload(),
              credentials: 'same-origin',
            });
            const result = await response.json().catch(() => null);
            if (!response.ok || result?.success !== true) throw new Error('submission_failed');

            form.reset();
            getRequiredFields().forEach(clearFieldError);
            setStatus("Thank you! We'll get back to you shortly.", 'success');
          } catch {
            setStatus('Unable to submit right now. Please try again.');
          } finally {
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = 'Submit';
            }

            isSubmitting = false;
          }
        };

        form.addEventListener('submit', (event) => {
          event.preventDefault();
          submitCleanBulkOrderEnquiry();
        });

        if (submitButton) {
          submitButton.addEventListener('click', (event) => {
            event.preventDefault();
            submitCleanBulkOrderEnquiry();
          });

          submitButton.addEventListener('pointerup', (event) => {
            if (event.pointerType !== 'touch') return;

            event.preventDefault();
            submitCleanBulkOrderEnquiry();
          });
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanBulkOrderEnquiry(), { once: true });
    } else {
      initCleanBulkOrderEnquiry();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanBulkOrderEnquiry(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-career-position"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORAGE_KEY = 'cleanCareersAppliedPositions:v1';
    const MAX_RESUME_BYTES = 5 * 1024 * 1024;
    const ALLOWED_RESUME_EXTENSIONS = new Set(['pdf', 'doc', 'docx']);
    const ALLOWED_RESUME_TYPES = new Set([
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ]);

    const normalizePosition = (value) =>
      String(value || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');

    const readAppliedPositions = () => {
      try {
        const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
        return new Set(Array.isArray(value) ? value.filter((item) => typeof item === 'string') : []);
      } catch {
        return new Set();
      }
    };

    const saveAppliedPositions = (positions) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(positions)));
      } catch {
        // The in-memory apply-once state remains active when storage is unavailable.
      }
    };

    const getResumeError = (file) => {
      if (!file) return 'Please select a resume file.';
      const extension = String(file.name || '')
        .split('.')
        .pop()
        .toLowerCase();
      const hasAllowedExtension = ALLOWED_RESUME_EXTENSIONS.has(extension);
      const hasAllowedType = !file.type || ALLOWED_RESUME_TYPES.has(file.type.toLowerCase());
      if (!hasAllowedExtension || !hasAllowedType) return 'Please upload a PDF, DOC, or DOCX file.';
      if (!file.size) return 'The selected file is empty. Please choose another resume.';
      if (file.size > MAX_RESUME_BYTES) return 'The resume must be 5 MB or smaller.';
      return '';
    };

    const initCleanCareerPositions = (root = document) => {
      root.querySelectorAll('[data-clean-career-position]').forEach((section) => {
        if (section.dataset.cleanCareerPositionReady === 'true') return;
        section.dataset.cleanCareerPositionReady = 'true';

        const form = section.querySelector('[data-clean-career-position-form]');
        const formView = section.querySelector('[data-clean-career-position-form-view]');
        const roleField = section.querySelector('[data-clean-career-position-role]');
        const resumeField = section.querySelector('[data-clean-career-position-resume]');
        const fileError = section.querySelector('[data-clean-career-position-file-error]');
        const status = section.querySelector('[data-clean-career-position-status]');
        const submitButton = section.querySelector('[data-clean-career-position-submit]');
        const submitLabel = section.querySelector('[data-clean-career-position-submit-label]');
        const successView = section.querySelector('[data-clean-career-position-success]');
        const successTitle = section.querySelector('[data-clean-career-position-success-title]');
        const successRole = section.querySelector('[data-clean-career-position-success-role]');
        const appliedPositions = readAppliedPositions();
        let isSubmitting = false;

        if (!form || !roleField || !resumeField) return;

        const isApplied = (position) => appliedPositions.has(normalizePosition(position));
        const setStatus = (message = '') => {
          if (!status) return;
          status.textContent = message;
          status.hidden = !message;
        };
        const setFileError = (message = '') => {
          resumeField.setCustomValidity(message);
          resumeField.setAttribute('aria-invalid', String(Boolean(message)));
          if (!fileError) return;
          fileError.textContent = message;
          fileError.hidden = !message;
        };
        const setAppliedState = () => {
          if (submitButton) submitButton.disabled = true;
          if (submitLabel) submitLabel.textContent = 'Application submitted';
          setStatus('An application for this position has already been sent from this browser.');
        };
        const validateForm = () => {
          setStatus();
          setFileError(getResumeError(resumeField.files?.[0]));
          if (form.checkValidity()) return true;
          setStatus('Please review the highlighted fields and try again.');
          form.reportValidity();
          return false;
        };
        const getValue = (name) => String(form.elements[name]?.value || '').trim();
        const getSubmissionData = (resume) => {
          const submissionData = new FormData();
          submissionData.append('name', getValue('clean_career_position_name'));
          submissionData.append('email', getValue('clean_career_position_email'));
          submissionData.append('phone', getValue('clean_career_position_phone'));
          submissionData.append('countryDial', getValue('clean_career_position_country_code'));
          submissionData.append('position', getValue('clean_career_position_role'));
          submissionData.append('linkedin', getValue('clean_career_position_linkedin'));
          submissionData.append('portfolio', getValue('clean_career_position_portfolio'));
          submissionData.append('message', getValue('clean_career_position_message'));
          submissionData.append('consent', form.elements.clean_career_position_consent?.checked ? 'true' : 'false');
          submissionData.append('website', getValue('website'));
          submissionData.append('resume', resume, resume.name);
          return submissionData;
        };

        if (isApplied(roleField.value)) setAppliedState();

        resumeField.addEventListener('change', () => {
          const file = resumeField.files?.[0];
          setFileError(file ? getResumeError(file) : '');
        });
        form.addEventListener('input', () => {
          if (!isApplied(roleField.value)) setStatus();
        });
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (isSubmitting || isApplied(roleField.value) || !validateForm()) return;

          const resume = resumeField.files[0];
          const position = roleField.value;
          isSubmitting = true;
          if (submitButton) submitButton.disabled = true;
          if (submitLabel) submitLabel.textContent = 'Sending application…';

          try {
            const response = await fetch('/api/career-application', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: getSubmissionData(resume),
              credentials: 'same-origin',
            });
            const result = await response.json().catch(() => null);
            if (!response.ok || result?.success !== true) throw new Error('submission_failed');
            appliedPositions.add(normalizePosition(position));
            saveAppliedPositions(appliedPositions);
            form.reset();
            if (formView) formView.hidden = true;
            if (successRole) successRole.textContent = position;
            if (successView) successView.hidden = false;
            window.requestAnimationFrame(() => successTitle?.focus());
          } catch {
            setStatus('We could not send your application. Please check your connection and try again.');
            status?.focus();
          } finally {
            isSubmitting = false;
            if (!isApplied(position)) {
              if (submitButton) submitButton.disabled = false;
              if (submitLabel) submitLabel.textContent = 'Submit application';
            }
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanCareerPositions(), { once: true });
    } else {
      initCleanCareerPositions();
    }
    document.addEventListener('shopify:section:load', (event) => initCleanCareerPositions(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-careers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STORAGE_KEY = 'cleanCareersAppliedPositions:v1';
    const MAX_RESUME_BYTES = 5 * 1024 * 1024;
    const ALLOWED_RESUME_EXTENSIONS = new Set(['pdf', 'doc', 'docx']);
    const ALLOWED_RESUME_TYPES = new Set([
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ]);

    const normalizePosition = (value) =>
      String(value || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');

    const readAppliedPositions = () => {
      try {
        const value = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
        return new Set(Array.isArray(value) ? value.filter((item) => typeof item === 'string') : []);
      } catch {
        return new Set();
      }
    };

    const saveAppliedPositions = (positions) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(positions)));
      } catch {
        // Application state still updates for the current page when storage is unavailable.
      }
    };

    const getResumeError = (file) => {
      if (!file) return 'Please select a resume file.';

      const extension = String(file.name || '')
        .split('.')
        .pop()
        .toLowerCase();
      const hasAllowedExtension = ALLOWED_RESUME_EXTENSIONS.has(extension);
      const hasAllowedType = !file.type || ALLOWED_RESUME_TYPES.has(file.type.toLowerCase());

      if (!hasAllowedExtension || !hasAllowedType) {
        return 'Please upload a PDF, DOC, or DOCX file.';
      }

      if (!file.size) return 'The selected file is empty. Please choose another resume.';
      if (file.size > MAX_RESUME_BYTES) return 'The resume must be 5 MB or smaller.';
      return '';
    };

    const initCleanCareers = (root = document) => {
      root.querySelectorAll('[data-clean-careers]').forEach((section) => {
        if (section.dataset.cleanCareersReady === 'true') return;
        section.dataset.cleanCareersReady = 'true';

        const dialog = section.querySelector('[data-clean-careers-modal]');
        const form = section.querySelector('[data-clean-careers-form]');
        const formView = section.querySelector('[data-clean-careers-form-view]');
        const positionField = section.querySelector('[data-clean-careers-position-field]');
        const resumeField = section.querySelector('[data-clean-careers-resume]');
        const fileError = section.querySelector('[data-clean-careers-file-error]');
        const status = section.querySelector('[data-clean-careers-status]');
        const submitButton = section.querySelector('[data-clean-careers-submit]');
        const submitLabel = section.querySelector('[data-clean-careers-submit-label]');
        const successView = section.querySelector('[data-clean-careers-success]');
        const successTitle = section.querySelector('[data-clean-careers-success-title]');
        const successDescription = section.querySelector('[data-clean-careers-success-description]');
        const successPosition = section.querySelector('[data-clean-careers-success-position]');
        const applyButtons = Array.from(section.querySelectorAll('[data-clean-careers-apply]'));
        const appliedPositions = readAppliedPositions();
        const formLabelledBy = dialog?.getAttribute('aria-labelledby') || '';
        const formDescribedBy = dialog?.getAttribute('aria-describedby') || '';
        let activeApplyButton = null;
        let isSubmitting = false;

        if (!dialog || !form || !positionField || !resumeField) return;

        const isApplied = (position) => appliedPositions.has(normalizePosition(position));

        const setButtonApplied = (button) => {
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('aria-label', `${button.dataset.cleanCareersPosition}: application submitted`);
          const label = button.querySelector('[data-clean-careers-apply-label]');
          if (label) label.textContent = 'Application submitted';
        };

        const markApplied = (position) => {
          const normalizedPosition = normalizePosition(position);
          if (!normalizedPosition) return;
          appliedPositions.add(normalizedPosition);
          saveAppliedPositions(appliedPositions);
          applyButtons.forEach((button) => {
            if (normalizePosition(button.dataset.cleanCareersPosition) === normalizedPosition) {
              setButtonApplied(button);
            }
          });
        };

        const setStatus = (message = '') => {
          if (!status) return;
          status.textContent = message;
          status.hidden = !message;
        };

        const setFileError = (message = '') => {
          resumeField.setCustomValidity(message);
          if (!fileError) return;
          fileError.textContent = message;
          fileError.hidden = !message;
          resumeField.setAttribute('aria-invalid', String(Boolean(message)));
        };

        const resetModal = () => {
          form.reset();
          setStatus();
          setFileError();
          dialog.setAttribute('aria-labelledby', formLabelledBy);
          dialog.setAttribute('aria-describedby', formDescribedBy);
          form.hidden = false;
          if (formView) formView.hidden = false;
          if (successView) successView.hidden = true;
          if (submitButton) submitButton.disabled = false;
          if (submitLabel) submitLabel.textContent = 'Submit application';
        };

        const openModal = (button) => {
          const position = button.dataset.cleanCareersPosition || '';
          if (!position || isApplied(position) || isSubmitting) return;

          activeApplyButton = button;
          resetModal();
          positionField.value = position;

          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }

          document.body.classList.add('clean-careers-modal-open');
          window.requestAnimationFrame(() => section.querySelector('.clean-careers__modal-title')?.focus());
        };

        const closeModal = () => {
          if (!dialog.open) return;
          if (typeof dialog.close === 'function') {
            dialog.close();
          } else {
            dialog.removeAttribute('open');
            document.body.classList.remove('clean-careers-modal-open');
            window.requestAnimationFrame(() => activeApplyButton?.focus());
          }
        };

        const getFocusableElements = () =>
          Array.from(
            dialog.querySelectorAll(
              'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
            ),
          ).filter(
            (element) => !element.hidden && (element.offsetParent !== null || element === document.activeElement),
          );

        const validateForm = () => {
          setStatus();
          setFileError(getResumeError(resumeField.files?.[0]));

          if (form.checkValidity()) return true;

          setStatus('Please review the highlighted fields and try again.');
          form.reportValidity();
          return false;
        };

        const getValue = (name) => String(form.elements[name]?.value || '').trim();

        const getSubmissionData = (resume) => {
          const submissionData = new FormData();
          submissionData.append('name', getValue('clean_careers_name'));
          submissionData.append('email', getValue('clean_careers_email'));
          submissionData.append('phone', getValue('clean_careers_phone'));
          submissionData.append('countryDial', getValue('clean_careers_country_code'));
          submissionData.append('position', getValue('clean_careers_position'));
          submissionData.append('linkedin', getValue('clean_careers_linkedin'));
          submissionData.append('portfolio', getValue('clean_careers_portfolio'));
          submissionData.append('message', getValue('clean_careers_message'));
          submissionData.append('consent', form.elements.clean_careers_consent?.checked ? 'true' : 'false');
          submissionData.append('website', getValue('website'));
          submissionData.append('resume', resume, resume.name);
          return submissionData;
        };

        applyButtons.forEach((button) => {
          if (isApplied(button.dataset.cleanCareersPosition)) setButtonApplied(button);
          button.addEventListener('click', () => openModal(button));
        });

        section.querySelectorAll('[data-clean-careers-close]').forEach((button) => {
          button.addEventListener('click', closeModal);
        });

        resumeField.addEventListener('change', () => {
          const file = resumeField.files?.[0];
          setFileError(file ? getResumeError(file) : '');
        });

        form.addEventListener('input', () => setStatus());

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (isSubmitting || !validateForm()) return;

          const position = getValue('clean_careers_position');
          if (isApplied(position)) {
            setStatus('An application for this position has already been sent from this browser.');
            status?.focus();
            return;
          }

          const resume = resumeField.files[0];
          isSubmitting = true;
          if (submitButton) submitButton.disabled = true;
          if (submitLabel) submitLabel.textContent = 'Sending application…';

          try {
            const response = await fetch('/api/career-application', {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: getSubmissionData(resume),
              credentials: 'same-origin',
            });
            const result = await response.json().catch(() => null);
            if (!response.ok || result?.success !== true) throw new Error('submission_failed');
            markApplied(position);
            form.reset();
            form.hidden = true;
            if (successTitle?.id) dialog.setAttribute('aria-labelledby', successTitle.id);
            if (successDescription?.id) dialog.setAttribute('aria-describedby', successDescription.id);
            if (formView) formView.hidden = true;
            if (successPosition) successPosition.textContent = position;
            if (successView) successView.hidden = false;
            window.requestAnimationFrame(() => successTitle?.focus());
          } catch {
            setStatus('We could not send your application. Please check your connection and try again.');
            status?.focus();
          } finally {
            isSubmitting = false;
            if (submitButton) submitButton.disabled = false;
            if (submitLabel) submitLabel.textContent = 'Submit application';
          }
        });

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeModal();
        });

        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeModal();
        });

        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeModal();
            return;
          }

          if (event.key !== 'Tab') return;
          const focusableElements = getFocusableElements();
          if (!focusableElements.length) {
            event.preventDefault();
            return;
          }

          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];
          const activeElementIndex = focusableElements.indexOf(document.activeElement);
          if (activeElementIndex === -1) {
            event.preventDefault();
            (event.shiftKey ? lastElement : firstElement).focus();
          } else if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        });

        dialog.addEventListener('close', () => {
          document.body.classList.remove('clean-careers-modal-open');
          window.requestAnimationFrame(() => activeApplyButton?.focus());
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanCareers(), { once: true });
    } else {
      initCleanCareers();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanCareers(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.matches('[data-clean-careers]') && !event.target.querySelector('[data-clean-careers]')) return;
      document.body.classList.remove('clean-careers-modal-open');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const cleanCartUpsellEnabled = true;
    const cleanCartUpsellCatalog = [
      {
        id: 'popular',
        label: 'Popular',
        products: [
          { name: 'Greeting Card As Per Occasion', handle: 'winni-addon-greeting-card-as-per-occasion' },
          { name: 'Birthday Message Mug', handle: 'winni-addon-birthday-message-mug' },
          { name: 'Magic Candle', handle: 'winni-addon-magic-candle' },
          { name: '8 Romantic Red Roses', handle: 'winni-addon-8-romantic-red-roses' },
          { name: 'Birthday Celebration Cushion', handle: 'winni-addon-birthday-celebration-cushion' },
          { name: 'Medium Size Teddy Bear', handle: 'winni-addon-medium-size-teddy-bear' },
          { name: 'Big Cadbury Celebrations', handle: 'winni-addon-big-cadbury-celebrations' },
          { name: 'Golden Party Popper', handle: 'winni-addon-golden-party-popper' },
          { name: 'Lucky Bamboo Small', handle: 'winni-addon-lucky-bamboo-small' },
        ],
      },
      {
        id: 'cakes',
        label: 'Cakes',
        products: [
          { name: 'Chocolate Cake 500 Gm', handle: 'winni-addon-chocolate-cake-500gm' },
          { name: 'Yummy Pineapple Cake 500 Gm', handle: 'winni-addon-yummy-pineapple-cake-500gm' },
          { name: 'Red Velvet Cake 500 Gm', handle: 'winni-addon-red-velvet-cake-500gm' },
          { name: 'Blackforest Cream Cake 500 Gm', handle: 'winni-addon-blackforest-cream-cake-500gm' },
          { name: 'Butterscotch Cake 500 Gm', handle: 'winni-addon-butterscotch-cake-500gm' },
        ],
      },
      {
        id: 'flowers',
        label: 'Flowers',
        products: [
          { name: 'Classy 6 Red Roses Bouquet', handle: 'winni-addon-classy-6-red-roses-bouquet' },
          {
            name: '6 Pink Carnations Flower Bouquet',
            handle: 'winni-addon-6-pink-carnations-flower-bouquet',
          },
          { name: '6 Blue Orchids', handle: 'winni-addon-6-blue-orchids' },
          { name: '10 Mix Roses Bouquet', handle: 'winni-addon-10-mix-roses-bouquet' },
          { name: 'Single Red Rose', handle: 'winni-addon-single-red-rose' },
          { name: '12 Red Roses Bouquet', handle: 'winni-addon-12-red-roses-bouquet' },
          { name: '8 Pink Roses Bouquet', handle: 'winni-addon-8-pink-roses-bouquet' },
          { name: '1 Single Rose', handle: 'winni-addon-1-single-rose' },
        ],
      },
      {
        id: 'chocolates',
        label: 'Chocolates',
        products: [
          { name: '10 Cadbury Milk Chocolates', handle: 'winni-addon-10-cadbury-milk-chocolates' },
          { name: 'Small Ferrero Rocher', handle: 'winni-addon-small-ferrero-rocher' },
          { name: 'Medium Ferrero Rocher', handle: 'winni-addon-medium-ferrero-rocher' },
          { name: '5 Dairy Milk Silk Chocolates', handle: 'winni-addon-5-dairy-milk-silk-chocolates' },
          { name: 'Big Ferrero Rochers', handle: 'winni-addon-big-ferrero-rochers' },
          {
            name: '5 Dairy Milk Chocolates With Greeting Card As Per Occasion',
            handle: 'winni-addon-5-dairy-milk-chocolates-with-greeting-card-as-per-occasion',
          },
        ],
      },
      {
        id: 'candles',
        label: 'Candles',
        products: [
          { name: 'Candle 0', handle: 'winni-addon-candle-0' },
          { name: 'Candle 1', handle: 'winni-addon-candle-1' },
          { name: 'Candle 2', handle: 'winni-addon-candle-2' },
          { name: 'Candle 3', handle: 'winni-addon-candle-3' },
          { name: 'Candle 4', handle: 'winni-addon-candle-4' },
          { name: 'Candle 5', handle: 'winni-addon-candle-5' },
          { name: 'Candle 6', handle: 'winni-addon-candle-6' },
          { name: 'Candle 7', handle: 'winni-addon-candle-7' },
          { name: 'Candle 8', handle: 'winni-addon-candle-8' },
          { name: 'Candle 9', handle: 'winni-addon-candle-9' },
        ],
      },
      {
        id: 'teddies',
        label: 'Teddies',
        products: [
          { name: 'Small White Teddy Bear', handle: 'winni-addon-small-white-teddy-bear' },
          { name: 'Small Teddy Bear', handle: 'winni-addon-small-teddy-bear' },
          { name: 'Medium Size Brown Teddy Bear', handle: 'winni-addon-medium-size-brown-teddy-bear' },
          {
            name: '6 Inches Teddy With Greeting Card As Per Occasion',
            handle: 'winni-addon-6-inches-teddy-with-greeting-card-as-per-occasion',
          },
          {
            name: '5 Dairy Milk Chocolates With 6 Inch Teddy Bear',
            handle: 'winni-addon-5-dairy-milk-chocolates-with-6-inch-teddy-bear',
          },
        ],
      },
      {
        id: 'greeting-cards',
        label: 'Greeting Cards',
        products: [
          { name: 'Small Love Greeting Card', handle: 'winni-addon-small-love-greeting-card' },
          { name: 'Greeting Card', handle: 'winni-addon-greeting-card' },
          { name: 'Big Greeting Card', handle: 'winni-addon-big-greeting-card' },
          { name: 'Medium Valentine Card', handle: 'winni-addon-medium-valentine-card' },
          { name: 'Large Valentine Card', handle: 'winni-addon-large-valentine-card' },
          {
            name: '6 Inch Teddy Bear With Anniversary Greeting Card',
            handle: 'winni-addon-6-inch-teddy-bear-with-anniversary-greeting-card',
          },
        ],
      },
    ];
    const cleanCartUpsellExcludedCatalogGroups = {
      cake: new Set(['cakes']),
      flower: new Set(['flowers', 'candles']),
      chocolate: new Set(['chocolates', 'candles']),
    };
    const cleanCartUpsellProductConcurrency = 5;
    const cleanCartUpsellProductRetries = 2;
    const cleanCartUpsellRetryConcurrency = 2;
    const cleanCartUpsellRetryBaseDelay = 1000;
    const cleanCartUpsellRetryMaxDelay = 30000;
    const cleanCartUpsellEligibleVendor = 'winni';
    const cleanCartAddOnParentProductProperty = '_clean_add_on_parent_product_id';
    const cleanCartAddOnParentVariantProperty = '_clean_add_on_parent_variant_id';
    const cleanCartUpsellMutations = new Set();
    let cleanCartUpsellFlowPromise = null;
    let cleanCartLastTrackedAddAt = 0;
    let cleanCartTrackedAddPromise = null;
    let cleanHydrogenCartNavigationStarted = false;
    let cleanCartReconciliationController = null;
    let cleanCartReconciliationPromise = null;
    let cleanCartReconciliationSequence = 0;

    const cancelCleanCartReconciliation = () => {
      cleanCartReconciliationSequence += 1;
      cleanCartReconciliationController?.abort();
      cleanCartReconciliationController = null;
      cleanCartReconciliationPromise = null;
      window.CleanCartState?.cancel?.();
    };

    const navigateToHydrogenCart = () => {
      if (cleanHydrogenCartNavigationStarted) return false;

      cleanHydrogenCartNavigationStarted = true;
      cancelCleanCartReconciliation();
      document.dispatchEvent(new CustomEvent('clean:cart:navigation-starting'));

      try {
        window.location.assign('/cart');
        return true;
      } catch (error) {
        cleanHydrogenCartNavigationStarted = false;
        document.dispatchEvent(new CustomEvent('clean:cart:navigation-cancelled'));
        throw error;
      }
    };

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      cleanHydrogenCartNavigationStarted = false;
      cancelCleanCartReconciliation();
      window.CleanCartUpsell?.restore?.();
    });

    const trackCleanCartUpsellMutation = (operation) => {
      const promise = Promise.resolve(operation);
      cleanCartUpsellMutations.add(promise);
      promise.then(
        () => cleanCartUpsellMutations.delete(promise),
        () => cleanCartUpsellMutations.delete(promise),
      );
      return promise;
    };

    const waitForCleanCartUpsellMutations = async () => {
      let mutationsCommitted = true;

      while (cleanCartUpsellMutations.size) {
        const results = await Promise.allSettled(Array.from(cleanCartUpsellMutations));
        if (results.some((result) => result.status === 'rejected')) mutationsCommitted = false;
      }

      return mutationsCommitted;
    };

    const waitForCleanCartAddTracking = async () => {
      const trackingPromise = window.GiftechGoogleTracking?.waitForCartAddTracking?.();
      if (!trackingPromise || typeof trackingPromise.then !== 'function') return;

      let timeoutId;

      try {
        await Promise.race([
          Promise.resolve(trackingPromise).catch(() => {}),
          new Promise((resolve) => {
            timeoutId = window.setTimeout(resolve, 75);
          }),
        ]);
      } finally {
        window.clearTimeout(timeoutId);
      }
    };

    const completeCleanCartPostAddFlow = async (onNavigationStart) => {
      const mutationsCommitted = await waitForCleanCartUpsellMutations();
      if (!mutationsCommitted) return false;
      await waitForCleanCartAddTracking();
      if (typeof onNavigationStart === 'function') onNavigationStart();
      return navigateToHydrogenCart();
    };

    const getCleanCartUpsellDrawer = () => document.querySelector('[data-clean-cart-upsell-drawer]');

    const getCleanCartUpsellCatalog = (drawer) => {
      const productGroup = String(drawer?.dataset.cleanCartUpsellProductGroup || '');
      const excludedGroups = cleanCartUpsellExcludedCatalogGroups[productGroup];

      if (!excludedGroups) return cleanCartUpsellCatalog;
      return cleanCartUpsellCatalog.filter((group) => !excludedGroups.has(group.id));
    };

    const prepareCleanCartUpsellCatalog = () => {
      const drawer = getCleanCartUpsellDrawer();
      const group = String(drawer?.dataset.cleanCartUpsellProductGroup || '');
      if (!drawer || !['cake', 'chocolate', 'flower'].includes(group)) return null;

      window.__GG_WINNI_ADD_ONS_PREFETCH_GROUP__ = group;
      const operation = window.GiftechWinniAddOnsBridge?.prefetch?.(group);
      Promise.resolve(operation).catch(() => {});
      return operation || null;
    };

    const initCleanCartUpsellDrawer = (root = document) => {
      if (!cleanCartUpsellEnabled) return;

      const drawer =
        root.querySelector?.('[data-clean-cart-upsell-drawer]') ||
        (root.matches?.('[data-clean-cart-upsell-drawer]') ? root : null);

      if (!drawer || drawer.dataset.cleanCartUpsellReady === 'true') return;

      const initialFocus = drawer.querySelector('[data-clean-cart-upsell-exit]');
      let exitCallback = null;
      let isClosing = false;
      let openPromise = null;
      let resolveOpenPromise = null;
      let lastOpenedAt = 0;
      const lifecycle = new AbortController();
      drawer.cleanCartUpsellLifecycle = lifecycle;

      const getFocusableElements = () =>
        Array.from(
          drawer.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
          ),
        ).filter((element) => element.offsetParent !== null && element.getAttribute('aria-hidden') !== 'true');

      const isOpen = () => !drawer.hidden;

      const wasRecentlyShown = () => isOpen() || Date.now() - lastOpenedAt < 3000;

      const settleOpenPromise = () => {
        resolveOpenPromise?.();
        openPromise = null;
        resolveOpenPromise = null;
      };

      const setCompletionState = (active, label = '') => {
        const continueButton = drawer.querySelector('.clean-cart-upsell-drawer__continue');
        drawer.toggleAttribute('aria-busy', active);
        drawer.querySelectorAll('button').forEach((control) => {
          if (active) {
            if (control.dataset.cleanCartUpsellCompletionDisabled === undefined) {
              control.dataset.cleanCartUpsellCompletionDisabled = String(control.disabled);
            }
            control.disabled = true;
            return;
          }

          if (control.dataset.cleanCartUpsellCompletionDisabled !== undefined) {
            control.disabled = control.dataset.cleanCartUpsellCompletionDisabled === 'true';
            delete control.dataset.cleanCartUpsellCompletionDisabled;
          }
        });

        if (active) {
          drawer.dataset.cleanCartUpsellCompleting = 'true';
          if (continueButton && label) continueButton.textContent = label;
          return;
        }

        delete drawer.dataset.cleanCartUpsellCompleting;
        const catalogRetry = drawer.querySelector('[data-clean-cart-upsell-catalog-retry]');
        if (catalogRetry && !catalogRetry.hidden) catalogRetry.disabled = false;
        syncCleanCartUpsellActions(drawer, drawer.cleanCartUpsellCart || window.cart);
        syncCleanCartUpsellContinueLabel(drawer);
      };

      const close = () => {
        if (isClosing) return openPromise || Promise.resolve();

        if (!isOpen()) {
          settleOpenPromise();
          return Promise.resolve();
        }

        isClosing = true;
        const hasPendingMutations = cleanCartUpsellMutations.size > 0;
        setCompletionState(true, hasPendingMutations ? 'FINISHING ADD-ON…' : 'OPENING CART...');
        cancelCleanCartReconciliation();

        waitForCleanCartUpsellMutations().then((mutationsCommitted) => {
          if (!mutationsCommitted) {
            isClosing = false;
            setCompletionState(false);
            drawer
              .querySelector(
                '[data-clean-cart-upsell-action-error="true"] [role="alert"], [data-clean-cart-upsell-state="error"]',
              )
              ?.focus({ preventScroll: true });
            return;
          }

          const callback = exitCallback;
          exitCallback = null;
          setCompletionState(true, 'OPENING CART...');
          drawer.dataset.cleanCartUpsellRetriesPaused = 'true';
          pauseCleanCartUpsellRetries(drawer);
          getCleanCartUpsellRetryState(drawer).requestController?.abort();
          Promise.resolve(typeof callback === 'function' ? callback() : null)
            .then((navigationStarted) => {
              if (navigationStarted || cleanHydrogenCartNavigationStarted) return;

              isClosing = false;
              setCompletionState(false);
            })
            .catch(() => {
              isClosing = false;
              setCompletionState(false);
            });
        });

        return openPromise || Promise.resolve();
      };

      const open = ({ onExit } = {}) => {
        if (isOpen() && openPromise) return openPromise;

        exitCallback = typeof onExit === 'function' ? onExit : null;
        isClosing = false;
        delete drawer.dataset.cleanCartUpsellCompleting;
        lastOpenedAt = Date.now();
        openPromise = new Promise((resolve) => {
          resolveOpenPromise = resolve;
        });

        drawer.hidden = false;
        drawer.dataset.cleanCartUpsellRetriesPaused = 'false';
        document.body.classList.add('clean-cart-upsell-open');
        syncCleanCartUpsellActions(drawer, drawer.cleanCartUpsellCart || window.cart);
        scheduleCleanCartUpsellRetries(drawer, { immediate: true });
        loadCleanCartUpsellCatalog(drawer).then(
          () => syncCleanCartUpsellActions(drawer, window.cart),
          () => syncCleanCartUpsellActions(drawer, window.cart),
        );

        window.requestAnimationFrame(() => {
          drawer.classList.add('clean-cart-upsell-drawer--open');
          drawer
            .querySelectorAll('[data-clean-cart-upsell-rail]')
            .forEach((rail) => updateCleanCartUpsellRailControls(rail));
          initialFocus?.focus({ preventScroll: true });
        });

        return openPromise;
      };

      const restore = () => {
        exitCallback = null;
        isClosing = false;
        window.clearTimeout(drawer.cleanCartUpsellCloseTimer);
        drawer.classList.remove('clean-cart-upsell-drawer--open');
        drawer.hidden = true;
        document.body.classList.remove('clean-cart-upsell-open');
        setCompletionState(false);
        settleOpenPromise();
      };

      drawer.dataset.cleanCartUpsellReady = 'true';
      initCleanCartUpsellCatalog(drawer);

      drawer.addEventListener(
        'click',
        (event) => {
          const catalogRetry = event.target.closest('[data-clean-cart-upsell-catalog-retry]');
          if (catalogRetry && drawer.contains(catalogRetry)) {
            event.preventDefault();
            if (drawer.dataset.cleanCartUpsellCompleting !== 'true') retryAllCleanCartUpsellProducts(drawer);
            return;
          }

          if (!event.target.closest('[data-clean-cart-upsell-exit]')) return;
          event.preventDefault();
          close();
        },
        { signal: lifecycle.signal },
      );

      drawer.addEventListener(
        'keydown',
        (event) => {
          if (!isOpen()) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            close();
            return;
          }

          if (event.key !== 'Tab') return;

          const focusable = getFocusableElements();
          if (!focusable.length) return;

          const first = focusable[0];
          const last = focusable[focusable.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus({ preventScroll: true });
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus({ preventScroll: true });
          }
        },
        { signal: lifecycle.signal },
      );

      document.addEventListener(
        'clean:cart:updated',
        (event) => {
          if (!drawer.isConnected) return;
          drawer.cleanCartUpsellCart = event.detail?.cart;

          if (drawer.hidden) {
            drawer.dataset.cleanCartUpsellSyncDirty = 'true';
            return;
          }

          syncCleanCartUpsellActions(drawer, event.detail?.cart);
        },
        { signal: lifecycle.signal },
      );

      window.CleanCartUpsell = {
        ...(window.CleanCartUpsell || {}),
        open,
        close,
        isOpen,
        restore,
        wasRecentlyShown,
      };
      drawer.cleanCartUpsellCleanup = () => {
        lifecycle.abort();
        const retryState = cleanCartUpsellRetryStates.get(drawer);
        retryState?.requestController?.abort();
        pauseCleanCartUpsellRetries(drawer);
        drawer.cleanCartUpsellResizeObserver?.disconnect();
        drawer.cleanCartUpsellAnimationFrames?.forEach((frame) => window.cancelAnimationFrame(frame));
        drawer.cleanCartUpsellAnimationFrames?.clear();
        window.clearTimeout(drawer.cleanCartUpsellCloseTimer);
        settleOpenPromise();
        delete drawer.dataset.cleanCartUpsellReady;
      };

      document.dispatchEvent(
        new CustomEvent('clean:cart-upsell:ready', { detail: { upsell: window.CleanCartUpsell } }),
      );
    };

    const cleanFormatCartMoney = (cents, moneyFormat) => {
      const amount = (Number(cents || 0) / 100).toFixed(2);
      const placeholderPattern = (name) => new RegExp(['\\{', `\\{\\s*${name}\\s*\\}\\}`].join(''), 'g');
      const format = moneyFormat || `₹${['{', '{ amount }}'].join('')}`;

      return format
        .replace(placeholderPattern('amount_with_comma_separator'), amount.replace('.', ','))
        .replace(placeholderPattern('amount_no_decimals'), amount.replace(/\.\d+$/, ''))
        .replace(placeholderPattern('amount'), amount)
        .replace(/<[^>]*>/g, '');
    };

    const escapeCleanCartHtml = (value) =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const cleanCartMoneyAttributes = (cents, drawer) => {
      const sourceText = cleanFormatCartMoney(cents, drawer.dataset.cleanCartMoneyFormat);
      const sourceCurrency =
        drawer.dataset.cleanCartSourceCurrency ||
        document.querySelector('[data-clean-display-currency-config]')?.dataset.cleanDisplayCurrencySource ||
        '';

      return `data-clean-money data-clean-money-minor="${escapeCleanCartHtml(
        cents,
      )}" data-clean-money-currency="${escapeCleanCartHtml(
        sourceCurrency,
      )}" data-clean-money-source-text="${escapeCleanCartHtml(sourceText)}"`;
    };

    const cleanCartAjaxUrl = (url, fallback) => {
      const rawUrl = url || fallback;

      try {
        const parsedUrl = new URL(rawUrl, window.location.origin);
        const path = parsedUrl.pathname.replace(/\/$/, '');
        parsedUrl.pathname = path.endsWith('.js') ? path : `${path}.js`;
        parsedUrl.search = '';

        return `${parsedUrl.pathname}${parsedUrl.search}`;
      } catch (error) {
        const path = String(rawUrl || fallback || '').replace(/\/$/, '');
        return path.endsWith('.js') ? path : `${path}.js`;
      }
    };

    const cleanCartRequest = (url, options = {}) =>
      fetch(url, {
        credentials: 'same-origin',
        ...options,
        headers: {
          Accept: 'application/json',
          'X-Clean-Cart': 'true',
          ...(options.headers || {}),
        },
      });

    const getCleanCartInitialState = () => {
      try {
        const source = document.querySelector('[data-clean-cart-initial-state]')?.textContent || '';
        const cart = JSON.parse(source);
        return cart && Array.isArray(cart.items) ? cart : null;
      } catch (error) {
        return null;
      }
    };

    const getCleanCartStateCoordinator = () => {
      if (window.CleanCartState?.refresh && window.CleanCartState?.publish) {
        if (!window.CleanCartState.state?.cleanCartInitialStateSeeded) {
          const initialCart = getCleanCartInitialState();
          if (initialCart) window.CleanCartState.publish(initialCart);
          if (window.CleanCartState.state) window.CleanCartState.state.cleanCartInitialStateSeeded = true;
        }
        return window.CleanCartState;
      }

      const initialCart = getCleanCartInitialState() || window.cart || null;
      const state = {
        cart: initialCart,
        cleanCartInitialStateSeeded: true,
        controller: null,
        inFlight: null,
        lastUpdatedAt: initialCart ? Date.now() : 0,
        revision: 0,
        sequence: 0,
      };
      const publish = (cart) => {
        if (!cart || !Array.isArray(cart.items)) return cart;
        state.revision += 1;
        state.controller?.abort();
        state.cart = cart;
        state.lastUpdatedAt = Date.now();
        return cart;
      };
      const readCart = async ({ signal } = {}) => {
        const drawer = getCleanCartDrawer();
        if (!drawer) return null;
        const response = await cleanCartRequest(getCleanCartJsonUrl(drawer), { signal });
        if (!response.ok) throw new Error('Unable to refresh cart.');
        return response.json();
      };
      const cancel = () => {
        state.sequence += 1;
        state.controller?.abort();
        state.controller = null;
        state.inFlight = null;
      };
      const refresh = (loader = readCart, { supersede = false } = {}) => {
        if (state.inFlight && !supersede) return state.inFlight;
        if (supersede) cancel();

        const controller = new AbortController();
        const sequence = ++state.sequence;
        const revision = state.revision;
        const operation = Promise.resolve()
          .then(() => loader({ signal: controller.signal, sequence }))
          .then((cart) => {
            if (controller.signal.aborted || sequence !== state.sequence || revision !== state.revision) {
              const error = new Error('Cart refresh was superseded.');
              error.name = 'AbortError';
              throw error;
            }
            if (!cart || !Array.isArray(cart.items)) return cart;
            state.cart = cart;
            state.lastUpdatedAt = Date.now();
            return cart;
          })
          .finally(() => {
            if (state.inFlight === operation) {
              state.controller = null;
              state.inFlight = null;
            }
          });

        state.controller = controller;
        state.inFlight = operation;
        return operation;
      };

      window.CleanCartState = { cancel, publish, refresh, state };
      return window.CleanCartState;
    };

    const cleanClampCartQuantity = (value) => {
      const quantity = Number.parseInt(value, 10);
      return Number.isFinite(quantity) ? Math.max(0, quantity) : 0;
    };

    const getCleanCartImageUrl = (source, width = 140) => {
      if (!source) return '';

      try {
        const imageUrl = new URL(source, window.location.origin);
        const hostname = imageUrl.hostname.toLowerCase();
        const isShopifyImage =
          hostname === window.location.hostname.toLowerCase() ||
          hostname === 'cdn.shopify.com' ||
          hostname.endsWith('.myshopify.com') ||
          hostname.endsWith('.shopifycdn.com');

        if (isShopifyImage) imageUrl.searchParams.set('width', String(width));
        return imageUrl.toString();
      } catch (error) {
        return String(source);
      }
    };

    const cleanCartProductCache = new Map();
    const cleanCartProductFailures = new Map();
    const cleanCartUpsellRetryStates = new WeakMap();
    const cleanCartPendingCompareHydrations = new WeakMap();
    const cleanCartCompareHydrationConcurrency = 3;
    let cleanCartRenderSequence = 0;

    const isCleanCartBulkEligible = (item) => {
      const state = window.CleanBulkDiscounts?.getState();
      return (state?.eligibleProductIds || []).some((id) => String(id) === String(item?.product_id));
    };

    const cleanNormalizeCartPrice = (value) => {
      const price = Number(value);
      return Number.isFinite(price) ? price : 0;
    };

    const getCleanCartLinePrice = (item) => {
      const finalLinePrice = cleanNormalizeCartPrice(item?.final_line_price);
      if (item?.final_line_price != null && Number.isFinite(Number(item.final_line_price))) return finalLinePrice;

      const linePrice = cleanNormalizeCartPrice(item?.line_price);
      if (linePrice > 0) return linePrice;

      const unitPrice = cleanNormalizeCartPrice(item?.final_price || item?.price);
      return unitPrice * cleanClampCartQuantity(item?.quantity || 1);
    };

    const getCleanCartDirectCompareUnitPrice = (item) => {
      const candidates = [
        item?.variant_compare_at_price,
        item?.compare_at_price,
        item?.variant?.compare_at_price,
        item?.original_price,
      ];

      return candidates.map(cleanNormalizeCartPrice).find((price) => price > 0) || 0;
    };

    const hasCleanCartDirectCompareAtPrice = (item) =>
      [item?.variant_compare_at_price, item?.compare_at_price, item?.variant?.compare_at_price]
        .map(cleanNormalizeCartPrice)
        .some((price) => price > 0);

    const getCleanCartCompareAtUnitPrice = (item) =>
      [item?.variant_compare_at_price, item?.compare_at_price, item?.variant?.compare_at_price]
        .map(cleanNormalizeCartPrice)
        .find((price) => price > 0) || 0;

    const getCleanCartCompareLinePrice = (item, compareUnitPrice = getCleanCartDirectCompareUnitPrice(item)) => {
      const quantity = cleanClampCartQuantity(item?.quantity || 1) || 1;
      const linePrice = getCleanCartLinePrice(item);
      const directCompareLinePrice = compareUnitPrice * quantity;
      const originalLinePrice = cleanNormalizeCartPrice(item?.original_line_price);

      if (isCleanCartBulkEligible(item)) return originalLinePrice > linePrice ? originalLinePrice : 0;
      if (directCompareLinePrice > linePrice) return directCompareLinePrice;
      if (originalLinePrice > linePrice) return originalLinePrice;
      return 0;
    };

    const getCleanCartDiscountPercent = (compareLinePrice, linePrice) => {
      if (!compareLinePrice || compareLinePrice <= linePrice) return 0;
      return Math.round(((compareLinePrice - linePrice) * 100) / compareLinePrice);
    };

    const renderCleanCartPriceHtml = (item, drawer, compareLinePrice = getCleanCartCompareLinePrice(item)) => {
      const linePrice = getCleanCartLinePrice(item);
      const discountPercent = getCleanCartDiscountPercent(compareLinePrice, linePrice);
      const comparePrice = compareLinePrice
        ? `<s class="clean-cart-drawer__compare-price" ${cleanCartMoneyAttributes(
            compareLinePrice,
            drawer,
          )}>${escapeCleanCartHtml(cleanFormatCartMoney(compareLinePrice, drawer.dataset.cleanCartMoneyFormat))}</s>`
        : '';
      const discount = discountPercent
        ? `<span class="clean-cart-drawer__discount">${discountPercent}% off</span>`
        : '';

      return `
        ${comparePrice}
        <span class="clean-cart-drawer__price" ${cleanCartMoneyAttributes(
          linePrice,
          drawer,
        )}>${escapeCleanCartHtml(cleanFormatCartMoney(linePrice, drawer.dataset.cleanCartMoneyFormat))}</span>
        ${discount}
      `;
    };

    const getCleanCartItemKey = (item) => String(item?.key || item?.id || item?.variant_id || '').trim();

    const getCleanCartCompareAtLinePrice = (item, compareUnitPrice = getCleanCartCompareAtUnitPrice(item)) => {
      if (isCleanCartBulkEligible(item)) return getCleanCartCompareLinePrice(item);
      const quantity = cleanClampCartQuantity(item?.quantity || 1) || 1;
      const linePrice = getCleanCartLinePrice(item);
      const compareLinePrice = compareUnitPrice * quantity;
      return compareLinePrice > linePrice ? compareLinePrice : 0;
    };

    const getCleanCartHydratedCompareLinePrice = (item, compareLinePrices) => {
      if (isCleanCartBulkEligible(item)) return getCleanCartCompareLinePrice(item);
      const directCompareLinePrice = getCleanCartCompareAtLinePrice(item);
      if (directCompareLinePrice) return directCompareLinePrice;

      if (!compareLinePrices) return 0;
      return cleanNormalizeCartPrice(compareLinePrices.get(getCleanCartItemKey(item)));
    };

    const cleanCartFreeShippingThreshold = 50000;
    const cleanCartStandardShippingCharge = 9000;

    const getCleanCartTotalsBreakdown = (cart, compareLinePrices) => {
      const items = cart?.items || [];
      const lineSubtotal = items.reduce((total, item) => total + getCleanCartLinePrice(item), 0);
      const shopifyCartTotal = cleanNormalizeCartPrice(cart?.total_price);
      const cartTotal = shopifyCartTotal || lineSubtotal;
      const hasFreeShipping = cartTotal > cleanCartFreeShippingThreshold;
      const shippingCharge = cartTotal > 0 && !hasFreeShipping ? cleanCartStandardShippingCharge : 0;
      const hasBulkDiscount = items.some(isCleanCartBulkEligible);
      const shippingSavings = hasFreeShipping && !hasBulkDiscount ? cleanCartStandardShippingCharge : 0;
      const freeShippingAmountRemaining = shippingCharge
        ? Math.max(100, Math.ceil((cleanCartFreeShippingThreshold - cartTotal + 1) / 100) * 100)
        : 0;
      const freeShippingProgress = hasFreeShipping
        ? 100
        : Math.min(99, Math.max(0, (cartTotal * 100) / cleanCartFreeShippingThreshold));
      const estimatedTotal = cartTotal + shippingCharge;
      let mrpTotal = 0;
      let hasCompareSavings = false;

      items.forEach((item) => {
        const linePrice = getCleanCartLinePrice(item);
        const compareLinePrice = getCleanCartHydratedCompareLinePrice(item, compareLinePrices);

        if (compareLinePrice > linePrice) {
          mrpTotal += compareLinePrice;
          hasCompareSavings = true;
          return;
        }

        mrpTotal += linePrice;
      });

      const savings = hasCompareSavings ? Math.max(0, mrpTotal - cartTotal) : 0;
      const totalSavings = savings + shippingSavings;
      const estimatedCompareTotal =
        mrpTotal + (hasBulkDiscount ? shippingCharge : items.length ? cleanCartStandardShippingCharge : 0);
      const discountPercent = totalSavings ? getCleanCartDiscountPercent(estimatedCompareTotal, estimatedTotal) : 0;

      return {
        cartTotal,
        hasBulkDiscount,
        discountPercent,
        estimatedCompareTotal,
        estimatedTotal,
        freeShippingAmountRemaining,
        freeShippingProgress,
        hasFreeShipping,
        hasItems: items.length > 0,
        hasSavings: totalSavings > 0,
        mrpTotal,
        savings,
        shippingCharge,
        shippingSavings,
        totalSavings,
      };
    };

    const setCleanCartMoneyText = (target, value, drawer, { prefix = '', suffix = '' } = {}) => {
      if (!target) return;

      const sourceText = cleanFormatCartMoney(value, drawer.dataset.cleanCartMoneyFormat);
      if (!prefix && !suffix) {
        target.dataset.cleanMoney = '';
        target.dataset.cleanMoneyMinor = String(value);
        target.dataset.cleanMoneyCurrency = drawer.dataset.cleanCartSourceCurrency || '';
        target.dataset.cleanMoneySourceText = sourceText;
        target.textContent = sourceText;
        if (window.CleanDisplayCurrency?.ready) {
          window.CleanDisplayCurrency.refresh(target);
        } else {
          window.CleanDisplayCurrencyBootstrap?.refresh?.(target);
        }
        return;
      }

      target.removeAttribute('data-clean-money');
      target.removeAttribute('data-clean-money-minor');
      target.removeAttribute('data-clean-money-currency');
      target.removeAttribute('data-clean-money-source-text');
      target.removeAttribute('data-clean-money-display-currency');
      target.removeAttribute('aria-label');
      const money = document.createElement('span');
      money.dataset.cleanMoney = '';
      money.dataset.cleanMoneyMinor = String(value);
      money.dataset.cleanMoneyCurrency = drawer.dataset.cleanCartSourceCurrency || '';
      money.dataset.cleanMoneySourceText = sourceText;
      money.textContent = sourceText;
      target.replaceChildren(document.createTextNode(prefix), money, document.createTextNode(suffix));
      if (window.CleanDisplayCurrency?.ready) {
        window.CleanDisplayCurrency.refresh(money);
      } else {
        window.CleanDisplayCurrencyBootstrap?.refresh?.(money);
      }
    };

    const renderCleanCartTotals = (drawer, cart, compareLinePrices) => {
      const totalTarget = drawer?.querySelector('[data-clean-cart-drawer-total]');
      const compareTarget = drawer?.querySelector('[data-clean-cart-total-compare]');
      const discountTarget = drawer?.querySelector('[data-clean-cart-total-discount]');
      const toggle = drawer?.querySelector('[data-clean-cart-summary-toggle]');
      const summary = drawer?.querySelector('[data-clean-cart-summary]');
      if (!drawer || !totalTarget) return;

      const breakdown = getCleanCartTotalsBreakdown(cart, compareLinePrices);
      setCleanCartMoneyText(totalTarget, breakdown.estimatedTotal, drawer);

      if (compareTarget) {
        compareTarget.hidden = !breakdown.hasSavings;
        if (breakdown.hasSavings) {
          setCleanCartMoneyText(compareTarget, breakdown.estimatedCompareTotal, drawer);
        }
      }

      if (discountTarget) {
        discountTarget.hidden = !breakdown.hasSavings || !breakdown.discountPercent;
        discountTarget.textContent = breakdown.discountPercent ? `(${breakdown.discountPercent}% OFF)` : '';
      }

      if (toggle) {
        toggle.hidden = !breakdown.hasItems;
        if (!breakdown.hasItems) toggle.setAttribute('aria-expanded', 'false');
      }

      if (summary) {
        const shouldShowSummary = breakdown.hasItems && toggle?.getAttribute('aria-expanded') === 'true';
        summary.hidden = !shouldShowSummary;
      }

      drawer.querySelectorAll('[data-clean-cart-summary-saved]').forEach((target) => {
        target.hidden = !breakdown.hasSavings;
        if (breakdown.hasSavings) {
          setCleanCartMoneyText(target, breakdown.totalSavings, drawer, { suffix: ' saved so far' });
        } else {
          target.replaceChildren();
        }
      });
      drawer.querySelectorAll('[data-clean-cart-shipping-progress-panel]').forEach((target) => {
        const shouldShowProgress = breakdown.hasItems && !breakdown.hasBulkDiscount;
        const messageTarget = target.querySelector('[data-clean-cart-shipping-progress-message]');
        const progressTarget = target.querySelector('[data-clean-cart-shipping-progress]');
        const progressFill = target.querySelector('[data-clean-cart-shipping-progress-fill]');
        const progressTruck = target.querySelector('[data-clean-cart-shipping-progress-truck]');

        target.hidden = !shouldShowProgress;
        target.dataset.cleanCartShippingProgress = String(breakdown.freeShippingProgress);
        if (messageTarget) {
          if (!shouldShowProgress) {
            messageTarget.replaceChildren();
          } else if (breakdown.hasFreeShipping) {
            messageTarget.textContent = 'Free Shipping Unlocked!';
          } else {
            setCleanCartMoneyText(messageTarget, breakdown.freeShippingAmountRemaining, drawer, {
              prefix: 'Add products worth ',
              suffix: ' to get free shipping!',
            });
          }
        }
        if (progressTarget)
          progressTarget.setAttribute('aria-valuenow', String(Math.round(breakdown.freeShippingProgress)));
        if (progressFill) progressFill.style.width = `${breakdown.freeShippingProgress}%`;
        if (progressTruck) progressTruck.style.left = `${breakdown.freeShippingProgress}%`;
      });
      drawer.querySelectorAll('[data-clean-cart-footer-savings]').forEach((target) => {
        const shouldShowShippingPrompt =
          !breakdown.hasBulkDiscount && breakdown.hasItems && breakdown.savings <= 0 && breakdown.shippingCharge > 0;
        const shouldShowRibbon = breakdown.hasSavings || shouldShowShippingPrompt;
        const textTarget = target.querySelector('[data-clean-cart-footer-savings-text]');

        target.hidden = !shouldShowRibbon;
        target.classList.toggle('clean-cart-drawer__savings-ribbon--shipping-prompt', shouldShowShippingPrompt);
        if (textTarget) {
          if (shouldShowShippingPrompt) {
            setCleanCartMoneyText(textTarget, breakdown.freeShippingAmountRemaining, drawer, {
              prefix: 'Add products worth ',
              suffix: ' to get free shipping!',
            });
          } else if (breakdown.hasSavings) {
            setCleanCartMoneyText(textTarget, breakdown.totalSavings, drawer, { suffix: ' saved so far!' });
          } else {
            textTarget.replaceChildren();
          }
        }
      });
      drawer.querySelectorAll('[data-clean-cart-base-label]').forEach((target) => {
        target.textContent = breakdown.hasBulkDiscount ? 'Items total' : 'MRP total';
      });
      drawer.querySelectorAll('[data-clean-cart-discount-label]').forEach((target) => {
        target.textContent = breakdown.hasBulkDiscount ? 'Discount' : 'Discount on MRP';
      });
      drawer
        .querySelectorAll('[data-clean-cart-summary-mrp]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.mrpTotal, drawer));
      drawer
        .querySelectorAll('[data-clean-cart-summary-discount-row]')
        .forEach((target) => (target.hidden = breakdown.savings <= 0));
      drawer
        .querySelectorAll('[data-clean-cart-summary-discount]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.savings, drawer, { prefix: '-' }));
      drawer.querySelectorAll('[data-clean-cart-summary-shipping]').forEach((target) => {
        const compareTarget = target.querySelector('[data-clean-cart-summary-shipping-compare]');
        const currentTarget = target.querySelector('[data-clean-cart-summary-shipping-current]');

        target.classList.toggle('clean-cart-drawer__summary-shipping--free', breakdown.hasFreeShipping);
        if (compareTarget) {
          compareTarget.hidden = !breakdown.hasFreeShipping;
          setCleanCartMoneyText(compareTarget, cleanCartStandardShippingCharge, drawer);
        }
        if (currentTarget) {
          if (breakdown.hasFreeShipping) {
            currentTarget.removeAttribute('data-clean-money');
            currentTarget.removeAttribute('data-clean-money-minor');
            currentTarget.removeAttribute('data-clean-money-currency');
            currentTarget.removeAttribute('data-clean-money-source-text');
            currentTarget.removeAttribute('data-clean-money-display-currency');
            currentTarget.removeAttribute('aria-label');
            currentTarget.textContent = 'FREE';
          } else {
            setCleanCartMoneyText(currentTarget, cleanCartStandardShippingCharge, drawer);
          }
        }
      });
      drawer
        .querySelectorAll('[data-clean-cart-summary-total-savings-row]')
        .forEach((target) => (target.hidden = !breakdown.hasSavings));
      drawer
        .querySelectorAll('[data-clean-cart-summary-total-savings]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.totalSavings, drawer));
      drawer
        .querySelectorAll('[data-clean-cart-summary-subtotal]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.cartTotal, drawer));
      drawer
        .querySelectorAll('[data-clean-cart-summary-total]')
        .forEach((target) => setCleanCartMoneyText(target, breakdown.estimatedTotal, drawer));
    };

    const getCleanCartProductJson = async (handle, { retries = 0, signal } = {}) => {
      const cleanHandle = String(handle || '').trim();
      if (!cleanHandle) return null;

      if (!cleanCartProductCache.has(cleanHandle)) {
        const rootUrl = window.Shopify?.routes?.root || '/';
        const productUrl = `${rootUrl.replace(/\/?$/, '/')}products/${encodeURIComponent(cleanHandle)}.js`;
        const requestPromise = (async () => {
          for (let attempt = 0; attempt <= retries; attempt += 1) {
            try {
              const response = await fetch(productUrl, {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
                signal,
              });

              if (response.ok) {
                const product = await response.json();
                cleanCartProductFailures.delete(cleanHandle);
                return product;
              }

              const isTransientResponse = response.status === 408 || response.status === 429 || response.status >= 500;
              cleanCartProductFailures.set(cleanHandle, { retryable: isTransientResponse });
              if (!isTransientResponse) return null;
            } catch (error) {
              if (error?.name === 'AbortError') return null;
              cleanCartProductFailures.set(cleanHandle, { retryable: true });
              if (attempt === retries) return null;
            }

            if (attempt < retries) {
              await new Promise((resolve) => {
                const timer = window.setTimeout(resolve, 200 * 2 ** attempt);
                signal?.addEventListener(
                  'abort',
                  () => {
                    window.clearTimeout(timer);
                    resolve();
                  },
                  { once: true },
                );
              });
              if (signal?.aborted) return null;
            }
          }

          return null;
        })();

        cleanCartProductCache.set(cleanHandle, requestPromise);
      }

      const cachedRequest = cleanCartProductCache.get(cleanHandle);
      const product = await cachedRequest;

      if (!product && cleanCartProductCache.get(cleanHandle) === cachedRequest) {
        cleanCartProductCache.delete(cleanHandle);
      }

      return product;
    };

    const isCleanCartProductFailureRetryable = (handle) =>
      cleanCartProductFailures.get(String(handle || '').trim())?.retryable !== false;

    const getCleanCartUpsellProductImage = (product) => {
      const source = product?.featured_image || product?.images?.[0] || '';
      if (!source) return '';

      try {
        const imageUrl = new URL(source, window.location.origin);
        imageUrl.searchParams.set('width', '360');
        return imageUrl.toString();
      } catch (error) {
        return String(source);
      }
    };

    const setCleanCartUpsellActiveTab = (drawer, groupId, { reveal = false } = {}) => {
      const tabs = drawer?.querySelectorAll('[data-clean-cart-upsell-tab]') || [];

      tabs.forEach((tab) => {
        const isActive = tab.dataset.cleanCartUpsellTab === groupId;
        tab.setAttribute('aria-current', String(isActive));

        if (isActive && reveal) {
          tab.scrollIntoView({
            behavior: 'auto',
            block: 'nearest',
            inline: 'center',
          });
        }
      });
    };

    const getCleanCartUpsellActiveGroup = (content, tabs, groups) => {
      const threshold = content.getBoundingClientRect().top + tabs.offsetHeight + 24;
      const passedGroups = groups.filter((group) => group.getBoundingClientRect().top <= threshold);
      const greetingCardsGroup = groups.find((group) => group.dataset.cleanCartUpsellGroup === 'greeting-cards');
      const teddiesHeading = content.querySelector('#clean-cart-upsell-heading-teddies');
      const teddiesLabelHasScrolledUp = teddiesHeading && teddiesHeading.getBoundingClientRect().bottom <= threshold;
      const isAtBottom = content.scrollTop + content.clientHeight >= content.scrollHeight - 2;

      if (greetingCardsGroup && (teddiesLabelHasScrolledUp || isAtBottom)) {
        return greetingCardsGroup;
      }

      return passedGroups[passedGroups.length - 1] || groups[0];
    };

    const renderCleanCartUpsellCatalogShell = (drawer) => {
      const content = drawer?.querySelector('[data-clean-cart-upsell-content]');
      if (!content) return;
      const catalog = getCleanCartUpsellCatalog(drawer);

      const tabs = catalog
        .map(
          (group, index) => `
            <button
              class="clean-cart-upsell-catalog__tab"
              type="button"
              data-clean-cart-upsell-tab="${escapeCleanCartHtml(group.id)}"
              aria-controls="clean-cart-upsell-group-${escapeCleanCartHtml(group.id)}"
              aria-current="${index === 0 ? 'true' : 'false'}"
            >
              ${escapeCleanCartHtml(group.label)}
            </button>
          `,
        )
        .join('');

      const groups = catalog
        .map(
          (group) => `
            <section
              class="clean-cart-upsell-catalog__group"
              id="clean-cart-upsell-group-${escapeCleanCartHtml(group.id)}"
              data-clean-cart-upsell-group="${escapeCleanCartHtml(group.id)}"
              aria-labelledby="clean-cart-upsell-heading-${escapeCleanCartHtml(group.id)}"
            >
              <div class="clean-cart-upsell-catalog__group-header">
                <h3
                  class="clean-cart-upsell-catalog__heading"
                  id="clean-cart-upsell-heading-${escapeCleanCartHtml(group.id)}"
                >
                  ${escapeCleanCartHtml(group.label)}
                </h3>
                <div
                  class="clean-cart-upsell-catalog__rail-controls"
                  role="group"
                  aria-label="${escapeCleanCartHtml(group.label)} product controls"
                >
                  <button
                    class="clean-cart-upsell-catalog__rail-button"
                    type="button"
                    data-clean-cart-upsell-rail-direction="previous"
                    aria-label="Show previous two ${escapeCleanCartHtml(group.label)} products"
                    disabled
                  >
                    <svg viewBox="0 0 20 20" aria-hidden="true">
                      <path d="m12.5 4.5-5 5.5 5 5.5"></path>
                    </svg>
                  </button>
                  <button
                    class="clean-cart-upsell-catalog__rail-button"
                    type="button"
                    data-clean-cart-upsell-rail-direction="next"
                    aria-label="Show next two ${escapeCleanCartHtml(group.label)} products"
                  >
                    <svg viewBox="0 0 20 20" aria-hidden="true">
                      <path d="m7.5 4.5 5 5.5-5 5.5"></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="clean-cart-upsell-catalog__grid" data-clean-cart-upsell-rail>
                ${group.products
                  .map(
                    (product) => `
                      <article
                        class="clean-cart-upsell-card"
                        data-clean-cart-upsell-product="${escapeCleanCartHtml(product.handle)}"
                        aria-busy="true"
                      >
                        <div class="clean-cart-upsell-card__media">
                          <span
                            class="clean-cart-upsell-card__skeleton clean-cart-upsell-card__skeleton--image"
                            aria-hidden="true"
                          ></span>
                        </div>
                        <div class="clean-cart-upsell-card__body">
                          <h4 class="clean-cart-upsell-card__title">${escapeCleanCartHtml(product.name)}</h4>
                          <span
                            class="clean-cart-upsell-card__skeleton clean-cart-upsell-card__skeleton--price"
                            aria-hidden="true"
                          ></span>
                          <div class="clean-cart-upsell-card__action" data-clean-cart-upsell-action>
                            <button
                              class="clean-cart-upsell-card__add"
                              type="button"
                              data-clean-cart-upsell-add
                              data-clean-cart-upsell-state="loading"
                              aria-live="polite"
                              disabled
                            >
                              LOADING…
                            </button>
                          </div>
                        </div>
                      </article>
                    `,
                  )
                  .join('')}
              </div>
            </section>
          `,
        )
        .join('');

      content.innerHTML = `
        <div class="clean-cart-upsell-catalog" data-clean-cart-upsell-catalog>
          <nav class="clean-cart-upsell-catalog__tabs" aria-label="Add-on categories">
            ${tabs}
          </nav>
          ${groups}
        </div>
      `;
    };

    const updateCleanCartUpsellRailControls = (rail) => {
      const group = rail?.closest('[data-clean-cart-upsell-group]');
      const previousButton = group?.querySelector('[data-clean-cart-upsell-rail-direction="previous"]');
      const nextButton = group?.querySelector('[data-clean-cart-upsell-rail-direction="next"]');
      if (!rail || !previousButton || !nextButton) return;

      const end = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previousButton.disabled = rail.scrollLeft <= 1;
      nextButton.disabled = rail.scrollLeft >= end - 1;
    };

    const initCleanCartUpsellCatalog = (drawer) => {
      const content = drawer?.querySelector('[data-clean-cart-upsell-content]');
      if (!content || content.dataset.cleanCartUpsellCatalogReady === 'true') return;

      content.dataset.cleanCartUpsellCatalogReady = 'true';
      renderCleanCartUpsellCatalogShell(drawer);
      const lifecycleSignal = drawer.cleanCartUpsellLifecycle?.signal;
      const animationFrames = new Set();
      drawer.cleanCartUpsellAnimationFrames = animationFrames;

      const rails = Array.from(content.querySelectorAll('[data-clean-cart-upsell-rail]'));
      rails.forEach((rail) => {
        let railFrame = 0;
        updateCleanCartUpsellRailControls(rail);
        rail.addEventListener(
          'scroll',
          () => {
            window.cancelAnimationFrame(railFrame);
            animationFrames.delete(railFrame);
            railFrame = window.requestAnimationFrame(() => {
              animationFrames.delete(railFrame);
              updateCleanCartUpsellRailControls(rail);
            });
            animationFrames.add(railFrame);
          },
          { passive: true, signal: lifecycleSignal },
        );
      });

      if ('ResizeObserver' in window) {
        const railResizeObserver = new ResizeObserver((entries) => {
          entries.forEach(({ target }) => updateCleanCartUpsellRailControls(target));
        });
        rails.forEach((rail) => railResizeObserver.observe(rail));
        drawer.cleanCartUpsellResizeObserver = railResizeObserver;
      }

      content.addEventListener(
        'click',
        (event) => {
          const addButton = event.target.closest('[data-clean-cart-upsell-add]');
          if (addButton && content.contains(addButton)) {
            event.preventDefault();
            if (drawer.dataset.cleanCartUpsellCompleting === 'true') return;
            trackCleanCartUpsellMutation(addCleanCartUpsellProduct(drawer, addButton));
            return;
          }

          const quantityButton = event.target.closest('[data-clean-cart-upsell-quantity-change]');
          if (quantityButton && content.contains(quantityButton)) {
            const action = quantityButton.closest('[data-clean-cart-upsell-action]');
            const currentQuantity = cleanClampCartQuantity(action?.dataset.cleanCartUpsellQuantity);
            const change = Number.parseInt(quantityButton.dataset.cleanCartUpsellQuantityChange, 10) || 0;
            if (!action || !currentQuantity || !change) return;

            if (drawer.dataset.cleanCartUpsellCompleting === 'true') return;
            trackCleanCartUpsellMutation(changeCleanCartUpsellQuantity(drawer, action, currentQuantity + change));
            return;
          }

          const removeButton = event.target.closest('[data-clean-cart-upsell-remove]');
          if (removeButton && content.contains(removeButton)) {
            const action = removeButton.closest('[data-clean-cart-upsell-action]');
            if (!action) return;

            if (drawer.dataset.cleanCartUpsellCompleting === 'true') return;
            trackCleanCartUpsellMutation(changeCleanCartUpsellQuantity(drawer, action, 0));
            return;
          }

          const railButton = event.target.closest('[data-clean-cart-upsell-rail-direction]');
          if (railButton && content.contains(railButton)) {
            const group = railButton.closest('[data-clean-cart-upsell-group]');
            const rail = group?.querySelector('[data-clean-cart-upsell-rail]');
            const firstCard = rail?.querySelector('.clean-cart-upsell-card');
            if (!rail || !firstCard) return;

            const gap = Number.parseFloat(window.getComputedStyle(rail).columnGap) || 0;
            const direction = railButton.dataset.cleanCartUpsellRailDirection === 'previous' ? -1 : 1;
            rail.scrollBy({
              left: direction * 2 * (firstCard.getBoundingClientRect().width + gap),
              behavior: reducedMotion.matches ? 'auto' : 'smooth',
            });
            return;
          }

          const tab = event.target.closest('[data-clean-cart-upsell-tab]');
          if (!tab || !content.contains(tab)) return;

          const groupId = tab.dataset.cleanCartUpsellTab;
          const group = content.querySelector(`[data-clean-cart-upsell-group="${groupId}"]`);
          const tabs = content.querySelector('.clean-cart-upsell-catalog__tabs');
          if (!group || !tabs) return;

          const contentBounds = content.getBoundingClientRect();
          const groupBounds = group.getBoundingClientRect();
          const top = content.scrollTop + groupBounds.top - contentBounds.top - tabs.offsetHeight - 12;

          setCleanCartUpsellActiveTab(drawer, groupId, { reveal: true });
          content.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
        },
        { signal: lifecycleSignal },
      );

      let scrollFrame = 0;
      content.addEventListener(
        'scroll',
        () => {
          window.cancelAnimationFrame(scrollFrame);
          animationFrames.delete(scrollFrame);
          scrollFrame = window.requestAnimationFrame(() => {
            animationFrames.delete(scrollFrame);
            const tabs = content.querySelector('.clean-cart-upsell-catalog__tabs');
            const groups = Array.from(content.querySelectorAll('[data-clean-cart-upsell-group]'));
            if (!tabs || !groups.length) return;

            const activeGroup = getCleanCartUpsellActiveGroup(content, tabs, groups);

            setCleanCartUpsellActiveTab(drawer, activeGroup.dataset.cleanCartUpsellGroup);
          });
          animationFrames.add(scrollFrame);
        },
        { passive: true, signal: lifecycleSignal },
      );

      const resumeCleanCartUpsellRetries = () => {
        if (document.visibilityState === 'hidden' || drawer.hidden) return;
        scheduleCleanCartUpsellRetries(drawer, { immediate: true });
      };

      window.addEventListener('online', resumeCleanCartUpsellRetries, { signal: lifecycleSignal });
      document.addEventListener('visibilitychange', resumeCleanCartUpsellRetries, { signal: lifecycleSignal });
    };

    const renderCleanCartUpsellProduct = (drawer, card, product) => {
      if (!card || !product) return false;

      const variants = Array.isArray(product.variants) ? product.variants : [];
      const availableVariant = variants.find((variant) => variant?.available && String(variant?.id || '').trim());
      const displayVariant = availableVariant || variants[0];
      const imageUrl = getCleanCartUpsellProductImage(product);
      const title = product.title || card.dataset.cleanCartUpsellProduct || 'Add-on';
      const price = displayVariant?.price ?? product.price;
      const variantId = String(availableVariant?.id || '').trim();
      const buttonLabel = variantId ? 'ADD' : 'UNAVAILABLE';
      const buttonState = variantId ? 'ready' : 'unavailable';

      card.innerHTML = `
        <div class="clean-cart-upsell-card__media">
          ${
            imageUrl
              ? `<img class="clean-cart-upsell-card__image" src="${escapeCleanCartHtml(
                  imageUrl,
                )}" alt="${escapeCleanCartHtml(
                  title,
                )}" width="360" height="360" loading="lazy" decoding="async" sizes="(max-width: 767px) 36vw, (max-width: 1200px) 25vw, 180px">`
              : ''
          }
        </div>
        <div class="clean-cart-upsell-card__body">
          <h4 class="clean-cart-upsell-card__title">${escapeCleanCartHtml(title)}</h4>
          <p class="clean-cart-upsell-card__price" ${cleanCartMoneyAttributes(
            price,
            drawer,
          )}>${escapeCleanCartHtml(cleanFormatCartMoney(price, drawer.dataset.cleanCartMoneyFormat))}</p>
          <div class="clean-cart-upsell-card__action" data-clean-cart-upsell-action>
            <button
              class="clean-cart-upsell-card__add"
              type="button"
              data-clean-cart-upsell-add
              data-clean-cart-upsell-state="${buttonState}"
              data-clean-cart-upsell-variant-id="${escapeCleanCartHtml(variantId)}"
              data-clean-cart-upsell-title="${escapeCleanCartHtml(title)}"
              aria-label="${escapeCleanCartHtml(`${buttonLabel === 'ADD' ? 'Add' : 'Unavailable'} ${title}`)}"
              aria-live="polite"
              ${variantId ? '' : 'disabled'}
            >
              ${buttonLabel}
            </button>
          </div>
        </div>
      `;
      card.setAttribute('aria-busy', 'false');
      delete card.dataset.cleanCartUpsellLoadingActive;
      syncCleanCartUpsellCardAction(drawer, card, drawer.cleanCartUpsellCart || window.cart);
      return true;
    };

    const setCleanCartUpsellProductLoading = (card, { active = false, retrying = false } = {}) => {
      if (!card) return;

      const media = card.querySelector('.clean-cart-upsell-card__media');
      const body = card.querySelector('.clean-cart-upsell-card__body');
      const button = body?.querySelector('[data-clean-cart-upsell-add]');
      const loadError = body?.querySelector('.clean-cart-upsell-card__load-error');

      loadError?.remove();

      if (media && !media.querySelector('.clean-cart-upsell-card__skeleton--image')) {
        media.insertAdjacentHTML(
          'afterbegin',
          '<span class="clean-cart-upsell-card__skeleton clean-cart-upsell-card__skeleton--image" aria-hidden="true"></span>',
        );
      }

      const spinner = media?.querySelector('.clean-cart-upsell-card__spinner');
      if (active && media && !spinner) {
        media.insertAdjacentHTML(
          'beforeend',
          '<span class="clean-cart-upsell-card__spinner" aria-hidden="true"></span>',
        );
      } else if (!active) {
        spinner?.remove();
      }

      if (body && button && !body.querySelector('.clean-cart-upsell-card__skeleton--price')) {
        const action = button.closest('[data-clean-cart-upsell-action]');
        (action || button).insertAdjacentHTML(
          'beforebegin',
          '<span class="clean-cart-upsell-card__skeleton clean-cart-upsell-card__skeleton--price" aria-hidden="true"></span>',
        );
      }

      if (button) {
        button.disabled = true;
        button.dataset.cleanCartUpsellState = 'loading';
        button.textContent = retrying ? 'RETRYING…' : 'LOADING…';
        button.removeAttribute('title');
      }

      card.dataset.cleanCartUpsellLoadingActive = active ? 'true' : 'false';
      card.setAttribute('aria-busy', 'true');
    };

    const renderCleanCartUpsellProductError = (card) => {
      const skeletons = card?.querySelectorAll('.clean-cart-upsell-card__skeleton') || [];
      skeletons.forEach((skeleton) => skeleton.remove());
      card?.querySelector('.clean-cart-upsell-card__spinner')?.remove();
      if (card) delete card.dataset.cleanCartUpsellLoadingActive;

      const body = card?.querySelector('.clean-cart-upsell-card__body');
      if (body && !body.querySelector('.clean-cart-upsell-card__load-error')) {
        const button = body.querySelector('[data-clean-cart-upsell-add]');
        if (button) {
          button.dataset.cleanCartUpsellState = 'error';
          button.disabled = true;
          button.textContent = 'ERROR';
        }

        body.insertAdjacentHTML(
          'beforeend',
          '<p class="clean-cart-upsell-card__load-error">Couldn’t load this add-on</p>',
        );
      }

      card?.setAttribute('aria-busy', 'false');
    };

    const getCleanCartUpsellIndex = (drawer, cart) => {
      if (drawer?.cleanCartUpsellIndexedCart === cart && drawer.cleanCartUpsellCartIndex) {
        return drawer.cleanCartUpsellCartIndex;
      }

      const byVariant = new Map();
      (cart?.items || []).forEach((item) => {
        const variantId = String(item?.variant_id || item?.id || '').trim();
        if (!variantId) return;
        if (!byVariant.has(variantId)) byVariant.set(variantId, []);
        byVariant.get(variantId).push(item);
      });

      if (drawer) {
        drawer.cleanCartUpsellIndexedCart = cart;
        drawer.cleanCartUpsellCartIndex = byVariant;
      }

      return byVariant;
    };

    const getCleanCartUpsellItemForVariant = (
      cart,
      variantId,
      drawer = getCleanCartUpsellDrawer(),
      index = getCleanCartUpsellIndex(drawer, cart),
    ) => {
      const cleanVariantId = String(variantId || '').trim();
      if (!cleanVariantId) return null;

      const matchingItems = index.get(cleanVariantId) || [];
      const parentProductId = String(drawer?.dataset.cleanCartUpsellParentProductId || '').trim();
      const parentVariantId = String(drawer?.dataset.cleanCartUpsellParentVariantId || '').trim();

      if (!parentProductId && !parentVariantId) return matchingItems[0] || null;

      return (
        matchingItems.find((item) => {
          const properties = item?.properties || {};
          const itemParentProductId = String(properties[cleanCartAddOnParentProductProperty] || '').trim();
          const itemParentVariantId = String(properties[cleanCartAddOnParentVariantProperty] || '').trim();

          if (parentVariantId && itemParentVariantId) return itemParentVariantId === parentVariantId;
          if (parentProductId && itemParentProductId) return itemParentProductId === parentProductId;
          return false;
        }) || null
      );
    };

    const syncCleanCartUpsellContinueLabel = (drawer) => {
      const continueButton = drawer?.querySelector('.clean-cart-upsell-drawer__continue');
      if (!continueButton) return;

      const hasSelectedAddOn = Boolean(drawer.querySelector('[data-clean-cart-upsell-quantity-change]'));
      continueButton.textContent = hasSelectedAddOn ? 'Continue With Add-Ons' : 'Continue Without Add-Ons';
    };

    const renderCleanCartUpsellAddAction = (action, { title, variantId, errorMessage = '' }) => {
      if (!action || !variantId) return;

      const cleanErrorMessage = String(errorMessage || '');
      const errorId = `clean-cart-upsell-error-${String(variantId).replace(/[^a-z0-9_-]/gi, '-')}`;
      const renderState = `add|${variantId}|${title}|${cleanErrorMessage}`;
      if (action.dataset.cleanCartUpsellRenderState === renderState && action.getAttribute('aria-busy') !== 'true') {
        return;
      }
      action.dataset.cleanCartUpsellRenderState = renderState;
      action.removeAttribute('aria-busy');
      action.toggleAttribute('data-clean-cart-upsell-action-error', Boolean(cleanErrorMessage));
      action.removeAttribute('title');
      delete action.dataset.cleanCartUpsellItemKey;
      delete action.dataset.cleanCartUpsellQuantity;
      action.dataset.cleanCartUpsellTitle = title;
      action.dataset.cleanCartUpsellVariantId = String(variantId);
      action.innerHTML = `
        <button
          class="clean-cart-upsell-card__add"
          type="button"
          data-clean-cart-upsell-add
          data-clean-cart-upsell-state="${cleanErrorMessage ? 'error' : 'ready'}"
          data-clean-cart-upsell-variant-id="${escapeCleanCartHtml(variantId)}"
          data-clean-cart-upsell-title="${escapeCleanCartHtml(title)}"
          aria-label="${escapeCleanCartHtml(`${cleanErrorMessage ? 'Retry adding' : 'Add'} ${title}`)}"
          ${cleanErrorMessage ? `aria-describedby="${errorId}"` : ''}
          aria-live="polite"
        >
          ${cleanErrorMessage ? 'RETRY' : 'ADD'}
        </button>
        ${
          cleanErrorMessage
            ? `<p class="clean-cart-upsell-card__action-error" id="${errorId}" role="alert" tabindex="-1">${escapeCleanCartHtml(
                cleanErrorMessage,
              )}</p>`
            : ''
        }
      `;
      if (action.closest('[data-clean-cart-upsell-drawer]')?.dataset.cleanCartUpsellCompleting === 'true') {
        action.querySelectorAll('button').forEach((control) => {
          control.dataset.cleanCartUpsellCompletionDisabled = String(control.disabled);
          control.disabled = true;
        });
      }
      syncCleanCartUpsellContinueLabel(action.closest('[data-clean-cart-upsell-drawer]'));
    };

    const renderCleanCartUpsellQuantityAction = (action, { itemKey, quantity, title, variantId }) => {
      if (!action || !variantId) return;

      const cleanQuantity = Math.max(1, cleanClampCartQuantity(quantity));
      const cleanItemKey = String(itemKey || variantId).trim();
      const renderState = `quantity|${cleanItemKey}|${variantId}|${cleanQuantity}|${title}`;
      if (action.dataset.cleanCartUpsellRenderState === renderState && action.getAttribute('aria-busy') !== 'true') {
        return;
      }

      action.dataset.cleanCartUpsellRenderState = renderState;
      action.dataset.cleanCartUpsellItemKey = cleanItemKey;
      action.dataset.cleanCartUpsellQuantity = String(cleanQuantity);
      action.dataset.cleanCartUpsellTitle = title;
      action.dataset.cleanCartUpsellVariantId = String(variantId);
      action.removeAttribute('aria-busy');
      action.removeAttribute('data-clean-cart-upsell-action-error');
      action.removeAttribute('title');
      action.innerHTML = `
        <div class="clean-cart-upsell-card__quantity-control">
          <div class="clean-cart-upsell-card__stepper" aria-label="Quantity for ${escapeCleanCartHtml(title)}">
            <button
              class="clean-cart-upsell-card__stepper-button"
              type="button"
              data-clean-cart-upsell-quantity-change="-1"
              aria-label="Decrease quantity of ${escapeCleanCartHtml(title)}"
              ${cleanQuantity <= 1 ? 'disabled' : ''}
            >
              −
            </button>
            <span class="clean-cart-upsell-card__quantity" aria-live="polite">${cleanQuantity}</span>
            <button
              class="clean-cart-upsell-card__stepper-button"
              type="button"
              data-clean-cart-upsell-quantity-change="1"
              aria-label="Increase quantity of ${escapeCleanCartHtml(title)}"
            >
              +
            </button>
          </div>
          <button
            class="clean-cart-upsell-card__remove"
            type="button"
            data-clean-cart-upsell-remove
            aria-label="Remove ${escapeCleanCartHtml(title)}"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M4 7h16M10 11v6M14 11v6M6 7l1 14h10l1-14M9 7V4h6v3"></path>
            </svg>
          </button>
        </div>
      `;
      if (action.closest('[data-clean-cart-upsell-drawer]')?.dataset.cleanCartUpsellCompleting === 'true') {
        action.querySelectorAll('button').forEach((control) => {
          control.dataset.cleanCartUpsellCompletionDisabled = String(control.disabled);
          control.disabled = true;
        });
      }
      syncCleanCartUpsellContinueLabel(action.closest('[data-clean-cart-upsell-drawer]'));
    };

    const renderCleanCartUpsellLockedAction = (action, { title, variantId }) => {
      if (!action || !variantId) return;
      const renderState = `locked|${variantId}|${title}`;
      if (action.dataset.cleanCartUpsellRenderState === renderState) return;

      action.dataset.cleanCartUpsellRenderState = renderState;
      action.dataset.cleanCartUpsellTitle = title;
      action.dataset.cleanCartUpsellVariantId = String(variantId);
      action.removeAttribute('aria-busy');
      action.innerHTML = `
        <button
          class="clean-cart-upsell-card__add"
          type="button"
          data-clean-cart-upsell-state="confirming"
          aria-label="Confirming whether ${escapeCleanCartHtml(title)} is already in your cart"
          disabled
        >
          CONFIRMING…
        </button>
      `;
    };

    const renderCleanCartUpsellActionError = (action, message, variantId) => {
      if (!action || !message) return null;
      const errorId = `clean-cart-upsell-error-${String(variantId || 'item').replace(/[^a-z0-9_-]/gi, '-')}`;
      action.dataset.cleanCartUpsellActionError = 'true';
      action.insertAdjacentHTML(
        'beforeend',
        `<p class="clean-cart-upsell-card__action-error" id="${errorId}" role="alert" tabindex="-1">${escapeCleanCartHtml(
          message,
        )}</p>`,
      );
      action.querySelectorAll('button').forEach((control) => control.setAttribute('aria-describedby', errorId));
      return action.querySelector(`#${errorId}`);
    };

    const syncCleanCartUpsellCardAction = (drawer, card, cart, index = getCleanCartUpsellIndex(drawer, cart)) => {
      const action = card?.querySelector('[data-clean-cart-upsell-action]');
      if (
        !action ||
        action.getAttribute('aria-busy') === 'true' ||
        action.dataset.cleanCartUpsellActionError === 'true'
      ) {
        return;
      }

      const addButton = action.querySelector('[data-clean-cart-upsell-add]');
      const variantId = String(
        action.dataset.cleanCartUpsellVariantId || addButton?.dataset.cleanCartUpsellVariantId || '',
      ).trim();
      const title = action.dataset.cleanCartUpsellTitle || addButton?.dataset.cleanCartUpsellTitle || 'add-on';
      if (!variantId) return;

      if (drawer?.dataset.cleanCartUpsellInteractionLocked === 'true') {
        renderCleanCartUpsellLockedAction(action, { title, variantId });
        return;
      }

      const item = getCleanCartUpsellItemForVariant(cart, variantId, drawer, index);

      if (item) {
        renderCleanCartUpsellQuantityAction(action, {
          itemKey: item.key,
          quantity: item.quantity,
          title,
          variantId,
        });
      } else {
        renderCleanCartUpsellAddAction(action, { title, variantId });
      }
    };

    const syncCleanCartUpsellActions = (drawer, cart) => {
      const content = drawer?.querySelector('[data-clean-cart-upsell-content]');
      if (!content) return;
      drawer.cleanCartUpsellCart = cart;

      if (drawer.hidden) {
        drawer.dataset.cleanCartUpsellSyncDirty = 'true';
        return;
      }

      const index = getCleanCartUpsellIndex(drawer, cart);
      content
        .querySelectorAll('[data-clean-cart-upsell-product]')
        .forEach((card) => syncCleanCartUpsellCardAction(drawer, card, cart, index));

      drawer.dataset.cleanCartUpsellSyncDirty = 'false';
      syncCleanCartUpsellContinueLabel(drawer);
    };

    const changeCleanCartUpsellQuantity = async (drawer, action, quantity) => {
      if (!drawer || !action || action.getAttribute('aria-busy') === 'true') return;

      const cartDrawer = getCleanCartDrawer();
      const itemKey = String(action.dataset.cleanCartUpsellItemKey || '').trim();
      const variantId = String(action.dataset.cleanCartUpsellVariantId || '').trim();
      const title = action.dataset.cleanCartUpsellTitle || 'add-on';
      const nextQuantity = cleanClampCartQuantity(quantity);
      if (!cartDrawer || !itemKey || !variantId) return;

      action.setAttribute('aria-busy', 'true');
      action.removeAttribute('data-clean-cart-upsell-action-error');
      action.removeAttribute('title');
      action.querySelectorAll('button').forEach((control) => {
        control.disabled = true;
      });

      try {
        const cart = await changeCleanCartItem(cartDrawer, itemKey, nextQuantity, {
          cascadeDependentAddOns: false,
        });
        const item = getCleanCartUpsellItemForVariant(cart, variantId, drawer);

        if (item) {
          renderCleanCartUpsellQuantityAction(action, {
            itemKey: item.key,
            quantity: item.quantity,
            title,
            variantId,
          });
        } else {
          renderCleanCartUpsellAddAction(action, { title, variantId });
        }
      } catch (error) {
        const currentQuantity = cleanClampCartQuantity(action.dataset.cleanCartUpsellQuantity) || 1;
        const message = getCleanCartPublicErrorMessage(error, 'Unable to update this add-on.');

        renderCleanCartUpsellQuantityAction(action, {
          itemKey,
          quantity: currentQuantity,
          title,
          variantId,
        });
        renderCleanCartUpsellActionError(action, message, variantId)?.focus({ preventScroll: true });
        throw error;
      }
    };

    const addCleanCartUpsellProduct = async (drawer, button) => {
      const variantId = String(button?.dataset.cleanCartUpsellVariantId || '').trim();
      if (!drawer || !button || !variantId || button.disabled) return;

      const cartDrawer = getCleanCartDrawer();
      const action = button.closest('[data-clean-cart-upsell-action]');
      if (!action) return;

      const title = button.dataset.cleanCartUpsellTitle || 'add-on';
      const parentProductId = String(drawer.dataset.cleanCartUpsellParentProductId || '').trim();
      const parentVariantId = String(drawer.dataset.cleanCartUpsellParentVariantId || '').trim();
      const properties = {};
      if (parentProductId) properties[cleanCartAddOnParentProductProperty] = parentProductId;
      if (parentVariantId) properties[cleanCartAddOnParentVariantProperty] = parentVariantId;
      let addedItem = null;
      let added = false;
      button.disabled = true;
      button.dataset.cleanCartUpsellState = 'loading';
      button.textContent = 'ADDING…';
      button.setAttribute('aria-label', `Adding ${title}`);
      button.removeAttribute('title');

      try {
        if (!cartDrawer) throw new Error('Cart drawer is not available.');

        const response = await cleanCartRequest(
          cleanCartAjaxUrl(getCleanCartUrl(cartDrawer, 'cleanCartAddUrl', '/cart/add'), '/cart/add'),
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties,
            }),
          },
        );

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(getCleanCartPublicErrorMessage(error, 'Unable to add this add-on.'));
        }

        added = true;
        addedItem = await response.json();
        const item = {
          ...addedItem,
          id: addedItem?.id || variantId,
          variant_id: addedItem?.variant_id || addedItem?.id || variantId,
          quantity: addedItem?.quantity || 1,
          title: addedItem?.title || title,
          properties: {
            ...properties,
            ...(addedItem?.properties || {}),
          },
        };
        action.cleanCartUpsellItem = item;
        const optimisticCart = drawer.cleanCartUpsellCart;
        if (optimisticCart && Array.isArray(optimisticCart.items)) {
          const items = optimisticCart.items.slice();
          const existingIndex = items.findIndex(
            (cartItem) =>
              (item.key && String(cartItem?.key || '') === String(item.key)) ||
              Boolean(getCleanCartUpsellItemForVariant({ items: [cartItem] }, variantId, drawer)),
          );
          if (existingIndex >= 0) {
            items[existingIndex] = item;
          } else {
            items.push(item);
          }
          drawer.cleanCartUpsellCart = {
            ...optimisticCart,
            item_count: Math.max(0, Number(optimisticCart.item_count || 0)) + (existingIndex >= 0 ? 0 : item.quantity),
            items,
          };
        }

        renderCleanCartUpsellQuantityAction(action, {
          itemKey: item.key,
          quantity: item.quantity,
          title,
          variantId,
        });
        reconcileCleanCartUpsell(drawer);
      } catch (error) {
        const message = getCleanCartPublicErrorMessage(error, 'Unable to add this add-on.');

        if (added) {
          renderCleanCartUpsellQuantityAction(action, {
            itemKey: addedItem?.key,
            quantity: addedItem?.quantity || 1,
            title,
            variantId,
          });
          setCleanCartUpsellReconciliationStatus(
            drawer,
            'The add-on was added. We’re confirming the updated cart in the background.',
          );
          reconcileCleanCartUpsell(drawer);
        } else {
          renderCleanCartUpsellAddAction(action, { title, variantId, errorMessage: message });
          action.querySelector('[role="alert"]')?.focus({ preventScroll: true });
          throw error;
        }
      }
    };

    const getCleanCartUpsellRetryState = (drawer) => {
      if (!cleanCartUpsellRetryStates.has(drawer)) {
        cleanCartUpsellRetryStates.set(drawer, {
          attempt: 0,
          handles: new Set(),
          groupRetryPromise: null,
          requestController: null,
          running: false,
          timer: 0,
        });
      }

      return cleanCartUpsellRetryStates.get(drawer);
    };

    const pauseCleanCartUpsellRetries = (drawer) => {
      const retryState = cleanCartUpsellRetryStates.get(drawer);
      if (!retryState?.timer) return;

      window.clearTimeout(retryState.timer);
      retryState.timer = 0;
    };

    const setCleanCartUpsellCatalogStatus = (drawer, message = '', { retry = false } = {}) => {
      const status = drawer?.querySelector('[data-clean-cart-upsell-catalog-status]');
      const text = status?.querySelector('[data-clean-cart-upsell-catalog-status-text]');
      const retryButton = status?.querySelector('[data-clean-cart-upsell-catalog-retry]');
      if (!status || !text || !retryButton) return;

      text.textContent = message;
      retryButton.hidden = !retry;
      retryButton.disabled = false;
      status.hidden = !message;
    };

    const updateCleanCartUpsellLoadedState = (drawer) => {
      const content = drawer?.querySelector('[data-clean-cart-upsell-content]');
      const retryState = drawer ? getCleanCartUpsellRetryState(drawer) : null;
      if (!content || !retryState) return;

      const hasPermanentErrors = Boolean(content.querySelector('.clean-cart-upsell-card__load-error'));
      const hasErrors = retryState.handles.size > 0 || hasPermanentErrors;
      content.dataset.cleanCartUpsellCatalogLoaded = String(!hasErrors);
      setCleanCartUpsellCatalogStatus(
        drawer,
        hasErrors ? 'Some add-ons couldn’t load. You can retry or continue without them.' : '',
        { retry: hasErrors },
      );
    };

    const retryAllCleanCartUpsellProducts = (drawer) => {
      const content = drawer?.querySelector('[data-clean-cart-upsell-content]');
      if (!content) return;

      const retryState = getCleanCartUpsellRetryState(drawer);
      if (retryState.groupRetryPromise) return retryState.groupRetryPromise;
      pauseCleanCartUpsellRetries(drawer);
      retryState.requestController?.abort();
      retryState.requestController = new AbortController();
      retryState.attempt = 0;

      const group = String(drawer.dataset.cleanCartUpsellProductGroup || '');
      let groupRetry;
      try {
        groupRetry = window.GiftechWinniAddOnsBridge?.retry?.(group);
      } catch (error) {
        groupRetry = Promise.reject(error);
      }
      const groupRetryPromise = Promise.resolve(groupRetry);
      retryState.groupRetryPromise = groupRetryPromise;
      const clearGroupRetry = () => {
        if (retryState.groupRetryPromise === groupRetryPromise) retryState.groupRetryPromise = null;
      };
      groupRetryPromise.then(clearGroupRetry, clearGroupRetry);

      content.querySelectorAll('[data-clean-cart-upsell-product]').forEach((card) => {
        const handle = String(card.dataset.cleanCartUpsellProduct || '');
        if (!handle) return;
        if (!card.querySelector('.clean-cart-upsell-card__load-error') && !retryState.handles.has(handle)) return;
        cleanCartProductCache.delete(handle);
        cleanCartProductFailures.delete(handle);
        retryState.handles.add(handle);
        setCleanCartUpsellProductLoading(card, { retrying: true });
      });

      setCleanCartUpsellCatalogStatus(drawer, 'Retrying add-ons…');
      scheduleCleanCartUpsellRetries(drawer, { immediate: true });
      return groupRetryPromise;
    };

    const retryCleanCartUpsellProducts = async (drawer) => {
      const content = drawer?.querySelector('[data-clean-cart-upsell-content]');
      const retryState = drawer ? getCleanCartUpsellRetryState(drawer) : null;
      if (!content || !retryState || retryState.running || retryState.handles.size === 0) return;
      if (
        drawer.hidden ||
        content.dataset.cleanCartUpsellCatalogLoading === 'true' ||
        drawer.dataset.cleanCartUpsellRetriesPaused === 'true' ||
        document.visibilityState === 'hidden' ||
        navigator.onLine === false
      ) {
        return;
      }

      retryState.running = true;
      if (!retryState.requestController || retryState.requestController.signal.aborted) {
        retryState.requestController = new AbortController();
      }
      const { signal } = retryState.requestController;
      const handles = Array.from(retryState.handles);
      let handleIndex = 0;

      const retryNextCleanCartUpsellProduct = async () => {
        while (handleIndex < handles.length) {
          if (
            signal.aborted ||
            drawer.hidden ||
            drawer.dataset.cleanCartUpsellRetriesPaused === 'true' ||
            document.visibilityState === 'hidden'
          ) {
            return;
          }

          const handle = handles[handleIndex];
          handleIndex += 1;

          if (!retryState.handles.has(handle)) continue;

          const card = content.querySelector(`[data-clean-cart-upsell-product="${handle}"]`);
          setCleanCartUpsellProductLoading(card, { active: true, retrying: true });

          const product = await getCleanCartProductJson(handle, { signal });
          if (signal.aborted || drawer.hidden) return;
          if (renderCleanCartUpsellProduct(drawer, card, product)) {
            retryState.handles.delete(handle);
            continue;
          }

          if (isCleanCartProductFailureRetryable(handle)) {
            setCleanCartUpsellProductLoading(card, { retrying: true });
          } else {
            retryState.handles.delete(handle);
            renderCleanCartUpsellProductError(card);
          }
        }
      };

      try {
        await Promise.all(
          Array.from(
            { length: Math.min(cleanCartUpsellRetryConcurrency, handles.length) },
            retryNextCleanCartUpsellProduct,
          ),
        );
      } catch {
        // Leave unresolved handles queued for the next backed-off attempt.
      }

      retryState.running = false;
      retryState.attempt += 1;
      updateCleanCartUpsellLoadedState(drawer);

      if (retryState.handles.size > 0) {
        scheduleCleanCartUpsellRetries(drawer);
      }
    };

    const scheduleCleanCartUpsellRetries = (drawer, { immediate = false } = {}) => {
      const retryState = drawer ? getCleanCartUpsellRetryState(drawer) : null;
      if (!retryState || retryState.running || retryState.handles.size === 0) return;
      const content = drawer?.querySelector('[data-clean-cart-upsell-content]');
      if (
        drawer.hidden ||
        content?.dataset.cleanCartUpsellCatalogLoading === 'true' ||
        drawer.dataset.cleanCartUpsellRetriesPaused === 'true' ||
        document.visibilityState === 'hidden' ||
        navigator.onLine === false
      ) {
        return;
      }

      if (retryState.timer) {
        if (!immediate) return;
        window.clearTimeout(retryState.timer);
      }

      const exponentialDelay = Math.min(
        cleanCartUpsellRetryMaxDelay,
        cleanCartUpsellRetryBaseDelay * 2 ** Math.min(retryState.attempt, 5),
      );
      const delay = immediate ? 0 : exponentialDelay + Math.floor(Math.random() * 250);

      retryState.timer = window.setTimeout(() => {
        retryState.timer = 0;
        retryCleanCartUpsellProducts(drawer);
      }, delay);
    };

    const loadCleanCartUpsellCatalog = async (drawer) => {
      const content = drawer?.querySelector('[data-clean-cart-upsell-content]');
      if (!content || drawer.hidden || content.dataset.cleanCartUpsellCatalogLoading === 'true') return;
      if (content.dataset.cleanCartUpsellCatalogLoaded === 'true') return;

      const retryState = getCleanCartUpsellRetryState(drawer);
      if (retryState.handles.size > 0 && content.dataset.cleanCartUpsellCatalogInitialComplete === 'true') {
        scheduleCleanCartUpsellRetries(drawer, { immediate: true });
        return;
      }

      if (!retryState.requestController || retryState.requestController.signal.aborted) {
        retryState.requestController = new AbortController();
      }
      const { signal } = retryState.requestController;
      content.dataset.cleanCartUpsellCatalogLoading = 'true';
      content.dataset.cleanCartUpsellCatalogInitialComplete = 'false';
      content.setAttribute('aria-busy', 'true');
      setCleanCartUpsellCatalogStatus(drawer, 'Loading add-ons…');
      retryState.attempt = 0;

      const cards = new Map(
        Array.from(content.querySelectorAll('[data-clean-cart-upsell-product]')).map((card) => [
          card.dataset.cleanCartUpsellProduct,
          card,
        ]),
      );
      const products = getCleanCartUpsellCatalog(drawer).flatMap((group) => group.products);
      let productIndex = 0;

      const loadNextCleanCartUpsellProduct = async () => {
        while (productIndex < products.length) {
          if (
            signal.aborted ||
            drawer.hidden ||
            drawer.dataset.cleanCartUpsellRetriesPaused === 'true' ||
            document.visibilityState === 'hidden'
          ) {
            return;
          }

          const { handle } = products[productIndex];
          productIndex += 1;

          const card = cards.get(handle);
          setCleanCartUpsellProductLoading(card, { active: true });
          const product = await getCleanCartProductJson(handle, {
            retries: cleanCartUpsellProductRetries,
            signal,
          });
          if (signal.aborted || drawer.hidden) {
            setCleanCartUpsellProductLoading(card);
            return;
          }
          if (renderCleanCartUpsellProduct(drawer, card, product)) continue;

          if (isCleanCartProductFailureRetryable(handle)) {
            retryState.handles.add(handle);
            setCleanCartUpsellProductLoading(card, { retrying: true });
          } else {
            renderCleanCartUpsellProductError(card);
          }
        }
      };

      await Promise.all(
        Array.from(
          { length: Math.min(cleanCartUpsellProductConcurrency, products.length) },
          loadNextCleanCartUpsellProduct,
        ),
      );

      content.dataset.cleanCartUpsellCatalogLoading = 'false';
      if (!signal.aborted) content.dataset.cleanCartUpsellCatalogInitialComplete = 'true';
      content.setAttribute('aria-busy', 'false');
      updateCleanCartUpsellLoadedState(drawer);

      if (retryState.handles.size > 0) {
        scheduleCleanCartUpsellRetries(drawer);
      }
    };

    const hydrateCleanCartComparePrices = async (drawer, cart, renderId) => {
      const items = cart?.items || [];
      const compareLinePrices = new Map();
      if (!drawer || !items.length) return;

      if (drawer.hidden || !drawer.classList.contains('clean-cart-drawer--open')) {
        cleanCartPendingCompareHydrations.set(drawer, { cart, renderId });
        return;
      }

      cleanCartPendingCompareHydrations.delete(drawer);

      const itemNodes = new Map(
        Array.from(drawer.querySelectorAll('[data-clean-cart-item]')).map((element) => [
          String(element.dataset.cleanCartItem || ''),
          element,
        ]),
      );
      const itemsByHandle = new Map();

      items.forEach((item) => {
        const itemKey = getCleanCartItemKey(item);
        if (isCleanCartBulkEligible(item)) return getCleanCartCompareLinePrice(item);
        const directCompareLinePrice = getCleanCartCompareAtLinePrice(item);
        if (directCompareLinePrice) compareLinePrices.set(itemKey, directCompareLinePrice);
        if (hasCleanCartDirectCompareAtPrice(item) || !item?.handle) return;

        const handle = String(item.handle);
        if (!itemsByHandle.has(handle)) itemsByHandle.set(handle, []);
        itemsByHandle.get(handle).push(item);
      });

      const handleEntries = Array.from(itemsByHandle.entries());
      let handleIndex = 0;
      let didHydrateComparePrice = false;

      const hydrateNextHandle = async () => {
        while (handleIndex < handleEntries.length) {
          if (
            drawer.hidden ||
            !drawer.classList.contains('clean-cart-drawer--open') ||
            drawer.dataset.cleanCartRenderId !== renderId
          ) {
            cleanCartPendingCompareHydrations.set(drawer, { cart, renderId });
            return;
          }

          const [handle, handleItems] = handleEntries[handleIndex];
          handleIndex += 1;
          const product = await getCleanCartProductJson(handle);
          const variants = new Map((product?.variants || []).map((variant) => [String(variant?.id || ''), variant]));

          if (
            drawer.hidden ||
            !drawer.classList.contains('clean-cart-drawer--open') ||
            drawer.dataset.cleanCartRenderId !== renderId
          ) {
            cleanCartPendingCompareHydrations.set(drawer, { cart, renderId });
            return;
          }

          handleItems.forEach((item) => {
            const itemKey = getCleanCartItemKey(item);
            const variant = variants.get(String(item?.variant_id || item?.id || ''));
            const compareLinePrice = getCleanCartCompareAtLinePrice(
              item,
              cleanNormalizeCartPrice(variant?.compare_at_price),
            );
            if (!compareLinePrice) return;

            compareLinePrices.set(itemKey, compareLinePrice);
            const priceBlock = itemNodes.get(String(item.key || ''))?.querySelector('[data-clean-cart-price-block]');
            const nextPriceHtml = renderCleanCartPriceHtml(item, drawer, compareLinePrice);

            if (priceBlock && priceBlock.innerHTML !== nextPriceHtml) {
              priceBlock.innerHTML = nextPriceHtml;
            }

            didHydrateComparePrice = true;
          });
        }
      };

      await Promise.all(
        Array.from({ length: Math.min(cleanCartCompareHydrationConcurrency, handleEntries.length) }, hydrateNextHandle),
      );

      if (didHydrateComparePrice && drawer.dataset.cleanCartRenderId === renderId && !drawer.hidden) {
        renderCleanCartTotals(drawer, cart, compareLinePrices);
      }
    };

    const resumeCleanCartCompareHydration = (drawer) => {
      const pending = cleanCartPendingCompareHydrations.get(drawer);
      if (!pending || drawer?.dataset.cleanCartRenderId !== pending.renderId) return;
      hydrateCleanCartComparePrices(drawer, pending.cart, pending.renderId).catch(() => {});
    };

    window.CleanGokwik =
      window.CleanGokwik ||
      (() => {
        const state = {
          countryPromise: null,
          scriptPromise: null,
          loaded: false,
        };

        const readDetectedCountry = async () => {
          if (state.countryPromise) return state.countryPromise;

          state.countryPromise = (async () => {
            try {
              const cachedCountry = sessionStorage.getItem('cleanGokwikCountry');
              if (cachedCountry) return cachedCountry;

              const response = await fetch('/browsing_context_suggestions.json', {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
              });
              if (!response.ok) return '';

              const data = await response.json();
              const detected = data?.detected_values || {};
              const country =
                detected.country_code ||
                detected.country?.iso_code ||
                detected.country?.handle ||
                (detected.country_name === 'India' ? 'IN' : detected.country_name || '');
              const normalizedCountry = String(country || '').toUpperCase();

              sessionStorage.setItem('cleanGokwikCountry', normalizedCountry);
              return normalizedCountry;
            } catch (error) {
              return '';
            }
          })();

          return state.countryPromise;
        };

        const scriptHostForEnv = (environment) => {
          const normalizedEnvironment = environment || 'production';
          if (normalizedEnvironment === 'production') return 'pdp.gokwik.co';
          if (normalizedEnvironment === 'sandbox') return 'sandbox.pdp.gokwik.co';
          return 'qa.pdp.gokwik.co';
        };

        const loadSdk = (scope) => {
          if (typeof window.onCheckoutClick === 'function') {
            state.loaded = true;
            return Promise.resolve();
          }
          if (state.loaded) return Promise.resolve();
          if (state.scriptPromise) return state.scriptPromise;

          window.merchantInfo = {
            mid: scope.dataset.cleanGokwikMid || '',
            environment: scope.dataset.cleanGokwikEnv || 'production',
            type: 'merchantInfo',
            storeId: scope.dataset.cleanGokwikStoreId || '',
            fbpixel: scope.dataset.cleanGokwikFbpixel || '',
          };
          window.productFormSelector = window.productFormSelector || '';
          window.templateName = window.templateName || 'product';

          state.scriptPromise = new Promise((resolve, reject) => {
            let isSettled = false;
            const existingScript = document.querySelector(
              '[data-clean-gokwik-sdk], script[src*="merchant-integration/build/merchant.integration.js"]',
            );
            let readyTimer = null;
            let readyTimeout = null;
            const finish = () => {
              if (isSettled || typeof window.onCheckoutClick !== 'function') return;
              isSettled = true;
              window.clearInterval(readyTimer);
              window.clearTimeout(readyTimeout);
              document.removeEventListener('gokwikLoaded', finish);
              window.removeEventListener('gokwikLoaded', finish);
              state.loaded = true;
              resolve();
            };
            const fail = () => {
              if (isSettled) return;
              isSettled = true;
              window.clearInterval(readyTimer);
              document.removeEventListener('gokwikLoaded', finish);
              window.removeEventListener('gokwikLoaded', finish);
              state.scriptPromise = null;
              reject(new Error('GoKwik checkout is not ready yet.'));
            };

            document.addEventListener('gokwikLoaded', finish);
            window.addEventListener('gokwikLoaded', finish);
            readyTimer = window.setInterval(finish, 100);
            readyTimeout = window.setTimeout(fail, 8000);

            if (existingScript) {
              finish();
              return;
            }

            const script = document.createElement('script');
            script.src = `https://${scriptHostForEnv(scope.dataset.cleanGokwikEnv)}/merchant-integration/build/merchant.integration.js?v4`;
            script.defer = true;
            script.dataset.cleanGokwikSdk = 'true';
            script.onload = () => {
              window.setTimeout(() => {
                if (window.onCheckoutClick) finish();
              }, 0);
            };
            script.onerror = () => {
              if (isSettled) return;
              isSettled = true;
              window.clearInterval(readyTimer);
              window.clearTimeout(readyTimeout);
              document.removeEventListener('gokwikLoaded', finish);
              window.removeEventListener('gokwikLoaded', finish);
              state.scriptPromise = null;
              reject(new Error('Unable to load GoKwik checkout.'));
            };
            document.head.appendChild(script);
          });

          return state.scriptPromise;
        };

        const setScopeVisibility = (scope, useGokwik) => {
          const gokwikButton = scope.querySelector('[data-clean-gokwik-checkout]');
          const shopifyCheckout = scope.querySelector('[data-clean-shopify-checkout]');

          if (shopifyCheckout) shopifyCheckout.hidden = useGokwik;
          if (!gokwikButton) return;

          gokwikButton.hidden = !useGokwik;
          gokwikButton.setAttribute('aria-hidden', useGokwik ? 'false' : 'true');
        };

        const getScopeCountry = (scope) => String(scope?.dataset.cleanGokwikCountry || '').toUpperCase();

        const isGokwikCountry = (country) => country === 'IN' || country === 'INDIA';

        const syncScope = async (scope, { detect = false, prepare = false } = {}) => {
          if (!scope || scope.dataset.cleanGokwikEnabled !== 'true') return false;

          const selectedCountry = getScopeCountry(scope);
          const detectedCountry = detect ? await readDetectedCountry() : '';
          const useGokwik = isGokwikCountry(selectedCountry) && (!detect || isGokwikCountry(detectedCountry));

          setScopeVisibility(scope, useGokwik);
          if (useGokwik && prepare) loadSdk(scope).catch(() => {});

          return useGokwik;
        };

        const checkout = async (button, scope) => {
          if (!scope || scope.dataset.cleanGokwikEnabled !== 'true') {
            throw new Error('GoKwik checkout is not available.');
          }

          const useGokwik = await syncScope(scope, { detect: true });

          if (!useGokwik) {
            const shopifyCheckout = scope.querySelector('[data-clean-shopify-checkout]');
            const checkoutUrl = shopifyCheckout?.getAttribute('href');
            if (checkoutUrl) window.location.assign(checkoutUrl);
            return;
          }

          await loadSdk(scope);

          if (typeof window.onCheckoutClick !== 'function') {
            throw new Error('GoKwik checkout is not ready yet.');
          }

          window.onCheckoutClick(button);
        };

        return { checkout, syncScope };
      })();

    const getCleanCartDrawer = () => document.querySelector('[data-clean-cart-drawer]');

    const getCleanCartUpsellApi = () => window.CleanCartUpsell || null;

    const waitForCleanCartUpsellApi = () => {
      if (!cleanCartUpsellEnabled) return Promise.resolve(null);

      initCleanCartUpsellDrawer();

      const readyApi = getCleanCartUpsellApi();
      if (readyApi?.open) return Promise.resolve(readyApi);

      if (!getCleanCartUpsellDrawer()) return Promise.resolve(null);

      return new Promise((resolve) => {
        let settled = false;

        const finish = (api = getCleanCartUpsellApi()) => {
          if (settled) return;
          settled = true;
          window.clearTimeout(timeout);
          document.removeEventListener('clean:cart-upsell:ready', handleReady);
          resolve(api?.open ? api : null);
        };

        const handleReady = (event) => finish(event.detail?.upsell);
        const timeout = window.setTimeout(() => finish(), 900);

        document.addEventListener('clean:cart-upsell:ready', handleReady);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanCartUpsellDrawer(), { once: true });
    } else {
      initCleanCartUpsellDrawer();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanCartUpsellDrawer(event.target));

    const getCleanCartUrl = (drawer, key, fallback) => drawer?.dataset[key] || fallback;

    const getCleanCartJsonUrl = (drawer) => {
      const cartUrl = getCleanCartUrl(drawer, 'cleanCartUrl', '/cart');
      return cleanCartAjaxUrl(cartUrl, '/cart');
    };

    const setCleanCartStatus = (drawer, message = '') => {
      const status = drawer?.querySelector('[data-clean-cart-drawer-status]');
      if (!status) return;

      status.textContent = message;
      status.hidden = !message;
    };

    const setCleanCartInputValue = (input, value = '') => {
      if (!input || document.activeElement === input) return;
      input.value = value || '';
    };

    const getCleanCartGiftWrapVariantId = (drawer) => String(drawer?.dataset.cleanCartGiftWrapVariantId || '').trim();

    const isCleanCartGiftWrapItem = (item, variantId) => {
      const giftWrapVariantId = String(variantId || '').trim();
      if (!giftWrapVariantId) return false;

      return String(item?.id || '') === giftWrapVariantId || String(item?.variant_id || '') === giftWrapVariantId;
    };

    const hasCleanCartGiftWrapItem = (cart, variantId) => {
      const giftWrapVariantId = String(variantId || '').trim();
      if (!giftWrapVariantId) return false;

      return (cart?.items || []).some((item) => isCleanCartGiftWrapItem(item, giftWrapVariantId));
    };

    const syncCleanCartToolCount = (drawer) => {
      const tools = drawer?.querySelector('[data-clean-cart-tools]');
      if (!tools) return;

      const visibleToolCount = [...tools.querySelectorAll('[data-clean-cart-tool-trigger]')].filter(
        (button) => !button.hidden,
      ).length;
      tools.dataset.cleanCartToolsCount = String(Math.max(visibleToolCount, 1));
    };

    const syncCleanCartGiftWrapTool = (drawer, cart) => {
      const giftWrapVariantId = getCleanCartGiftWrapVariantId(drawer);
      const giftWrapTool = drawer?.querySelector('[data-clean-cart-gift-wrap-tool]');
      const giftWrapPanel = drawer?.querySelector('[data-clean-cart-tool-panel="gift-wrap"]');
      const hasGiftWrap = hasCleanCartGiftWrapItem(cart, giftWrapVariantId);
      const shouldShowGiftWrap = Boolean(giftWrapVariantId);

      if (giftWrapTool) {
        giftWrapTool.hidden = !shouldShowGiftWrap;
        giftWrapTool.disabled = hasGiftWrap;
        giftWrapTool.setAttribute('aria-disabled', String(hasGiftWrap));
        if (!shouldShowGiftWrap || hasGiftWrap) giftWrapTool.setAttribute('aria-expanded', 'false');
      }

      if ((!shouldShowGiftWrap || hasGiftWrap) && giftWrapPanel) {
        giftWrapPanel.hidden = true;
      }

      if (!drawer?.querySelector('[data-clean-cart-tool-panel]:not([hidden])')) {
        drawer?.classList.remove('clean-cart-drawer--tool-open');
      }

      syncCleanCartToolCount(drawer);
    };

    const syncCleanCartToolFields = (drawer, cart) => {
      if (!drawer || !cart) return;

      const attributes = cart.attributes || {};

      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-note-input]'), cart.note || '');
      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-card-to]'), attributes.To || '');
      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-card-from]'), attributes.From || '');
      setCleanCartInputValue(drawer.querySelector('[data-clean-cart-card-message]'), attributes.Message || '');
      syncCleanCartGiftWrapTool(drawer, cart);
    };

    const closeCleanCartToolPanel = (drawer = getCleanCartDrawer()) => {
      if (!drawer) return;

      drawer.classList.remove('clean-cart-drawer--tool-open');
      drawer.querySelectorAll('[data-clean-cart-tool-trigger]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
      drawer.querySelectorAll('[data-clean-cart-tool-panel]').forEach((panel) => {
        panel.hidden = true;
      });
    };

    const openCleanCartToolPanel = (drawer, toolName) => {
      if (!drawer || !toolName) return;

      drawer.classList.add('clean-cart-drawer--tool-open');
      drawer.querySelectorAll('[data-clean-cart-tool-trigger]').forEach((button) => {
        button.setAttribute('aria-expanded', String(button.dataset.cleanCartToolTrigger === toolName));
      });
      drawer.querySelectorAll('[data-clean-cart-tool-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.cleanCartToolPanel !== toolName;
      });

      const panel = drawer.querySelector(`[data-clean-cart-tool-panel="${toolName}"]`);
      const firstField = panel?.querySelector('textarea, button');
      const fieldScroller = panel?.querySelector('.clean-cart-drawer__tool-fields');

      if (panel) panel.scrollTop = 0;
      if (fieldScroller) fieldScroller.scrollTop = 0;
      firstField?.focus({ preventScroll: true });
    };

    const updateCleanCartDetails = async (drawer, entries = {}) => {
      const body = new FormData();

      Object.entries(entries).forEach(([name, value]) => {
        body.append(name, value || '');
      });

      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartUpdateUrl', '/cart/update'), '/cart/update'),
        {
          method: 'POST',
          body,
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to save cart details.');
      }

      const cart = await response.json();
      renderCleanCartItems(drawer, cart);
      broadcastCleanCart(cart);
      return cart;
    };

    const addCleanCartGiftWrap = async (drawer) => {
      const giftWrapVariantId = getCleanCartGiftWrapVariantId(drawer);

      if (!giftWrapVariantId) {
        throw new Error('Gift wrap is not available.');
      }

      if (hasCleanCartGiftWrapItem(window.cart, giftWrapVariantId)) {
        return refreshCleanCartDrawer(drawer);
      }

      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartAddUrl', '/cart/add'), '/cart/add'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftWrapVariantId,
            quantity: 1,
          }),
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to add gift wrap.');
      }

      return refreshCleanCartDrawer(drawer);
    };

    const saveCleanCartToolPanel = async (drawer, toolName, saveButton) => {
      if (!drawer || !toolName || !saveButton) return;

      const originalLabel = saveButton.textContent.trim();
      saveButton.disabled = true;
      saveButton.textContent = 'Saving...';
      setCleanCartStatus(drawer);

      try {
        if (toolName === 'instructions') {
          await updateCleanCartDetails(drawer, {
            note: drawer.querySelector('[data-clean-cart-note-input]')?.value || '',
          });
        }

        if (toolName === 'gift-wrap') {
          await addCleanCartGiftWrap(drawer);
        }

        if (toolName === 'card') {
          await updateCleanCartDetails(drawer, {
            'attributes[To]': drawer.querySelector('[data-clean-cart-card-to]')?.value || '',
            'attributes[From]': drawer.querySelector('[data-clean-cart-card-from]')?.value || '',
            'attributes[Message]': drawer.querySelector('[data-clean-cart-card-message]')?.value || '',
          });
        }

        closeCleanCartToolPanel(drawer);
      } catch (error) {
        setCleanCartStatus(drawer, error?.message || 'Unable to save cart details.');
      } finally {
        saveButton.disabled = false;
        saveButton.textContent = originalLabel;
      }
    };

    const updateCleanCartCountTargets = (itemCount) => {
      document.querySelectorAll('[data-clean-cart-count]').forEach((target) => {
        target.textContent = String(itemCount);
      });
    };

    const cleanCartNameOnCakePropertyName = 'Name On Cake';
    const cleanCartNameOnCakePropertyHandle = cleanCartNameOnCakePropertyName.toLowerCase();

    const cleanCartPropertyStringValue = (value) => (Array.isArray(value) ? value.join(', ') : String(value ?? ''));

    const isCleanCartPreviewProperty = (name) =>
      String(name || '')
        .trim()
        .toLowerCase()
        .startsWith('preview.');

    const isCleanCartNameOnCakeProperty = (name) =>
      String(name || '')
        .trim()
        .toLowerCase() === cleanCartNameOnCakePropertyHandle;

    const getCleanCartItemByKey = (key) =>
      (window.cart?.items || []).find((item) => String(item?.key || '') === String(key || ''));

    const getCleanCartPreviewUrls = (value) => {
      const values = Array.isArray(value) ? value : [value];
      const urls = [];

      values.forEach((item) => {
        const matches = String(item ?? '').match(/https?:\/\/[^\s,]+/gi) || [];

        matches.forEach((match) => {
          const candidate = match.replace(/^[('"[]+|[)'"\]]+$/g, '');

          try {
            const url = new URL(candidate);
            if ((url.protocol === 'http:' || url.protocol === 'https:') && !urls.includes(url.href)) {
              urls.push(url.href);
            }
          } catch (error) {
            // Ignore malformed preview URLs and fall back to the raw property value below.
          }
        });
      });

      return urls;
    };

    const renderCleanCartPropertyValue = (name, value) => {
      const normalizedName = String(name || '')
        .trim()
        .toLowerCase();
      const previewUrls = isCleanCartPreviewProperty(name) ? getCleanCartPreviewUrls(value) : [];

      if (normalizedName === 'preview.images' && previewUrls.length) {
        return previewUrls
          .map(
            (previewUrl, index) =>
              `<a class="clean-cart-drawer__meta-link" href="${escapeCleanCartHtml(
                previewUrl,
              )}" target="_blank" rel="noopener noreferrer">Image ${index + 1}</a>`,
          )
          .join(', ');
      }

      if (previewUrls.length) {
        return `<a class="clean-cart-drawer__meta-link" href="${escapeCleanCartHtml(
          previewUrls[0],
        )}" target="_blank" rel="noopener noreferrer">View Preview</a>`;
      }

      return escapeCleanCartHtml(cleanCartPropertyStringValue(value));
    };

    const renderCleanCartPropertyLabel = (name) => {
      const normalizedName = String(name || '')
        .trim()
        .toLowerCase();
      if (normalizedName === 'preview.effects') return '';
      if (normalizedName === 'preview.texts') return 'Text';
      if (normalizedName === 'preview.images') return 'Photos';
      return name;
    };

    const isCleanCartZipcodeProperty = (name) =>
      ['pincode', 'delivery tier', 'delivery estimate', 'delivery speed'].includes(
        String(name || '')
          .trim()
          .toLowerCase(),
      );

    const renderCleanCartVariantOptions = (item = {}) => {
      const options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
      const visibleOptions = options.filter((option) => {
        const name = String(option?.name || '').trim();
        const value = String(option?.value || '').trim();
        return name && value && value !== 'Default Title';
      });

      if (visibleOptions.length) {
        return `
          <dl class="clean-cart-drawer__meta clean-cart-drawer__meta--variants">
            ${visibleOptions
              .map(
                (option) => `
                  <div class="clean-cart-drawer__meta-row">
                    <dt>${escapeCleanCartHtml(option.name)}:</dt>
                    <dd>${escapeCleanCartHtml(option.value)}</dd>
                  </div>
                `,
              )
              .join('')}
          </dl>
        `;
      }

      const variantTitle = String(item.variant_title || '').trim();
      if (!variantTitle || variantTitle === 'Default Title') return '';

      return `
        <dl class="clean-cart-drawer__meta clean-cart-drawer__meta--variants">
          <div class="clean-cart-drawer__meta-row">
            <dt>Variant:</dt>
            <dd>${escapeCleanCartHtml(variantTitle)}</dd>
          </div>
        </dl>
      `;
    };

    const renderCleanCartNameOnCakeProperty = (value) => {
      const stringValue = cleanCartPropertyStringValue(value);
      const escapedValue = escapeCleanCartHtml(stringValue);

      return `
        <div class="clean-cart-drawer__meta-row clean-cart-drawer__meta-row--editable" data-clean-cart-name-on-cake-row>
          <dt>${escapeCleanCartHtml(cleanCartNameOnCakePropertyName)}:</dt>
          <dd>
            <span class="clean-cart-drawer__property-view" data-clean-cart-name-on-cake-view>
              <span data-clean-cart-name-on-cake-value>${escapedValue}</span>
              <button
                class="clean-cart-drawer__property-edit"
                type="button"
                aria-label="Edit name on cake"
                data-clean-cart-edit-name-on-cake
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="m4 20 4.5-1 10-10a2.1 2.1 0 0 0-3-3l-10 10L4 20Z"></path>
                  <path d="m13.5 7.5 3 3"></path>
                </svg>
              </button>
            </span>
            <span class="clean-cart-drawer__property-editor" data-clean-cart-name-on-cake-editor hidden>
              <input
                class="clean-cart-drawer__property-input"
                type="text"
                value="${escapedValue}"
                autocomplete="off"
                aria-label="Name On Cake"
                data-clean-cart-name-on-cake-input
              >
              <button
                class="clean-cart-drawer__property-action clean-cart-drawer__property-action--save"
                type="button"
                data-clean-cart-save-name-on-cake
              >
                Save
              </button>
              <button
                class="clean-cart-drawer__property-action"
                type="button"
                data-clean-cart-cancel-name-on-cake
              >
                Cancel
              </button>
            </span>
          </dd>
        </div>
      `;
    };

    const renderCleanCartProperties = (properties = {}) => {
      const entries = Object.entries(properties).filter(([name, value]) => {
        const stringValue = cleanCartPropertyStringValue(value);
        return name && !name.startsWith('_') && !isCleanCartZipcodeProperty(name) && stringValue.trim() !== '';
      });

      if (!entries.length) return '';

      const visibleEntries = entries.filter(
        ([name]) =>
          ['Delivery Date', 'Delivery Day', 'Delivery Time', 'Name On Cake'].includes(name) ||
          isCleanCartPreviewProperty(name),
      );
      const fallbackEntries = visibleEntries.length ? visibleEntries : entries.slice(0, 3);

      return `
        <dl class="clean-cart-drawer__meta">
          ${fallbackEntries
            .map(([name, value]) => {
              if (isCleanCartNameOnCakeProperty(name)) {
                return renderCleanCartNameOnCakeProperty(value);
              }

              const label = renderCleanCartPropertyLabel(name);
              return `
                <div class="clean-cart-drawer__meta-row">
                  ${label ? `<dt>${escapeCleanCartHtml(label)}:</dt>` : ''}
                  <dd>${renderCleanCartPropertyValue(name, value)}</dd>
                </div>
              `;
            })
            .join('')}
        </dl>
      `;
    };

    const isCleanCartAddOnItem = (item = {}) =>
      String(item.handle || '')
        .trim()
        .toLowerCase()
        .startsWith('winni-addon-');

    const isCleanCartLikelyLegacyAddOnParent = (item = {}) => {
      const vendor = String(item.vendor || '')
        .trim()
        .toLowerCase();
      const productType = String(item.product_type || '')
        .trim()
        .toLowerCase();
      const productTokens = `${item.product_title || item.title || ''} ${item.handle || ''}`
        .trim()
        .toLowerCase()
        .split(/[^a-z0-9]+/)
        .filter(Boolean);

      return (
        vendor === cleanCartUpsellEligibleVendor &&
        (['cake', 'cakes', 'cupcake', 'cupcakes'].includes(productType) ||
          productTokens.some((token) => ['cake', 'cakes', 'cupcake', 'cupcakes'].includes(token)))
      );
    };

    const getCleanCartDependentAddOnKeys = (cart, parentKey) => {
      const items = cart?.items || [];
      const parent = items.find((item) => String(item?.key || '') === String(parentKey || ''));
      if (!parent || isCleanCartAddOnItem(parent)) return [];

      const parentProductId = String(parent.product_id || '').trim();
      const parentVariantId = String(parent.variant_id || parent.id || '').trim();
      const addOnItems = items.filter(isCleanCartAddOnItem);
      const linkedKeys = addOnItems
        .filter((item) => {
          const properties = item?.properties || {};
          const itemParentProductId = String(properties[cleanCartAddOnParentProductProperty] || '').trim();
          const itemParentVariantId = String(properties[cleanCartAddOnParentVariantProperty] || '').trim();

          if (itemParentVariantId) return itemParentVariantId === parentVariantId;
          return Boolean(itemParentProductId && itemParentProductId === parentProductId);
        })
        .map((item) => String(item.key || '').trim())
        .filter(Boolean);

      const likelyLegacyParents = items.filter(
        (item) => !isCleanCartAddOnItem(item) && isCleanCartLikelyLegacyAddOnParent(item),
      );
      const canClaimUnlinkedAddOns =
        likelyLegacyParents.length === 1 && String(likelyLegacyParents[0]?.key || '') === String(parentKey || '');
      const legacyKeys = canClaimUnlinkedAddOns
        ? addOnItems
            .filter((item) => {
              const properties = item?.properties || {};
              return (
                !String(properties[cleanCartAddOnParentProductProperty] || '').trim() &&
                !String(properties[cleanCartAddOnParentVariantProperty] || '').trim()
              );
            })
            .map((item) => String(item.key || '').trim())
            .filter(Boolean)
        : [];

      return [...new Set([...linkedKeys, ...legacyKeys])];
    };

    const renderCleanCartItems = (drawer, cart) => {
      const itemsTarget = drawer?.querySelector('[data-clean-cart-drawer-items]');
      const countTarget = drawer?.querySelector('[data-clean-cart-drawer-count]');
      const totalTarget = drawer?.querySelector('[data-clean-cart-drawer-total]');
      const footer = drawer?.querySelector('[data-clean-cart-drawer-footer]');
      const checkout = drawer?.querySelector('.clean-cart-drawer__checkout');
      const gokwikCheckout = drawer?.querySelector('[data-clean-gokwik-checkout]');

      if (!itemsTarget || !countTarget || !totalTarget) return;

      const renderId = String(++cleanCartRenderSequence);
      drawer.dataset.cleanCartRenderId = renderId;
      const giftWrapVariantId = getCleanCartGiftWrapVariantId(drawer);
      const itemCount = Number(cart?.item_count || 0);
      const itemText = itemCount === 1 ? 'item' : 'items';
      itemsTarget.classList.toggle('clean-cart-drawer__items--empty', itemCount === 0);
      if (footer) footer.hidden = itemCount === 0;
      countTarget.textContent = `${itemCount} ${itemText}`;
      renderCleanCartTotals(drawer, cart);
      window.cart = cart;
      drawer.cleanCartRenderedCart = cart;
      syncCleanCartToolFields(drawer, cart);
      updateCleanCartCountTargets(itemCount);

      [checkout, gokwikCheckout].forEach((target) => {
        if (!target) return;

        if (itemCount === 0) {
          target.setAttribute('aria-disabled', 'true');
        } else {
          target.removeAttribute('aria-disabled');
        }
      });

      if (!itemCount) {
        const emptyTemplate = drawer.querySelector('[data-clean-cart-empty-template]');
        if (emptyTemplate) {
          itemsTarget.replaceChildren(emptyTemplate.content.cloneNode(true));
        } else {
          itemsTarget.replaceChildren();
        }
        return;
      }

      const addOnsWereOpen = itemsTarget.querySelector('[data-clean-cart-drawer-add-ons]')?.open ?? true;
      const ordinaryItems = cart.items.filter((item) => !isCleanCartAddOnItem(item));
      const addOnItems = cart.items.filter((item) => isCleanCartAddOnItem(item));
      const addOnQuantity = addOnItems.reduce((total, item) => total + Number(item.quantity || 0), 0);
      const renderItem = (item) => {
        const isGiftWrapItem = isCleanCartGiftWrapItem(item, giftWrapVariantId);
        const isAddOnItem = isCleanCartAddOnItem(item);
        const itemImage = item.image
          ? `<img class="clean-cart-drawer__image" src="${escapeCleanCartHtml(
              getCleanCartImageUrl(item.image),
            )}" alt="${escapeCleanCartHtml(item.product_title || item.title)}" width="70" height="70" loading="lazy">`
          : '<div class="clean-cart-drawer__image" aria-hidden="true"></div>';
        const quantityControls = isGiftWrapItem
          ? ''
          : `
                <div class="clean-cart-drawer__quantity" data-clean-cart-quantity>
                  <button type="button" aria-label="Decrease quantity" data-clean-cart-quantity-decrease>-</button>
                  <input
                    type="number"
                    min="0"
                    value="${Number(item.quantity || 0)}"
                    inputmode="numeric"
                    aria-label="Quantity for ${escapeCleanCartHtml(item.product_title || item.title)}"
                    data-clean-cart-quantity-input
                  >
                  <button type="button" aria-label="Increase quantity" data-clean-cart-quantity-increase>+</button>
                </div>
              `;

        return `
            <article class="clean-cart-drawer__item${
              isAddOnItem ? ' clean-cart-drawer__item--add-on' : ''
            }" data-clean-cart-item="${escapeCleanCartHtml(item.key)}">
              <a href="${escapeCleanCartHtml(item.url || '#')}" aria-label="${escapeCleanCartHtml(item.title)}">
                ${itemImage}
              </a>
              <div class="clean-cart-drawer__item-body">
                <a class="clean-cart-drawer__item-title" href="${escapeCleanCartHtml(item.url || '#')}">
                  ${escapeCleanCartHtml(item.product_title || item.title)}
                </a>
                ${renderCleanCartVariantOptions(item)}
                ${renderCleanCartProperties(item.properties)}
                <div class="clean-cart-drawer__prices" data-clean-cart-price-block>
                  ${renderCleanCartPriceHtml(item, drawer)}
                </div>
                ${quantityControls}
              </div>
              <button class="clean-cart-drawer__remove" type="button" aria-label="Remove ${escapeCleanCartHtml(
                item.product_title || item.title,
              )}" data-clean-cart-remove>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M4 7h16M10 11v6M14 11v6M6 7l1 14h10l1-14M9 7V4h6v3"></path>
                </svg>
              </button>
              <span class="clean-cart-drawer__item-loading" data-clean-cart-item-loading-label aria-live="polite">
                Updating cart...
              </span>
            </article>
          `;
      };
      const addOnMarkup = addOnItems.map(renderItem).join('');

      itemsTarget.innerHTML = `
        ${ordinaryItems.map(renderItem).join('')}
        ${
          addOnItems.length
            ? `
              <details class="clean-cart-drawer__add-ons" data-clean-cart-drawer-add-ons${
                addOnsWereOpen ? ' open' : ''
              }>
                <summary class="clean-cart-drawer__add-ons-summary">
                  <span>Add-ons</span>
                  <span class="clean-cart-drawer__add-ons-count">${addOnQuantity}</span>
                </summary>
                <div class="clean-cart-drawer__add-ons-items">
                  ${addOnMarkup}
                </div>
              </details>
            `
            : ''
        }
      `;

      hydrateCleanCartComparePrices(drawer, cart, renderId).catch(() => {});
    };

    const setCleanCartItemLoading = (item, isLoading, message = 'Updating cart...') => {
      if (!item) return;

      item.classList.toggle('clean-cart-drawer__item--loading', isLoading);
      item.toggleAttribute('aria-busy', isLoading);
      item.dataset.cleanCartItemLoading = isLoading ? 'true' : 'false';

      const label = item.querySelector('[data-clean-cart-item-loading-label]');
      if (label) label.textContent = message;

      item.querySelectorAll('button, input').forEach((control) => {
        control.disabled = isLoading;
      });
    };

    const changeCleanCartItemWithLoading = async (drawer, item, quantity, message) => {
      const key = item?.dataset.cleanCartItem;
      if (!drawer || !item || !key || item.dataset.cleanCartItemLoading === 'true') return null;

      setCleanCartItemLoading(item, true, message);

      try {
        return await changeCleanCartItem(drawer, key, quantity);
      } finally {
        if (item.isConnected) {
          setCleanCartItemLoading(item, false);
        }
      }
    };

    const fetchCleanCart = async (drawer = getCleanCartDrawer(), { supersede = false } = {}) => {
      if (!drawer) return null;

      const coordinator = getCleanCartStateCoordinator();
      const cart = await coordinator.refresh(
        async ({ signal } = {}) => {
          const response = await cleanCartRequest(getCleanCartJsonUrl(drawer), { signal });
          if (!response.ok) throw new Error('Unable to refresh cart.');
          return response.json();
        },
        { supersede },
      );

      if (drawer.cleanCartRenderedCart !== cart) renderCleanCartItems(drawer, cart);
      return cart;
    };

    const broadcastCleanCart = (cart, origin = 'clean-cart-drawer') => {
      getCleanCartStateCoordinator().publish(cart);
      document.dispatchEvent(
        new CustomEvent('clean:cart:updated', {
          detail: { cart, origin },
        }),
      );
    };

    const refreshCleanCartDrawer = async (drawer = getCleanCartDrawer(), options = {}) => {
      const cart = await fetchCleanCart(drawer, options);
      if (cart) broadcastCleanCart(cart);
      return cart;
    };

    const animateCleanCartShippingProgress = (drawer) => {
      if (!drawer || drawer.cleanCartShippingProgressAnimated) return false;

      const panel = drawer.querySelector('[data-clean-cart-shipping-progress-panel]');
      if (!panel || panel.hidden) return false;

      const progress = Math.min(100, Math.max(0, Number(panel.dataset.cleanCartShippingProgress) || 0));
      const fill = panel.querySelector('[data-clean-cart-shipping-progress-fill]');
      const truck = panel.querySelector('[data-clean-cart-shipping-progress-truck]');
      if (!fill || !truck) return false;

      drawer.cleanCartShippingProgressAnimated = true;
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressStartFrame);
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressEndFrame);

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        fill.style.width = `${progress}%`;
        truck.style.left = `${progress}%`;
        return true;
      }

      fill.style.transition = 'none';
      truck.style.transition = 'none';
      fill.style.width = '0%';
      truck.style.left = '0%';

      drawer.cleanCartShippingProgressStartFrame = window.requestAnimationFrame(() => {
        drawer.cleanCartShippingProgressEndFrame = window.requestAnimationFrame(() => {
          fill.style.removeProperty('transition');
          truck.style.removeProperty('transition');
          fill.style.width = `${progress}%`;
          truck.style.left = `${progress}%`;
        });
      });

      return true;
    };

    const openCleanCartDrawer = async ({ refresh = true } = {}) => {
      const drawer = getCleanCartDrawer();
      if (!drawer) return;

      setCleanCartStatus(drawer);
      drawer.hidden = false;
      drawer.cleanCartShippingProgressAnimated = false;
      document.body.classList.add('clean-cart-drawer-open');

      window.cancelAnimationFrame(drawer.cleanCartOpenFrame);
      drawer.cleanCartOpenFrame = window.requestAnimationFrame(() => {
        drawer.classList.add('clean-cart-drawer--open');
        resumeCleanCartCompareHydration(drawer);
        if (!refresh) animateCleanCartShippingProgress(drawer);
      });

      window.CleanGokwik.syncScope(drawer, { detect: true, prepare: true }).catch(() => {});

      if (refresh) {
        try {
          await fetchCleanCart(drawer);
          if (drawer.classList.contains('clean-cart-drawer--open')) {
            animateCleanCartShippingProgress(drawer);
          }
        } catch (error) {
          setCleanCartStatus(drawer, error?.message || 'Unable to refresh cart.');
          if (drawer.classList.contains('clean-cart-drawer--open')) {
            animateCleanCartShippingProgress(drawer);
          }
        }
      }
    };

    const getCleanCartAddedItems = (payload) => {
      if (Array.isArray(payload)) return payload;
      if (Array.isArray(payload?.items)) return payload.items;
      return payload && typeof payload === 'object' ? [payload] : [];
    };

    const getCleanCartUpsellEligibleItem = (payload, cart) => {
      const upsellDrawer = getCleanCartUpsellDrawer();
      const eligibleProductId = String(upsellDrawer?.dataset.cleanCartUpsellSourceProductId || '');
      const eligibleProductGroup = String(upsellDrawer?.dataset.cleanCartUpsellProductGroup || '');
      if (!eligibleProductId || !['cake', 'chocolate', 'flower'].includes(eligibleProductGroup)) return null;

      const addedItems = getCleanCartAddedItems(payload);
      const productIds = new Set(addedItems.map((item) => String(item?.product_id || '')).filter(Boolean));
      const variantIds = new Set(addedItems.map((item) => String(item?.variant_id || item?.id || '')).filter(Boolean));
      const handles = new Set(addedItems.map((item) => String(item?.handle || '')).filter(Boolean));
      const matchingCartItems = (cart?.items || []).filter(
        (item) =>
          productIds.has(String(item?.product_id || '')) ||
          variantIds.has(String(item?.variant_id || item?.id || '')) ||
          handles.has(String(item?.handle || '')),
      );

      return (
        [...addedItems, ...matchingCartItems].find(
          (item) =>
            String(item?.vendor || '')
              .trim()
              .toLowerCase() === cleanCartUpsellEligibleVendor && String(item?.product_id || '') === eligibleProductId,
        ) || null
      );
    };

    const setCleanCartUpsellParentContext = (drawer, item) => {
      if (!drawer || !item) return;

      drawer.dataset.cleanCartUpsellParentProductId = String(item.product_id || '').trim();
      drawer.dataset.cleanCartUpsellParentVariantId = String(item.variant_id || item.id || '').trim();
    };

    const setCleanCartUpsellReconciliationStatus = (drawer, message = '') => {
      const status = drawer?.querySelector('[data-clean-cart-upsell-reconciliation-status]');
      if (!status) return;
      status.textContent = message;
      status.hidden = !message;
    };

    const getCleanCartCachedState = () => {
      const coordinator = getCleanCartStateCoordinator();
      const cart = coordinator.state?.cart || window.cart || null;
      return cart && Array.isArray(cart.items) ? cart : null;
    };

    const reconcileCleanCartUpsell = (drawer) => {
      if (!drawer || drawer.dataset.cleanCartUpsellCompleting === 'true' || cleanHydrogenCartNavigationStarted) {
        return Promise.resolve(null);
      }

      cancelCleanCartReconciliation();
      const sequence = ++cleanCartReconciliationSequence;
      const controller = new AbortController();
      cleanCartReconciliationController = controller;

      const operation = refreshCleanCartDrawer(getCleanCartDrawer(), { supersede: true })
        .then((cart) => {
          if (
            controller.signal.aborted ||
            sequence !== cleanCartReconciliationSequence ||
            drawer.dataset.cleanCartUpsellCompleting === 'true'
          ) {
            return null;
          }

          drawer.dataset.cleanCartUpsellInteractionLocked = 'false';
          setCleanCartUpsellReconciliationStatus(drawer);
          syncCleanCartUpsellActions(drawer, cart);
          return cart;
        })
        .catch((error) => {
          if (
            error?.name === 'AbortError' ||
            controller.signal.aborted ||
            sequence !== cleanCartReconciliationSequence
          ) {
            return null;
          }

          const hasCachedCart = Boolean(drawer.cleanCartUpsellCart && Array.isArray(drawer.cleanCartUpsellCart.items));
          drawer.dataset.cleanCartUpsellInteractionLocked = String(!hasCachedCart);
          setCleanCartUpsellReconciliationStatus(
            drawer,
            hasCachedCart
              ? 'We couldn’t refresh your add-ons. Your confirmed selections are still available, and you can continue to cart.'
              : 'We couldn’t confirm existing add-ons. Add-on controls are unavailable, but you can continue to cart.',
          );
          syncCleanCartUpsellActions(drawer, drawer.cleanCartUpsellCart);
          return null;
        })
        .finally(() => {
          if (cleanCartReconciliationPromise === operation) {
            cleanCartReconciliationController = null;
            cleanCartReconciliationPromise = null;
          }
        });

      cleanCartReconciliationPromise = operation;
      return operation;
    };

    const openCleanCartUpsellBeforeCart = async (addedProduct, cart, { onNavigationStart } = {}) => {
      if (cleanCartUpsellFlowPromise) return cleanCartUpsellFlowPromise;

      const eligibleItem = getCleanCartUpsellEligibleItem(addedProduct, cart);

      if (!cleanCartUpsellEnabled || !eligibleItem) {
        return completeCleanCartPostAddFlow(onNavigationStart);
      }

      const drawer = getCleanCartUpsellDrawer();
      const cachedCart = cart && Array.isArray(cart.items) ? cart : getCleanCartCachedState();
      setCleanCartUpsellParentContext(drawer, eligibleItem);
      drawer.cleanCartUpsellCart = cachedCart;
      drawer.dataset.cleanCartUpsellInteractionLocked = String(!cachedCart);
      setCleanCartUpsellReconciliationStatus(
        drawer,
        cachedCart ? 'Checking your current add-ons…' : 'Checking your cart…',
      );

      cleanCartUpsellFlowPromise = (async () => {
        const upsell = await waitForCleanCartUpsellApi();

        if (upsell?.open) {
          const flowCompletion = upsell.open({
            onExit: () => completeCleanCartPostAddFlow(onNavigationStart),
          });
          reconcileCleanCartUpsell(drawer);
          await flowCompletion;
          return cleanHydrogenCartNavigationStarted;
        }

        throw new Error('Cart upsell drawer is not available.');
      })();

      try {
        return await cleanCartUpsellFlowPromise;
      } finally {
        cleanCartUpsellFlowPromise = null;
      }
    };

    const openCleanCartUpsellDrawer = async ({ onContinue, onExit } = {}) => {
      const callback = onExit || onContinue || completeCleanCartPostAddFlow;

      if (!cleanCartUpsellEnabled) {
        await callback();
        return;
      }

      const upsell = await waitForCleanCartUpsellApi();

      if (upsell?.open) {
        await upsell.open({ onExit: callback });
        return;
      }

      throw new Error('Cart upsell drawer is not available.');
    };

    const closeCleanCartUpsellDrawer = () => getCleanCartUpsellApi()?.close?.();

    const isCleanCartUpsellOpen = () => Boolean(getCleanCartUpsellApi()?.isOpen?.());

    const wasCleanCartUpsellRecentlyShown = () => Boolean(getCleanCartUpsellApi()?.wasRecentlyShown?.());

    const closeCleanCartDrawer = () => {
      const drawer = getCleanCartDrawer();
      if (!drawer) return;

      const wasOpen = drawer.classList.contains('clean-cart-drawer--open');
      closeCleanCartToolPanel(drawer);
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressStartFrame);
      window.cancelAnimationFrame(drawer.cleanCartShippingProgressEndFrame);
      drawer.classList.remove('clean-cart-drawer--open');
      document.body.classList.remove('clean-cart-drawer-open');

      if (wasOpen) {
        document.dispatchEvent(
          new CustomEvent('clean:cart-drawer:closed', {
            detail: { cart: window.cart || null },
          }),
        );
      }

      window.clearTimeout(drawer.cleanCartCloseTimer);
      drawer.cleanCartCloseTimer = window.setTimeout(
        () => {
          if (!drawer.classList.contains('clean-cart-drawer--open')) {
            drawer.hidden = true;
          }
        },
        reducedMotion.matches ? 0 : 220,
      );
    };

    const changeCleanCartItem = async (drawer, key, quantity, { cascadeDependentAddOns = true } = {}) => {
      const cleanQuantity = cleanClampCartQuantity(quantity);
      let currentCart = window.cart;

      if (
        cascadeDependentAddOns &&
        cleanQuantity === 0 &&
        !(currentCart?.items || []).some((item) => String(item?.key || '') === String(key || ''))
      ) {
        currentCart = await fetchCleanCart(drawer);
      }

      const dependentAddOnKeys =
        cascadeDependentAddOns && cleanQuantity === 0 ? getCleanCartDependentAddOnKeys(currentCart, key) : [];
      const hasDependentAddOns = dependentAddOnKeys.length > 0;
      const body = hasDependentAddOns
        ? JSON.stringify({
            updates: Object.fromEntries([key, ...dependentAddOnKeys].map((itemKey) => [itemKey, 0])),
          })
        : JSON.stringify({ id: key, quantity: cleanQuantity });
      const response = await cleanCartRequest(
        cleanCartAjaxUrl(
          getCleanCartUrl(
            drawer,
            hasDependentAddOns ? 'cleanCartUpdateUrl' : 'cleanCartChangeUrl',
            hasDependentAddOns ? '/cart/update' : '/cart/change',
          ),
          hasDependentAddOns ? '/cart/update' : '/cart/change',
        ),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to update cart.');
      }

      const cart = await response.json();
      renderCleanCartItems(drawer, cart);
      broadcastCleanCart(cart);
      return cart;
    };

    const updateCleanCartItemProperties = async (drawer, key, properties = {}, quantity = 1) => {
      const body = JSON.stringify({
        id: key,
        quantity: cleanClampCartQuantity(quantity),
        properties,
      });
      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartChangeUrl', '/cart/change'), '/cart/change'),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Unable to update cart.');
      }

      const cart = await response.json();
      renderCleanCartItems(drawer, cart);
      broadcastCleanCart(cart);
      return cart;
    };

    const setCleanCartNameOnCakeEditing = (row, isEditing) => {
      const view = row?.querySelector('[data-clean-cart-name-on-cake-view]');
      const editor = row?.querySelector('[data-clean-cart-name-on-cake-editor]');
      const input = row?.querySelector('[data-clean-cart-name-on-cake-input]');

      if (!view || !editor || !input) return;

      view.hidden = isEditing;
      editor.hidden = !isEditing;

      if (isEditing) {
        input.value = input.defaultValue;
        input.focus({ preventScroll: true });
        input.select();
      }
    };

    const saveCleanCartNameOnCake = async (drawer, row, saveButton) => {
      const itemElement = row?.closest('[data-clean-cart-item]');
      const key = itemElement?.dataset.cleanCartItem;
      const item = getCleanCartItemByKey(key);
      const input = row?.querySelector('[data-clean-cart-name-on-cake-input]');

      if (!drawer || !row || !saveButton || !key || !item || !input) {
        setCleanCartStatus(drawer, 'Unable to edit the name on cake.');
        return;
      }

      const originalLabel = saveButton.textContent.trim();
      const properties = { ...(item.properties || {}) };
      const propertyName =
        Object.keys(properties).find((name) => isCleanCartNameOnCakeProperty(name)) || cleanCartNameOnCakePropertyName;
      const nextValue = input.value.trim();

      if (nextValue) {
        properties[propertyName] = nextValue;
      } else {
        properties[propertyName] = '';
      }

      saveButton.disabled = true;
      saveButton.textContent = 'Saving';
      setCleanCartStatus(drawer);

      try {
        await updateCleanCartItemProperties(drawer, key, properties, item.quantity || 1);
      } catch (error) {
        setCleanCartStatus(drawer, error?.message || 'Unable to update the name on cake.');
        saveButton.disabled = false;
        saveButton.textContent = originalLabel;
      }
    };

    const getCleanProductCartFlow = (productForm) =>
      String(productForm?.dataset.cleanProductFlow || '')
        .trim()
        .toLowerCase();

    const getCleanCartPublicErrorMessage = (
      payload,
      fallback = 'Unable to add this item right now. Please try again.',
    ) => {
      const candidate = [payload?.description, payload?.message].find((value) => typeof value === 'string');
      const message =
        candidate
          ?.replace(/[\u0000-\u001f\u007f]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim() || '';

      if (
        !message ||
        message.length > 300 ||
        /^(?:Failed to fetch|NetworkError when attempting to fetch resource\.)$/i.test(message) ||
        /(?:key|token)=|cookie|gid:\/\/shopify\/Cart/i.test(message)
      ) {
        return fallback;
      }

      return message;
    };

    const addCleanCartForm = async (drawer, productForm) => {
      const response = await cleanCartRequest(
        cleanCartAjaxUrl(getCleanCartUrl(drawer, 'cleanCartAddUrl', '/cart/add'), '/cart/add'),
        {
          method: 'POST',
          body: new FormData(productForm),
        },
      );

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(getCleanCartPublicErrorMessage(error));
      }

      cleanCartLastTrackedAddAt = Date.now();
      return response.json().catch(() => null);
    };

    const addCleanCartFormAndOpen = async (productForm, { onNavigationStart } = {}) => {
      const drawer = getCleanCartDrawer();
      if (!drawer || !productForm) throw new Error('Cart drawer is not available.');

      setCleanCartStatus(drawer);
      const isStandardProduct = getCleanProductCartFlow(productForm) === 'standard';
      if (isStandardProduct) prepareCleanCartUpsellCatalog();

      try {
        const addedProduct = await addCleanCartForm(drawer, productForm);

        const eligibleItem = getCleanCartUpsellEligibleItem(addedProduct);
        if (!eligibleItem) {
          await completeCleanCartPostAddFlow(onNavigationStart);
          return null;
        }

        try {
          await openCleanCartUpsellBeforeCart(addedProduct, null, {
            onNavigationStart,
          });
        } catch (error) {
          setCleanCartStatus(drawer, error?.message || 'Unable to open add-ons.');
          await completeCleanCartPostAddFlow(onNavigationStart);
        }

        return null;
      } catch (error) {
        setCleanCartStatus(drawer, error?.message || 'Unable to add this item.');
        throw error;
      }
    };

    const isCleanCartAddUrl = (input) => {
      const rawUrl = typeof input === 'string' ? input : input?.url;
      if (!rawUrl) return false;

      try {
        const url = new URL(rawUrl, window.location.origin);
        return /\/cart\/add(\.js)?$/.test(url.pathname);
      } catch (error) {
        return String(rawUrl).includes('/cart/add');
      }
    };

    const isCleanCartInternalRequest = (init) => {
      try {
        return new Headers(init?.headers || {}).get('X-Clean-Cart') === 'true';
      } catch (error) {
        return false;
      }
    };

    const getCleanCartAddFetchPayload = (response) => {
      try {
        return response
          .clone()
          .json()
          .catch(() => null);
      } catch (error) {
        return Promise.resolve(null);
      }
    };

    const getCleanCartAddXhrPayload = (request) => {
      try {
        if (request.responseType === 'json') return request.response;
        if (!request.responseType || request.responseType === 'text') return JSON.parse(request.responseText);
      } catch (error) {
        return null;
      }

      return null;
    };

    const refreshCleanCartAfterTrackedAdd = async (addedProductPromise) => {
      const drawer = getCleanCartDrawer();
      if (!drawer) return;

      cleanCartLastTrackedAddAt = Date.now();
      const operation = (async () => {
        const [cart, addedProduct] = await Promise.all([
          refreshCleanCartDrawer(drawer),
          Promise.resolve(addedProductPromise).catch(() => null),
        ]);
        await openCleanCartUpsellBeforeCart(addedProduct, cart);
        return cart;
      })();
      cleanCartTrackedAddPromise = operation;

      try {
        return await operation;
      } finally {
        if (cleanCartTrackedAddPromise === operation) cleanCartTrackedAddPromise = null;
      }
    };

    const initCleanCartDrawer = (root = document) => {
      const drawer = getCleanCartDrawer();
      if (!drawer || drawer.dataset.cleanCartDrawerReady === 'true') return;

      drawer.dataset.cleanCartDrawerReady = 'true';
      const lifecycle = new AbortController();
      drawer.cleanCartDrawerLifecycle = lifecycle;
      syncCleanCartToolCount(drawer);

      drawer.addEventListener(
        'click',
        (event) => {
          const closeButton = event.target.closest('[data-clean-cart-drawer-close]');
          if (closeButton && drawer.contains(closeButton)) {
            event.preventDefault();
            closeCleanCartDrawer();
            return;
          }

          const summaryToggle = event.target.closest('[data-clean-cart-summary-toggle]');
          if (summaryToggle && drawer.contains(summaryToggle)) {
            event.preventDefault();
            const summary = drawer.querySelector('[data-clean-cart-summary]');
            const isExpanded = summaryToggle.getAttribute('aria-expanded') === 'true';
            summaryToggle.setAttribute('aria-expanded', String(!isExpanded));
            if (summary) summary.hidden = isExpanded;
            return;
          }

          const trigger = event.target.closest('[data-clean-cart-tool-trigger]');
          if (trigger && drawer.contains(trigger)) {
            event.preventDefault();
            if (trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;
            openCleanCartToolPanel(drawer, trigger.dataset.cleanCartToolTrigger);
            return;
          }

          if (event.target.closest('[data-clean-cart-tool-cancel]')) {
            event.preventDefault();
            closeCleanCartToolPanel(drawer);
            return;
          }

          const saveButton = event.target.closest('[data-clean-cart-tool-save]');
          if (saveButton && drawer.contains(saveButton)) {
            event.preventDefault();
            saveCleanCartToolPanel(drawer, saveButton.dataset.cleanCartToolSave, saveButton);
          }
        },
        { signal: lifecycle.signal },
      );

      drawer.querySelectorAll('[data-clean-gokwik-checkout]').forEach((button) => {
        button.addEventListener(
          'click',
          async (event) => {
            event.preventDefault();

            if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

            button.disabled = true;
            setCleanCartStatus(drawer);

            try {
              await refreshCleanCartDrawer(drawer);
              await window.CleanGokwik.checkout(button, drawer);
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to start GoKwik checkout.');
            } finally {
              button.disabled = false;
            }
          },
          { signal: lifecycle.signal },
        );
      });

      drawer.addEventListener(
        'click',
        async (event) => {
          const item = event.target.closest('[data-clean-cart-item]');
          if (!item || !drawer.contains(item)) return;

          const quantityInput = item.querySelector('[data-clean-cart-quantity-input]');

          const editNameOnCakeButton = event.target.closest('[data-clean-cart-edit-name-on-cake]');
          if (editNameOnCakeButton) {
            event.preventDefault();
            setCleanCartNameOnCakeEditing(editNameOnCakeButton.closest('[data-clean-cart-name-on-cake-row]'), true);
            return;
          }

          const cancelNameOnCakeButton = event.target.closest('[data-clean-cart-cancel-name-on-cake]');
          if (cancelNameOnCakeButton) {
            event.preventDefault();
            setCleanCartNameOnCakeEditing(cancelNameOnCakeButton.closest('[data-clean-cart-name-on-cake-row]'), false);
            return;
          }

          const saveNameOnCakeButton = event.target.closest('[data-clean-cart-save-name-on-cake]');
          if (saveNameOnCakeButton) {
            event.preventDefault();
            await saveCleanCartNameOnCake(
              drawer,
              saveNameOnCakeButton.closest('[data-clean-cart-name-on-cake-row]'),
              saveNameOnCakeButton,
            );
            return;
          }

          if (event.target.closest('[data-clean-cart-remove]')) {
            event.preventDefault();
            try {
              await changeCleanCartItemWithLoading(drawer, item, 0, 'Removing...');
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to remove item.');
            }
            return;
          }

          if (event.target.closest('[data-clean-cart-quantity-decrease]')) {
            event.preventDefault();
            try {
              await changeCleanCartItemWithLoading(
                drawer,
                item,
                cleanClampCartQuantity(quantityInput?.value) - 1,
                'Updating cart...',
              );
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to update cart.');
            }
            return;
          }

          if (event.target.closest('[data-clean-cart-quantity-increase]')) {
            event.preventDefault();
            try {
              await changeCleanCartItemWithLoading(
                drawer,
                item,
                cleanClampCartQuantity(quantityInput?.value) + 1,
                'Updating cart...',
              );
            } catch (error) {
              setCleanCartStatus(drawer, error?.message || 'Unable to update cart.');
            }
          }
        },
        { signal: lifecycle.signal },
      );

      drawer.addEventListener(
        'change',
        async (event) => {
          const input = event.target.closest('[data-clean-cart-quantity-input]');
          if (!input || !drawer.contains(input)) return;

          const item = input.closest('[data-clean-cart-item]');
          if (!item) return;

          try {
            await changeCleanCartItemWithLoading(drawer, item, input.value, 'Updating cart...');
          } catch (error) {
            setCleanCartStatus(drawer, error?.message || 'Unable to update cart.');
          }
        },
        { signal: lifecycle.signal },
      );

      drawer.addEventListener(
        'keydown',
        async (event) => {
          const input = event.target.closest('[data-clean-cart-name-on-cake-input]');
          if (!input || !drawer.contains(input)) return;

          const row = input.closest('[data-clean-cart-name-on-cake-row]');

          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            setCleanCartNameOnCakeEditing(row, false);
            row?.querySelector('[data-clean-cart-edit-name-on-cake]')?.focus({ preventScroll: true });
            return;
          }

          if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            const saveButton = row?.querySelector('[data-clean-cart-save-name-on-cake]');
            if (!saveButton || saveButton.disabled) return;
            await saveCleanCartNameOnCake(drawer, row, saveButton);
          }
        },
        { signal: lifecycle.signal },
      );

      document.addEventListener(
        'keydown',
        (event) => {
          if (event.key !== 'Escape' || drawer.hidden) return;

          if (drawer.classList.contains('clean-cart-drawer--tool-open')) {
            closeCleanCartToolPanel(drawer);
            return;
          }

          closeCleanCartDrawer();
        },
        { signal: lifecycle.signal },
      );

      drawer.cleanCartDrawerCleanup = () => {
        lifecycle.abort();
        window.cancelAnimationFrame(drawer.cleanCartOpenFrame);
        window.cancelAnimationFrame(drawer.cleanCartShippingProgressStartFrame);
        window.cancelAnimationFrame(drawer.cleanCartShippingProgressEndFrame);
        window.clearTimeout(drawer.cleanCartCloseTimer);
        cleanCartPendingCompareHydrations.delete(drawer);
        delete drawer.dataset.cleanCartDrawerReady;
      };
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanCartDrawer(), { once: true });
    } else {
      initCleanCartDrawer();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanCartDrawer(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const cartDrawer =
        event.target.querySelector?.('[data-clean-cart-drawer]') ||
        (event.target.matches?.('[data-clean-cart-drawer]') ? event.target : null);
      const upsellDrawer =
        event.target.querySelector?.('[data-clean-cart-upsell-drawer]') ||
        (event.target.matches?.('[data-clean-cart-upsell-drawer]') ? event.target : null);

      upsellDrawer?.cleanCartUpsellCleanup?.();
      cartDrawer?.cleanCartDrawerCleanup?.();
    });

    if (document.body.dataset.cleanCartAddWatcherReady !== 'true') {
      document.body.dataset.cleanCartAddWatcherReady = 'true';

      const nativeFetch = window.fetch;
      window.fetch = function cleanCartDrawerFetch(input, init) {
        const isCartAdd = isCleanCartAddUrl(input);
        const responsePromise = nativeFetch.apply(this, arguments);

        if (isCartAdd && !isCleanCartInternalRequest(init) && getCleanCartDrawer()) {
          responsePromise
            .then((response) => {
              if (response.ok) {
                const addedProductPromise = getCleanCartAddFetchPayload(response);
                refreshCleanCartAfterTrackedAdd(addedProductPromise).catch(() => {});
              }
            })
            .catch(() => {});
        }

        return responsePromise;
      };

      const nativeXhrOpen = window.XMLHttpRequest?.prototype?.open;
      if (nativeXhrOpen) {
        window.XMLHttpRequest.prototype.open = function cleanCartDrawerXhrOpen(method, url) {
          this.cleanCartDrawerTrackedAdd = isCleanCartAddUrl(url);

          if (this.cleanCartDrawerLoadReady !== 'true') {
            this.cleanCartDrawerLoadReady = 'true';
            this.addEventListener('load', function cleanCartDrawerXhrLoad() {
              if (this.cleanCartDrawerTrackedAdd && this.status >= 200 && this.status < 300 && getCleanCartDrawer()) {
                const addedProduct = getCleanCartAddXhrPayload(this);
                refreshCleanCartAfterTrackedAdd(addedProduct).catch(() => {});
              }
            });
          }

          return nativeXhrOpen.apply(this, arguments);
        };
      }
    }

    window.CleanCart = {
      ...(window.CleanCart || {}),
      addFromForm: addCleanCartFormAndOpen,
      prepareUpsellCatalog: prepareCleanCartUpsellCatalog,
      changeItem: changeCleanCartItem,
      fetch: refreshCleanCartDrawer,
      openUpsellDrawer: openCleanCartUpsellDrawer,
      closeUpsellDrawer: closeCleanCartUpsellDrawer,
      isUpsellOpen: isCleanCartUpsellOpen,
      wasUpsellRecentlyShown: wasCleanCartUpsellRecentlyShown,
      getRecentCart: (maxAge = 2000) => {
        const coordinator = getCleanCartStateCoordinator();
        const isRecent =
          Date.now() - Math.max(cleanCartLastTrackedAddAt, coordinator.state?.lastUpdatedAt || 0) <= maxAge;
        return {
          cart: isRecent ? coordinator.state?.cart || window.cart || null : null,
          inFlight: coordinator.state?.inFlight || cleanCartTrackedAddPromise,
          isRecent,
        };
      },
      openDrawer: openCleanCartDrawer,
      closeDrawer: closeCleanCartDrawer,
    };

    document.addEventListener('clean:bulk-discounts:updated', () => {
      const drawer = getCleanCartDrawer();
      const cart = getCleanCartStateCoordinator().state.cart;
      if (drawer && cart) renderCleanCartItems(drawer, cart);
    });

    document.dispatchEvent(new CustomEvent('clean:cart:ready', { detail: { cart: window.CleanCart } }));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-client-partners"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 768px)');

    const setupCarousel = (carousel) => {
      if (carousel.dataset.cleanClientPartnersInitialized === 'true') return;

      const viewport = carousel.querySelector('[data-clean-client-partners-viewport]');
      const previousButton = carousel.querySelector('[data-clean-client-partners-prev]');
      const nextButton = carousel.querySelector('[data-clean-client-partners-next]');

      if (!viewport || !previousButton || !nextButton) return;

      carousel.dataset.cleanClientPartnersInitialized = 'true';

      const getStep = () => Math.max(1, Math.round(viewport.clientWidth * 0.92));

      const updateButtons = () => {
        if (!desktopQuery.matches) {
          previousButton.disabled = true;
          nextButton.disabled = true;
          return;
        }

        const maxScroll = viewport.scrollWidth - viewport.clientWidth - 1;
        previousButton.disabled = viewport.scrollLeft <= 1;
        nextButton.disabled = viewport.scrollLeft >= maxScroll;
      };

      previousButton.addEventListener('click', () => {
        viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      viewport.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);

      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', updateButtons);
      } else if (desktopQuery.addListener) {
        desktopQuery.addListener(updateButtons);
      }

      updateButtons();
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-clean-client-partners-carousel]').forEach(setupCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-exit-offer"]) return;
  try {
    
  (() => {
    const offer = document.querySelector('[data-clean-exit-offer]');
    if (!offer || offer.dataset.cleanExitOfferReady === 'true') return;

    offer.dataset.cleanExitOfferReady = 'true';

    const seenKey = 'cleanCartCloseOfferSeenV1';
    const knownVisitorKey = 'cleanKnownVisitorV1';
    const newSessionKey = 'cleanNewVisitorSessionV1';
    const dialog = offer.querySelector('[data-clean-exit-offer-dialog]');
    const copyButton = offer.querySelector('[data-clean-exit-offer-copy]');
    const copyLabel = offer.querySelector('[data-clean-exit-offer-copy-label]');
    const copyStatus = offer.querySelector('[data-clean-exit-offer-copy-status]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let cartCount = Number(offer.dataset.cleanExitOfferCartCount || 0);
    let isOpen = false;
    let shownThisPage = false;
    let showTimer = null;
    let copyResetTimer = null;
    let previousFocus = null;

    const getStored = (storage, key) => {
      try {
        return storage.getItem(key);
      } catch (error) {
        return null;
      }
    };

    const setStored = (storage, key, value) => {
      try {
        storage.setItem(key, value);
      } catch (error) {
        // Storage can be unavailable in privacy-restricted browsers.
      }
    };

    if (getStored(window.localStorage, seenKey) === 'true') return;

    let isNewVisitorSession = getStored(window.sessionStorage, newSessionKey) === 'true';
    if (!getStored(window.localStorage, knownVisitorKey)) {
      setStored(window.localStorage, knownVisitorKey, String(Date.now()));
      setStored(window.sessionStorage, newSessionKey, 'true');
      isNewVisitorSession = true;
    }

    if (!isNewVisitorSession) return;

    const getFocusableElements = () =>
      [...dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter(
        (element) => !element.hidden,
      );

    const canShow = () => {
      if (shownThisPage || isOpen || cartCount < 1) return false;
      if (getStored(window.localStorage, seenKey) === 'true') return false;
      if (document.querySelector('.clean-cart-drawer--open, .clean-cart-upsell-drawer--open')) return false;
      if (
        document.body.classList.contains('clean-bulk-gifting-popup-open') ||
        document.body.classList.contains('clean-bulk-gifting-thank-you-open') ||
        document.body.classList.contains('clean-bulk-enquiry-open')
      )
        return false;
      return true;
    };

    const showOffer = () => {
      if (!canShow()) return;

      shownThisPage = true;
      isOpen = true;
      previousFocus = document.activeElement;
      setStored(window.localStorage, seenKey, 'true');
      offer.hidden = false;
      document.body.classList.add('clean-exit-offer-open');

      window.requestAnimationFrame(() => {
        offer.classList.add('clean-exit-offer--open');
        dialog.focus({ preventScroll: true });
      });
    };

    const closeOffer = () => {
      if (!isOpen) return;

      isOpen = false;
      offer.classList.remove('clean-exit-offer--open');
      document.body.classList.remove('clean-exit-offer-open');

      window.setTimeout(
        () => {
          if (!isOpen) offer.hidden = true;
        },
        reducedMotion.matches ? 0 : 180,
      );

      if (previousFocus instanceof HTMLElement && previousFocus.isConnected) {
        previousFocus.focus({ preventScroll: true });
      }
    };

    document.addEventListener('clean:cart:updated', (event) => {
      cartCount = Number(event.detail?.cart?.item_count || 0);
    });

    document.addEventListener('clean:cart-drawer:closed', (event) => {
      if (event.detail?.cart) {
        cartCount = Number(event.detail.cart.item_count || 0);
      }

      window.clearTimeout(showTimer);
      if (cartCount < 1) return;
      showTimer = window.setTimeout(showOffer, 1000);
    });

    const copyDiscountCode = async () => {
      const code = offer.dataset.cleanExitOfferCode || '';
      if (!code) return;

      let copied = false;

      try {
        if (navigator.clipboard?.writeText && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          copied = true;
        } else {
          const temporaryInput = document.createElement('textarea');
          temporaryInput.value = code;
          temporaryInput.setAttribute('readonly', '');
          temporaryInput.style.position = 'fixed';
          temporaryInput.style.opacity = '0';
          document.body.appendChild(temporaryInput);
          temporaryInput.select();
          copied = document.execCommand('copy');
          temporaryInput.remove();
        }
      } catch (error) {
        copied = false;
      }

      window.clearTimeout(copyResetTimer);

      if (!copied) {
        copyStatus.textContent = 'Couldn’t copy automatically. Press and hold the code to copy it.';
        return;
      }

      copyButton.classList.add('clean-exit-offer__copy-button--copied');
      copyLabel.textContent = 'Copied!';
      copyStatus.textContent = `${code} copied to your clipboard.`;
      copyResetTimer = window.setTimeout(() => {
        copyButton.classList.remove('clean-exit-offer__copy-button--copied');
        copyLabel.textContent = 'Copy code';
      }, 2200);
    };

    copyButton?.addEventListener('click', copyDiscountCode);

    offer.addEventListener('click', (event) => {
      if (event.target.closest('[data-clean-exit-offer-close]')) closeOffer();
    });

    document.addEventListener('keydown', (event) => {
      if (!isOpen) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeOffer();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = getFocusableElements();
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus({ preventScroll: true });
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const submittedKey = 'clean:newsletter-submitted:v2';
    const submittedEvent = 'newsletter-submitted';
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    document.querySelectorAll('[data-clean-footer]').forEach((footer) => {
      const forms = footer.querySelectorAll('[data-clean-newsletter-form]');
      const successMessages = footer.querySelectorAll('[data-clean-newsletter-success]');
      const errorMessages = footer.querySelectorAll('[data-clean-newsletter-error]');

      const hasSubmitted = () => {
        try {
          return window.localStorage.getItem(submittedKey) === 'true';
        } catch {
          return false;
        }
      };

      const showSubmitted = () => {
        forms.forEach((form) => {
          const button = form.querySelector('[data-clean-newsletter-button]');

          if (button) {
            button.disabled = true;
            button.textContent = 'Submit';
          }

          form.hidden = true;
        });
        errorMessages.forEach((message) => {
          message.hidden = true;
        });
        successMessages.forEach((message) => {
          message.hidden = false;
        });
      };

      const showError = (messageText) => {
        errorMessages.forEach((message) => {
          message.textContent = messageText;
          message.hidden = false;
        });
      };

      if (hasSubmitted()) showSubmitted();
      window.addEventListener(submittedEvent, showSubmitted);

      forms.forEach((form) => {
        const input = form.querySelector('input[name="email"]');
        const button = form.querySelector('[data-clean-newsletter-button]');

        input.addEventListener('input', () => {
          errorMessages.forEach((message) => {
            message.hidden = true;
          });
        });

        form.addEventListener('submit', async (event) => {
          event.preventDefault();

          if (hasSubmitted()) {
            showSubmitted();
            return;
          }

          const email = input.value.trim();
          const endpoint = footer.dataset.newsletterEndpoint;

          if (!email) {
            showError('Please enter your email address.');
            return;
          }

          if (!emailPattern.test(email)) {
            showError('Please enter a valid email address.');
            return;
          }

          if (!endpoint) {
            showError('Unable to subscribe right now. Please try again.');
            return;
          }

          button.disabled = true;
          button.textContent = 'Submitting...';
          errorMessages.forEach((message) => {
            message.hidden = true;
          });

          try {
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
              body: new URLSearchParams({
                email,
                website: form.elements.website?.value || '',
              }),
            });
            const result = await response.json().catch(() => null);
            if (!response.ok || result?.success !== true) throw new Error('subscription_failed');

            try {
              window.localStorage.setItem(submittedKey, 'true');
            } catch {
              // The success state still works for this page when storage is unavailable.
            }
            window.dispatchEvent(new Event(submittedEvent));
          } catch {
            showError('Unable to subscribe right now. Please try again.');
            button.disabled = false;
            button.textContent = 'Submit';
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-gifts-for-everyone"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeGiftsForEveryone = (section) => {
      if (section.dataset.cleanGiftsInitialized === 'true') return;

      const track = section.querySelector('[data-clean-gifts-track]');
      const previousButton = section.querySelector('[data-clean-gifts-previous]');
      const nextButton = section.querySelector('[data-clean-gifts-next]');
      const slides = Array.from(section.querySelectorAll('.clean-gifts-for-everyone__slide'));

      if (!track || !previousButton || !nextButton || !slides.length) return;

      const desktopQuery = window.matchMedia('(min-width: 768px)');
      const visibleSlides = 5;
      let currentIndex = 0;

      const maximumIndex = () => Math.max(0, slides.length - visibleSlides);

      const updateButtons = () => {
        previousButton.disabled = currentIndex <= 0;
        nextButton.disabled = currentIndex >= maximumIndex();
      };

      const scrollToIndex = (index) => {
        currentIndex = Math.min(Math.max(index, 0), maximumIndex());
        const targetSlide = slides[currentIndex];
        if (!targetSlide) return;

        track.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
        updateButtons();
      };

      previousButton.addEventListener('click', () => scrollToIndex(currentIndex - 1));
      nextButton.addEventListener('click', () => scrollToIndex(currentIndex + 1));

      desktopQuery.addEventListener('change', () => {
        currentIndex = 0;
        track.scrollTo({ left: 0, behavior: 'auto' });
        updateButtons();
      });

      updateButtons();
      section.dataset.cleanGiftsInitialized = 'true';
    };

    const initializeAllGiftsForEveryone = (container = document) => {
      container.querySelectorAll('[data-clean-gifts-for-everyone]').forEach(initializeGiftsForEveryone);
    };

    initializeAllGiftsForEveryone();
    document.addEventListener('shopify:section:load', (event) => initializeAllGiftsForEveryone(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCleanDisplayCurrencyLoader = () => {
      const config = document.querySelector('[data-clean-display-currency-config]');
      if (!config || config.dataset.cleanDisplayCurrencyBootstrapReady === 'true') return;

      config.dataset.cleanDisplayCurrencyBootstrapReady = 'true';
      const storageKey = 'clean:display-currency:v1';
      const sourceCurrency = String(config.dataset.cleanDisplayCurrencySource || '').toUpperCase();
      const initialCurrency = String(config.dataset.cleanDisplayCurrencyInitial || sourceCurrency).toUpperCase();
      const initialCountry = String(config.dataset.cleanDisplayCurrencyCountry || '').toUpperCase();
      const currencySelectors = [...document.querySelectorAll('[data-clean-display-currency]')];
      const countryCurrencyMap = new Map(
        [...document.querySelectorAll('[data-clean-display-currency-option]')]
          .map((option) => [
            String(option.dataset.cleanDisplayCurrencyCountry || '').toUpperCase(),
            String(option.dataset.cleanDisplayCurrencyCode || '').toUpperCase(),
          ])
          .filter(([country, currency]) => /^[A-Z]{2}$/.test(country) && /^[A-Z]{3}$/.test(currency)),
      );
      let memoryPreference;
      let controllerRequest;

      const validPreference = (value) =>
        value &&
        value.version === 1 &&
        /^[A-Z]{3}$/.test(String(value.currency || '')) &&
        /^[A-Z]{2}$/.test(String(value.country || ''));

      const readPreference = () => {
        try {
          const stored = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
          if (validPreference(stored)) return stored;
        } catch (error) {}

        return validPreference(memoryPreference) ? memoryPreference : null;
      };

      const writePreference = (preference) => {
        memoryPreference = preference;
        try {
          window.localStorage.setItem(storageKey, JSON.stringify(preference));
        } catch (error) {}
        return preference;
      };

      const captureInitialPreference = () =>
        readPreference() ||
        writePreference({
          version: 1,
          currency: initialCurrency,
          country: initialCountry,
          explicit: false,
        });

      const sourceFormatterCache = new Map();
      const sourceFormatter = (currency) => {
        const normalizedCurrency = String(currency || sourceCurrency).toUpperCase();
        const cacheKey = `${document.documentElement.lang || 'en'}:${normalizedCurrency}`;
        if (!sourceFormatterCache.has(cacheKey)) {
          const currencyDigits = new Intl.NumberFormat(document.documentElement.lang || 'en', {
            style: 'currency',
            currency: normalizedCurrency,
          }).resolvedOptions().maximumFractionDigits;
          sourceFormatterCache.set(
            cacheKey,
            new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency: normalizedCurrency,
              currencyDisplay: 'narrowSymbol',
              minimumFractionDigits: 0,
              maximumFractionDigits: currencyDigits,
            }),
          );
        }
        return sourceFormatterCache.get(cacheKey);
      };

      const refreshSourceMoney = (root = document) => {
        const moneyElements = [...(root.querySelectorAll?.('[data-clean-money]') || [])];
        if (root instanceof Element && root.matches('[data-clean-money]')) moneyElements.unshift(root);

        moneyElements.forEach((money) => {
          const minorAmount = Number(money.dataset.cleanMoneyMinor);
          const currency = String(money.dataset.cleanMoneyCurrency || sourceCurrency).toUpperCase();
          if (!Number.isFinite(minorAmount) || !/^[A-Z]{3}$/.test(currency)) return;

          try {
            money.textContent = sourceFormatter(currency).format(minorAmount / 100);
            money.dataset.cleanMoneyDisplayCurrency = currency;
            money.removeAttribute('aria-label');
          } catch (error) {}
        });
      };

      const loadController = () => {
        if (window.CleanDisplayCurrency?.ready) return Promise.resolve(window.CleanDisplayCurrency);
        if (controllerRequest) return controllerRequest;

        controllerRequest = new Promise((resolve, reject) => {
          const existing = document.querySelector('[data-clean-display-currency-controller]');
          const script = existing || document.createElement('script');

          const finish = () => resolve(window.CleanDisplayCurrency);
          script.addEventListener('load', finish, { once: true });
          script.addEventListener('error', () => reject(new Error('Display currency controls could not load.')), {
            once: true,
          });

          if (!existing) {
            script.src = config.dataset.cleanDisplayCurrencyControllerUrl;
            script.defer = true;
            script.dataset.cleanDisplayCurrencyController = 'true';
            document.head.append(script);
          }
        }).catch((error) => {
          controllerRequest = undefined;
          document.querySelector('[data-clean-display-currency-controller]')?.remove();
          throw error;
        });

        return controllerRequest;
      };

      const preference = captureInitialPreference();
      window.CleanDisplayCurrencyBootstrap = {
        captureInitialPreference,
        load: loadController,
        readPreference,
        refresh: (root = document) => {
          if (window.CleanDisplayCurrency?.ready) {
            window.CleanDisplayCurrency.refresh(root);
            return;
          }
          refreshSourceMoney(root);
        },
        writePreference,
      };
      refreshSourceMoney();

      const syncBootstrapSelector = (selector, nextPreference) => {
        const trigger = selector.querySelector('[data-clean-display-currency-trigger]');
        const triggerCode = selector.querySelector('[data-clean-display-currency-trigger-code]');
        const triggerFlag = selector.querySelector('[data-clean-display-currency-trigger-flag]');
        const options = [...selector.querySelectorAll('[data-clean-display-currency-option]')];
        const option =
          options.find(
            (candidate) =>
              candidate.dataset.cleanDisplayCurrencyCode === nextPreference.currency &&
              candidate.dataset.cleanDisplayCurrencyCountry === nextPreference.country,
          ) || options.find((candidate) => candidate.dataset.cleanDisplayCurrencyCode === nextPreference.currency);

        if (triggerCode) triggerCode.textContent = nextPreference.currency;
        if (trigger) trigger.setAttribute('aria-label', `Display currency, ${nextPreference.currency}`);
        if (triggerFlag && option?.querySelector('img')) triggerFlag.src = option.querySelector('img').src;
      };

      const detectLocationPreference = async () => {
        if (readPreference()?.explicit || countryCurrencyMap.size === 0) return;

        const shopifyRoot = String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
        const suggestionsUrl = new URL(`${shopifyRoot}browsing_context_suggestions.json`, window.location.origin);
        suggestionsUrl.searchParams.set('country[enabled]', 'true');
        if (/^[A-Z]{2}$/.test(initialCountry)) suggestionsUrl.searchParams.set('country[exclude]', initialCountry);

        const response = await fetch(suggestionsUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Shopify location detection was unavailable.');

        const payload = await response.json();
        const countryCandidates = [
          payload?.detected_values?.country?.handle,
          payload?.suggestions?.[0]?.parts?.country?.handle,
        ]
          .map((country) => String(country || '').toUpperCase())
          .filter((country) => /^[A-Z]{2}$/.test(country));
        const detectedCountry = countryCandidates.find((country) => countryCurrencyMap.has(country));
        const detectedCurrency = countryCurrencyMap.get(detectedCountry);
        if (!detectedCountry || !detectedCurrency) return;

        const latestPreference = readPreference();
        if (latestPreference?.explicit) return;
        if (
          latestPreference?.country === detectedCountry &&
          latestPreference?.currency === detectedCurrency &&
          latestPreference?.explicit === false
        ) {
          return;
        }

        const detectedPreference = writePreference({
          version: 1,
          currency: detectedCurrency,
          country: detectedCountry,
          explicit: false,
        });
        currencySelectors.forEach((selector) => syncBootstrapSelector(selector, detectedPreference));
        document.dispatchEvent(
          new CustomEvent('clean:display-currency:location-detected', {
            detail: { preference: detectedPreference },
          }),
        );
        loadController().catch(() => {});
      };

      currencySelectors.forEach((selector) => {
        const trigger = selector.querySelector('[data-clean-display-currency-trigger]');
        if (!trigger) return;

        syncBootstrapSelector(selector, preference);
        const loadOnIntent = () => loadController().catch(() => {});
        selector.addEventListener('pointerenter', loadOnIntent, { once: true, passive: true });
        trigger.addEventListener('focus', loadOnIntent, { once: true });
        trigger.addEventListener('click', (event) => {
          if (window.CleanDisplayCurrency?.ready) return;
          event.preventDefault();
          loadController()
            .then(() => window.CleanDisplayCurrency?.open(selector))
            .catch(() => {});
        });
      });

      window.addEventListener('storage', (event) => {
        if (event.key !== storageKey || !event.newValue || window.CleanDisplayCurrency?.ready) return;

        try {
          const nextPreference = JSON.parse(event.newValue);
          if (!validPreference(nextPreference)) return;
          document
            .querySelectorAll('[data-clean-display-currency]')
            .forEach((selector) => syncBootstrapSelector(selector, nextPreference));
          loadController().catch(() => {});
        } catch (error) {}
      });

      if (preference.currency !== sourceCurrency) loadController().catch(() => {});
      detectLocationPreference().catch(() => {});
    };

    initializeCleanDisplayCurrencyLoader();

    const sections = document.querySelectorAll('[data-clean-header]');

    sections.forEach((section) => {
      const placeholderCategories = ['Personalized Gifts', 'Corporate Gifts', 'Birthday Gifts', 'Anniversary Gifts'];
      const placeholderTypeMs = 90;
      const placeholderDeleteMs = 45;
      const placeholderPauseMs = 1600;
      const placeholderNextMs = 300;
      const mount = section.querySelector('[data-clean-header-mount]');
      const desktopTemplate = section.querySelector('[data-clean-header-desktop]');
      const mobileTemplate = section.querySelector('[data-clean-header-mobile]');
      const breakpoint = Number(section.dataset.desktopBreakpoint) || 1024;
      const desktopOnly = section.dataset.cleanHeaderDesktopOnly === 'true';
      const media = window.matchMedia(`(min-width: ${breakpoint}px)`);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let mode;
      let ticking = false;
      let placeholderTimeout;
      let placeholderCategoryIndex = 0;
      let placeholderLength = 0;
      let isDeletingPlaceholder = false;
      let enableNavHoverOnPointerMove;
      let searchAbortController;
      let searchTimeout;
      let cleanCartItemCount = Number.parseInt(section.dataset.cleanInitialCartCount || '0', 10) || 0;
      let mobileHeaderHeight = 84;
      const searchCache = new Map();

      const getWishlistCount = () => {
        try {
          const items = JSON.parse(localStorage.getItem('wishlistItem') || '[]');
          return Array.isArray(items) ? items.filter((item) => typeof item === 'string' && item.trim()).length : 0;
        } catch (error) {
          return 0;
        }
      };

      const updateCountBadges = (selector, count) => {
        const safeCount = Number.isFinite(Number(count)) ? Math.max(0, Number(count)) : 0;
        document.querySelectorAll(selector).forEach((badge) => {
          badge.textContent = String(safeCount);
          badge.hidden = safeCount === 0;
        });
      };

      const syncWishlistCount = () => {
        updateCountBadges('[data-clean-wishlist-count], [data-wishlist-count]', getWishlistCount());
      };

      const syncCartCount = (cart) => {
        if (cart && typeof cart.item_count !== 'undefined') {
          cleanCartItemCount = Number(cart.item_count || 0);
        }

        updateCountBadges('[data-clean-cart-count]', cleanCartItemCount);
      };

      const isBulkEnquireLink = (link) => {
        const href = link.getAttribute('href')?.trim();
        const title = link.textContent.trim().replace(/\s+/g, ' ').toLowerCase();
        if (!href || title !== 'bulk enquire') return false;

        try {
          const url = new URL(href, window.location.origin);
          return url.pathname.includes('corporate-gifting');
        } catch (error) {
          return href.includes('corporate-gifting');
        }
      };

      const scrollToBulkGiftingForm = () => {
        const target =
          document.querySelector('#clean-bulk-gifting-banner') ||
          document.querySelector('.clean-bulk-gifting-banner') ||
          document.querySelector('.bgb-container') ||
          document.querySelector('.bgb-section');
        if (!target) return false;

        updateSticky();

        const headerOffset = (mount.querySelector('[data-clean-header-bar]')?.offsetHeight || 64) + 10;
        const top = Math.max(target.getBoundingClientRect().top + window.scrollY - headerOffset, 0);
        window.scrollTo({
          top,
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
        });

        return true;
      };

      const cleanBulkGiftingScrollUrl = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('scrollto');
        const query = url.searchParams.toString();
        window.history.replaceState({}, document.title, `${url.pathname}${query ? `?${query}` : ''}${url.hash}`);
      };

      const normalizePathname = (pathname) => pathname.replace(/\/+$/, '') || '/';

      const handleBulkGiftingScrollRequest = () => {
        const params = new URLSearchParams(window.location.search);
        const scrollTarget = params.get('scrollto');
        const hashTarget = window.location.hash.replace('#', '');
        const shouldScroll =
          scrollTarget === 'clean-bulk-gifting-banner' ||
          scrollTarget === 'bgb-container' ||
          hashTarget === 'clean-bulk-gifting-banner';
        if (!shouldScroll) return;

        let attempts = 0;
        const tryScroll = () => {
          attempts += 1;

          if (scrollToBulkGiftingForm()) {
            cleanBulkGiftingScrollUrl();
            return;
          }

          if (attempts < 10) {
            window.setTimeout(tryScroll, 100);
          }
        };

        window.setTimeout(tryScroll, 400);
      };

      const stopPlaceholder = () => {
        window.clearTimeout(placeholderTimeout);
      };

      const startPlaceholder = () => {
        stopPlaceholder();

        const input = mount.querySelector('.clean-header__search input[type="search"]');
        if (!input) return;

        if (!input.dataset.cleanPlaceholderReady) {
          input.dataset.cleanPlaceholderReady = 'true';
          input.addEventListener('focus', () => {
            stopPlaceholder();
            input.placeholder = '';
          });
          input.addEventListener('blur', startPlaceholder);
        }

        if (document.hidden || document.activeElement === input) {
          input.placeholder = '';
          return;
        }

        if (reducedMotion.matches) {
          input.placeholder = `Search for ${placeholderCategories[0]}`;
          return;
        }

        const updatePlaceholder = () => {
          const category = placeholderCategories[placeholderCategoryIndex];
          const isComplete = placeholderLength === category.length;
          const isEmpty = placeholderLength === 0;
          let delay = isDeletingPlaceholder ? placeholderDeleteMs : placeholderTypeMs;

          input.placeholder = `Search for ${category.slice(0, placeholderLength)}`;

          if (isComplete && !isDeletingPlaceholder) {
            delay = placeholderPauseMs;
          } else if (isEmpty && isDeletingPlaceholder) {
            delay = placeholderNextMs;
          }

          placeholderTimeout = window.setTimeout(() => {
            if (isComplete && !isDeletingPlaceholder) {
              isDeletingPlaceholder = true;
            } else if (isEmpty && isDeletingPlaceholder) {
              placeholderCategoryIndex = (placeholderCategoryIndex + 1) % placeholderCategories.length;
              isDeletingPlaceholder = false;
            } else {
              placeholderLength += isDeletingPlaceholder ? -1 : 1;
            }

            updatePlaceholder();
          }, delay);
        };

        updatePlaceholder();
      };

      const updateSticky = () => {
        const bar = mount.querySelector('[data-clean-header-bar]');
        const spacer = mount.querySelector('.clean-header__spacer');
        if (!bar || !spacer) return;

        const threshold = mode === 'desktop' ? 80 : mobileHeaderHeight;
        const sticky = window.scrollY > threshold;
        const stickyChanged = bar.classList.contains('is-sticky') !== sticky;

        if (mode === 'desktop' && stickyChanged) {
          bar.classList.add('is-nav-hover-suppressed');

          if (enableNavHoverOnPointerMove) {
            window.removeEventListener('pointermove', enableNavHoverOnPointerMove);
          }

          enableNavHoverOnPointerMove = () => {
            bar.classList.remove('is-nav-hover-suppressed');
            enableNavHoverOnPointerMove = undefined;
          };
          window.addEventListener('pointermove', enableNavHoverOnPointerMove, { once: true });
        }

        bar.classList.toggle('is-sticky', sticky);
        spacer.classList.toggle('is-visible', sticky);
      };

      const setupSearch = () => {
        const root = mount.querySelector('[data-clean-search]');
        if (!root) return;

        const form = root.querySelector('form');
        const input = root.querySelector('input[type="search"]');
        const panel = root.querySelector('[data-clean-search-panel]');
        const clearButton = root.querySelector('[data-clean-search-clear]');

        const updateClearButton = () => {
          clearButton.hidden = input.value.length === 0;
        };

        const setOpen = (open) => {
          panel.hidden = !open;
          input.setAttribute('aria-expanded', String(open));
        };

        let isSearchReady = false;
        let handleSearchIntent = () => {};
        let handleSearchSubmit = () => {};

        const initializeSearch = () => {
          if (isSearchReady) return;

          isSearchReady = true;
          input.removeEventListener('focus', onSearchIntent);
          input.removeEventListener('click', onSearchIntent);
          input.removeEventListener('input', onSearchIntent);
          clearButton.removeEventListener('click', onSearchClearIntent);
          form.removeEventListener('submit', onSearchSubmit);

          const heading = root.querySelector('[data-clean-search-heading]');
          const results = root.querySelector('[data-clean-search-results]');
          const viewAll = root.querySelector('[data-clean-search-view-all]');
          let popularMarkup = '';
          let popularRequest;
          const searchMode = root.dataset.cleanSearchMode === 'corporate' ? 'corporate' : 'personal';
          const emptySearchMarkup = '<p class="clean-header__search-message">No products found.</p>';

          const escapeHtml = (value) =>
            String(value ?? '')
              .replaceAll('&', '&amp;')
              .replaceAll('<', '&lt;')
              .replaceAll('>', '&gt;')
              .replaceAll('"', '&quot;')
              .replaceAll("'", '&#39;');

          const currencyFractionDigits = (currencyCode) => {
            try {
              return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
                style: 'currency',
                currency: currencyCode,
              }).resolvedOptions().maximumFractionDigits;
            } catch (error) {
              return 2;
            }
          };

          const formatSourceMoney = (money) => {
            const amount = Number(money?.amount);
            const currencyCode = String(money?.currencyCode || '').toUpperCase();
            if (!Number.isFinite(amount) || !/^[A-Z]{3}$/.test(currencyCode)) return '';

            try {
              return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
                style: 'currency',
                currency: currencyCode,
                maximumFractionDigits: currencyFractionDigits(currencyCode),
              }).format(amount);
            } catch (error) {
              return `${currencyCode} ${amount}`;
            }
          };

          const renderMoney = (money, className) => {
            const amount = Number(money?.amount);
            const currencyCode = String(money?.currencyCode || '').toUpperCase();
            if (!Number.isFinite(amount) || !/^[A-Z]{3}$/.test(currencyCode)) return '';

            const sourceText = formatSourceMoney(money);
            const minorAmount = Math.round(amount * 10 ** currencyFractionDigits(currencyCode));
            return `<span class="${className}" data-clean-money data-clean-money-minor="${minorAmount}" data-clean-money-currency="${currencyCode}" data-clean-money-source-text="${escapeHtml(sourceText)}">${escapeHtml(sourceText)}</span>`;
          };

          const productImageUrl = (value, width) => {
            try {
              const url = new URL(value);
              if (url.protocol !== 'https:') return '';
              url.searchParams.set('width', String(width));
              return url.toString();
            } catch (error) {
              return '';
            }
          };

          const metadataIcon = (kind) => {
            if (kind === 'personalizable') {
              return '<svg viewBox="0 0 6 6" aria-hidden="true" focusable="false"><path d="M4.106 1.151 4.354.904a.525.525 0 0 1 .742.742l-.247.248-1.665 1.665a.98.98 0 0 1-.46.26L2 4l.181-.724a.98.98 0 0 1 .26-.46l1.665-1.665Zm0 0 .743.743"></path><path d="M4.75 3.375c0 .822 0 1.233-.227 1.509a1.19 1.19 0 0 1-.139.139c-.276.227-.687.227-1.509.227H2.75c-.943 0-1.414 0-1.707-.293C.75 4.664.75 4.193.75 3.25v-.125c0-.822 0-1.233.227-1.509.041-.051.088-.097.139-.139.276-.227.687-.227 1.509-.227"></path></svg>';
            }

            if (kind === 'same-day') {
              return '<svg viewBox="0 0 15 15" aria-hidden="true" focusable="false"><path d="M13.75 7.5A6.25 6.25 0 1 0 5.543 13.438M5.625 8.75 7.5 7.5V4.167M8.125 10h1.25a.625.625 0 0 1 .625.625v.625a.625.625 0 0 1-.625.625H8.75a.625.625 0 0 0-.625.625v.625c0 .345.28.625.625.625H10M13.75 10v1.875m0 0H12.5a.625.625 0 0 1-.625-.625V10m1.875 1.875v1.875"></path></svg>';
            }

            if (kind === 'express') {
              return '<svg viewBox="0 0 15 15" aria-hidden="true" focusable="false"><path d="M12.5625 10.9375C12.5625 11.8004 11.8629 12.5 11 12.5C10.1371 12.5 9.4375 11.8004 9.4375 10.9375C9.4375 10.0746 10.1371 9.375 11 9.375C11.8629 9.375 12.5625 10.0746 12.5625 10.9375Z"></path><path d="M6.3125 10.9375C6.3125 11.8004 5.61294 12.5 4.75 12.5C3.88706 12.5 3.1875 11.8004 3.1875 10.9375C3.1875 10.0746 3.88706 9.375 4.75 9.375C5.61294 9.375 6.3125 10.0746 6.3125 10.9375Z"></path><path d="M9.43749 10.9375H6.31249M12.5625 10.9375H13.0395C13.1769 10.9375 13.2457 10.9375 13.3034 10.9303C13.7293 10.8773 14.0647 10.5418 14.1178 10.1159C14.125 10.0582 14.125 9.98945 14.125 9.85201V8.12501C14.125 5.88135 12.3062 4.06251 10.0625 4.06251M0.375 2.4375L7.87499 2.50001C8.75886 2.50001 9.2008 2.50001 9.47543 2.7746C9.74999 3.04918 9.74999 3.49113 9.74999 4.37501V9.68751M1.62499 7.96876V9.37501C1.62499 9.95913 1.62499 10.2512 1.75059 10.4688C1.83287 10.6113 1.95122 10.7296 2.09374 10.8119C2.31129 10.9375 2.60335 10.9375 3.18749 10.9375"></path><path d="M0.375 4.5H5.25M0.375 6.375H3.625"></path></svg>';
            }

            if (kind === 'moq') {
              return '<svg viewBox="0 0 16 15" aria-hidden="true" focusable="false"><path d="M1 1.5h9v12H1zM10 4.5h5v9h-5zM3 4h5M3 7h5M3 10h5M11.5 7h2M11.5 10h2"></path></svg>';
            }

            return '';
          };

          const renderMetadata = (metadata) => {
            if (!Array.isArray(metadata) || !metadata.length) return '';

            const firstPromotion = metadata.find((tag) => tag?.kind !== 'moq');
            const minimumQuantity = metadata.find((tag) => tag?.kind === 'moq');
            const tags = [firstPromotion, minimumQuantity].filter(Boolean).map((tag) => {
              const kind = String(tag?.kind || '');
              const modifier =
                kind === 'personalizable'
                  ? ' clean-product-card__tag--personalizable'
                  : kind === 'same-day'
                    ? ' clean-product-card__tag--same-day'
                    : kind === 'express'
                      ? ' clean-product-card__tag--express'
                      : kind === 'moq'
                        ? ' clean-product-card__tag--minimum-quantity'
                        : '';
              const label = kind === 'same-day' ? 'Same Day' : kind === 'express' ? 'Express' : tag?.label;
              return `<span class="clean-product-card__tag${modifier}">${metadataIcon(kind)}${escapeHtml(label)}</span>`;
            });

            return `<span class="clean-product-card__tags">${tags.join('')}</span>`;
          };

          const renderSearchCard = (product) => {
            const handle = String(product?.handle || '');
            const title = String(product?.title || '');
            if (!handle || !title) return '';

            const imageUrl = productImageUrl(product.image?.url, 480);
            const imageWidth = Number(product.image?.width) || 480;
            const imageHeight = Number(product.image?.height) || 480;
            const imageMarkup = imageUrl
              ? `<img class="clean-product-card__image clean-product-card__image--primary" src="${escapeHtml(imageUrl)}" srcset="${escapeHtml(productImageUrl(product.image?.url, 240))} 240w, ${escapeHtml(productImageUrl(product.image?.url, 360))} 360w, ${escapeHtml(imageUrl)} 480w" sizes="(min-width: 1024px) min(25vw, 277px), calc((100vw - 50px) / 2)" alt="${escapeHtml(product.image?.altText || title)}" width="${imageWidth}" height="${imageHeight}" loading="lazy" decoding="async">`
              : '';
            const compareAtPrice = product.compareAtPrice
              ? renderMoney(product.compareAtPrice, 'clean-product-card__compare-price')
              : '';
            const priceClass = `clean-product-card__price${compareAtPrice ? ' clean-product-card__price--sale' : ''}`;

            return `<div class="clean-product-card clean-product-card--search"><a class="clean-product-card__link" href="/products/${encodeURIComponent(handle)}"><span class="clean-product-card__media">${imageMarkup}</span><span class="clean-product-card__content"><span class="clean-product-card__title">${escapeHtml(title)}</span><span class="clean-product-card__price-row">${compareAtPrice}${renderMoney(product.price, priceClass)}</span>${renderMetadata(product.metadata)}</span></a></div>`;
          };

          const renderSearchProducts = (products) => {
            if (!Array.isArray(products) || !products.length) return emptySearchMarkup;
            const cards = products.map(renderSearchCard).filter(Boolean);
            return cards.length ? `<div class="clean-header__search-grid">${cards.join('')}</div>` : emptySearchMarkup;
          };

          const fetchSearchProducts = async (query, signal) => {
            const url = new URL(root.dataset.predictiveSearchUrl, window.location.origin);
            url.searchParams.set('mode', searchMode);
            url.searchParams.set('q', query);

            const response = await fetch(url, {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' },
              signal,
            });
            if (!response.ok) throw new Error(`Search request failed: ${response.status}`);

            const payload = await response.json();
            return renderSearchProducts(payload?.products);
          };

          const loadPopularMarkup = async () => {
            if (popularMarkup) return popularMarkup;

            if (!popularRequest) {
              popularRequest = fetchSearchProducts('', undefined)
                .then((markup) => {
                  popularMarkup = markup;
                  return popularMarkup;
                })
                .catch(() => {
                  popularMarkup = emptySearchMarkup;
                  return popularMarkup;
                })
                .finally(() => {
                  popularRequest = undefined;
                });
            }

            return popularRequest;
          };

          const showPopular = async () => {
            const requestedQuery = input.value.trim();

            window.clearTimeout(searchTimeout);
            searchAbortController?.abort();
            heading.textContent = 'Popular products';
            viewAll.hidden = true;

            if (popularMarkup) {
              results.innerHTML = popularMarkup;
              setOpen(true);
              return;
            }

            results.innerHTML = '<p class="clean-header__search-message">Loading...</p>';
            setOpen(true);

            const markup = await loadPopularMarkup();

            if (input.value.trim() === requestedQuery) {
              results.innerHTML = markup;
              heading.textContent = 'Popular products';
              viewAll.hidden = true;
              setOpen(true);
            }
          };

          const showSearchResults = (query, markup) => {
            heading.textContent = 'Product results';
            results.innerHTML = markup;

            const searchUrl = new URL(form.action, window.location.origin);
            searchUrl.searchParams.set('q', query);
            viewAll.href = searchUrl.toString();
            viewAll.hidden = false;
            setOpen(true);
          };

          const loadSearchResults = (query) => {
            const normalizedQuery = query.toLowerCase();
            const cacheKey = `${searchMode}:${normalizedQuery}`;
            const cachedMarkup = searchCache.get(cacheKey);

            window.clearTimeout(searchTimeout);
            searchAbortController?.abort();

            if (cachedMarkup) {
              showSearchResults(query, cachedMarkup);
              return;
            }

            results.innerHTML = '<p class="clean-header__search-message">Loading...</p>';
            heading.textContent = 'Product results';
            viewAll.hidden = true;
            setOpen(true);

            searchTimeout = window.setTimeout(async () => {
              searchAbortController = new AbortController();

              try {
                const markup = await fetchSearchProducts(query, searchAbortController.signal);
                searchCache.set(cacheKey, markup);

                if (input.value.trim().toLowerCase() === normalizedQuery) {
                  showSearchResults(input.value.trim(), markup);
                }
              } catch (error) {
                if (error.name !== 'AbortError') {
                  results.innerHTML = '<p class="clean-header__search-message">No products found.</p>';
                }
              }
            }, 500);
          };

          handleSearchIntent = () => {
            updateClearButton();
            const query = input.value.trim();
            if (query) {
              loadSearchResults(query);
            } else {
              showPopular();
            }
          };

          handleSearchSubmit = (event) => {
            if (!input.value.trim()) {
              event.preventDefault();
              showPopular();
            }
          };

          input.addEventListener('focus', handleSearchIntent);
          input.addEventListener('input', handleSearchIntent);

          clearButton.addEventListener('click', () => {
            input.value = '';
            updateClearButton();
            input.focus();
            showPopular();
          });

          form.addEventListener('submit', handleSearchSubmit);

          updateClearButton();
        };

        function onSearchIntent() {
          initializeSearch();
          handleSearchIntent();
        }

        function onSearchSubmit(event) {
          initializeSearch();
          handleSearchSubmit(event);
        }

        function onSearchClearIntent() {
          initializeSearch();
          input.value = '';
          updateClearButton();
          input.focus();
          handleSearchIntent();
        }

        input.addEventListener('focus', onSearchIntent);
        input.addEventListener('click', onSearchIntent);
        input.addEventListener('input', onSearchIntent);
        clearButton.addEventListener('click', onSearchClearIntent);
        form.addEventListener('submit', onSearchSubmit);
        updateClearButton();
      };

      const setupNavDropdowns = () => {
        mount
          .querySelectorAll('.clean-header__nav-link, .clean-header__dropdown-link, .clean-header__submenu-link')
          .forEach((link) => {
            link.addEventListener('click', (event) => {
              const href = link.getAttribute('href')?.trim();
              if (isBulkEnquireLink(link)) {
                event.preventDefault();

                const destination = new URL(href, window.location.origin);
                if (normalizePathname(destination.pathname) === normalizePathname(window.location.pathname)) {
                  scrollToBulkGiftingForm();
                } else {
                  const cleanDestination = new URL('/pages/corporate-gifting', window.location.origin);
                  cleanDestination.hash = 'clean-bulk-gifting-banner';
                  window.location.href = cleanDestination.toString();
                }

                return;
              }

              if (!href || href === '#') {
                event.preventDefault();
              }
            });
          });

        mount
          .querySelectorAll(
            '.clean-header__nav--sticky .clean-header__nav-trigger, .clean-header__dropdown-link, .clean-header__submenu-link',
          )
          .forEach((link) => {
            link.addEventListener('pointerup', () => {
              link.blur();
            });
          });
      };

      const render = () => {
        const nextMode = media.matches ? 'desktop' : desktopOnly ? 'disabled' : 'mobile';
        if (nextMode === mode) return;

        mode = nextMode;
        stopPlaceholder();
        if (mode === 'disabled') {
          mount.replaceChildren();
          return;
        }

        mount.replaceChildren((mode === 'desktop' ? desktopTemplate : mobileTemplate).content.cloneNode(true));

        if (mode === 'mobile') {
          const renderedBar = mount.querySelector('[data-clean-header-bar]');
          const renderedSpacer = mount.querySelector('.clean-header__spacer');
          mobileHeaderHeight = renderedBar?.offsetHeight || 84;
          if (renderedSpacer) renderedSpacer.style.height = `${mobileHeaderHeight}px`;
        }

        updateSticky();
        syncWishlistCount();
        syncCartCount();
        startPlaceholder();
        setupSearch();
        setupNavDropdowns();
        document.dispatchEvent(new CustomEvent('clean:header:rendered'));
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          updateSticky();
          ticking = false;
        });
      };

      render();
      media.addEventListener('change', render);
      reducedMotion.addEventListener('change', startPlaceholder);
      document.addEventListener('visibilitychange', startPlaceholder);
      document.addEventListener('addwishlistitem', syncWishlistCount);
      document.addEventListener('updatewishlistmail', syncWishlistCount);
      window.addEventListener('storage', (event) => {
        if (event.key === 'wishlistItem') syncWishlistCount();
      });
      document.addEventListener('clean:cart:updated', (event) => syncCartCount(event.detail?.cart));
      document.addEventListener('cart-update', (event) => syncCartCount(event.detail));
      document.addEventListener('cart:updated', (event) => syncCartCount(event.detail?.cart || event.detail));
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handleBulkGiftingScrollRequest, { once: true });
      } else {
        handleBulkGiftingScrollRequest();
      }
      document.addEventListener('mousedown', (event) => {
        const search = mount.querySelector('[data-clean-search]');
        if (search && !search.contains(event.target)) {
          const panel = search.querySelector('[data-clean-search-panel]');
          const input = search.querySelector('input[type="search"]');
          panel.hidden = true;
          input.setAttribute('aria-expanded', 'false');
        }
      });
      window.addEventListener('scroll', onScroll, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSlideshow = (slideshow) => {
      if (slideshow.dataset.cleanHeroInitialized === 'true') return;

      const slides = Array.from(slideshow.querySelectorAll('[data-clean-hero-slide]'));
      const indicators = Array.from(slideshow.querySelectorAll('[data-clean-hero-indicator]'));
      const slidesContainer = slideshow.querySelector('.clean-hero-slideshow__slides');
      const autoplay = slideshow.dataset.autoplay === 'true';
      const mobileViewport = window.matchMedia('(max-width: 767px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const interval = Number(slideshow.dataset.interval) || 5000;
      let activeIndex = 0;
      let autoplayReady = false;
      let paused = false;
      let scrollFrame;
      let resizeFrame;
      let restoreScrollBehaviorFrame;
      let loopResetTimer;
      let preloadTimer;
      let timer;
      let inlinePadding;
      let loopClone;
      let backwardLoopClone;
      let dragPointerId = null;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let dragDidMove = false;
      let swipePointerId = null;
      let swipeStartX = 0;
      let suppressClickUntil = 0;

      if (!slides.length || !slidesContainer) return;

      const hydrateSlide = (slide, urgent = false) => {
        if (!slide) return;

        slide.querySelectorAll('source[data-clean-hero-srcset]').forEach((source) => {
          source.srcset = source.dataset.cleanHeroSrcset;
          source.removeAttribute('data-clean-hero-srcset');
        });

        const image = slide.querySelector('img');
        if (!image) return;

        if (urgent && image.fetchPriority !== 'high') image.fetchPriority = 'auto';
        if (!image.hasAttribute('data-clean-hero-src')) return;

        image.loading = 'eager';
        image.srcset = image.dataset.cleanHeroSrcset;
        image.src = image.dataset.cleanHeroSrc;
        image.removeAttribute('data-clean-hero-srcset');
        image.removeAttribute('data-clean-hero-src');
      };

      hydrateSlide(slides[0], true);

      const createLoopClone = (sourceSlide, prepend = false) => {
        const clone = sourceSlide.cloneNode(true);
        clone.classList.remove('clean-hero-slideshow__slide--active');
        clone.classList.add('clean-hero-slideshow__slide--loop-clone');
        clone.removeAttribute('id');
        clone.removeAttribute('data-clean-hero-slide');
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('role', 'presentation');
        clone.removeAttribute('aria-label');
        clone.removeAttribute('aria-roledescription');

        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
          element.tabIndex = -1;
        });

        const loopImage = clone.querySelector('img');
        if (loopImage) {
          loopImage.loading = 'lazy';
          loopImage.fetchPriority = 'low';
        }

        if (prepend) {
          slidesContainer.prepend(clone);
        } else {
          slidesContainer.appendChild(clone);
        }

        return clone;
      };

      if (slides.length > 1) {
        loopClone = createLoopClone(slides[0]);
        loopClone.classList.add('clean-hero-slideshow__slide--loop-start');
        createLoopClone(slides[1]);
        backwardLoopClone = createLoopClone(slides[slides.length - 1], true);
        backwardLoopClone.classList.add('clean-hero-slideshow__slide--loop-backward');
      }

      const updateMeasurements = () => {
        inlinePadding = Number.parseFloat(window.getComputedStyle(slidesContainer).paddingInlineStart) || 0;
      };

      updateMeasurements();

      if (backwardLoopClone) {
        slidesContainer.style.scrollBehavior = 'auto';
        slidesContainer.scrollLeft = slides[0].offsetLeft - inlinePadding;
        slidesContainer.style.removeProperty('scroll-behavior');
      }

      const scheduleNextSlide = () => {
        window.clearTimeout(preloadTimer);
        window.clearTimeout(timer);
        if (
          !autoplayReady ||
          !autoplay ||
          paused ||
          dragPointerId !== null ||
          mobileViewport.matches ||
          reducedMotion.matches ||
          document.hidden ||
          slides.length < 2
        ) {
          return;
        }

        const nextIndex = activeIndex + 1;
        const normalizedNextIndex = nextIndex % slides.length;
        const preloadDelay = Math.max(0, interval - 1000);

        preloadTimer = window.setTimeout(() => hydrateSlide(slides[normalizedNextIndex]), preloadDelay);
        timer = window.setTimeout(() => goToSlide(nextIndex), interval);
      };

      const updateActiveState = (requestedIndex) => {
        activeIndex = (requestedIndex + slides.length) % slides.length;
        slideshow.dataset.currentSlide = String(activeIndex + 1);
        hydrateSlide(slides[activeIndex], true);
        hydrateSlide(slides[(activeIndex + 1) % slides.length], true);

        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          const link = slide.querySelector('a');

          slide.classList.toggle('clean-hero-slideshow__slide--active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          if (link) link.tabIndex = isActive ? 0 : -1;
        });

        indicators.forEach((indicator, index) => {
          const isActive = index === activeIndex;
          indicator.classList.toggle('clean-hero-slideshow__indicator--active', isActive);
          indicator.setAttribute('aria-selected', String(isActive));
        });
      };

      const scrollToPosition = (left, smooth = true) => {
        if (smooth && !reducedMotion.matches) {
          slidesContainer.scrollTo({ left, behavior: 'smooth' });
          return;
        }

        if (restoreScrollBehaviorFrame) window.cancelAnimationFrame(restoreScrollBehaviorFrame);
        slidesContainer.style.scrollBehavior = 'auto';
        slidesContainer.scrollTo({ left, behavior: 'auto' });
        restoreScrollBehaviorFrame = window.requestAnimationFrame(() => {
          restoreScrollBehaviorFrame = undefined;
          slidesContainer.style.removeProperty('scroll-behavior');
        });
      };

      const goToSlide = (requestedIndex, smooth = true) => {
        const nextIndex = (requestedIndex + slides.length) % slides.length;
        const followingIndex = (nextIndex + 1) % slides.length;
        const isForwardLoop = requestedIndex >= slides.length && loopClone;
        const isBackwardLoop = requestedIndex < 0 && backwardLoopClone;
        const targetSlide = isForwardLoop ? loopClone : isBackwardLoop ? backwardLoopClone : slides[nextIndex];
        const left = targetSlide.offsetLeft - inlinePadding;

        hydrateSlide(slides[nextIndex], true);
        hydrateSlide(slides[followingIndex], true);
        if (targetSlide !== slides[nextIndex]) hydrateSlide(targetSlide, true);

        scrollToPosition(left, smooth);

        scheduleNextSlide();
      };

      const resetForwardLoop = () => {
        if (!loopClone || dragPointerId !== null) return;

        const cloneLeft = loopClone.offsetLeft - inlinePadding;
        if (Math.abs(slidesContainer.scrollLeft - cloneLeft) > 2) return;

        updateActiveState(0);
        scrollToPosition(slides[0].offsetLeft - inlinePadding, false);
        scheduleNextSlide();
      };

      const resetBackwardLoop = () => {
        if (!backwardLoopClone || dragPointerId !== null) return;

        const cloneLeft = backwardLoopClone.offsetLeft - inlinePadding;
        if (Math.abs(slidesContainer.scrollLeft - cloneLeft) > 2) return;

        updateActiveState(slides.length - 1);
        scrollToPosition(slides[slides.length - 1].offsetLeft - inlinePadding, false);
        scheduleNextSlide();
      };

      const resetLoopPosition = () => {
        resetForwardLoop();
        resetBackwardLoop();
      };

      const getClosestDesktopDragTarget = () => {
        let requestedIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const distance = Math.abs(slide.offsetLeft - inlinePadding - slidesContainer.scrollLeft);
          if (distance >= nearestDistance) return;
          nearestDistance = distance;
          requestedIndex = index;
        });

        if (loopClone) {
          const loopDistance = Math.abs(loopClone.offsetLeft - inlinePadding - slidesContainer.scrollLeft);
          if (loopDistance < nearestDistance) {
            nearestDistance = loopDistance;
            requestedIndex = slides.length;
          }
        }

        if (backwardLoopClone) {
          const loopDistance = Math.abs(backwardLoopClone.offsetLeft - inlinePadding - slidesContainer.scrollLeft);
          if (loopDistance < nearestDistance) requestedIndex = -1;
        }

        return requestedIndex;
      };

      const finishDesktopDrag = (event) => {
        if (event.pointerId !== dragPointerId) return;

        const shouldSnap = dragDidMove;
        const requestedIndex = shouldSnap ? getClosestDesktopDragTarget() : activeIndex;

        if (slidesContainer.hasPointerCapture(event.pointerId)) {
          slidesContainer.releasePointerCapture(event.pointerId);
        }

        dragPointerId = null;
        dragDidMove = false;
        slidesContainer.classList.remove('clean-hero-slideshow__slides--dragging');

        if (!shouldSnap) return;

        suppressClickUntil = Date.now() + 400;
        window.requestAnimationFrame(() => goToSlide(requestedIndex));
      };

      indicators.forEach((indicator) => {
        const hydrateIndicatorSlide = () => hydrateSlide(slides[Number(indicator.dataset.slideIndex)]);

        indicator.addEventListener('pointerenter', hydrateIndicatorSlide);
        indicator.addEventListener('focus', hydrateIndicatorSlide);
        indicator.addEventListener('click', () => goToSlide(Number(indicator.dataset.slideIndex)));
      });

      slidesContainer.addEventListener('pointerdown', (event) => {
        if (event.button !== 0 || slides.length < 2) return;

        if (mobileViewport.matches) {
          swipePointerId = event.pointerId;
          swipeStartX = event.clientX;
          return;
        }

        dragPointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartScrollLeft = slidesContainer.scrollLeft;
        dragDidMove = false;
      });

      slidesContainer.addEventListener('pointermove', (event) => {
        if (event.pointerId === swipePointerId) {
          const distance = event.clientX - swipeStartX;
          if (Math.abs(distance) < 5) return;

          const swipeTargetIndex = distance < 0 ? activeIndex + 1 : activeIndex - 1;
          hydrateSlide(slides[(swipeTargetIndex + slides.length) % slides.length]);
          swipePointerId = null;
          return;
        }

        if (event.pointerId !== dragPointerId) return;

        const distance = event.clientX - dragStartX;
        if (!dragDidMove && Math.abs(distance) < 5) return;

        if (!dragDidMove) {
          dragDidMove = true;
          const dragTargetIndex = distance < 0 ? activeIndex + 1 : activeIndex - 1;
          hydrateSlide(slides[(dragTargetIndex + slides.length) % slides.length]);
          slidesContainer.setPointerCapture(event.pointerId);
        }

        event.preventDefault();
        slidesContainer.classList.add('clean-hero-slideshow__slides--dragging');
        slidesContainer.scrollLeft = dragStartScrollLeft - distance;
      });

      slidesContainer.addEventListener('pointerup', finishDesktopDrag);
      slidesContainer.addEventListener('pointercancel', finishDesktopDrag);
      slidesContainer.addEventListener('pointerup', (event) => {
        if (event.pointerId === swipePointerId) swipePointerId = null;
      });
      slidesContainer.addEventListener('pointercancel', (event) => {
        if (event.pointerId === swipePointerId) swipePointerId = null;
      });
      slidesContainer.addEventListener('pointerleave', (event) => {
        if (event.pointerId === dragPointerId && !dragDidMove) dragPointerId = null;
      });
      slidesContainer.addEventListener('dragstart', (event) => event.preventDefault());
      slidesContainer.addEventListener(
        'click',
        (event) => {
          if (Date.now() >= suppressClickUntil) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true,
      );

      slidesContainer.addEventListener('scrollend', resetLoopPosition);

      slidesContainer.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(loopResetTimer);
          loopResetTimer = window.setTimeout(resetLoopPosition, 80);
          if (scrollFrame) return;

          scrollFrame = window.requestAnimationFrame(() => {
            scrollFrame = undefined;
            let nearestIndex = 0;
            let nearestDistance = Number.POSITIVE_INFINITY;

            slides.forEach((slide, index) => {
              const distance = Math.abs(slide.offsetLeft - inlinePadding - slidesContainer.scrollLeft);
              if (distance >= nearestDistance) return;
              nearestDistance = distance;
              nearestIndex = index;
            });

            if (nearestIndex !== activeIndex) updateActiveState(nearestIndex);
            scheduleNextSlide();
          });
        },
        { passive: true },
      );

      slideshow.addEventListener('pointerenter', () => {
        paused = true;
        window.clearTimeout(preloadTimer);
        window.clearTimeout(timer);
      });

      slideshow.addEventListener('pointerleave', () => {
        paused = false;
        scheduleNextSlide();
      });

      slideshow.addEventListener('focusin', () => {
        paused = true;
        window.clearTimeout(preloadTimer);
        window.clearTimeout(timer);
      });

      slideshow.addEventListener('focusout', (event) => {
        if (slideshow.contains(event.relatedTarget)) return;
        paused = false;
        scheduleNextSlide();
      });

      window.addEventListener(
        'resize',
        () => {
          if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
          resizeFrame = window.requestAnimationFrame(() => {
            resizeFrame = undefined;
            updateMeasurements();
            goToSlide(activeIndex, false);
          });
        },
        { passive: true },
      );

      document.addEventListener('shopify:block:select', (event) => {
        const selectedSlide = event.target.closest('[data-clean-hero-slide]');
        if (!selectedSlide || !slideshow.contains(selectedSlide)) return;
        goToSlide(slides.indexOf(selectedSlide), false);
      });

      slideshow.dataset.cleanHeroInitialized = 'true';
      updateActiveState(0);
      document.addEventListener('visibilitychange', scheduleNextSlide);
      mobileViewport.addEventListener('change', scheduleNextSlide);
      reducedMotion.addEventListener('change', scheduleNextSlide);

      const initialImage = slides[0].querySelector('img');
      const enableAutoplay = () => {
        autoplayReady = true;
        scheduleNextSlide();
      };

      if (!initialImage || initialImage.complete) {
        enableAutoplay();
      } else {
        initialImage.addEventListener('load', enableAutoplay, { once: true });
        initialImage.addEventListener('error', enableAutoplay, { once: true });
      }
    };

    const initializeAllSlideshows = (container = document) => {
      container.querySelectorAll('[data-clean-hero-slideshow]').forEach(initializeSlideshow);
    };

    initializeAllSlideshows();
    document.addEventListener('shopify:section:load', (event) => initializeAllSlideshows(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-cart"]) return;
  try {
    
  (() => {
    const escapeCleanCartPageHtml = (value) =>
      String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const cleanCartPageAjaxUrl = (url, fallback) => {
      const rawUrl = url || fallback;

      try {
        const parsedUrl = new URL(rawUrl, window.location.origin);
        const path = parsedUrl.pathname.replace(/\/$/, '');
        parsedUrl.pathname = path.endsWith('.js') ? path : `${path}.js`;
        parsedUrl.search = '';

        return `${parsedUrl.pathname}${parsedUrl.search}`;
      } catch (error) {
        const path = String(rawUrl || fallback || '').replace(/\/$/, '');
        return path.endsWith('.js') ? path : `${path}.js`;
      }
    };

    const cleanCartPageRequest = (url, options = {}) =>
      fetch(url, {
        credentials: 'same-origin',
        ...options,
        headers: {
          Accept: 'application/json',
          'X-Clean-Cart': 'true',
          ...(options.headers || {}),
        },
      });

    const cleanCartPageFormatMoney = (cents, moneyFormat) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat).replace(/\.00(?!\d)/g, '');
      }

      const amount = (Number(cents || 0) / 100).toFixed(2).replace(/\.00$/, '');
      if (!moneyFormat) return amount;

      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amount.replace(/\.\d+$/, ''))
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/<[^>]*>/g, '');
    };

    const cleanCartPageSourceCurrency = () =>
      document.querySelector('[data-clean-display-currency-config]')?.dataset.cleanDisplayCurrencySource || '';

    const cleanCartPageMoneyAttributes = (cents, moneyFormat) => {
      const sourceText = cleanCartPageFormatMoney(cents, moneyFormat);
      return `data-clean-money data-clean-money-minor="${escapeCleanCartPageHtml(
        cents,
      )}" data-clean-money-currency="${escapeCleanCartPageHtml(
        cleanCartPageSourceCurrency(),
      )}" data-clean-money-source-text="${escapeCleanCartPageHtml(sourceText)}"`;
    };

    const cleanSetCartPageMoney = (target, cents, moneyFormat) => {
      if (!target) return;

      const sourceText = cleanCartPageFormatMoney(cents, moneyFormat);
      target.dataset.cleanMoney = '';
      target.dataset.cleanMoneyMinor = String(cents);
      target.dataset.cleanMoneyCurrency = cleanCartPageSourceCurrency();
      target.dataset.cleanMoneySourceText = sourceText;
      target.textContent = sourceText;
      if (window.CleanDisplayCurrency?.ready) {
        window.CleanDisplayCurrency.refresh(target);
      } else {
        window.CleanDisplayCurrencyBootstrap?.refresh?.(target);
      }
    };

    const cleanCartPageQuantity = (value) => {
      const quantity = Number.parseInt(value, 10);
      return Number.isFinite(quantity) ? Math.max(0, quantity) : 0;
    };

    const getCleanCartPageImageUrl = (source, width = 220) => {
      if (!source) return '';

      try {
        const imageUrl = new URL(source, window.location.origin);
        const hostname = imageUrl.hostname.toLowerCase();
        const isShopifyImage =
          hostname === window.location.hostname.toLowerCase() ||
          hostname === 'cdn.shopify.com' ||
          hostname.endsWith('.myshopify.com') ||
          hostname.endsWith('.shopifycdn.com');

        if (isShopifyImage) imageUrl.searchParams.set('width', String(width));
        return imageUrl.toString();
      } catch (error) {
        return String(source);
      }
    };

    const cleanCartPageLinePrice = (item) => Number(item?.final_line_price || 0);
    const cleanCartPageAddOnParentProductProperty = '_clean_add_on_parent_product_id';
    const cleanCartPageAddOnParentVariantProperty = '_clean_add_on_parent_variant_id';

    window.CleanGokwik =
      window.CleanGokwik ||
      (() => {
        const state = {
          countryPromise: null,
          scriptPromise: null,
          loaded: false,
        };

        const readDetectedCountry = async () => {
          if (state.countryPromise) return state.countryPromise;

          state.countryPromise = (async () => {
            try {
              const cachedCountry = sessionStorage.getItem('cleanGokwikCountry');
              if (cachedCountry) return cachedCountry;

              const response = await fetch('/browsing_context_suggestions.json', {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
              });
              if (!response.ok) return '';

              const data = await response.json();
              const detected = data?.detected_values || {};
              const country =
                detected.country_code ||
                detected.country?.iso_code ||
                detected.country?.handle ||
                (detected.country_name === 'India' ? 'IN' : detected.country_name || '');
              const normalizedCountry = String(country || '').toUpperCase();

              sessionStorage.setItem('cleanGokwikCountry', normalizedCountry);
              return normalizedCountry;
            } catch (error) {
              return '';
            }
          })();

          return state.countryPromise;
        };

        const scriptHostForEnv = (environment) => {
          const normalizedEnvironment = environment || 'production';
          if (normalizedEnvironment === 'production') return 'pdp.gokwik.co';
          if (normalizedEnvironment === 'sandbox') return 'sandbox.pdp.gokwik.co';
          return 'qa.pdp.gokwik.co';
        };

        const loadSdk = (scope) => {
          if (typeof window.onCheckoutClick === 'function') {
            state.loaded = true;
            return Promise.resolve();
          }
          if (state.loaded) return Promise.resolve();
          if (state.scriptPromise) return state.scriptPromise;

          window.merchantInfo = {
            mid: scope.dataset.cleanGokwikMid || '',
            environment: scope.dataset.cleanGokwikEnv || 'production',
            type: 'merchantInfo',
            storeId: scope.dataset.cleanGokwikStoreId || '',
            fbpixel: scope.dataset.cleanGokwikFbpixel || '',
          };
          window.productFormSelector = window.productFormSelector || '';
          window.templateName = window.templateName || 'cart';

          state.scriptPromise = new Promise((resolve, reject) => {
            let isSettled = false;
            const existingScript = document.querySelector(
              '[data-clean-gokwik-sdk], script[src*="merchant-integration/build/merchant.integration.js"]',
            );
            let readyTimer = null;
            let readyTimeout = null;
            const finish = () => {
              if (isSettled || typeof window.onCheckoutClick !== 'function') return;
              isSettled = true;
              window.clearInterval(readyTimer);
              window.clearTimeout(readyTimeout);
              document.removeEventListener('gokwikLoaded', finish);
              window.removeEventListener('gokwikLoaded', finish);
              state.loaded = true;
              resolve();
            };
            const fail = () => {
              if (isSettled) return;
              isSettled = true;
              window.clearInterval(readyTimer);
              document.removeEventListener('gokwikLoaded', finish);
              window.removeEventListener('gokwikLoaded', finish);
              state.scriptPromise = null;
              reject(new Error('GoKwik checkout is not ready yet.'));
            };

            document.addEventListener('gokwikLoaded', finish);
            window.addEventListener('gokwikLoaded', finish);
            readyTimer = window.setInterval(finish, 100);
            readyTimeout = window.setTimeout(fail, 8000);

            if (existingScript) {
              finish();
              return;
            }

            const script = document.createElement('script');
            script.src = `https://${scriptHostForEnv(scope.dataset.cleanGokwikEnv)}/merchant-integration/build/merchant.integration.js?v4`;
            script.defer = true;
            script.dataset.cleanGokwikSdk = 'true';
            script.onload = () => {
              window.setTimeout(() => {
                if (window.onCheckoutClick) finish();
              }, 0);
            };
            script.onerror = () => {
              if (isSettled) return;
              isSettled = true;
              window.clearInterval(readyTimer);
              window.clearTimeout(readyTimeout);
              document.removeEventListener('gokwikLoaded', finish);
              window.removeEventListener('gokwikLoaded', finish);
              state.scriptPromise = null;
              reject(new Error('Unable to load GoKwik checkout.'));
            };
            document.head.appendChild(script);
          });

          return state.scriptPromise;
        };

        const setScopeVisibility = (scope, useGokwik) => {
          const gokwikButton = scope.querySelector('[data-clean-gokwik-checkout]');
          const shopifyCheckout = scope.querySelector('[data-clean-shopify-checkout]');

          if (shopifyCheckout) shopifyCheckout.hidden = useGokwik;
          if (!gokwikButton) return;

          gokwikButton.hidden = !useGokwik;
          gokwikButton.setAttribute('aria-hidden', useGokwik ? 'false' : 'true');
        };

        const getScopeCountry = (scope) => String(scope?.dataset.cleanGokwikCountry || '').toUpperCase();

        const isGokwikCountry = (country) => country === 'IN' || country === 'INDIA';

        const syncScope = async (scope, { detect = false, prepare = false } = {}) => {
          if (!scope || scope.dataset.cleanGokwikEnabled !== 'true') return false;

          const selectedCountry = getScopeCountry(scope);
          const detectedCountry = detect ? await readDetectedCountry() : '';
          const useGokwik = isGokwikCountry(selectedCountry) && (!detect || isGokwikCountry(detectedCountry));

          setScopeVisibility(scope, useGokwik);
          if (useGokwik && prepare) loadSdk(scope).catch(() => {});

          return useGokwik;
        };

        const checkout = async (button, scope) => {
          if (!scope || scope.dataset.cleanGokwikEnabled !== 'true') {
            throw new Error('GoKwik checkout is not available.');
          }

          const useGokwik = await syncScope(scope, { detect: true });

          if (!useGokwik) {
            const shopifyCheckout = scope.querySelector('[data-clean-shopify-checkout]');
            const checkoutUrl = shopifyCheckout?.getAttribute('href');
            if (checkoutUrl) window.location.assign(checkoutUrl);
            return;
          }

          await loadSdk(scope);

          if (typeof window.onCheckoutClick !== 'function') {
            throw new Error('GoKwik checkout is not ready yet.');
          }

          window.onCheckoutClick(button);
        };

        return { checkout, syncScope };
      })();

    const setCleanCartPageStatus = (cartPage, message = '') => {
      const status = cartPage.querySelector('[data-clean-cart-page-status]');
      if (!status) return;

      status.textContent = message;
      status.hidden = !message;
    };

    const cleanCartPagePropertyStringValue = (value) => (Array.isArray(value) ? value.join(', ') : String(value ?? ''));

    const isCleanCartPagePreviewProperty = (name) =>
      String(name || '')
        .trim()
        .toLowerCase()
        .startsWith('preview.');

    const getCleanCartPagePreviewUrls = (value) => {
      const values = Array.isArray(value) ? value : [value];
      const urls = [];

      values.forEach((item) => {
        const matches = String(item ?? '').match(/https?:\/\/[^\s,]+/gi) || [];

        matches.forEach((match) => {
          const candidate = match.replace(/^[('"[]+|[)'"\]]+$/g, '');

          try {
            const url = new URL(candidate);
            if ((url.protocol === 'http:' || url.protocol === 'https:') && !urls.includes(url.href)) {
              urls.push(url.href);
            }
          } catch (error) {
            // Ignore malformed preview URLs and fall back to the raw property value below.
          }
        });
      });

      return urls;
    };

    const renderCleanCartPagePropertyValue = (name, value) => {
      const normalizedName = String(name || '')
        .trim()
        .toLowerCase();
      const previewUrls = isCleanCartPagePreviewProperty(name) ? getCleanCartPagePreviewUrls(value) : [];

      if (normalizedName === 'preview.images' && previewUrls.length) {
        return previewUrls
          .map(
            (previewUrl, index) =>
              `<a class="clean-main-cart__meta-link" href="${escapeCleanCartPageHtml(
                previewUrl,
              )}" target="_blank" rel="noopener noreferrer">Image ${index + 1}</a>`,
          )
          .join(', ');
      }

      if (previewUrls.length) {
        return `<a class="clean-main-cart__meta-link" href="${escapeCleanCartPageHtml(
          previewUrls[0],
        )}" target="_blank" rel="noopener noreferrer">View Preview</a>`;
      }

      return escapeCleanCartPageHtml(cleanCartPagePropertyStringValue(value));
    };

    const renderCleanCartPagePropertyLabel = (name) => {
      const normalizedName = String(name || '')
        .trim()
        .toLowerCase();
      if (normalizedName === 'preview.effects') return '';
      if (normalizedName === 'preview.texts') return 'Text';
      if (normalizedName === 'preview.images') return 'Photos';
      return name;
    };

    const isCleanCartPageZipcodeProperty = (name) =>
      ['pincode', 'delivery tier', 'delivery estimate', 'delivery speed'].includes(
        String(name || '')
          .trim()
          .toLowerCase(),
      );

    const renderCleanCartPageVariantOptions = (item = {}) => {
      const options = Array.isArray(item.options_with_values) ? item.options_with_values : [];
      const visibleOptions = options.filter((option) => {
        const name = String(option?.name || '').trim();
        const value = String(option?.value || '').trim();
        return name && value && value !== 'Default Title';
      });

      if (visibleOptions.length) {
        return `
          <dl class="clean-main-cart__meta clean-main-cart__meta--variants">
            ${visibleOptions
              .map(
                (option) => `
                  <div class="clean-main-cart__meta-row">
                    <dt>${escapeCleanCartPageHtml(option.name)}:</dt>
                    <dd>${escapeCleanCartPageHtml(option.value)}</dd>
                  </div>
                `,
              )
              .join('')}
          </dl>
        `;
      }

      const variantTitle = String(item.variant_title || '').trim();
      if (!variantTitle || variantTitle === 'Default Title') return '';

      return `
        <dl class="clean-main-cart__meta clean-main-cart__meta--variants">
          <div class="clean-main-cart__meta-row">
            <dt>Variant:</dt>
            <dd>${escapeCleanCartPageHtml(variantTitle)}</dd>
          </div>
        </dl>
      `;
    };

    const renderCleanCartPageProperties = (properties = {}) => {
      const entries = Object.entries(properties).filter(([name, value]) => {
        const stringValue = cleanCartPagePropertyStringValue(value);
        return name && !name.startsWith('_') && !isCleanCartPageZipcodeProperty(name) && stringValue.trim() !== '';
      });

      if (!entries.length) return '';

      const visibleEntries = entries.filter(
        ([name]) =>
          ['Delivery Date', 'Delivery Day', 'Delivery Time', 'Name On Cake'].includes(name) ||
          isCleanCartPagePreviewProperty(name),
      );
      const fallbackEntries = visibleEntries.length ? visibleEntries : entries.slice(0, 3);

      return `
        <dl class="clean-main-cart__meta">
          ${fallbackEntries
            .map(([name, value]) => {
              const label = renderCleanCartPagePropertyLabel(name);
              return `
                <div class="clean-main-cart__meta-row">
                  ${label ? `<dt>${escapeCleanCartPageHtml(label)}:</dt>` : ''}
                  <dd>${renderCleanCartPagePropertyValue(name, value)}</dd>
                </div>
              `;
            })
            .join('')}
        </dl>
      `;
    };

    const isCleanCartPageAddOnItem = (item = {}) =>
      String(item.handle || '')
        .trim()
        .toLowerCase()
        .startsWith('winni-addon-');

    const isCleanCartPageLikelyLegacyAddOnParent = (item = {}) => {
      const vendor = String(item.vendor || '')
        .trim()
        .toLowerCase();
      const productType = String(item.product_type || '')
        .trim()
        .toLowerCase();
      const productTokens = `${item.product_title || item.title || ''} ${item.handle || ''}`
        .trim()
        .toLowerCase()
        .split(/[^a-z0-9]+/)
        .filter(Boolean);

      return (
        vendor === 'winni' &&
        (['cake', 'cakes', 'cupcake', 'cupcakes'].includes(productType) ||
          productTokens.some((token) => ['cake', 'cakes', 'cupcake', 'cupcakes'].includes(token)))
      );
    };

    const getCleanCartPageDependentAddOnKeys = (cart, parentKey) => {
      const items = cart?.items || [];
      const parent = items.find((item) => String(item?.key || '') === String(parentKey || ''));
      if (!parent || isCleanCartPageAddOnItem(parent)) return [];

      const parentProductId = String(parent.product_id || '').trim();
      const parentVariantId = String(parent.variant_id || parent.id || '').trim();
      const addOnItems = items.filter(isCleanCartPageAddOnItem);
      const linkedKeys = addOnItems
        .filter((item) => {
          const properties = item?.properties || {};
          const itemParentProductId = String(properties[cleanCartPageAddOnParentProductProperty] || '').trim();
          const itemParentVariantId = String(properties[cleanCartPageAddOnParentVariantProperty] || '').trim();

          if (itemParentVariantId) return itemParentVariantId === parentVariantId;
          return Boolean(itemParentProductId && itemParentProductId === parentProductId);
        })
        .map((item) => String(item.key || '').trim())
        .filter(Boolean);

      const likelyLegacyParents = items.filter(
        (item) => !isCleanCartPageAddOnItem(item) && isCleanCartPageLikelyLegacyAddOnParent(item),
      );
      const canClaimUnlinkedAddOns =
        likelyLegacyParents.length === 1 && String(likelyLegacyParents[0]?.key || '') === String(parentKey || '');
      const legacyKeys = canClaimUnlinkedAddOns
        ? addOnItems
            .filter((item) => {
              const properties = item?.properties || {};
              return (
                !String(properties[cleanCartPageAddOnParentProductProperty] || '').trim() &&
                !String(properties[cleanCartPageAddOnParentVariantProperty] || '').trim()
              );
            })
            .map((item) => String(item.key || '').trim())
            .filter(Boolean)
        : [];

      return [...new Set([...linkedKeys, ...legacyKeys])];
    };

    const renderCleanCartPage = (cartPage, cart) => {
      const itemsTarget = cartPage.querySelector('[data-clean-cart-page-items]');
      const countTarget = cartPage.querySelector('[data-clean-cart-page-count]');
      const subtotalTarget = cartPage.querySelector('[data-clean-cart-page-subtotal]');
      const totalTarget = cartPage.querySelector('[data-clean-cart-page-total]');
      const checkout = cartPage.querySelector('.clean-main-cart__checkout');
      const gokwikCheckout = cartPage.querySelector('[data-clean-gokwik-checkout]');
      const itemCount = Number(cart?.item_count || 0);

      if (!itemsTarget || !countTarget || !subtotalTarget || !totalTarget) return;

      countTarget.textContent = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;
      cleanSetCartPageMoney(
        subtotalTarget,
        Number(cart?.items_subtotal_price || 0),
        cartPage.dataset.cleanCartMoneyFormat,
      );
      cleanSetCartPageMoney(totalTarget, Number(cart?.total_price || 0), cartPage.dataset.cleanCartMoneyFormat);
      window.cart = cart;

      document.querySelectorAll('[data-clean-cart-count]').forEach((target) => {
        target.textContent = String(itemCount);
      });

      [checkout, gokwikCheckout].forEach((target) => {
        if (!target) return;

        if (itemCount === 0) {
          target.setAttribute('aria-disabled', 'true');
        } else {
          target.removeAttribute('aria-disabled');
        }
      });

      if (!itemCount) {
        itemsTarget.innerHTML = `
          <div class="clean-main-cart__empty">
            <h2>Your cart is empty.</h2>
            <a class="clean-main-cart__continue" href="${escapeCleanCartPageHtml(
              cartPage.dataset.cleanCartRootUrl || '/',
            )}">Continue shopping</a>
          </div>
        `;
        return;
      }

      const addOnsWereOpen = itemsTarget.querySelector('[data-clean-cart-page-add-ons]')?.open ?? true;
      const ordinaryItems = cart.items.filter((item) => !isCleanCartPageAddOnItem(item));
      const addOnItems = cart.items.filter((item) => isCleanCartPageAddOnItem(item));
      const addOnQuantity = addOnItems.reduce((total, item) => total + Number(item.quantity || 0), 0);
      const renderItem = (item) => {
        const linePrice = cleanCartPageLinePrice(item);
        const compareLinePrice = Number(item.original_line_price || 0);
        const isAddOnItem = isCleanCartPageAddOnItem(item);
        const imageMarkup = item.image
          ? `<img class="clean-main-cart__image" src="${escapeCleanCartPageHtml(
              getCleanCartPageImageUrl(item.image),
            )}" alt="${escapeCleanCartPageHtml(
              item.product_title || item.title,
            )}" width="110" height="110" loading="lazy">`
          : '<span class="clean-main-cart__image clean-main-cart__image--placeholder" aria-hidden="true"></span>';
        const compareMarkup =
          compareLinePrice > linePrice
            ? `<s class="clean-main-cart__compare-price" ${cleanCartPageMoneyAttributes(
                compareLinePrice,
                cartPage.dataset.cleanCartMoneyFormat,
              )}>${escapeCleanCartPageHtml(
                cleanCartPageFormatMoney(compareLinePrice, cartPage.dataset.cleanCartMoneyFormat),
              )}</s>`
            : '';

        return `
            <article class="clean-main-cart__item${
              isAddOnItem ? ' clean-main-cart__item--add-on' : ''
            }" data-clean-cart-page-item="${escapeCleanCartPageHtml(item.key)}"
              data-clean-cart-page-variant-id="${escapeCleanCartPageHtml(item.variant_id || item.id)}"
              data-clean-cart-page-properties="${escapeCleanCartPageHtml(JSON.stringify(item.properties || {}))}"
              data-clean-cart-page-selling-plan-id="${escapeCleanCartPageHtml(item.selling_plan_allocation?.selling_plan?.id || '')}">
              <a class="clean-main-cart__image-link" href="${escapeCleanCartPageHtml(
                item.url || '#',
              )}" aria-label="${escapeCleanCartPageHtml(item.title)}">
                ${imageMarkup}
              </a>
              <div class="clean-main-cart__item-body">
                <a class="clean-main-cart__item-title" href="${escapeCleanCartPageHtml(item.url || '#')}">
                  ${escapeCleanCartPageHtml(item.product_title || item.title)}
                </a>
                ${renderCleanCartPageVariantOptions(item)}
                ${renderCleanCartPageProperties(item.properties)}
                <div class="clean-main-cart__prices">
                  ${compareMarkup}
                  <span class="clean-main-cart__price" ${cleanCartPageMoneyAttributes(
                    linePrice,
                    cartPage.dataset.cleanCartMoneyFormat,
                  )}>${escapeCleanCartPageHtml(
                    cleanCartPageFormatMoney(linePrice, cartPage.dataset.cleanCartMoneyFormat),
                  )}</span>
                </div>
                <div class="clean-main-cart__quantity" data-clean-cart-page-quantity>
                  <button type="button" aria-label="Decrease quantity" data-clean-cart-page-quantity-decrease>-</button>
                  <input
                    type="number"
                    min="0"
                    value="${Number(item.quantity || 0)}"
                    inputmode="numeric"
                    aria-label="Quantity for ${escapeCleanCartPageHtml(item.product_title || item.title)}"
                    data-clean-cart-page-quantity-input
                  >
                  <button type="button" aria-label="Increase quantity" data-clean-cart-page-quantity-increase>+</button>
                </div>
              </div>
              <button class="clean-main-cart__remove" type="button" aria-label="Remove ${escapeCleanCartPageHtml(
                item.product_title || item.title,
              )}" data-clean-cart-page-remove>
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M4 7h16M10 11v6M14 11v6M6 7l1 14h10l1-14M9 7V4h6v3"></path>
                </svg>
              </button>
            </article>
          `;
      };
      const addOnMarkup = addOnItems.map(renderItem).join('');

      itemsTarget.innerHTML = `
        ${ordinaryItems.map(renderItem).join('')}
        ${
          addOnItems.length
            ? `
              <details class="clean-main-cart__add-ons" data-clean-cart-page-add-ons${addOnsWereOpen ? ' open' : ''}>
                <summary class="clean-main-cart__add-ons-summary">
                  <span>Add-ons</span>
                  <span class="clean-main-cart__add-ons-count">${addOnQuantity}</span>
                </summary>
                <div class="clean-main-cart__add-ons-items">
                  ${addOnMarkup}
                </div>
              </details>
            `
            : ''
        }
      `;
    };

    const fetchCleanCartPage = async (cartPage) => {
      const cartUrl = cleanCartPageAjaxUrl(cartPage.dataset.cleanCartUrl, '/cart');
      const loadCart = async () => {
        const response = await cleanCartPageRequest(cartUrl, { cache: 'no-store' });
        if (!response.ok) throw new Error('Unable to refresh cart.');
        return response.json();
      };
      const cart = window.CleanCartState?.refresh
        ? await window.CleanCartState.refresh(loadCart, { supersede: true })
        : await loadCart();
      window.CleanCartState?.publish?.(cart);
      window.cart = cart;
      return cart;
    };

    const getCleanCartPageLineIdentity = (item) =>
      JSON.stringify([
        String(item?.variant_id || item?.id || ''),
        String(item?.selling_plan_allocation?.selling_plan?.id || ''),
        Object.entries(item?.properties || {})
          .filter(([, value]) => value != null && value !== '')
          .map(([name, value]) => [name, String(value)])
          .sort(([a], [b]) => a.localeCompare(b)),
      ]);

    const resolveCleanCartPageLine = (cart, key, identity) => {
      const items = cart?.items || [];
      const exact = items.find(
        (item) => item.key === key && (!identity || getCleanCartPageLineIdentity(item) === identity),
      );
      if (exact) return exact;
      const matches = identity ? items.filter((item) => getCleanCartPageLineIdentity(item) === identity) : [];
      if (matches.length === 1) return matches[0];
      throw new Error('Your cart has changed. Please refresh it and try again.');
    };

    const changeCleanCartPageItem = async (cartPage, key, quantity, { signal, identity } = {}) => {
      const cleanQuantity = cleanCartPageQuantity(quantity);
      for (let attempt = 0; attempt < 2; attempt += 1) {
        // Discount thresholds can rotate every affected line key, including other queued lines.
        const currentCart = await fetchCleanCartPage(cartPage);
        const currentItem = resolveCleanCartPageLine(currentCart, key, identity);
        const currentKey = currentItem.key;
        const dependentAddOnKeys =
          cleanQuantity === 0 ? getCleanCartPageDependentAddOnKeys(currentCart, currentKey) : [];
        const hasDependentAddOns = dependentAddOnKeys.length > 0;
        const response = await cleanCartPageRequest(
          cleanCartPageAjaxUrl(
            hasDependentAddOns ? cartPage.dataset.cleanCartUpdateUrl : cartPage.dataset.cleanCartChangeUrl,
            hasDependentAddOns ? '/cart/update' : '/cart/change',
          ),
          {
            method: 'POST',
            signal,
            headers: { 'Content-Type': 'application/json' },
            body: hasDependentAddOns
              ? JSON.stringify({
                  updates: Object.fromEntries([currentKey, ...dependentAddOnKeys].map((itemKey) => [itemKey, 0])),
                })
              : JSON.stringify({ id: currentKey, quantity: cleanQuantity }),
          },
        );
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          const message = error.description || error.message || 'Unable to update cart.';
          if (
            [400, 404].includes(response.status) &&
            /no valid id or line parameter|line item.*not found/i.test(message)
          ) {
            if (attempt === 0) continue;
            throw new Error('Your cart has changed. Please refresh it and try again.');
          }
          throw new Error(message);
        }
        const cart = await response.json();
        window.CleanCartState?.publish?.(cart);
        document.dispatchEvent(new CustomEvent('clean:cart:updated', { detail: { cart, origin: 'clean-main-cart' } }));
        return cart;
      }
    };

    const setCleanCartPageItemBusy = (item, isBusy) => {
      if (!item) return;
      item.toggleAttribute('aria-busy', isBusy);
      item.dataset.cleanCartPageItemBusy = isBusy ? 'true' : 'false';
      item.querySelectorAll('button, input').forEach((control) => {
        control.disabled = isBusy;
      });
    };

    const restoreCleanCartPageItemQuantity = (item) => {
      const key = item?.dataset.cleanCartPageItem;
      const currentItem = (window.cart?.items || []).find(
        (cartItem) => String(cartItem?.key || '') === String(key || ''),
      );
      const input = item?.querySelector('[data-clean-cart-page-quantity-input]');
      if (!input) return;
      input.value = currentItem ? String(currentItem.quantity || 0) : input.defaultValue;
    };

    const queueCleanCartPageMutation = (cartPage, mutationState, item, quantity) => {
      const key = item?.dataset.cleanCartPageItem;
      if (!key || item.dataset.cleanCartPageItemBusy === 'true' || mutationState.destroyed) {
        return Promise.resolve(null);
      }

      const identity = getCleanCartPageLineIdentity({
        variant_id: item.dataset.cleanCartPageVariantId,
        properties: JSON.parse(item.dataset.cleanCartPageProperties || '{}'),
        selling_plan_allocation: { selling_plan: { id: item.dataset.cleanCartPageSellingPlanId } },
      });
      setCleanCartPageItemBusy(item, true);
      const operation = mutationState.queue.then(() =>
        changeCleanCartPageItem(cartPage, key, quantity, { signal: mutationState.signal, identity }),
      );
      mutationState.queue = operation.catch(() => {});

      return operation.finally(() => {
        if (item.isConnected) setCleanCartPageItemBusy(item, false);
      });
    };

    const initCleanCartPage = (root = document) => {
      root.querySelectorAll('[data-clean-cart-page]').forEach((cartPage) => {
        if (cartPage.dataset.cleanCartPageReady === 'true') return;
        cartPage.dataset.cleanCartPageReady = 'true';
        const lifecycle = new AbortController();
        const mutationState = {
          destroyed: false,
          queue: Promise.resolve(),
          signal: lifecycle.signal,
        };
        cartPage.cleanCartPageLifecycle = lifecycle;
        cartPage.cleanCartPageMutationState = mutationState;

        const cartSummary = cartPage.querySelector('.clean-main-cart__summary');
        let gokwikVisibilitySyncStarted = false;
        const syncGokwikVisibilityOnIntent = () => {
          if (gokwikVisibilitySyncStarted) return;
          gokwikVisibilitySyncStarted = true;
          window.CleanGokwik.syncScope(cartPage, { detect: true, prepare: true }).catch(() => {});
        };

        cartSummary?.addEventListener('pointerenter', syncGokwikVisibilityOnIntent, {
          once: true,
          signal: lifecycle.signal,
        });
        cartSummary?.addEventListener('focusin', syncGokwikVisibilityOnIntent, {
          once: true,
          signal: lifecycle.signal,
        });
        cartSummary?.addEventListener('touchstart', syncGokwikVisibilityOnIntent, {
          once: true,
          passive: true,
          signal: lifecycle.signal,
        });

        cartPage.querySelectorAll('[data-clean-gokwik-checkout]').forEach((button) => {
          button.addEventListener(
            'click',
            async (event) => {
              event.preventDefault();

              if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

              button.disabled = true;
              setCleanCartPageStatus(cartPage);

              try {
                await fetchCleanCartPage(cartPage);
                await window.CleanGokwik.checkout(button, cartPage);
              } catch (error) {
                setCleanCartPageStatus(cartPage, error?.message || 'Unable to start GoKwik checkout.');
              } finally {
                button.disabled = false;
              }
            },
            { signal: lifecycle.signal },
          );
        });

        cartPage.addEventListener(
          'click',
          async (event) => {
            const item = event.target.closest('[data-clean-cart-page-item]');
            if (!item || !cartPage.contains(item)) return;

            const quantityInput = item.querySelector('[data-clean-cart-page-quantity-input]');
            let quantity = null;

            if (event.target.closest('[data-clean-cart-page-remove]')) {
              quantity = 0;
            } else if (event.target.closest('[data-clean-cart-page-quantity-decrease]')) {
              quantity = cleanCartPageQuantity(quantityInput?.value) - 1;
            } else if (event.target.closest('[data-clean-cart-page-quantity-increase]')) {
              quantity = cleanCartPageQuantity(quantityInput?.value) + 1;
            }

            if (quantity === null) return;

            event.preventDefault();
            setCleanCartPageStatus(cartPage);

            try {
              await queueCleanCartPageMutation(cartPage, mutationState, item, quantity);
            } catch (error) {
              if (window.cart?.items) renderCleanCartPage(cartPage, window.cart);
              else restoreCleanCartPageItemQuantity(item);
              setCleanCartPageStatus(cartPage, error?.message || 'Unable to update cart.');
            }
          },
          { signal: lifecycle.signal },
        );

        cartPage.addEventListener(
          'change',
          async (event) => {
            const input = event.target.closest('[data-clean-cart-page-quantity-input]');
            if (!input || !cartPage.contains(input)) return;

            const item = input.closest('[data-clean-cart-page-item]');
            if (!item) return;

            setCleanCartPageStatus(cartPage);

            try {
              await queueCleanCartPageMutation(cartPage, mutationState, item, input.value);
            } catch (error) {
              if (window.cart?.items) renderCleanCartPage(cartPage, window.cart);
              else restoreCleanCartPageItemQuantity(item);
              setCleanCartPageStatus(cartPage, error?.message || 'Unable to update cart.');
            }
          },
          { signal: lifecycle.signal },
        );

        document.addEventListener(
          'clean:cart:updated',
          (event) => {
            if (event.detail?.cart) renderCleanCartPage(cartPage, event.detail.cart);
          },
          { signal: lifecycle.signal },
        );
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanCartPage(), { once: true });
    } else {
      initCleanCartPage();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanCartPage(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.('[data-clean-cart-page]').forEach((cartPage) => {
        if (cartPage.cleanCartPageMutationState) cartPage.cleanCartPageMutationState.destroyed = true;
        cartPage.cleanCartPageLifecycle?.abort();
        delete cartPage.dataset.cleanCartPageReady;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanWishlistStorageKey = 'wishlistItem';
    const cleanAutoLoadCount = 2;
    const cleanCollectionStates = new WeakMap();

    const getCleanWishlistItems = () => {
      try {
        const items = JSON.parse(localStorage.getItem(cleanWishlistStorageKey) || '[]');
        return Array.isArray(items) ? items.filter((item) => typeof item === 'string' && item.trim()) : [];
      } catch (error) {
        return [];
      }
    };

    const setCleanWishlistItems = (items) => {
      const cleanItems = Array.from(new Set(items.filter((item) => typeof item === 'string' && item.trim())));

      try {
        localStorage.setItem(cleanWishlistStorageKey, JSON.stringify(cleanItems));
        return getCleanWishlistItems();
      } catch (error) {
        console.error(error);
        return getCleanWishlistItems();
      }
    };

    const updateCleanWishlistCount = (items) => {
      document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
        count.textContent = String(items.length);
      });
    };

    const updateCleanWishlistButton = (button, isActive) => {
      button.setAttribute('aria-pressed', String(isActive));
      button.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
    };

    const updateCleanWishlistButtonsByHandle = (handle, isActive, root = document) => {
      root.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
        if (button.dataset.cleanProductWishlistHandle?.trim() === handle) {
          updateCleanWishlistButton(button, isActive);
        }
      });
    };

    const initCleanProductCardWishlists = (root = document) => {
      const wishlistItems = getCleanWishlistItems();

      root.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
        if (button.dataset.cleanProductWishlistReady === 'true') return;

        button.dataset.cleanProductWishlistReady = 'true';

        const handle = button.dataset.cleanProductWishlistHandle?.trim();

        if (!handle || typeof Storage === 'undefined') {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          return;
        }

        updateCleanWishlistButton(button, wishlistItems.includes(handle));

        button.addEventListener('click', () => {
          const wishlistItems = getCleanWishlistItems();
          const isActive = wishlistItems.includes(handle);
          const nextWishlistItems = isActive
            ? wishlistItems.filter((item) => item !== handle)
            : wishlistItems.concat(handle);
          const confirmedWishlistItems = setCleanWishlistItems(nextWishlistItems);
          const isConfirmedActive = confirmedWishlistItems.includes(handle);

          updateCleanWishlistButtonsByHandle(handle, isConfirmedActive);
          updateCleanWishlistCount(confirmedWishlistItems);

          document.dispatchEvent(
            new CustomEvent(isConfirmedActive ? 'addwishlistitem' : 'updatewishlistmail', {
              detail: { handle },
              bubbles: true,
            }),
          );
        });
      });

      updateCleanWishlistCount(wishlistItems);
    };

    const getCleanProductCards = (grid) =>
      Array.from(grid.children).filter((card) => card.classList.contains('clean-product-card'));

    const getCleanCollectionState = (root) => {
      if (!cleanCollectionStates.has(root)) {
        cleanCollectionStates.set(root, {
          autoLoadsRemaining: cleanAutoLoadCount,
          isLoading: false,
          loadMoreObserver: null,
          loadedProductCount: 0,
          nextUrl: '',
          totalProducts: 0,
        });
      }

      return cleanCollectionStates.get(root);
    };

    const formatCleanFetchUrl = (url) => {
      if (!url) return '';

      const cleanUrl = new URL(url, window.location.href);

      return `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`;
    };

    const formatCleanSectionFetchUrl = (root, url) => {
      if (!url) return '';

      const cleanUrl = new URL(formatCleanFetchUrl(url), window.location.href);
      const sectionId = root.dataset.cleanSectionId;

      if (sectionId) {
        cleanUrl.searchParams.set('section_id', sectionId);
      }

      return `${cleanUrl.pathname}${cleanUrl.search}`;
    };

    const getCleanRemainingProductCount = (root) => {
      const state = getCleanCollectionState(root);

      return Math.max(state.totalProducts - state.loadedProductCount, 0);
    };

    const updateCleanLoadMoreButton = (root) => {
      const state = getCleanCollectionState(root);
      const wrap = root.querySelector('[data-clean-collection-load-more-wrap]');
      const button = root.querySelector('[data-clean-collection-load-more]');
      const text = root.querySelector('[data-clean-collection-load-more-text]');

      if (!wrap || !button || !text) return;

      const remainingProducts = getCleanRemainingProductCount(root);
      wrap.hidden = !state.nextUrl || remainingProducts === 0;
      button.disabled = state.isLoading;
      text.textContent = state.isLoading
        ? button.dataset.cleanLoadingText
        : `${button.dataset.cleanDefaultText} (${remainingProducts})`;
    };

    const appendCleanProductCards = (root, cards) => {
      const grid = root.querySelector('[data-clean-main-collection-grid]');

      if (!grid || cards.length === 0) return 0;

      const fragment = document.createDocumentFragment();

      cards.forEach((card) => fragment.appendChild(card));
      initCleanProductCardWishlists(fragment);
      grid.appendChild(fragment);

      return cards.length;
    };

    const setCleanLoadMoreStatus = (root, message = '') => {
      const status = root.querySelector('[data-clean-load-more-status]');

      if (status) {
        status.textContent = message;
      }
    };

    const fetchCleanNextCards = async (root) => {
      const state = getCleanCollectionState(root);

      if (!state.nextUrl) return 0;

      state.isLoading = true;
      setCleanLoadMoreStatus(root);
      updateCleanLoadMoreButton(root);

      try {
        const response = await fetch(formatCleanSectionFetchUrl(root, state.nextUrl), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) {
          throw new Error(`Collection section request failed with status ${response.status}`);
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextRoot = doc.querySelector('[data-clean-main-collection]');
        const nextGrid = nextRoot?.querySelector('[data-clean-main-collection-grid]');
        const nextButton = nextRoot?.querySelector('[data-clean-collection-load-more]');
        const nextCards = nextGrid ? getCleanProductCards(nextGrid) : [];

        state.nextUrl = formatCleanFetchUrl(nextButton?.dataset.cleanNextUrl || '');

        const appendedCount = appendCleanProductCards(root, nextCards);
        state.loadedProductCount += appendedCount;

        return appendedCount;
      } catch (error) {
        console.error(error);
        setCleanLoadMoreStatus(root, 'Unable to load more products. Please try again.');
        return 0;
      } finally {
        state.isLoading = false;
        updateCleanLoadMoreButton(root);
      }
    };

    const loadCleanMoreProducts = async (root) => {
      const state = getCleanCollectionState(root);

      if (state.isLoading) return 0;

      return fetchCleanNextCards(root);
    };

    const initCleanAutoLoadMore = (root) => {
      const state = getCleanCollectionState(root);
      const wrap = root.querySelector('[data-clean-collection-load-more-wrap]');

      if (!wrap || state.loadMoreObserver || !('IntersectionObserver' in window)) return;

      state.loadMoreObserver = new IntersectionObserver(
        async (entries) => {
          const shouldAutoLoad = entries.some((entry) => entry.isIntersecting);

          if (!shouldAutoLoad || state.autoLoadsRemaining <= 0 || state.isLoading) return;

          const loadedCount = await loadCleanMoreProducts(root);

          if (loadedCount > 0) {
            state.autoLoadsRemaining -= 1;
          }

          if (state.autoLoadsRemaining <= 0 || getCleanRemainingProductCount(root) === 0) {
            state.loadMoreObserver.disconnect();
            state.loadMoreObserver = null;
          }
        },
        { rootMargin: '600px 0px 300px' },
      );

      state.loadMoreObserver.observe(wrap);
    };

    const initCleanCollectionLoadMore = (root = document) => {
      root.querySelectorAll('[data-clean-main-collection]').forEach((collectionRoot) => {
        const state = getCleanCollectionState(collectionRoot);
        const button = collectionRoot.querySelector('[data-clean-collection-load-more]');
        const grid = collectionRoot.querySelector('[data-clean-main-collection-grid]');

        state.nextUrl = formatCleanFetchUrl(button?.dataset.cleanNextUrl || state.nextUrl);
        state.totalProducts = Number.parseInt(button?.dataset.cleanTotalProducts || '0', 10) || 0;
        state.loadedProductCount = grid ? getCleanProductCards(grid).length : 0;

        updateCleanLoadMoreButton(collectionRoot);
        initCleanAutoLoadMore(collectionRoot);

        if (!button || button.dataset.cleanLoadMoreReady === 'true') return;

        button.dataset.cleanLoadMoreReady = 'true';

        button.addEventListener('click', async () => {
          state.autoLoadsRemaining = 0;

          if (state.loadMoreObserver) {
            state.loadMoreObserver.disconnect();
            state.loadMoreObserver = null;
          }

          await loadCleanMoreProducts(collectionRoot);
        });
      });
    };

    const submitCleanCollectionSortForm = (form) => {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    };

    const initCleanCollectionSort = (root = document) => {
      root.querySelectorAll('[data-clean-sort-select]').forEach((select) => {
        if (select.dataset.cleanSortReady === 'true') return;

        const form = select.closest('form');

        if (!form) return;

        select.dataset.cleanSortReady = 'true';

        select.addEventListener('change', () => {
          submitCleanCollectionSortForm(form);
        });
      });
    };

    const initCleanCollectionEyelets = (root = document) => {
      root.querySelectorAll('[data-clean-collection-eyelets]').forEach((eyelets) => {
        if (eyelets.dataset.cleanEyeletsReady === 'true') return;

        const track = eyelets.querySelector('[data-clean-eyelets-track]');
        const previousButton = eyelets.querySelector('[data-clean-eyelets-previous]');
        const nextButton = eyelets.querySelector('[data-clean-eyelets-next]');

        if (!track || !previousButton || !nextButton) return;

        eyelets.dataset.cleanEyeletsReady = 'true';

        const dropdownCloseTimers = new WeakMap();

        const updateArrows = () => {
          const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
          const hasOverflow = maxScroll > 1;

          eyelets.classList.toggle('clean-collection-eyelets--has-overflow', hasOverflow);
          previousButton.hidden = !hasOverflow;
          nextButton.hidden = !hasOverflow;
          previousButton.disabled = track.scrollLeft <= 1;
          nextButton.disabled = track.scrollLeft >= maxScroll - 1;
        };

        const clearMenuPosition = (dropdown) => {
          const menu = dropdown.querySelector('.clean-collection-eyelets__menu');

          if (!menu) return;

          menu.classList.remove('clean-collection-eyelets__menu--positioned');
          menu.style.left = '';
          menu.style.top = '';
        };

        const positionOpenMenu = (dropdown) => {
          const summary = dropdown.querySelector('.clean-collection-eyelets__summary');
          const menu = dropdown.querySelector('.clean-collection-eyelets__menu');

          if (!summary || !menu) return;

          const summaryRect = summary.getBoundingClientRect();
          const viewportGap = 12;
          const menuWidth = menu.offsetWidth;
          const maxLeft = Math.max(viewportGap, window.innerWidth - menuWidth - viewportGap);
          const centeredLeft = summaryRect.left + summaryRect.width / 2 - menuWidth / 2;
          const menuLeft = Math.min(Math.max(centeredLeft, viewportGap), maxLeft);

          menu.style.left = `${menuLeft}px`;
          menu.style.top = `${summaryRect.bottom + 8}px`;
          menu.classList.add('clean-collection-eyelets__menu--positioned');
        };

        const positionOpenMenus = () => {
          eyelets.querySelectorAll('.clean-collection-eyelets__dropdown[open]').forEach(positionOpenMenu);
        };

        const cancelDropdownClose = (dropdown) => {
          const timer = dropdownCloseTimers.get(dropdown);

          if (!timer) return;

          window.clearTimeout(timer);
          dropdownCloseTimers.delete(dropdown);
        };

        const closeDropdown = (dropdown) => {
          cancelDropdownClose(dropdown);
          dropdown.open = false;
          clearMenuPosition(dropdown);
        };

        const scheduleDropdownClose = (dropdown) => {
          cancelDropdownClose(dropdown);

          dropdownCloseTimers.set(
            dropdown,
            window.setTimeout(() => closeDropdown(dropdown), 120),
          );
        };

        const getPageScrollDistance = () => {
          const firstItem = track.querySelector('.clean-collection-eyelets__item');

          if (!firstItem) return track.clientWidth * 0.85;

          const trackStyles = window.getComputedStyle(track);
          const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
          const itemStep = firstItem.getBoundingClientRect().width + gap;

          if (!itemStep) return track.clientWidth * 0.85;

          const visibleItems = Math.max(Math.floor((track.clientWidth + gap) / itemStep), 1);

          return Math.max(itemStep, (visibleItems - 1) * itemStep);
        };

        const scrollEyeletsPage = (direction) => {
          const maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
          const nextLeft = Math.min(Math.max(track.scrollLeft + direction * getPageScrollDistance(), 0), maxScroll);

          track.scrollTo({
            left: nextLeft,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        };

        const bindPageScroll = (button, direction) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;

            scrollEyeletsPage(direction);
          });
        };

        bindPageScroll(previousButton, -1);
        bindPageScroll(nextButton, 1);

        eyelets.querySelectorAll('.clean-collection-eyelets__dropdown').forEach((dropdown) => {
          const menu = dropdown.querySelector('.clean-collection-eyelets__menu');

          dropdown.addEventListener('toggle', () => {
            if (dropdown.open) {
              cancelDropdownClose(dropdown);
              positionOpenMenu(dropdown);
            } else {
              clearMenuPosition(dropdown);
            }
          });

          dropdown.addEventListener('pointerenter', () => cancelDropdownClose(dropdown));
          dropdown.addEventListener('pointerleave', () => scheduleDropdownClose(dropdown));

          if (menu) {
            menu.addEventListener('pointerenter', () => cancelDropdownClose(dropdown));
            menu.addEventListener('pointerleave', () => scheduleDropdownClose(dropdown));
          }
        });

        track.addEventListener(
          'scroll',
          () => {
            updateArrows();
            positionOpenMenus();
          },
          { passive: true },
        );
        window.addEventListener('resize', () => {
          updateArrows();
          positionOpenMenus();
        });
        window.addEventListener('scroll', positionOpenMenus, { passive: true });
        updateArrows();
        window.setTimeout(updateArrows, 100);
      });
    };

    const initCleanCollectionSeoFooter = (root = document) => {
      root.querySelectorAll('[data-clean-collection-seo-footer]').forEach((footer) => {
        const toggle = footer.querySelector('[data-clean-collection-seo-toggle]');
        const content = footer.querySelector('[data-clean-collection-seo-content]');

        if (!toggle || !content || toggle.dataset.cleanSeoFooterReady === 'true') return;

        toggle.dataset.cleanSeoFooterReady = 'true';

        toggle.addEventListener('click', () => {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          const shouldExpand = !isExpanded;

          toggle.setAttribute('aria-expanded', String(shouldExpand));
          toggle.textContent = shouldExpand ? toggle.dataset.cleanLessText : toggle.dataset.cleanMoreText;
          content.classList.toggle('clean-main-collection__seo-footer-copy--collapsed', !shouldExpand);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          initCleanProductCardWishlists();
          initCleanCollectionLoadMore();
          initCleanCollectionSort();
          initCleanCollectionEyelets();
          initCleanCollectionSeoFooter();
        },
        { once: true },
      );
    } else {
      initCleanProductCardWishlists();
      initCleanCollectionLoadMore();
      initCleanCollectionSort();
      initCleanCollectionEyelets();
      initCleanCollectionSeoFooter();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initCleanProductCardWishlists(event.target);
      initCleanCollectionLoadMore(event.target);
      initCleanCollectionSort(event.target);
      initCleanCollectionEyelets(event.target);
      initCleanCollectionSeoFooter(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-product"]) return;
  try {
    
  (() => {
    if (document.querySelector('.clean-main-product[data-clean-product-gallery]')) {
      console.log('[GG-Liquid] Product page console check');
    }

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const cakeMoreInformationMarkers = [
      'perishable',
      'delivery will be attempted only once',
      'delivery cannot be redirected',
    ];

    const createVegBadge = () => {
      const svgNamespace = 'http://www.w3.org/2000/svg';
      const badge = document.createElement('div');
      const svg = document.createElementNS(svgNamespace, 'svg');
      const border = document.createElementNS(svgNamespace, 'rect');
      const dot = document.createElementNS(svgNamespace, 'circle');

      badge.className = 'clean-main-product__veg-icon';
      badge.dataset.cleanVegBadge = 'injected';
      badge.setAttribute('aria-label', 'Vegetarian');

      svg.setAttribute('viewBox', '0 0 69 69');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');

      border.setAttribute('x', '2');
      border.setAttribute('y', '2');
      border.setAttribute('width', '65');
      border.setAttribute('height', '65');
      border.setAttribute('rx', '5');
      border.setAttribute('stroke', '#008300');
      border.setAttribute('stroke-width', '4');
      border.setAttribute('stroke-linejoin', 'round');

      dot.setAttribute('cx', '35');
      dot.setAttribute('cy', '35');
      dot.setAttribute('r', '17');
      dot.setAttribute('fill', '#008300');

      svg.append(border, dot);
      badge.append(svg);

      return badge;
    };

    const rendersCakeMoreInformation = (productSection) => {
      const moreInformation = productSection.querySelector('[data-clean-product-more-information]');
      const moreInformationText = moreInformation?.textContent.toLowerCase() || '';

      return cakeMoreInformationMarkers.every((marker) => moreInformationText.includes(marker));
    };

    const ensureVegBadge = (root = document) => {
      root.querySelectorAll('[data-clean-product-gallery]').forEach((productSection) => {
        if (!rendersCakeMoreInformation(productSection)) return;

        const titleRow = productSection.querySelector('.clean-main-product__title-row');
        const title = titleRow?.querySelector('.clean-main-product__title');

        if (!titleRow || !title) return;

        if (productSection.dataset.cleanVegBadgeRepairReady !== 'true') {
          productSection.dataset.cleanVegBadgeRepairReady = 'true';

          const observer = new MutationObserver(() => {
            if (!productSection.isConnected) {
              observer.disconnect();
              return;
            }

            if (!productSection.querySelector('.clean-main-product__veg-icon')) {
              ensureVegBadge(productSection.parentElement || document);
            }
          });

          observer.observe(productSection, { childList: true, subtree: true });
        }

        if (titleRow.querySelector('.clean-main-product__veg-icon')) return;

        const titleGroup = titleRow.querySelector('.clean-main-product__title-group');
        const badge = createVegBadge();

        if (titleGroup) {
          titleGroup.insertBefore(badge, title);
        } else {
          titleRow.insertBefore(badge, title);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => ensureVegBadge(), { once: true });
    } else {
      ensureVegBadge();
    }

    document.addEventListener('shopify:section:load', (event) => ensureVegBadge(event.target));

    const cleanWishlistStorageKey = 'wishlistItem';

    const getCleanWishlistItems = () => {
      try {
        const items = JSON.parse(localStorage.getItem(cleanWishlistStorageKey) || '[]');
        return Array.isArray(items) ? items.filter((item) => typeof item === 'string' && item.trim()) : [];
      } catch (error) {
        return [];
      }
    };

    const setCleanWishlistItems = (items) => {
      const cleanItems = Array.from(new Set(items.filter((item) => typeof item === 'string' && item.trim())));

      try {
        localStorage.setItem(cleanWishlistStorageKey, JSON.stringify(cleanItems));
        return getCleanWishlistItems();
      } catch (error) {
        console.error(error);
        return getCleanWishlistItems();
      }
    };

    const updateCleanWishlistCount = (items) => {
      document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
        count.textContent = String(items.length);
      });
    };

    const updateCleanWishlistButton = (button, isActive) => {
      button.setAttribute('aria-pressed', String(isActive));
      button.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
    };

    const updateCleanWishlistButtonsByHandle = (handle, isActive, root = document) => {
      root.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
        if (button.dataset.cleanProductWishlistHandle?.trim() === handle) {
          updateCleanWishlistButton(button, isActive);
        }
      });
    };

    const initWishlistButtons = (root = document) => {
      root.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
        if (button.dataset.cleanProductWishlistReady === 'true') return;

        button.dataset.cleanProductWishlistReady = 'true';

        const handle = button.dataset.cleanProductWishlistHandle?.trim();

        if (!handle || typeof Storage === 'undefined') {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          return;
        }

        updateCleanWishlistButton(button, getCleanWishlistItems().includes(handle));

        button.addEventListener('click', () => {
          const wishlistItems = getCleanWishlistItems();
          const isActive = wishlistItems.includes(handle);
          const nextWishlistItems = isActive
            ? wishlistItems.filter((item) => item !== handle)
            : wishlistItems.concat(handle);
          const confirmedWishlistItems = setCleanWishlistItems(nextWishlistItems);
          const isConfirmedActive = confirmedWishlistItems.includes(handle);

          updateCleanWishlistButtonsByHandle(handle, isConfirmedActive);
          updateCleanWishlistCount(confirmedWishlistItems);

          document.dispatchEvent(
            new CustomEvent(isConfirmedActive ? 'addwishlistitem' : 'updatewishlistmail', {
              detail: { handle },
              bubbles: true,
            }),
          );
        });
      });

      updateCleanWishlistCount(getCleanWishlistItems());
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initWishlistButtons(), { once: true });
    } else {
      initWishlistButtons();
    }

    document.addEventListener('shopify:section:load', (event) => initWishlistButtons(event.target));

    const cleanClampProductQuantity = (value) => {
      const parsedValue = Number.parseInt(value, 10);
      return Number.isFinite(parsedValue) && parsedValue > 0 ? parsedValue : 1;
    };

    const cleanClampQuantityToInput = (input, value) => {
      const minimum = Math.max(1, cleanClampProductQuantity(input?.min));
      const maximum = Number.parseInt(input?.max, 10);
      const quantity = Math.max(minimum, cleanClampProductQuantity(value));

      return Number.isFinite(maximum) && maximum >= minimum ? Math.min(quantity, maximum) : quantity;
    };

    const syncCleanQuantityControlState = (input) => {
      const quantityControl = input?.closest('.clean-main-product__quantity-control');
      if (!quantityControl) return;

      const isStickyQuantity = input.matches('[data-clean-sticky-quantity-input]');
      const decreaseButton = quantityControl.querySelector(
        isStickyQuantity ? '[data-clean-sticky-quantity-decrease]' : '[data-clean-product-quantity-decrease]',
      );
      const increaseButton = quantityControl.querySelector(
        isStickyQuantity ? '[data-clean-sticky-quantity-increase]' : '[data-clean-product-quantity-increase]',
      );
      const minimum = Math.max(1, cleanClampProductQuantity(input.min));
      const maximum = Number.parseInt(input.max, 10);
      const quantity = cleanClampProductQuantity(input.value);

      if (decreaseButton) decreaseButton.disabled = input.disabled || quantity <= minimum;
      if (increaseButton) {
        increaseButton.disabled = input.disabled || (Number.isFinite(maximum) && quantity >= maximum);
      }
    };

    let cleanInventoryCart = null;
    let cleanInventoryRequest = null;
    let cleanInventoryRevision = 0;

    const getCleanPurchaseStock = () => {
      const form = getCleanProductForm();
      const variantId = form?.elements.namedItem('id')?.value;
      const source = form?.querySelector('[data-clean-product-inventory]');
      if (!source || !variantId) return null;
      try {
        const inventory = JSON.parse(source.textContent)[variantId];
        if (!inventory || !Number.isSafeInteger(inventory.limit)) return null;
        const cartQuantity = cleanInventoryCart
          ? cleanInventoryCart.reduce(
              (total, item) => total + (String(item.variant_id) === String(variantId) ? item.quantity : 0),
              0,
            )
          : inventory.cartQuantity;
        return { total: inventory.limit, cartQuantity, maximum: Math.max(0, inventory.limit - cartQuantity) };
      } catch {
        return null;
      }
    };

    const getCleanStockMessage = (stock) => {
      if (!stock) return '';
      if (stock.total === 0) return 'This item is currently out of stock.';
      const items = stock.total === 1 ? 'item' : 'items';
      return `Only ${stock.total} ${items} in stock`;
    };

    const syncCleanQuantityStockMessage = (input) => {
      const stock = getCleanPurchaseStock();
      const quantity = Number(input?.value);
      const show = stock && input && quantity > stock.maximum;
      const minimum = Number(input?.min) || 1;
      const maximum = Number.parseInt(input?.max, 10);
      const valid =
        input &&
        Number.isSafeInteger(quantity) &&
        quantity >= minimum &&
        (!Number.isFinite(maximum) || quantity <= maximum) &&
        !show;
      const error = getCleanProductForm()?.querySelector('[data-clean-product-cart-error]');
      if (valid && error?.dataset?.cleanQuantityError === 'true') {
        error.textContent = '';
        error.hidden = true;
        delete error.dataset.cleanQuantityError;
        input.removeAttribute('aria-invalid');
      }
      document.querySelectorAll('[data-clean-product-quantity-stock]').forEach((notice) => {
        notice.textContent = show ? getCleanStockMessage(stock) : '';
        notice.hidden = !show;
      });
    };

    const validateCleanPurchaseQuantity = () => {
      const form = getCleanProductForm();
      const input = getCleanProductQuantityInput();
      if (!input) return true; // Enquiry-only products have no purchase quantity.
      const stock = getCleanPurchaseStock();
      const quantity = Number(input.value);
      const minimum = Number(input.min) || 1;
      const maximum = Number.parseInt(input.max, 10);
      let message = '';
      if (stock && quantity > stock.maximum) {
        message = getCleanStockMessage(stock);
      } else if (!Number.isSafeInteger(quantity) || quantity < minimum) {
        message = `Please enter a whole-number quantity of at least ${minimum}.`;
      } else if (Number.isFinite(maximum) && quantity > maximum) {
        message = `Please enter a quantity of ${maximum} or fewer.`;
      }
      syncCleanQuantityStockMessage(input);
      if (message) input.setAttribute('aria-invalid', 'true');
      else input.removeAttribute('aria-invalid');
      setCleanProductCartError(form, message);
      const error = form?.querySelector('[data-clean-product-cart-error]');
      if (message && error?.dataset) error.dataset.cleanQuantityError = 'true';
      return !message;
    };

    const refreshCleanPurchaseCart = () => {
      if (!document.querySelector('[data-clean-product-inventory]')) return Promise.resolve();
      if (cleanInventoryRequest) return cleanInventoryRequest;
      const revision = cleanInventoryRevision;
      cleanInventoryRequest = fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart is unavailable.');
          return response.json();
        })
        .then((cart) => {
          if (revision !== cleanInventoryRevision) return;
          if (Array.isArray(cart.items)) cleanInventoryCart = cart.items;
          updateCleanPurchaseInventory(getCleanSelectedProductVariant(), { preserveQuantity: true });
        })
        .catch(() => {}) // Keep the server-rendered snapshot when a refresh is unavailable.
        .finally(() => {
          cleanInventoryRequest = null;
        });
      return cleanInventoryRequest;
    };

    const cleanFormatProductMoney = (cents, moneyFormat) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat).replace(/\.00(?!\d)/g, '');
      }

      const amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      if (!moneyFormat) return amount;

      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amount.replace(/\.\d+$/, ''))
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/<[^>]*>/g, '');
    };

    const refreshCleanProductMoney = (root) => {
      if (window.CleanDisplayCurrency?.ready) {
        window.CleanDisplayCurrency.refresh(root);
      } else {
        window.CleanDisplayCurrencyBootstrap?.refresh?.(root);
      }
    };

    const cleanSetProductMoney = (target, cents, moneyFormat) => {
      if (!target) return;

      const sourceText = cleanFormatProductMoney(cents, moneyFormat);
      target.dataset.cleanMoney = '';
      target.dataset.cleanMoneyMinor = String(cents);
      target.dataset.cleanMoneyCurrency =
        target.dataset.cleanMoneyCurrency ||
        document.querySelector('[data-clean-display-currency-config]')?.dataset.cleanDisplayCurrencySource ||
        '';
      target.dataset.cleanMoneySourceText = sourceText;
      target.textContent = sourceText;
      refreshCleanProductMoney(target);
    };

    const updateProductSubtotal = (productForm, selectedVariant) => {
      const subtotal = productForm?.querySelector('[data-clean-product-subtotal]');
      const subtotalValue = subtotal?.querySelector('[data-clean-product-subtotal-value]');
      const quantityInput = getCleanProductQuantityInput();

      if (!subtotal || !subtotalValue || !quantityInput) return;

      const variantPrice = Number.parseInt(selectedVariant?.price, 10);
      const currentPrice = Number.parseInt(subtotal.dataset.cleanProductPrice, 10);
      const price = Number.isFinite(variantPrice) ? variantPrice : currentPrice;
      const quantity = cleanClampProductQuantity(quantityInput.value);

      if (!Number.isFinite(price)) return;

      subtotal.dataset.cleanProductPrice = String(price);
      cleanSetProductMoney(subtotalValue, price * quantity, subtotal.dataset.cleanProductMoneyFormat);
      cleanSetProductMoney(
        getCleanProductSticky()?.querySelector('[data-clean-sticky-price]'),
        price * quantity,
        subtotal.dataset.cleanProductMoneyFormat,
      );
    };

    const getCleanProductSticky = () => document.querySelector('[data-clean-product-sticky]');

    const getCleanProductForm = () => document.querySelector('[data-clean-product-form]');

    const getCleanProductVariantInput = () => getCleanProductForm()?.querySelector('[name="id"]') || null;

    const getCleanProductQuantityInput = () => getCleanProductForm()?.elements.namedItem('quantity') || null;

    const getCleanProductSubmitButton = () =>
      getCleanProductForm()?.querySelector('[data-clean-product-submit]') || null;

    const isCleanActionDisabled = (button) =>
      !button ||
      button.disabled ||
      button.getAttribute('aria-disabled') === 'true' ||
      button.classList.contains('disabled') ||
      button.classList.contains('is-disabled');

    const syncCleanStickyQuantity = (value, { clamp = true } = {}) => {
      const productQuantityInput = getCleanProductQuantityInput();
      const quantity =
        productQuantityInput && clamp
          ? cleanClampQuantityToInput(productQuantityInput, value)
          : cleanClampProductQuantity(value);
      const maximum = productQuantityInput?.getAttribute('max');

      document
        .querySelectorAll('[data-clean-product-quantity-input], [data-clean-sticky-quantity-input]')
        .forEach((input) => {
          if (input.matches('[data-clean-sticky-quantity-input]')) {
            if (maximum === null || maximum === undefined) {
              input.removeAttribute('max');
            } else {
              input.max = maximum;
            }

            input.disabled = Boolean(productQuantityInput?.disabled);
          }

          input.value = quantity;
          syncCleanQuantityControlState(input);
        });

      syncCleanQuantityStockMessage(productQuantityInput);
      updateProductSubtotal(getCleanProductForm());
    };

    const updateCleanPurchaseInventory = (selectedVariant, { preserveQuantity = false } = {}) => {
      const quantityInput = getCleanProductQuantityInput();
      if (!quantityInput || !selectedVariant) return;
      const stock = getCleanPurchaseStock();
      const bulk = quantityInput.matches('[data-clean-bulk-quantity-input]');
      const maximum = stock ? (bulk ? Math.min(9999, stock.maximum) : stock.maximum) : bulk ? 9999 : null;
      if (maximum === null) {
        quantityInput.removeAttribute('max');
      } else {
        quantityInput.max = String(maximum);
      }
      quantityInput.disabled = false;
      if (bulk) {
        quantityInput.dispatchEvent(new CustomEvent('clean:inventory:change'));
        syncCleanQuantityStockMessage(quantityInput);
        syncCleanBulkPrice();
      } else {
        syncCleanStickyQuantity(quantityInput.value, { clamp: !preserveQuantity });
      }
    };

    const syncCleanStickyActionState = (productForm = getCleanProductForm()) => {
      const submitButton = productForm?.querySelector('[data-clean-product-submit]');
      const stickySubmit = getCleanProductSticky()?.querySelector('[data-clean-sticky-submit]');

      if (!submitButton || !stickySubmit) return;

      const isDisabled = isCleanActionDisabled(submitButton);

      stickySubmit.disabled = isDisabled;
      stickySubmit.toggleAttribute('aria-disabled', isDisabled);

      const mainButtonText = submitButton.textContent.trim().toLowerCase();
      const stickyButtonLabels = {
        'adding...': 'ADDING...',
        'opening cart...': 'OPENING CART...',
        'customize now': 'CUSTOMIZE NOW',
        'sold out': 'SOLD OUT',
      };

      stickySubmit.textContent =
        stickyButtonLabels[mainButtonText] || stickySubmit.dataset.cleanStickyAddLabel || 'ADD TO CART';
    };

    const updateCleanStickyPrices = (selectedVariant) => {
      const sticky = getCleanProductSticky();
      if (!sticky || !selectedVariant) return;

      const price = Number.parseInt(selectedVariant.price, 10);
      const compareAtPrice = Number.parseInt(selectedVariant.compare_at_price, 10);
      const priceElement = sticky.querySelector('[data-clean-sticky-price]');
      const comparePriceElement = sticky.querySelector('[data-clean-sticky-compare-price]');

      if (!Number.isFinite(price) || !priceElement || !comparePriceElement) return;

      const quantity = cleanClampProductQuantity(getCleanProductQuantityInput()?.value || 1);
      const tiered = document.querySelector('[data-clean-bulk-mode="tiered"]');
      const total = tiered ? getCleanBulkSubtotal(getCleanBulkDisplayPrice(price), price) : price * quantity;
      cleanSetProductMoney(priceElement, total, sticky.dataset.cleanProductMoneyFormat);

      const comparison = tiered ? price : compareAtPrice;
      if (Number.isFinite(comparison) && comparison * quantity > total) {
        cleanSetProductMoney(comparePriceElement, comparison * quantity, sticky.dataset.cleanProductMoneyFormat);
        comparePriceElement.hidden = false;
        return;
      }
      comparePriceElement.hidden = true;
    };

    const cleanBulkEstimatedCostRatio = 0.53035452;
    const cleanBulkPricingQuantityLimit = 500;
    const cleanWholeCurrencyUnitInCents = 100;
    let cleanBulkDiscountState =
      window.CleanBulkDiscounts?.getState() ||
      JSON.parse(document.querySelector('[data-clean-bulk-discount-state]')?.textContent || '{}');

    const getCleanBulkMode = () => document.querySelector('[data-clean-bulk-mode]')?.dataset?.cleanBulkMode;

    const getCleanBulkTierPercent = (quantity) =>
      (cleanBulkDiscountState.tiers || []).reduce(
        (percent, tier) =>
          tier.minimum > 0 && tier.percent > 0 && tier.percent <= 100 && quantity >= tier.minimum
            ? tier.percent
            : percent,
        0,
      );

    const getCleanBulkQuantity = () => {
      const quantityInput = document.querySelector('[data-clean-bulk-quantity-input]');
      const rawQuantity = quantityInput?.value.trim() || '';
      const quantity = Number.parseInt(rawQuantity, 10);
      const minimumQuantity = Number.parseInt(quantityInput?.min, 10);
      const maximumQuantity = Number.parseInt(quantityInput?.max, 10);
      const isValidQuantity =
        /^\d{1,4}$/.test(rawQuantity) &&
        Number.isFinite(quantity) &&
        Number.isFinite(minimumQuantity) &&
        quantity >= minimumQuantity &&
        (!Number.isFinite(maximumQuantity) || quantity <= maximumQuantity);

      return isValidQuantity ? quantity : null;
    };

    const getCleanBulkDisplayPrice = (basePrice, usesUndiscountedTotal = false) => {
      const quantity = getCleanBulkQuantity();

      if (!Number.isFinite(quantity)) return basePrice;

      if (getCleanBulkMode() === 'tiered') {
        return Math.round(
          (basePrice * (100 - getCleanBulkTierPercent(quantity + (cleanBulkDiscountState.eligibleQuantity || 0)))) /
            100,
        );
      }
      if (getCleanBulkMode() === 'regular') return basePrice;
      if (usesUndiscountedTotal) return basePrice;

      const pricingQuantity = Math.min(quantity, cleanBulkPricingQuantityLimit);
      const quantityFactor = 1.159821 * pricingQuantity ** -0.1380503;
      const estimatedPrice =
        basePrice * (cleanBulkEstimatedCostRatio + (1 - cleanBulkEstimatedCostRatio) * quantityFactor);
      const wholeCurrencyPrice =
        Math.ceil(estimatedPrice / cleanWholeCurrencyUnitInCents) * cleanWholeCurrencyUnitInCents;

      return Math.min(basePrice, wholeCurrencyPrice);
    };

    const getCleanBulkSubtotal = (basePrice, originalPrice = basePrice) => {
      const quantity = getCleanBulkQuantity();

      if (Number.isFinite(quantity) && getCleanBulkMode() === 'tiered') {
        return Math.round(
          (originalPrice *
            quantity *
            (100 - getCleanBulkTierPercent(quantity + (cleanBulkDiscountState.eligibleQuantity || 0)))) /
            100,
        );
      }
      return Number.isFinite(quantity) ? basePrice * quantity : basePrice;
    };

    const updateCleanBulkPrice = (selectedVariant) => {
      const bulkPricing = document.querySelector('.clean-main-product__bulk-pricing');
      const bulkBasePriceElement = bulkPricing?.querySelector('[data-clean-bulk-base-price]');
      const bulkPriceElement = bulkPricing?.querySelector('[data-clean-bulk-price]');
      const bulkSubtotalElement = bulkPricing?.querySelector('[data-clean-bulk-subtotal]');
      const bulkSavingsElement = bulkPricing?.querySelector('[data-clean-bulk-savings]');
      const price = Number.parseInt(selectedVariant?.price, 10);

      if (!bulkPricing || !bulkPriceElement || !Number.isFinite(price)) return;

      const usesUndiscountedTotal = bulkPricing.dataset.cleanBulkUndiscountedTotal === 'true';
      const bulkPrice = getCleanBulkDisplayPrice(price, usesUndiscountedTotal);
      const moneyFormat = bulkPricing.dataset.cleanProductMoneyFormat;
      const savingsPercentage =
        getCleanBulkMode() === 'tiered'
          ? getCleanBulkTierPercent((getCleanBulkQuantity() || 0) + (cleanBulkDiscountState.eligibleQuantity || 0))
          : !usesUndiscountedTotal && price > 0
            ? Math.max(0, Math.round(((price - bulkPrice) * 100) / price))
            : 0;

      if (bulkBasePriceElement) {
        cleanSetProductMoney(bulkBasePriceElement, price, moneyFormat);
      }
      cleanSetProductMoney(bulkPriceElement, bulkPrice, moneyFormat);

      if (bulkSubtotalElement) {
        cleanSetProductMoney(bulkSubtotalElement, getCleanBulkSubtotal(bulkPrice, price), moneyFormat);
      }

      if (bulkSavingsElement) {
        bulkSavingsElement.hidden = savingsPercentage < 1;
        bulkSavingsElement.textContent = savingsPercentage > 0 ? `Save ${savingsPercentage}% per item` : '';
      }
    };

    const updateCleanMainPrice = (selectedVariant) => {
      const priceWrapper = document.querySelector('[data-clean-product-price]');
      if (!selectedVariant) return;

      updateCleanBulkPrice(selectedVariant);
      if (!priceWrapper) return;

      const price = Number.parseInt(selectedVariant.price, 10);
      const compareAtPrice = Number.parseInt(selectedVariant.compare_at_price, 10);
      const currentPriceElement = priceWrapper.querySelector('[data-clean-product-current-price]');
      const comparePriceElement = priceWrapper.querySelector('[data-clean-product-compare-price]');
      const discountElement = priceWrapper.querySelector('[data-clean-product-discount]');

      if (!Number.isFinite(price) || !currentPriceElement) return;

      const hasSalePrice = Number.isFinite(compareAtPrice) && compareAtPrice > price;

      cleanSetProductMoney(currentPriceElement, price, priceWrapper.dataset.cleanProductMoneyFormat);
      priceWrapper.classList.toggle('clean-main-product__price--sale', hasSalePrice);
      currentPriceElement.classList.toggle('clean-main-product__current-price--sale', hasSalePrice);

      if (comparePriceElement) {
        comparePriceElement.hidden = !hasSalePrice;
        if (hasSalePrice) {
          cleanSetProductMoney(comparePriceElement, compareAtPrice, priceWrapper.dataset.cleanProductMoneyFormat);
        }
      }

      if (!discountElement) return;

      discountElement.hidden = !hasSalePrice;
      if (hasSalePrice) {
        discountElement.textContent = `${Math.round(((compareAtPrice - price) * 100) / compareAtPrice)}% OFF`;
      }
    };

    const updateCleanProductSku = (selectedVariant) => {
      const skuWrapper = document.querySelector('[data-clean-product-sku]');
      const skuValue = skuWrapper?.querySelector('[data-clean-product-sku-value]');
      const copyButton = skuWrapper?.querySelector('[data-clean-product-sku-copy]');

      if (!skuWrapper || !skuValue || !copyButton) return;

      const sku = selectedVariant?.sku?.trim() || '';

      skuValue.textContent = sku;
      copyButton.dataset.cleanProductSkuText = sku;
      skuWrapper.hidden = !sku;
    };

    const getCleanSelectedProductVariant = () => {
      const productForm = getCleanProductForm();
      const variantInput = productForm?.querySelector('[data-clean-product-variant-id]');
      const variantsJson = productForm?.querySelector('[data-clean-product-variants]');

      if (!variantInput || !variantsJson?.textContent) return null;

      try {
        const variants = JSON.parse(variantsJson.textContent);
        return variants.find((variant) => String(variant.id) === String(variantInput.value)) || null;
      } catch (error) {
        return null;
      }
    };

    const syncCleanBulkPrice = () => {
      const selectedVariant = getCleanSelectedProductVariant();
      if (selectedVariant) {
        updateCleanBulkPrice(selectedVariant);
        updateCleanStickyPrices(selectedVariant);
      }
    };

    document.addEventListener('clean:bulk-quantity:change', syncCleanBulkPrice);

    document.addEventListener('clean:bulk-discounts:updated', (event) => {
      cleanBulkDiscountState = event.detail;
      syncCleanBulkPrice();
    });

    const updateCleanTaxShippingNote = (selectedVariant) => {
      const note = document.querySelector('[data-clean-product-tax-shipping-note]');
      const price = Number.parseInt(selectedVariant?.price, 10);

      if (!note || !Number.isFinite(price)) return;

      note.hidden = price <= 50000;
    };

    const syncCleanCustomeowDisabledState = (productForm = getCleanProductForm()) => {
      const submitButton = productForm?.querySelector('[data-clean-product-submit]');
      const isDisabled = submitButton ? isCleanActionDisabled(submitButton) : false;

      document.querySelectorAll('customeow-block-button, [data-type="customeowApp"]').forEach((element) => {
        element.toggleAttribute('aria-disabled', isDisabled);
        element.dataset.cleanCustomeowDisabled = String(isDisabled);

        if (isDisabled) {
          if (!element.dataset.cleanPreviousPointerEvents) {
            element.dataset.cleanPreviousPointerEvents = element.style.pointerEvents || ' ';
          }
          element.style.pointerEvents = 'none';
          element.style.cursor = 'not-allowed';
          return;
        }

        if (element.dataset.cleanPreviousPointerEvents) {
          element.style.pointerEvents =
            element.dataset.cleanPreviousPointerEvents === ' ' ? '' : element.dataset.cleanPreviousPointerEvents;
          delete element.dataset.cleanPreviousPointerEvents;
        }
        element.style.cursor = '';
      });
    };

    const patchCleanCustomeow = () => {
      const productForm = getCleanProductForm();
      const variantInput = getCleanProductVariantInput();

      if (!productForm || !variantInput) return false;

      let patched = false;
      const customeowEmbed = window._customeowDebug?.customeowDesign;

      if (customeowEmbed) {
        customeowEmbed.$form = productForm;
        customeowEmbed.$formParent = productForm.parentElement;
        customeowEmbed.getVariantIdDom = getCleanProductVariantInput;
        customeowEmbed.getQuantityDom = getCleanProductQuantityInput;
        customeowEmbed.getSubmitButton = getCleanProductSubmitButton;
        patched = true;
      }

      document.querySelectorAll('customeow-block-button').forEach((button) => {
        button.getVariantIdDom = getCleanProductVariantInput;
        button.getQuantityDom = getCleanProductQuantityInput;
        button.variantIdStore?.set(String(variantInput.value));
        patched = true;
      });

      syncCleanCustomeowDisabledState(productForm);

      return patched;
    };

    const initializeCleanCustomeowPatch = (attempt = 0) => {
      if (patchCleanCustomeow() || attempt >= 40) return;
      window.setTimeout(() => initializeCleanCustomeowPatch(attempt + 1), 250);
    };

    const observeCleanCustomeowState = () => {
      const submitButton = getCleanProductSubmitButton();

      if (submitButton && submitButton.dataset.cleanCustomeowObserverReady !== 'true') {
        submitButton.dataset.cleanCustomeowObserverReady = 'true';

        new MutationObserver(() => {
          syncCleanCustomeowDisabledState();
          syncCleanStickyActionState();
        }).observe(submitButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          characterData: true,
          subtree: true,
        });
      }

      if (document.body.dataset.cleanCustomeowObserverReady === 'true') return;
      document.body.dataset.cleanCustomeowObserverReady = 'true';

      new MutationObserver(() => {
        patchCleanCustomeow();
      }).observe(document.body, { childList: true, subtree: true });
    };

    const initVariantPickers = (root = document) => {
      root.querySelectorAll('[data-clean-product-variant-picker]').forEach((variantPicker) => {
        if (variantPicker.dataset.cleanVariantPickerReady === 'true') return;

        variantPicker.dataset.cleanVariantPickerReady = 'true';

        const purchase = variantPicker.closest('.clean-main-product__purchase');
        const productForm = purchase?.querySelector('[data-clean-product-form]');
        const variantInput = productForm?.querySelector('[data-clean-product-variant-id]');
        const submitButton = productForm?.querySelector('[data-clean-product-submit]');
        const variantsJson = productForm?.querySelector('[data-clean-product-variants]');
        let variants = [];

        if (variantsJson?.textContent) {
          try {
            variants = JSON.parse(variantsJson.textContent);
          } catch (error) {
            variants = [];
          }
        }

        const getCleanOptionButtonValue = (button) =>
          button?.dataset.cleanProductOptionValueText || button?.textContent.trim() || '';

        const updateSelectedVariant = () => {
          if (!variantInput || !variants.length) return;

          const selectedOptions = Array.from(variantPicker.querySelectorAll('.clean-main-product__option')).map(
            (option) =>
              getCleanOptionButtonValue(option.querySelector('[data-clean-product-option-value][aria-pressed="true"]')),
          );
          const selectedVariant = variants.find((variant) =>
            selectedOptions.every((selectedOption, index) => variant.options[index] === selectedOption),
          );

          if (!selectedVariant) return;

          variantInput.value = selectedVariant.id;
          updateCleanProductSku(selectedVariant);
          updateCleanPurchaseInventory(selectedVariant);
          updateProductSubtotal(productForm, selectedVariant);

          if (submitButton) {
            submitButton.disabled = !selectedVariant.available;
            submitButton.textContent = selectedVariant.available
              ? submitButton.dataset.cleanProductAddLabel || 'ADD TO CART'
              : 'SOLD OUT';
            syncCleanCustomeowDisabledState(productForm);
            syncCleanStickyActionState(productForm);
            productForm.dispatchEvent(new CustomEvent('clean:variant:change'));
          }

          updateCleanStickyPrices(selectedVariant);
          updateCleanMainPrice(selectedVariant);
          updateCleanTaxShippingNote(selectedVariant);
        };

        variantPicker.addEventListener('click', (event) => {
          const selectedButton = event.target.closest('[data-clean-product-option-value]');

          if (!selectedButton || !variantPicker.contains(selectedButton)) return;

          const option = selectedButton.closest('.clean-main-product__option');
          const selectedValue = option?.querySelector('[data-clean-product-option-selected-value]');

          if (!option || !selectedValue) return;

          option.querySelectorAll('[data-clean-product-option-value]').forEach((button) => {
            button.setAttribute('aria-pressed', String(button === selectedButton));
          });

          selectedValue.textContent = getCleanOptionButtonValue(selectedButton);

          if (selectedButton.dataset.cleanProductVariantImageId) {
            variantPicker.closest('[data-clean-product-gallery]')?.dispatchEvent(
              new CustomEvent('clean:gallery:select-image', {
                detail: {
                  imageId: selectedButton.dataset.cleanProductVariantImageId,
                },
              }),
            );
          }

          updateSelectedVariant();
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initVariantPickers(), { once: true });
    } else {
      initVariantPickers();
    }

    document.addEventListener('shopify:section:load', (event) => initVariantPickers(event.target));

    const initQuantityControls = (root = document) => {
      root.querySelectorAll('[data-clean-product-quantity]').forEach((quantityControl) => {
        if (quantityControl.dataset.cleanQuantityReady === 'true') return;

        const input = quantityControl.querySelector('[data-clean-product-quantity-input]');
        const decreaseButton = quantityControl.querySelector('[data-clean-product-quantity-decrease]');
        const increaseButton = quantityControl.querySelector('[data-clean-product-quantity-increase]');

        if (!input || !decreaseButton || !increaseButton) return;

        quantityControl.dataset.cleanQuantityReady = 'true';
        const productForm = quantityControl.closest('[data-clean-product-form]');

        const setQuantity = (value) => {
          input.value = cleanClampQuantityToInput(input, value);
          updateProductSubtotal(productForm);
          syncCleanStickyQuantity(input.value);
        };

        decreaseButton.addEventListener('click', () => {
          setQuantity(cleanClampProductQuantity(input.value) - 1);
        });

        increaseButton.addEventListener('click', () => {
          setQuantity(cleanClampProductQuantity(input.value) + 1);
        });

        input.addEventListener('input', () => setQuantity(input.value));
        input.addEventListener('change', () => setQuantity(input.value));
        syncCleanQuantityControlState(input);
        syncCleanQuantityStockMessage(input);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initQuantityControls(), { once: true });
    } else {
      initQuantityControls();
    }

    document.addEventListener('shopify:section:load', (event) => initQuantityControls(event.target));

    const initBulkQuantityControls = (root = document) => {
      root.querySelectorAll('[data-clean-bulk-quantity]').forEach((quantityControl) => {
        if (quantityControl.dataset.cleanBulkQuantityReady === 'true') return;

        const input = quantityControl.querySelector('[data-clean-bulk-quantity-input]');
        const decreaseButton = quantityControl.querySelector('[data-clean-bulk-quantity-decrease]');
        const increaseButton = quantityControl.querySelector('[data-clean-bulk-quantity-increase]');
        const minimumError = quantityControl
          .closest('.clean-main-product__bulk-quantity-group')
          ?.querySelector('[data-clean-bulk-quantity-error]');

        if (!input || !decreaseButton || !increaseButton) return;

        quantityControl.dataset.cleanBulkQuantityReady = 'true';
        input.form?.addEventListener(
          'click',
          (event) => {
            if (
              event.target.closest('[data-clean-product-submit], customeow-block-button') &&
              (!validateCleanPurchaseQuantity() || !input.reportValidity())
            ) {
              event.preventDefault();
              event.stopImmediatePropagation();
            }
          },
          true,
        );
        const minimumQuantity = Math.max(1, cleanClampProductQuantity(input.min));
        const getMaximumQuantity = () => Number.parseInt(input.max, 10);

        const setMinimumError = (isVisible) => {
          if (minimumError) minimumError.setAttribute('aria-hidden', String(!isVisible));
          if (isVisible) {
            input.setAttribute('aria-invalid', 'true');
          } else {
            input.removeAttribute('aria-invalid');
          }
        };

        const setQuantity = (value, emitChange = true) => {
          const maximumQuantity = getMaximumQuantity();
          const quantity = cleanClampQuantityToInput(input, value);
          input.value = quantity;
          decreaseButton.disabled = false;
          increaseButton.disabled = quantity >= maximumQuantity;
          setMinimumError(false);
          syncCleanQuantityStockMessage(input);

          if (emitChange) {
            quantityControl.dispatchEvent(
              new CustomEvent('clean:bulk-quantity:change', {
                bubbles: true,
                detail: { quantity },
              }),
            );
          }
        };

        decreaseButton.addEventListener('click', () => {
          const quantity = Number.parseInt(input.value, 10);

          if (!Number.isFinite(quantity) || quantity <= minimumQuantity) {
            input.value = minimumQuantity;
            decreaseButton.disabled = false;
            increaseButton.disabled = minimumQuantity >= getMaximumQuantity();
            setMinimumError(false);
            syncCleanQuantityStockMessage(input);
            syncCleanBulkPrice();
            return;
          }

          setQuantity(quantity - 1);
        });

        increaseButton.addEventListener('click', () => {
          setQuantity(cleanClampProductQuantity(input.value) + 1);
        });

        input.addEventListener('keydown', (event) => {
          if (['e', 'E', '+', '-', '.', ','].includes(event.key)) event.preventDefault();
        });

        input.addEventListener('input', () => {
          const digits = input.value.replace(/\D/g, '').slice(0, 4);
          input.value = digits;
          const quantity = Number.parseInt(digits, 10);
          decreaseButton.disabled = false;
          increaseButton.disabled = Number.isFinite(quantity) && quantity >= getMaximumQuantity();
          setMinimumError(Number.isFinite(quantity) && quantity < minimumQuantity);
          syncCleanQuantityStockMessage(input);
          syncCleanBulkPrice();
        });

        input.addEventListener('change', () => {
          const quantity = Number.parseInt(input.value, 10);

          if (Number.isFinite(quantity) && quantity < minimumQuantity) {
            setMinimumError(true);
            syncCleanBulkPrice();
            return;
          }

          // Keep an over-stock draft visible so the customer can correct it.
          if (Number.isFinite(quantity) && quantity > getMaximumQuantity()) {
            syncCleanQuantityStockMessage(input);
            return;
          }
          setQuantity(input.value);
        });
        input.addEventListener('clean:inventory:change', () => {
          increaseButton.disabled = Number(input.value) >= getMaximumQuantity();
        });
        setQuantity(input.value, false);
        syncCleanBulkPrice();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initBulkQuantityControls(), { once: true });
    } else {
      initBulkQuantityControls();
    }

    document.addEventListener('shopify:section:load', (event) => initBulkQuantityControls(event.target));

    document.addEventListener('clean:cart:updated', (event) => {
      if (Array.isArray(event.detail?.cart?.items)) {
        cleanInventoryRevision += 1;
        cleanInventoryCart = event.detail.cart.items;
        updateCleanPurchaseInventory(getCleanSelectedProductVariant(), { preserveQuantity: true });
      }
    });
    window.addEventListener('pageshow', refreshCleanPurchaseCart);
    window.addEventListener('focus', refreshCleanPurchaseCart);
    refreshCleanPurchaseCart();

    const getCleanCartApi = () => window.CleanCart || null;

    const waitForCleanCartApi = () => {
      const readyApi = getCleanCartApi();
      if (readyApi) return Promise.resolve(readyApi);

      return new Promise((resolve, reject) => {
        const timeout = window.setTimeout(() => {
          document.removeEventListener('clean:cart:ready', handleReady);
          reject(new Error('Cart drawer is not ready.'));
        }, 3000);

        const handleReady = () => {
          window.clearTimeout(timeout);
          document.removeEventListener('clean:cart:ready', handleReady);
          resolve(getCleanCartApi());
        };

        document.addEventListener('clean:cart:ready', handleReady);
      });
    };

    const getCleanProductCartFlow = (productForm) =>
      String(productForm?.dataset.cleanProductFlow || '')
        .trim()
        .toLowerCase();

    const setCleanProductCartError = (productForm, message = '') => {
      const error = productForm?.querySelector('[data-clean-product-cart-error]');
      if (!error) return;

      error.textContent = message;
      error.hidden = !message;
      delete error.dataset.cleanQuantityError;
    };

    const setCleanProductSubmissionState = (productForm, state, label) => {
      const submitButton = productForm?.querySelector('[data-clean-product-submit]');
      if (!productForm || !submitButton) return;

      if (!productForm.dataset.cleanCartOriginalLabel) {
        productForm.dataset.cleanCartOriginalLabel = submitButton.textContent;
        productForm.dataset.cleanCartOriginalDisabled = String(submitButton.disabled);
      }

      productForm.dataset.cleanCartSubmissionState = state;
      productForm.setAttribute('aria-busy', 'true');
      submitButton.disabled = true;
      submitButton.textContent = label;
      syncCleanStickyActionState(productForm);
      syncCleanCustomeowDisabledState(productForm);
    };

    const resetCleanProductSubmissionState = (productForm) => {
      const submitButton = productForm?.querySelector('[data-clean-product-submit]');
      if (!productForm || !submitButton) return;

      const originalLabel = productForm.dataset.cleanCartOriginalLabel;
      const originalDisabled = productForm.dataset.cleanCartOriginalDisabled;

      if (originalLabel !== undefined) submitButton.textContent = originalLabel;
      if (originalDisabled !== undefined) submitButton.disabled = originalDisabled === 'true';

      delete productForm.dataset.cleanCartSubmissionState;
      delete productForm.dataset.cleanCartOriginalLabel;
      delete productForm.dataset.cleanCartOriginalDisabled;
      productForm.removeAttribute('aria-busy');
      syncCleanStickyActionState(productForm);
      syncCleanCustomeowDisabledState(productForm);
    };

    const getCleanProductCartErrorMessage = (error) => {
      const message = typeof error?.message === 'string' ? error.message.trim() : '';
      if (!message || message === 'Failed to fetch' || message === 'NetworkError when attempting to fetch resource.') {
        return 'Unable to add this item right now. Please try again.';
      }
      return message;
    };

    const addCleanCustomizedProductToCart = async (productForm) => {
      const submitButton = productForm?.querySelector('[data-clean-product-submit]');

      if (!productForm || isCleanActionDisabled(submitButton)) return;

      if (submitButton.dataset.cleanDeliveryValid === 'false') {
        productForm.dispatchEvent(new CustomEvent('clean:delivery:request-validation', { bubbles: true }));
        return;
      }

      const originalLabel = submitButton.textContent;
      const wasDisabled = submitButton.disabled;
      submitButton.disabled = true;
      submitButton.textContent = 'ADDING...';

      try {
        await refreshCleanPurchaseCart();
        if (!validateCleanPurchaseQuantity()) return;
        const cleanCart = await waitForCleanCartApi();
        await cleanCart?.addFromForm?.(productForm);
      } catch (error) {
        // CleanCart owns cart UI after successful adds; do not bypass the upsell gate here.
      } finally {
        submitButton.disabled = wasDisabled;
        submitButton.textContent = originalLabel;
        syncCleanStickyActionState(productForm);
        syncCleanCustomeowDisabledState(productForm);
      }
    };

    const addCleanStandardProductToCart = async (productForm) => {
      const submitButton = productForm?.querySelector('[data-clean-product-submit]');

      if (
        !productForm ||
        isCleanActionDisabled(submitButton) ||
        ['submitting', 'navigating'].includes(productForm.dataset.cleanCartSubmissionState)
      ) {
        return;
      }

      if (submitButton.dataset.cleanDeliveryValid === 'false') {
        productForm.dispatchEvent(new CustomEvent('clean:delivery:request-validation', { bubbles: true }));
        return;
      }

      let navigationStarted = false;
      setCleanProductCartError(productForm);
      setCleanProductSubmissionState(productForm, 'submitting', 'ADDING...');

      try {
        await refreshCleanPurchaseCart();
        if (!validateCleanPurchaseQuantity()) return;
        const cleanCart = await waitForCleanCartApi();
        if (typeof cleanCart?.addFromForm !== 'function') throw new Error('Cart is not ready.');

        await cleanCart.addFromForm(productForm, {
          onNavigationStart: () => {
            navigationStarted = true;
            setCleanProductSubmissionState(productForm, 'navigating', 'OPENING CART...');
          },
        });
      } catch (error) {
        navigationStarted = false;
        setCleanProductCartError(productForm, getCleanProductCartErrorMessage(error));
      } finally {
        if (!navigationStarted) resetCleanProductSubmissionState(productForm);
      }
    };

    const addCleanProductToCart = async (productForm) => {
      if (getCleanProductCartFlow(productForm) !== 'standard') {
        await addCleanCustomizedProductToCart(productForm);
        return;
      }

      await addCleanStandardProductToCart(productForm);
    };

    const initCleanProductCartBridge = (root = document) => {
      root.querySelectorAll('[data-clean-product-form]').forEach((productForm) => {
        if (productForm.dataset.cleanCartSubmitReady === 'true') return;

        productForm.dataset.cleanCartSubmitReady = 'true';
        productForm.addEventListener(
          'click',
          (event) => {
            if (
              event.target.closest('[data-clean-product-submit], customeow-block-button, [data-type="customeowApp"]') &&
              !validateCleanPurchaseQuantity()
            ) {
              event.preventDefault();
              event.stopImmediatePropagation();
            }
          },
          true,
        );
        productForm.addEventListener(
          'submit',
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            const quantity = getCleanProductQuantityInput();
            if (!validateCleanPurchaseQuantity()) return;
            if (quantity?.matches('[data-clean-bulk-quantity-input]') && !quantity.reportValidity()) return;
            addCleanProductToCart(productForm);
          },
          true,
        );
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanProductCartBridge(), { once: true });
    } else {
      initCleanProductCartBridge();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanProductCartBridge(event.target));

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;

      document
        .querySelectorAll('[data-clean-product-form][data-clean-product-flow="standard"]')
        .forEach((productForm) => resetCleanProductSubmissionState(productForm));
    });

    const initCleanBulkEnquiry = (root = document) => {
      root.querySelectorAll('[data-clean-bulk-enquiry-modal]').forEach((modal) => {
        if (modal.dataset.cleanBulkEnquiryReady === 'true') return;
        modal.dataset.cleanBulkEnquiryReady = 'true';

        const productSection = modal.closest('.clean-main-product') || document;
        const closeButtons = modal.querySelectorAll('[data-clean-bulk-enquiry-close]');
        const firstField = modal.querySelector('.clean-bulk-enquiry__field');
        const form = modal.querySelector('[data-clean-bulk-enquiry-form]');
        const status = modal.querySelector('[data-clean-bulk-enquiry-status]');
        const submitButton = modal.querySelector('[data-clean-bulk-enquiry-submit]');
        const endpoint = modal.dataset.cleanBulkEnquiryEndpoint || '';
        const productName = modal.dataset.cleanBulkEnquiryProduct || '';
        let opener = null;
        let isSubmitting = false;

        const getFocusable = () =>
          Array.from(
            modal.querySelectorAll(
              '.clean-bulk-enquiry__close, .clean-bulk-enquiry__field, .clean-bulk-enquiry__submit',
            ),
          ).filter((element) => !element.disabled && element.offsetParent !== null);

        const getRequiredFields = () =>
          Array.from(modal.querySelectorAll('.clean-bulk-enquiry__field')).filter((field) =>
            (field.getAttribute('placeholder') || '').trim().endsWith('*'),
          );

        const setStatus = (message = '', type = 'error') => {
          if (!status) return;
          status.textContent = message;
          status.classList.toggle('clean-bulk-enquiry__status--success', type === 'success');
          status.hidden = !message;
        };

        const clearFieldError = (field) => {
          field.removeAttribute('aria-invalid');
          if (getRequiredFields().every((requiredField) => requiredField.getAttribute('aria-invalid') !== 'true')) {
            setStatus();
          }
        };

        const validateRequiredFields = ({ focusFirstInvalid = true } = {}) => {
          let firstInvalid = null;
          let hasInvalidEmail = false;

          getRequiredFields().forEach((field) => {
            field.required = true;

            const isEmpty = !String(field.value || '').trim();
            const isInvalidEmail = !isEmpty && field.type === 'email' && !field.validity.valid;
            const isInvalid = isEmpty || isInvalidEmail;

            field.setAttribute('aria-invalid', String(isInvalid));

            if (isInvalid && !firstInvalid) firstInvalid = field;
            if (isInvalidEmail) hasInvalidEmail = true;
          });

          if (!firstInvalid) {
            setStatus();
            return true;
          }

          setStatus(hasInvalidEmail ? 'Please enter a valid email address.' : 'Please fill all required fields.');

          if (focusFirstInvalid) {
            firstInvalid.focus();
          }

          return false;
        };

        const getFieldValue = (fieldName) => String(form?.elements?.[fieldName]?.value || '').trim();

        const getBulkEnquiryPayload = () => {
          return new URLSearchParams({
            name: getFieldValue('clean_bulk_name'),
            email: getFieldValue('clean_bulk_email'),
            phone: getFieldValue('clean_bulk_phone'),
            countryDial: getFieldValue('clean_bulk_country_code'),
            company: getFieldValue('clean_bulk_company'),
            message: getFieldValue('clean_bulk_message') || '-',
            productName: productName || document.title,
            website: getFieldValue('website'),
          });
        };

        const closeModal = () => {
          if (modal.hidden) return;

          modal.hidden = true;
          modal.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('clean-bulk-enquiry-open');
          setStatus();
          getRequiredFields().forEach(clearFieldError);
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = 'Submit';
          }

          if (opener?.isConnected) {
            opener.focus();
          }
        };

        const openModal = (trigger) => {
          if (!modal.hidden) return;

          opener = trigger || document.activeElement;
          modal.hidden = false;
          modal.setAttribute('aria-hidden', 'false');
          document.body.classList.add('clean-bulk-enquiry-open');
          window.requestAnimationFrame(() => firstField?.focus());
        };

        productSection
          .querySelectorAll('[data-clean-product-enquire], [data-clean-sticky-enquire]')
          .forEach((button) => {
            button.addEventListener('click', (event) => {
              event.preventDefault();
              openModal(button);
            });
          });

        closeButtons.forEach((button) => {
          button.addEventListener('click', closeModal);
        });

        getRequiredFields().forEach((field) => {
          field.required = true;
          field.addEventListener('input', () => clearFieldError(field));
          field.addEventListener('change', () => clearFieldError(field));
        });

        form?.addEventListener('submit', async (event) => {
          event.preventDefault();
          if (isSubmitting) return;

          if (!validateRequiredFields()) return;

          if (!endpoint) {
            setStatus('Unable to submit right now. Please try again.');
            return;
          }

          isSubmitting = true;
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';
          }

          try {
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
              body: getBulkEnquiryPayload(),
            });
            const result = await response.json().catch(() => null);
            if (!response.ok || result?.success !== true) throw new Error('submission_failed');

            form.reset();
            getRequiredFields().forEach(clearFieldError);
            setStatus("Thank you! We'll get back to you shortly.", 'success');
          } catch {
            setStatus('Unable to submit right now. Please try again.');
          } finally {
            isSubmitting = false;
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = 'Submit';
            }
          }
        });

        modal.addEventListener('keydown', (event) => {
          if (modal.hidden) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            closeModal();
            return;
          }

          if (event.key !== 'Tab') return;

          const focusable = getFocusable();
          if (!focusable.length) return;

          const first = focusable[0];
          const last = focusable[focusable.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanBulkEnquiry(), { once: true });
    } else {
      initCleanBulkEnquiry();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanBulkEnquiry(event.target));

    const initCleanStickyAtc = () => {
      const sticky = getCleanProductSticky();
      const buyButtons = document.querySelector('[data-clean-product-buy-buttons]');

      if (!sticky || !buyButtons) return;

      if (sticky.dataset.cleanStickyAtcReady !== 'true') {
        sticky.dataset.cleanStickyAtcReady = 'true';

        const quantityInput = sticky.querySelector('[data-clean-sticky-quantity-input]');
        const decreaseButton = sticky.querySelector('[data-clean-sticky-quantity-decrease]');
        const increaseButton = sticky.querySelector('[data-clean-sticky-quantity-increase]');
        const stickySubmit = sticky.querySelector('[data-clean-sticky-submit]');

        decreaseButton?.addEventListener('click', () => {
          syncCleanStickyQuantity(Math.max(1, cleanClampProductQuantity(quantityInput?.value) - 1));
        });

        increaseButton?.addEventListener('click', () => {
          syncCleanStickyQuantity(cleanClampProductQuantity(quantityInput?.value) + 1);
        });

        quantityInput?.addEventListener('input', () => {
          syncCleanStickyQuantity(quantityInput.value);
        });

        quantityInput?.addEventListener('change', () => {
          syncCleanStickyQuantity(quantityInput.value);
        });

        stickySubmit?.addEventListener('click', () => {
          const submitButton = getCleanProductSubmitButton();
          if (isCleanActionDisabled(submitButton)) return;
          if (!validateCleanPurchaseQuantity()) return;
          const productForm = getCleanProductForm();
          if (submitButton.dataset.cleanDeliveryValid === 'false') {
            productForm.dispatchEvent(new CustomEvent('clean:delivery:request-validation', { bubbles: true }));
            return;
          }
          const invalid = Array.from(productForm.elements).find((field) => field.willValidate && !field.validity.valid);
          if (invalid) {
            const focusTarget =
              quantityInput && invalid.matches('[data-clean-product-quantity-input]') ? quantityInput : invalid;
            focusTarget?.scrollIntoView({ block: 'center', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
            focusTarget?.focus({ preventScroll: true });
            focusTarget?.reportValidity();
            return;
          }
          // Ignore inactive app masks, but allow the purchase row hidden by the mobile layout.
          const customizer = Array.from(
            productForm.querySelectorAll(
              '[data-clean-product-submit] [data-type="customeowApp"], customeow-block-button',
            ),
          ).find((element) => {
            const mobileOwner = window.matchMedia('(max-width: 767px)').matches
              ? element.closest('[data-clean-product-buy-buttons]')
              : null;
            if (!mobileOwner && element.getClientRects().length === 0) return false;
            for (let node = element; node && node !== productForm; node = node.parentElement) {
              const style = getComputedStyle(node);
              if (style.visibility === 'hidden' || (style.display === 'none' && node !== mobileOwner)) return false;
            }
            return true;
          });
          if (customizer) {
            customizer.click();
          } else if (window._customeowDebug?.customeowDesign?.isShowLoading) {
            setCleanProductCartError(productForm, 'Customization is loading. Please try again.');
          } else {
            submitButton.click();
          }
        });
      }

      syncCleanStickyQuantity(getCleanProductQuantityInput()?.value || 1);
      syncCleanStickyActionState();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCleanStickyAtc, { once: true });
    } else {
      initCleanStickyAtc();
    }

    document.addEventListener('shopify:section:load', initCleanStickyAtc);

    const initCleanCustomeowBridge = () => {
      observeCleanCustomeowState();
      initializeCleanCustomeowPatch();
      syncCleanCustomeowDisabledState();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCleanCustomeowBridge, { once: true });
    } else {
      initCleanCustomeowBridge();
    }

    if (window.customElements) {
      customElements.whenDefined('customeow-block-button').then(() => {
        patchCleanCustomeow();
        syncCleanCustomeowDisabledState();
      });
    }

    document.addEventListener('customeow-data-updated', () => {
      patchCleanCustomeow();
      syncCleanCustomeowDisabledState();
    });

    document.querySelectorAll('[data-clean-product-accordion]').forEach((accordion) => {
      if (accordion.dataset.cleanAccordionReady === 'true') return;

      const summary = accordion.querySelector('summary');
      const content = accordion.querySelector('[data-clean-product-accordion-content]');

      if (!summary || !content) return;

      accordion.dataset.cleanAccordionReady = 'true';

      const clearAnimationStyles = () => {
        content.style.height = '';
        content.style.opacity = '';
      };

      const setContentHeight = (height, opacity) => {
        content.style.height = `${height}px`;
        content.style.opacity = opacity;
      };

      const finishOpening = (event) => {
        if (event.target !== content || event.propertyName !== 'height') return;
        content.removeEventListener('transitionend', finishOpening);
        clearAnimationStyles();
      };

      const finishClosing = (event) => {
        if (event.target !== content || event.propertyName !== 'height') return;
        content.removeEventListener('transitionend', finishClosing);
        accordion.open = false;
        clearAnimationStyles();
      };

      const openAccordion = () => {
        accordion.open = true;
        setContentHeight(0, '0');

        requestAnimationFrame(() => {
          content.addEventListener('transitionend', finishOpening);
          setContentHeight(content.scrollHeight, '1');
        });
      };

      const closeAccordion = () => {
        setContentHeight(content.scrollHeight, '1');

        requestAnimationFrame(() => {
          content.addEventListener('transitionend', finishClosing);
          setContentHeight(0, '0');
        });
      };

      summary.addEventListener('click', (event) => {
        if (reducedMotion.matches) return;

        event.preventDefault();

        if (accordion.open) {
          closeAccordion();
        } else {
          openAccordion();
        }
      });
    });

    const copyText = (text) => {
      if (navigator.clipboard?.writeText) {
        return navigator.clipboard.writeText(text);
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-9999px';
      document.body.append(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      } finally {
        textarea.remove();
      }
    };

    const getCleanProductShareUrl = () => {
      try {
        const url = new URL(window.location.href);
        url.hash = '';
        return url.toString();
      } catch (error) {
        return window.location.href.split('#')[0];
      }
    };

    const initProductShareButtons = (root = document) => {
      root.querySelectorAll('[data-clean-product-share]').forEach((button) => {
        if (button.dataset.cleanProductShareReady === 'true') return;
        button.dataset.cleanProductShareReady = 'true';
        button.dataset.cleanProductShareOriginalLabel = button.getAttribute('aria-label') || 'Share product';

        button.addEventListener('click', () => {
          const productSection = button.closest('.clean-main-product');
          const toast = productSection?.querySelector('[data-clean-product-share-toast]');

          copyText(getCleanProductShareUrl())
            .then(() => {
              button.setAttribute('aria-label', 'Product link copied');

              if (toast) {
                window.clearTimeout(Number(toast.dataset.cleanProductShareToastTimer));
                toast.hidden = false;
              }

              const timer = window.setTimeout(() => {
                if (toast) {
                  toast.hidden = true;
                }

                button.setAttribute('aria-label', button.dataset.cleanProductShareOriginalLabel || 'Share product');
              }, 2500);

              if (toast) {
                toast.dataset.cleanProductShareToastTimer = String(timer);
              }
            })
            .catch((error) => {
              console.error(error);
            });
        });
      });
    };

    initProductShareButtons();
    document.addEventListener('shopify:section:load', (event) => initProductShareButtons(event.target));

    document.querySelectorAll('[data-clean-product-sku-copy]').forEach((button) => {
      if (button.dataset.cleanSkuCopyReady === 'true') return;
      button.dataset.cleanSkuCopyReady = 'true';

      button.addEventListener('click', () => {
        const sku = button.dataset.cleanProductSkuText?.trim();
        const successMessage = button
          .closest('[data-clean-product-sku]')
          ?.querySelector('[data-clean-product-sku-copy-success]');
        if (!sku) return;

        copyText(sku)
          .then(() => {
            button.setAttribute('aria-label', 'SKU copied');
            if (!successMessage) return;

            window.clearTimeout(Number(successMessage.dataset.cleanSkuSuccessTimer));
            successMessage.hidden = false;
            successMessage.dataset.cleanSkuSuccessTimer = String(
              window.setTimeout(() => {
                successMessage.hidden = true;
              }, 2500),
            );
          })
          .catch((error) => {
            console.error(error);
          });
      });
    });

    const galleries = document.querySelectorAll('[data-clean-product-gallery]');

    galleries.forEach((gallery) => {
      if (gallery.dataset.cleanGalleryReady === 'true') return;
      gallery.dataset.cleanGalleryReady = 'true';

      const thumbnails = Array.from(gallery.querySelectorAll('[data-clean-gallery-thumbnail]'));
      const mainImage = gallery.querySelector('[data-clean-gallery-main-image]');
      const mainImageFrame = gallery.querySelector('.clean-product-gallery__main');
      const openButton = gallery.querySelector('[data-clean-gallery-open]');
      const viewerTemplate = gallery.querySelector('[data-clean-product-viewer-template]');

      if (!thumbnails.length || !mainImage || !openButton) {
        return;
      }

      let viewer = null;
      let viewerImage = null;
      let viewerImageArea = null;
      let viewerCount = null;
      let closeButton = null;
      let viewerThumbnails = [];
      let viewerEventsReady = false;
      let activeIndex = Math.max(
        0,
        thumbnails.findIndex((thumbnail) => thumbnail.getAttribute('aria-current') === 'true'),
      );
      let previousBodyOverflow = '';
      let isZoomed = false;
      let zoomOrigin = { x: 50, y: 50 };
      let pan = { x: 0, y: 0 };
      let dragStart = null;
      let panStart = { x: 0, y: 0 };
      let dragged = false;
      let mainSwipeStart = null;
      let mainSwipeDelta = { x: 0, y: 0 };
      let mainSwipePointerId = null;
      let mainSwipeMoved = false;
      let suppressNextOpen = false;
      let mainImageLoadToken = 0;
      let viewerImageLoadToken = 0;
      const mobileGalleryMedia = window.matchMedia('(max-width: 767px)');

      const setLoadingImage = (image, loadingElement, loadingClass, attributes, token) => {
        const nextSrc = attributes.src || '';
        const nextSrcset = attributes.srcset || '';
        const currentSrc = image.getAttribute('src') || '';
        const currentSrcset = image.getAttribute('srcset') || '';
        const shouldShowLoader = currentSrc !== nextSrc || currentSrcset !== nextSrcset;
        const shouldWaitForLoad = shouldShowLoader || !image.complete;
        let finished = false;

        const finishLoading = () => {
          if (finished) return;
          finished = true;
          image.removeEventListener('load', finishLoading);
          image.removeEventListener('error', finishLoading);

          if (token.getCurrent() === token.value) {
            loadingElement?.classList.remove(loadingClass);
          }
        };

        if (shouldWaitForLoad) {
          loadingElement?.classList.add(loadingClass);
          image.addEventListener('load', finishLoading);
          image.addEventListener('error', finishLoading);
        }

        if (attributes.alt != null) image.alt = attributes.alt;
        if (attributes.width != null) image.width = attributes.width;
        if (attributes.height != null) image.height = attributes.height;
        if (nextSrcset) image.srcset = nextSrcset;
        if (nextSrc) image.src = nextSrc;

        if (!shouldWaitForLoad || image.complete) {
          window.requestAnimationFrame(finishLoading);
        }
      };

      const refreshViewerElements = () => {
        viewer = gallery.querySelector('[data-clean-product-viewer]');
        viewerImage = gallery.querySelector('[data-clean-viewer-image]');
        viewerImageArea = gallery.querySelector('[data-clean-viewer-image-area]');
        viewerCount = gallery.querySelector('[data-clean-viewer-count]');
        closeButton = gallery.querySelector('[data-clean-viewer-close]');
        viewerThumbnails = Array.from(gallery.querySelectorAll('[data-clean-viewer-thumbnail]'));
      };

      const resetZoom = () => {
        if (!viewerImageArea || !viewerImage) return;
        isZoomed = false;
        zoomOrigin = { x: 50, y: 50 };
        pan = { x: 0, y: 0 };
        dragStart = null;
        dragged = false;
        viewerImageArea.classList.remove(
          'clean-product-viewer__image-area--zoomed',
          'clean-product-viewer__image-area--dragging',
        );
        viewerImageArea.setAttribute('aria-label', 'Zoom in product image');
        viewerImage.style.transformOrigin = '50% 50%';
        viewerImage.style.transform = 'translate3d(0, 0, 0) scale(1)';
        viewerImage.style.transition = 'transform 220ms ease-out';
      };

      const renderTransform = (dragging = false) => {
        if (!viewerImage) return;
        viewerImage.style.transformOrigin = `${zoomOrigin.x}% ${zoomOrigin.y}%`;
        viewerImage.style.transform = `translate3d(${pan.x}px, ${pan.y}px, 0) scale(${isZoomed ? 2.5 : 1})`;
        viewerImage.style.transition = dragging ? 'none' : 'transform 220ms ease-out';
      };

      const selectImage = (requestedIndex, options = {}) => {
        activeIndex = (requestedIndex + thumbnails.length) % thumbnails.length;
        const selected = thumbnails[activeIndex];

        mainImageLoadToken += 1;
        setLoadingImage(
          mainImage,
          mainImageFrame,
          'clean-product-gallery__main--loading',
          {
            src: selected.dataset.cleanGallerySrc,
            srcset: selected.dataset.cleanGallerySrcset.trim(),
            alt: selected.dataset.cleanGalleryAlt,
            width: selected.dataset.cleanGalleryWidth,
            height: selected.dataset.cleanGalleryHeight,
          },
          { getCurrent: () => mainImageLoadToken, value: mainImageLoadToken },
        );

        if (viewerImage) {
          const viewerImageAttributes = {
            alt: selected.dataset.cleanGalleryAlt,
            width: selected.dataset.cleanGalleryWidth,
            height: selected.dataset.cleanGalleryHeight,
          };

          if (viewer && !viewer.hidden) {
            viewerImageLoadToken += 1;
            setLoadingImage(
              viewerImage,
              viewerImageArea,
              'clean-product-viewer__image-area--loading',
              {
                ...viewerImageAttributes,
                src: selected.dataset.cleanGalleryViewerSrc,
              },
              { getCurrent: () => viewerImageLoadToken, value: viewerImageLoadToken },
            );
          } else {
            viewerImage.alt = viewerImageAttributes.alt;
            viewerImage.width = viewerImageAttributes.width;
            viewerImage.height = viewerImageAttributes.height;
          }
        }

        thumbnails.forEach((thumbnail, index) => {
          const isActive = index === activeIndex;
          thumbnail.classList.toggle('clean-product-gallery__thumbnail--active', isActive);
          if (isActive) {
            thumbnail.setAttribute('aria-current', 'true');
          } else {
            thumbnail.removeAttribute('aria-current');
          }
        });

        viewerThumbnails.forEach((thumbnail) => {
          const isActive = Number(thumbnail.dataset.cleanGalleryIndex) === activeIndex;
          thumbnail.classList.toggle('clean-product-viewer__thumbnail--active', isActive);
          if (isActive) {
            thumbnail.setAttribute('aria-current', 'true');
          } else {
            thumbnail.removeAttribute('aria-current');
          }
        });

        if (viewerCount) {
          viewerCount.textContent = `${activeIndex + 1} / ${thumbnails.length}`;
        }
        resetZoom();

        if (options.scrollThumbnail === false) {
          return;
        }

        if (!viewer || viewer.hidden) {
          selected.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } else {
          viewerThumbnails
            .filter((thumbnail) => Number(thumbnail.dataset.cleanGalleryIndex) === activeIndex)
            .forEach((thumbnail) =>
              thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }),
            );
        }
      };

      gallery.addEventListener('clean:gallery:select-image', (event) => {
        const imageId = String(event.detail?.imageId || '');
        if (!imageId) return;

        const requestedIndex = thumbnails.findIndex((thumbnail) => thumbnail.dataset.cleanGalleryImageId === imageId);
        if (requestedIndex < 0 || requestedIndex === activeIndex) return;

        selectImage(requestedIndex, { scrollThumbnail: false });
      });

      const handleMainSwipeStart = (event) => {
        if (!mobileGalleryMedia.matches || thumbnails.length < 2 || event.button > 0) return;
        mainSwipeStart = { x: event.clientX, y: event.clientY };
        mainSwipeDelta = { x: 0, y: 0 };
        mainSwipePointerId = event.pointerId;
        mainSwipeMoved = false;
        openButton.setPointerCapture(event.pointerId);
      };

      const handleMainSwipeMove = (event) => {
        if (!mainSwipeStart || event.pointerId !== mainSwipePointerId) return;

        mainSwipeDelta = {
          x: event.clientX - mainSwipeStart.x,
          y: event.clientY - mainSwipeStart.y,
        };

        const isHorizontalSwipe =
          Math.abs(mainSwipeDelta.x) > 8 && Math.abs(mainSwipeDelta.x) > Math.abs(mainSwipeDelta.y);
        if (!isHorizontalSwipe && !mainSwipeMoved) return;

        mainSwipeMoved = true;
      };

      const handleMainSwipeEnd = (event) => {
        if (!mainSwipeStart || event.pointerId !== mainSwipePointerId) return;

        if (openButton.hasPointerCapture(event.pointerId)) {
          openButton.releasePointerCapture(event.pointerId);
        }

        const swipeDistance = Math.abs(mainSwipeDelta.x);
        const isIntentionalSwipe =
          mainSwipeMoved && swipeDistance > 44 && swipeDistance > Math.abs(mainSwipeDelta.y) * 1.15;

        mainSwipeStart = null;
        mainSwipePointerId = null;

        if (!isIntentionalSwipe) {
          if (mainSwipeMoved) {
            suppressNextOpen = true;
            window.setTimeout(() => {
              suppressNextOpen = false;
            }, 350);
          }

          mainSwipeMoved = false;
          return;
        }

        suppressNextOpen = true;
        window.setTimeout(() => {
          suppressNextOpen = false;
        }, 350);

        const direction = mainSwipeDelta.x < 0 ? 1 : -1;
        mainSwipeMoved = false;
        selectImage(activeIndex + direction);
      };

      const closeViewer = () => {
        if (!viewer) return;
        viewer.hidden = true;
        document.body.style.overflow = previousBodyOverflow;
        resetZoom();
        openButton.focus();
      };

      const openViewer = () => {
        if (!ensureDesktopViewer()) return;
        previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        viewer.hidden = false;
        selectImage(activeIndex);
        closeButton.focus();
      };

      function ensureDesktopViewer() {
        if (mobileGalleryMedia.matches) return false;

        if (!viewer) {
          const viewerMarkup = viewerTemplate?.content?.firstElementChild?.cloneNode(true);
          if (!viewerMarkup) return false;
          viewerTemplate.insertAdjacentElement('afterend', viewerMarkup);
          refreshViewerElements();
        }

        if (!viewer || !viewerImage || !viewerImageArea || !closeButton) return false;
        bindViewerEvents();
        return true;
      }

      function bindViewerEvents() {
        if (viewerEventsReady) return;
        viewerEventsReady = true;

        viewer.querySelectorAll('[data-clean-gallery-previous]').forEach((button) => {
          button.addEventListener('click', () => selectImage(activeIndex - 1));
        });

        viewer.querySelectorAll('[data-clean-gallery-next]').forEach((button) => {
          button.addEventListener('click', () => selectImage(activeIndex + 1));
        });

        viewerThumbnails.forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => selectImage(Number(thumbnail.dataset.cleanGalleryIndex)));
        });

        closeButton.addEventListener('click', closeViewer);

        window.addEventListener('keydown', (event) => {
          if (!viewer || viewer.hidden) return;

          if (event.key === 'Escape') {
            closeViewer();
            return;
          }

          if (event.key === 'ArrowLeft' && thumbnails.length > 1) {
            selectImage(activeIndex - 1);
            return;
          }

          if (event.key === 'ArrowRight' && thumbnails.length > 1) {
            selectImage(activeIndex + 1);
            return;
          }

          if (event.key !== 'Tab') return;
          const focusable = Array.from(viewer.querySelectorAll('button, [role="button"][tabindex="0"]')).filter(
            (element) => element.offsetParent !== null,
          );
          if (!focusable.length) return;
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });

        viewerImageArea.addEventListener('click', (event) => {
          if (dragged) {
            dragged = false;
            return;
          }

          if (isZoomed) {
            resetZoom();
            return;
          }

          const bounds = viewerImage.getBoundingClientRect();
          if (
            event.clientX < bounds.left ||
            event.clientX > bounds.right ||
            event.clientY < bounds.top ||
            event.clientY > bounds.bottom
          ) {
            return;
          }

          isZoomed = true;
          zoomOrigin = {
            x: ((event.clientX - bounds.left) / bounds.width) * 100,
            y: ((event.clientY - bounds.top) / bounds.height) * 100,
          };
          viewerImageArea.classList.add('clean-product-viewer__image-area--zoomed');
          viewerImageArea.setAttribute('aria-label', 'Zoom out product image');
          renderTransform();
        });

        viewerImageArea.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (isZoomed) {
            resetZoom();
          } else {
            isZoomed = true;
            viewerImageArea.classList.add('clean-product-viewer__image-area--zoomed');
            viewerImageArea.setAttribute('aria-label', 'Zoom out product image');
            renderTransform();
          }
        });

        viewerImageArea.addEventListener('pointerdown', (event) => {
          if (!isZoomed) return;
          viewerImageArea.setPointerCapture(event.pointerId);
          dragStart = { x: event.clientX, y: event.clientY };
          panStart = { ...pan };
          dragged = false;
          viewerImageArea.classList.add('clean-product-viewer__image-area--dragging');
        });

        viewerImageArea.addEventListener('pointermove', (event) => {
          if (!isZoomed || !dragStart) return;
          const deltaX = event.clientX - dragStart.x;
          const deltaY = event.clientY - dragStart.y;
          if (Math.abs(deltaX) + Math.abs(deltaY) > 5) dragged = true;
          pan = { x: panStart.x + deltaX, y: panStart.y + deltaY };
          renderTransform(true);
        });

        const stopDragging = (event) => {
          if (viewerImageArea.hasPointerCapture(event.pointerId)) {
            viewerImageArea.releasePointerCapture(event.pointerId);
          }
          dragStart = null;
          viewerImageArea.classList.remove('clean-product-viewer__image-area--dragging');
          renderTransform();
        };

        viewerImageArea.addEventListener('pointerup', stopDragging);
        viewerImageArea.addEventListener('pointercancel', stopDragging);
      }

      gallery.querySelectorAll('[data-clean-gallery-previous]').forEach((button) => {
        button.addEventListener('click', () => selectImage(activeIndex - 1));
      });

      gallery.querySelectorAll('[data-clean-gallery-next]').forEach((button) => {
        button.addEventListener('click', () => selectImage(activeIndex + 1));
      });

      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => selectImage(Number(thumbnail.dataset.cleanGalleryIndex)));
      });

      openButton.addEventListener('pointerdown', handleMainSwipeStart);
      openButton.addEventListener('pointermove', handleMainSwipeMove);
      openButton.addEventListener('pointerup', handleMainSwipeEnd);
      openButton.addEventListener('pointercancel', handleMainSwipeEnd);
      openButton.addEventListener('click', (event) => {
        if (suppressNextOpen) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        openViewer();
      });
    });

    const initializeRelatedCarousel = (section) => {
      if (section.dataset.cleanRelatedReady === 'true') {
        section.dispatchEvent(new CustomEvent('clean:related-updated'));
        return;
      }

      const track = section.querySelector('[data-clean-related-track]');
      const carousel = section.querySelector('.clean-main-product__related-carousel');
      const previousButton = section.querySelector('[data-clean-related-previous]');
      const nextButton = section.querySelector('[data-clean-related-next]');

      if (!track || !carousel || !previousButton || !nextButton || !track.firstElementChild) return;

      section.dataset.cleanRelatedReady = 'true';

      const updateScrollState = () => {
        const edgeTolerance = 2;
        const hasOverflow = track.scrollWidth > track.clientWidth + edgeTolerance;
        const showArrows = track.children.length > 4 && hasOverflow;

        carousel.classList.toggle('clean-main-product__related-carousel--has-overflow', showArrows);
        previousButton.hidden = !showArrows;
        nextButton.hidden = !showArrows;
        previousButton.disabled = track.scrollLeft <= edgeTolerance;
        nextButton.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - edgeTolerance;
      };

      const scrollByCard = (direction) => {
        const firstCard = track.firstElementChild;
        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const cardWidth = firstCard.getBoundingClientRect().width;

        track.scrollBy({
          left: direction * (cardWidth + gap),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      };

      previousButton.addEventListener('click', () => scrollByCard(-1));
      nextButton.addEventListener('click', () => scrollByCard(1));
      track.addEventListener('scroll', updateScrollState, { passive: true });
      section.addEventListener('clean:related-updated', updateScrollState);
      window.addEventListener('resize', updateScrollState);
      updateScrollState();
    };

    document.querySelectorAll('[data-clean-product-recommendations]').forEach((recommendations) => {
      const track = recommendations.querySelector('[data-clean-related-track]');

      if (track && track.firstElementChild) {
        recommendations.hidden = false;
        refreshCleanProductMoney(recommendations);
        initializeRelatedCarousel(recommendations);
        return;
      }

      let recommendationsRequested = false;

      const loadRecommendations = () => {
        if (recommendationsRequested) return;
        recommendationsRequested = true;

        fetch(recommendations.dataset.cleanProductRecommendationsUrl)
          .then((response) => {
            if (!response.ok) throw new Error(`Product recommendations request failed: ${response.status}`);
            return response.text();
          })
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const replacement = html.querySelector('[data-clean-product-recommendations]');
            const replacementTrack = replacement?.querySelector('[data-clean-related-track]');

            if (!replacement || !replacementTrack?.firstElementChild) return;

            recommendations.innerHTML = replacement.innerHTML;
            recommendations.hidden = false;
            refreshCleanProductMoney(recommendations);
            initializeRelatedCarousel(recommendations);
            initWishlistButtons(recommendations);
          })
          .catch((error) => {
            console.error(error);
          });
      };

      const loadTrigger = recommendations.closest('.clean-main-product__lower-content') || recommendations;

      if (!('IntersectionObserver' in window)) {
        loadRecommendations();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          loadRecommendations();
        },
        { rootMargin: '600px 0px' },
      );

      observer.observe(loadTrigger);
    });

    const recentlyViewedStorageKey = 'giftech_recently_viewed_products';
    const recentlyViewedStorageLimit = 7;
    const recentlyViewedDisplayLimit = 6;
    const recentlyViewedInitialBatchSize = 4;

    document.querySelectorAll('[data-clean-product-recently-viewed]').forEach((recentlyViewed) => {
      const track = recentlyViewed.querySelector('[data-clean-related-track]');
      const currentProductElement = recentlyViewed.querySelector('[data-clean-recent-product]');
      const loadTrigger = recentlyViewed.closest('.clean-main-product__lower-content');

      if (!track || !currentProductElement || !loadTrigger) return;

      let currentProduct;
      let storedProducts = [];

      try {
        currentProduct = JSON.parse(currentProductElement.textContent);
      } catch {
        return;
      }

      try {
        const storedValue = window.localStorage.getItem(recentlyViewedStorageKey);
        const parsedValue = storedValue ? JSON.parse(storedValue) : [];
        storedProducts = Array.isArray(parsedValue) ? parsedValue : [];
      } catch {
        storedProducts = [];
      }

      const savedProducts = [currentProduct, ...storedProducts]
        .filter((storedProduct) => storedProduct && typeof storedProduct.handle === 'string')
        .filter(
          (storedProduct, index, products) =>
            products.findIndex((product) => product.handle === storedProduct.handle) === index,
        )
        .slice(0, recentlyViewedStorageLimit);

      const displayProducts = savedProducts
        .filter((storedProduct) => storedProduct.handle !== currentProduct.handle)
        .slice(0, recentlyViewedDisplayLimit);

      try {
        window.localStorage.setItem(recentlyViewedStorageKey, JSON.stringify(savedProducts));
      } catch {
        // The section can still render when browser storage is unavailable.
      }

      if (!displayProducts.length) return;

      const loadProduct = (recentProduct) => {
        const productUrl = `${recentlyViewed.dataset.cleanRecentlyViewedRoot}products/${encodeURIComponent(
          recentProduct.handle,
        )}?view=clean_recently_viewed`;

        return fetch(productUrl)
          .then((response) => {
            if (!response.ok) throw new Error(`Recently viewed product request failed: ${response.status}`);
            return response.text();
          })
          .then((text) => new DOMParser().parseFromString(text, 'text/html').body.firstElementChild)
          .then((card) => {
            if (!card) return;
            track.append(card);
            recentlyViewed.hidden = false;
            refreshCleanProductMoney(card);
            initializeRelatedCarousel(recentlyViewed);
            initWishlistButtons(card);
          })
          .catch((error) => {
            console.error(error);
          });
      };

      const loadRecentlyViewed = async () => {
        const initialProducts = displayProducts.slice(0, recentlyViewedInitialBatchSize);
        const remainingProducts = displayProducts.slice(recentlyViewedInitialBatchSize);

        await Promise.all(initialProducts.map(loadProduct));
        await Promise.all(remainingProducts.map(loadProduct));
      };

      if (!('IntersectionObserver' in window)) {
        loadRecentlyViewed();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          loadRecentlyViewed();
        },
        { rootMargin: '600px 0px' },
      );

      observer.observe(loadTrigger);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanWishlistStorageKey = 'wishlistItem';
    const cleanAutoLoadCount = 2;
    const cleanSearchStates = new WeakMap();
    const cleanSearchResultCache = new Map();

    const getCleanWishlistItems = () => {
      try {
        const items = JSON.parse(localStorage.getItem(cleanWishlistStorageKey) || '[]');
        return Array.isArray(items)
          ? Array.from(new Set(items.filter((item) => typeof item === 'string' && item.trim())))
          : [];
      } catch (error) {
        return [];
      }
    };

    const setCleanWishlistItems = (items) => {
      const cleanItems = Array.from(new Set(items.filter((item) => typeof item === 'string' && item.trim())));

      try {
        localStorage.setItem(cleanWishlistStorageKey, JSON.stringify(cleanItems));
        return getCleanWishlistItems();
      } catch (error) {
        console.error(error);
        return getCleanWishlistItems();
      }
    };

    const updateCleanWishlistCount = (items) => {
      document.querySelectorAll('[data-clean-wishlist-count], [data-wishlist-count]').forEach((count) => {
        count.textContent = String(items.length);
        count.hidden = items.length === 0;
      });
    };

    const updateCleanWishlistButton = (button, isActive) => {
      button.setAttribute('aria-pressed', String(isActive));
      button.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
    };

    const updateCleanWishlistButtonsByHandle = (handle, isActive, root = document) => {
      root.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
        if (button.dataset.cleanProductWishlistHandle?.trim() === handle) {
          updateCleanWishlistButton(button, isActive);
        }
      });
    };

    const initCleanMainSearchWishlists = (root = document) => {
      const wishlistItems = getCleanWishlistItems();

      root.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
        if (button.dataset.cleanProductWishlistReady === 'true') return;

        button.dataset.cleanProductWishlistReady = 'true';

        const handle = button.dataset.cleanProductWishlistHandle?.trim();

        if (!handle || typeof Storage === 'undefined') {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          return;
        }

        updateCleanWishlistButton(button, wishlistItems.includes(handle));

        button.addEventListener('click', () => {
          const currentWishlistItems = getCleanWishlistItems();
          const isActive = currentWishlistItems.includes(handle);
          const nextWishlistItems = isActive
            ? currentWishlistItems.filter((item) => item !== handle)
            : currentWishlistItems.concat(handle);
          const confirmedWishlistItems = setCleanWishlistItems(nextWishlistItems);
          const isConfirmedActive = confirmedWishlistItems.includes(handle);

          updateCleanWishlistButtonsByHandle(handle, isConfirmedActive);
          updateCleanWishlistCount(confirmedWishlistItems);

          document.dispatchEvent(
            new CustomEvent(isConfirmedActive ? 'addwishlistitem' : 'updatewishlistmail', {
              detail: { handle },
              bubbles: true,
            }),
          );
        });
      });

      updateCleanWishlistCount(wishlistItems);
    };

    const getCleanProductCards = (grid) =>
      Array.from(grid.children).filter((card) => card.classList.contains('clean-product-card'));

    const getCleanSearchState = (root) => {
      if (!cleanSearchStates.has(root)) {
        cleanSearchStates.set(root, {
          autoLoadsRemaining: cleanAutoLoadCount,
          isLoading: false,
          loadMoreObserver: null,
          loadedProductCount: 0,
          nextUrl: '',
          totalProducts: 0,
        });
      }

      return cleanSearchStates.get(root);
    };

    const formatCleanFetchUrl = (url) => {
      if (!url) return '';

      const cleanUrl = new URL(url, window.location.href);

      return `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`;
    };

    const formatCleanSectionFetchUrl = (root, url) => {
      if (!url) return '';

      const cleanUrl = new URL(formatCleanFetchUrl(url), window.location.href);
      const sectionId = root.dataset.cleanSectionId;

      if (sectionId) {
        cleanUrl.searchParams.set('section_id', sectionId);
      }

      return `${cleanUrl.pathname}${cleanUrl.search}`;
    };

    const getCleanRemainingProductCount = (root) => {
      const state = getCleanSearchState(root);

      return Math.max(state.totalProducts - state.loadedProductCount, 0);
    };

    const updateCleanLoadMoreButton = (root) => {
      const state = getCleanSearchState(root);
      const wrap = root.querySelector('[data-clean-search-load-more-wrap]');
      const button = root.querySelector('[data-clean-search-load-more]');
      const text = root.querySelector('[data-clean-search-load-more-text]');

      if (!wrap || !button || !text) return;

      const remainingProducts = getCleanRemainingProductCount(root);
      wrap.hidden = !state.nextUrl || remainingProducts === 0;
      button.disabled = state.isLoading;
      text.textContent = state.isLoading
        ? button.dataset.cleanLoadingText
        : `${button.dataset.cleanDefaultText} (${remainingProducts})`;
    };

    const appendCleanProductCards = (root, cards) => {
      const grid = root.querySelector('[data-clean-main-search-grid]');

      if (!grid || cards.length === 0) return 0;

      const fragment = document.createDocumentFragment();

      cards.forEach((card) => fragment.appendChild(card));
      initCleanMainSearchWishlists(fragment);
      grid.appendChild(fragment);

      return cards.length;
    };

    const setCleanLoadMoreStatus = (root, message = '') => {
      const status = root.querySelector('[data-clean-search-load-more-status]');

      if (status) {
        status.textContent = message;
      }
    };

    const fetchCleanNextCards = async (root) => {
      const state = getCleanSearchState(root);

      if (!state.nextUrl) return 0;

      state.isLoading = true;
      setCleanLoadMoreStatus(root);
      updateCleanLoadMoreButton(root);

      try {
        const response = await fetch(formatCleanSectionFetchUrl(root, state.nextUrl), {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        if (!response.ok) {
          throw new Error(`Search section request failed with status ${response.status}`);
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextRoot = doc.querySelector('[data-clean-main-search]');
        const nextGrid = nextRoot?.querySelector('[data-clean-main-search-grid]');
        const nextButton = nextRoot?.querySelector('[data-clean-search-load-more]');
        const nextCards = nextGrid ? getCleanProductCards(nextGrid) : [];

        state.nextUrl = formatCleanFetchUrl(nextButton?.dataset.cleanNextUrl || '');

        const appendedCount = appendCleanProductCards(root, nextCards);
        state.loadedProductCount += appendedCount;

        return appendedCount;
      } catch (error) {
        console.error(error);
        setCleanLoadMoreStatus(root, 'Unable to load more products. Please try again.');
        return 0;
      } finally {
        state.isLoading = false;
        updateCleanLoadMoreButton(root);
      }
    };

    const loadCleanMoreProducts = async (root) => {
      const state = getCleanSearchState(root);

      if (state.isLoading) return 0;

      return fetchCleanNextCards(root);
    };

    const initCleanAutoLoadMore = (root) => {
      const state = getCleanSearchState(root);
      const wrap = root.querySelector('[data-clean-search-load-more-wrap]');

      if (!wrap || state.loadMoreObserver || !('IntersectionObserver' in window)) return;

      state.loadMoreObserver = new IntersectionObserver(
        async (entries) => {
          const shouldAutoLoad = entries.some((entry) => entry.isIntersecting);

          if (!shouldAutoLoad || state.autoLoadsRemaining <= 0 || state.isLoading) return;

          const loadedCount = await loadCleanMoreProducts(root);

          if (loadedCount > 0) {
            state.autoLoadsRemaining -= 1;
          }

          if (state.autoLoadsRemaining <= 0 || getCleanRemainingProductCount(root) === 0) {
            state.loadMoreObserver.disconnect();
            state.loadMoreObserver = null;
          }
        },
        { rootMargin: '600px 0px 300px' },
      );

      state.loadMoreObserver.observe(wrap);
    };

    const initCleanSearchLoadMore = (root = document) => {
      root.querySelectorAll('[data-clean-main-search]').forEach((searchRoot) => {
        const state = getCleanSearchState(searchRoot);
        const button = searchRoot.querySelector('[data-clean-search-load-more]');
        const grid = searchRoot.querySelector('[data-clean-main-search-grid]');

        state.nextUrl = formatCleanFetchUrl(button?.dataset.cleanNextUrl || state.nextUrl);
        state.totalProducts = Number.parseInt(button?.dataset.cleanTotalProducts || '0', 10) || 0;
        state.loadedProductCount = grid ? getCleanProductCards(grid).length : 0;

        updateCleanLoadMoreButton(searchRoot);
        initCleanAutoLoadMore(searchRoot);

        if (!button || button.dataset.cleanLoadMoreReady === 'true') return;

        button.dataset.cleanLoadMoreReady = 'true';

        button.addEventListener('click', async () => {
          state.autoLoadsRemaining = 0;

          if (state.loadMoreObserver) {
            state.loadMoreObserver.disconnect();
            state.loadMoreObserver = null;
          }

          await loadCleanMoreProducts(searchRoot);
        });
      });
    };

    const initCleanMainSearchAutocomplete = (root = document) => {
      root.querySelectorAll('[data-clean-main-search-autocomplete]').forEach((searchRoot) => {
        if (searchRoot.dataset.cleanAutocompleteReady === 'true') return;

        const form = searchRoot.querySelector('form');
        const input = searchRoot.querySelector('input[type="search"]');
        const panel = searchRoot.querySelector('[data-clean-main-search-panel]');
        const heading = searchRoot.querySelector('[data-clean-main-search-heading]');
        const results = searchRoot.querySelector('[data-clean-main-search-results]');
        const viewAll = searchRoot.querySelector('[data-clean-main-search-view-all]');
        const clearButton = searchRoot.querySelector('[data-clean-main-search-clear]');
        const sectionRoot = searchRoot.closest('[data-clean-main-search]');
        const mobileInlineMedia = window.matchMedia('(max-width: 767px)');

        if (!form || !input || !panel || !heading || !results || !viewAll || !clearButton) return;

        searchRoot.dataset.cleanAutocompleteReady = 'true';

        let abortController;
        let searchTimeout;
        let popularMarkup = results.innerHTML.trim();
        let popularRequest;
        let activeResultMode = popularMarkup ? 'popular' : '';

        const updateClearButton = () => {
          clearButton.hidden = input.value.length === 0;
        };

        const setOpen = (open) => {
          panel.hidden = !open;
          input.setAttribute('aria-expanded', String(open));
          sectionRoot?.classList.toggle('clean-main-search--dropdown-open', open);
        };

        const buildSearchUrl = (query) => {
          const searchUrl = new URL(form.action, window.location.origin);
          searchUrl.searchParams.set('q', query);
          searchUrl.searchParams.set('options[prefix]', 'last');
          searchUrl.searchParams.set('type', 'product');

          if (searchRoot.dataset.cleanPreviewTemplate === 'true') {
            searchUrl.searchParams.set('view', 'clean');
          }

          return searchUrl;
        };

        const loadPopularMarkup = async () => {
          if (popularMarkup) return popularMarkup;

          if (!searchRoot.dataset.cleanPopularSearchUrl) {
            popularMarkup = '<p class="clean-header__search-message">No products found.</p>';
            return popularMarkup;
          }

          if (!popularRequest) {
            popularRequest = fetch(searchRoot.dataset.cleanPopularSearchUrl, {
              credentials: 'same-origin',
              headers: { 'X-Requested-With': 'XMLHttpRequest' },
            })
              .then((response) => {
                if (!response.ok) throw new Error(`Popular search request failed: ${response.status}`);
                return response.text();
              })
              .then((html) => {
                const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
                const responseResults = parsedDocument.querySelector('[data-clean-popular-search-response]');
                if (!responseResults) throw new Error('Popular search response markup was missing.');

                popularMarkup = responseResults.innerHTML;
                return popularMarkup;
              })
              .catch(() => {
                popularMarkup = '<p class="clean-header__search-message">No products found.</p>';
                return popularMarkup;
              })
              .finally(() => {
                popularRequest = undefined;
              });
          }

          return popularRequest;
        };

        const showPopular = async () => {
          const requestedQuery = input.value.trim();

          window.clearTimeout(searchTimeout);
          abortController?.abort();
          heading.textContent = 'Popular products';
          viewAll.hidden = true;

          if (popularMarkup) {
            if (activeResultMode !== 'popular') {
              results.innerHTML = popularMarkup;
            }

            activeResultMode = 'popular';
            setOpen(true);
            return;
          }

          results.innerHTML = '<p class="clean-header__search-message">Loading...</p>';
          activeResultMode = 'loading';
          setOpen(true);

          const markup = await loadPopularMarkup();

          if (input.value.trim() === requestedQuery) {
            results.innerHTML = markup;
            activeResultMode = 'popular';
            heading.textContent = 'Popular products';
            viewAll.hidden = true;
            setOpen(true);
          }
        };

        const showSearchResults = (query, markup) => {
          heading.textContent = 'Product results';
          results.innerHTML = markup;
          activeResultMode = 'search';
          viewAll.href = buildSearchUrl(query).toString();
          viewAll.hidden = false;
          setOpen(true);
        };

        const hasCleanSearchResultCards = (markup) => {
          const parsedDocument = new DOMParser().parseFromString(markup, 'text/html');

          return Boolean(parsedDocument.querySelector('.clean-product-card'));
        };

        const fetchSearchFallbackMarkup = async (query, signal) => {
          const url = buildSearchUrl(query);
          url.searchParams.set('section_id', 'clean-header-search-results');

          const response = await fetch(url, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal,
          });

          if (!response.ok) throw new Error(`Search fallback request failed: ${response.status}`);

          const parsedDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
          const responseResults = parsedDocument.querySelector('[data-clean-search-response]');
          if (!responseResults) throw new Error('Search fallback response markup was missing.');

          return responseResults.innerHTML;
        };

        const loadSearchResults = (query) => {
          const cacheKey = query.toLowerCase();
          const cachedMarkup = cleanSearchResultCache.get(cacheKey);

          window.clearTimeout(searchTimeout);
          abortController?.abort();

          if (cachedMarkup) {
            showSearchResults(query, cachedMarkup);
            return;
          }

          if (!searchRoot.dataset.predictiveSearchUrl) {
            return;
          }

          results.innerHTML = '<p class="clean-header__search-message">Loading...</p>';
          activeResultMode = 'loading';
          heading.textContent = 'Product results';
          viewAll.hidden = true;
          setOpen(true);

          searchTimeout = window.setTimeout(async () => {
            abortController = new AbortController();
            const url = new URL(searchRoot.dataset.predictiveSearchUrl, window.location.origin);
            url.searchParams.set('q', query);
            url.searchParams.set('resources[type]', 'product');
            url.searchParams.set('resources[limit]', '6');
            url.searchParams.set('section_id', 'clean-header-search-results');

            try {
              const response = await fetch(url, { signal: abortController.signal });
              if (!response.ok) throw new Error(`Search request failed: ${response.status}`);

              const parsedDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
              const responseResults = parsedDocument.querySelector('[data-clean-search-response]');
              if (!responseResults) throw new Error('Search response markup was missing.');

              let markup = responseResults.innerHTML;

              if (!hasCleanSearchResultCards(markup)) {
                markup = await fetchSearchFallbackMarkup(query, abortController.signal);
              }

              cleanSearchResultCache.set(cacheKey, markup);

              if (input.value.trim().toLowerCase() === cacheKey) {
                showSearchResults(input.value.trim(), markup);
              }
            } catch (error) {
              if (error.name !== 'AbortError') {
                results.innerHTML = '<p class="clean-header__search-message">No products found.</p>';
                activeResultMode = 'message';
              }
            }
          }, 500);
        };

        input.addEventListener('focus', () => {
          const query = input.value.trim();

          if (query) {
            loadSearchResults(query);
          } else {
            showPopular();
          }
        });

        input.addEventListener('input', () => {
          updateClearButton();

          const query = input.value.trim();

          if (query) {
            loadSearchResults(query);
          } else {
            showPopular();
          }
        });

        clearButton.addEventListener('click', () => {
          input.value = '';
          updateClearButton();
          input.focus();
          showPopular();
        });

        form.addEventListener('submit', (event) => {
          if (!input.value.trim()) {
            event.preventDefault();
            showPopular();
          }
        });

        document.addEventListener('mousedown', (event) => {
          if (mobileInlineMedia.matches) return;

          if (!searchRoot.contains(event.target)) {
            setOpen(false);
          }
        });

        updateClearButton();

        if (mobileInlineMedia.matches && !input.value.trim()) {
          setOpen(true);
        }
      });
    };

    const submitCleanSearchSortForm = (form) => {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    };

    const initCleanSearchSort = (root = document) => {
      root.querySelectorAll('[data-clean-search-sort-select]').forEach((select) => {
        if (select.dataset.cleanSortReady === 'true') return;

        const form = select.closest('form');

        if (!form) return;

        select.dataset.cleanSortReady = 'true';

        select.addEventListener('change', () => {
          submitCleanSearchSortForm(form);
        });
      });
    };

    document.querySelectorAll('[data-clean-main-search]').forEach((root) => {
      initCleanMainSearchWishlists(root);
    });

    initCleanSearchLoadMore();
    initCleanMainSearchAutocomplete();
    initCleanSearchSort();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-main-wishlist"]) return;
  try {
    
  (() => {
    const cleanWishlistStorageKey = 'wishlistItem';
    const cleanWishlistCardHandlePlaceholder = '__HANDLE__';

    const getCleanWishlistItems = () => {
      try {
        const items = JSON.parse(localStorage.getItem(cleanWishlistStorageKey) || '[]');
        return Array.isArray(items)
          ? Array.from(new Set(items.filter((item) => typeof item === 'string' && item.trim())))
          : [];
      } catch (error) {
        return [];
      }
    };

    const setCleanWishlistItems = (items) => {
      const cleanItems = Array.from(new Set(items.filter((item) => typeof item === 'string' && item.trim())));

      try {
        localStorage.setItem(cleanWishlistStorageKey, JSON.stringify(cleanItems));
        return getCleanWishlistItems();
      } catch (error) {
        console.error(error);
        return getCleanWishlistItems();
      }
    };

    const updateCleanWishlistCount = (items) => {
      document.querySelectorAll('[data-clean-wishlist-count], [data-wishlist-count]').forEach((count) => {
        count.textContent = String(items.length);
        count.hidden = items.length === 0;
      });
    };

    const updateCleanWishlistButton = (button, isActive) => {
      button.setAttribute('aria-pressed', String(isActive));
      button.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
    };

    const updateCleanWishlistButtonsByHandle = (handle, isActive, root = document) => {
      root.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
        if (button.dataset.cleanProductWishlistHandle?.trim() === handle) {
          updateCleanWishlistButton(button, isActive);
        }
      });
    };

    const setCleanWishlistStatus = (root, message = '') => {
      const status = root.querySelector('[data-clean-wishlist-status]');

      if (status) status.textContent = message;
    };

    const updateCleanWishlistEmptyState = (root) => {
      const grid = root.querySelector('[data-clean-wishlist-grid]');
      const empty = root.querySelector('[data-clean-wishlist-empty]');
      const hasCards = Boolean(grid?.querySelector('.clean-product-card'));

      if (grid) grid.hidden = !hasCards;
      if (empty) empty.hidden = hasCards;
    };

    const removeCleanWishlistCard = (root, handle) => {
      const button = Array.from(root.querySelectorAll('[data-clean-product-wishlist]')).find(
        (wishlistButton) => wishlistButton.dataset.cleanProductWishlistHandle?.trim() === handle,
      );
      const card = button?.closest('.clean-product-card');

      if (card) {
        card.remove();
      }

      updateCleanWishlistEmptyState(root);
    };

    const initCleanProductCardWishlists = (root = document) => {
      root.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
        if (button.dataset.cleanProductWishlistReady === 'true') return;

        button.dataset.cleanProductWishlistReady = 'true';

        const handle = button.dataset.cleanProductWishlistHandle?.trim();

        if (!handle || typeof Storage === 'undefined') {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          return;
        }

        updateCleanWishlistButton(button, getCleanWishlistItems().includes(handle));

        button.addEventListener('click', () => {
          const wishlistItems = getCleanWishlistItems();
          const isActive = wishlistItems.includes(handle);
          const nextWishlistItems = isActive
            ? wishlistItems.filter((item) => item !== handle)
            : wishlistItems.concat(handle);
          const confirmedWishlistItems = setCleanWishlistItems(nextWishlistItems);
          const isConfirmedActive = confirmedWishlistItems.includes(handle);

          updateCleanWishlistButtonsByHandle(handle, isConfirmedActive);
          updateCleanWishlistCount(confirmedWishlistItems);

          document.dispatchEvent(
            new CustomEvent(isConfirmedActive ? 'addwishlistitem' : 'updatewishlistmail', {
              detail: { handle },
              bubbles: true,
            }),
          );
        });
      });

      updateCleanWishlistCount(getCleanWishlistItems());
    };

    const buildCleanWishlistCardUrl = (root, handle) => {
      const template = root.dataset.cleanProductCardUrlTemplate || '';
      const encodedHandle = encodeURIComponent(handle);

      return template.replace(cleanWishlistCardHandlePlaceholder, encodedHandle);
    };

    const fetchCleanWishlistCard = async (root, handle) => {
      const response = await fetch(buildCleanWishlistCardUrl(root, handle), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });

      if (!response.ok) {
        throw new Error(`Wishlist product request failed with status ${response.status}`);
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const card = doc.querySelector('.clean-product-card');

      if (!card) {
        throw new Error(`Wishlist product card was not found for ${handle}`);
      }

      return card;
    };

    const appendCleanWishlistCard = async (root, handle) => {
      const grid = root.querySelector('[data-clean-wishlist-grid]');
      const hasCard = Array.from(grid?.querySelectorAll('[data-clean-product-wishlist]') || []).some(
        (button) => button.dataset.cleanProductWishlistHandle?.trim() === handle,
      );

      if (!grid || hasCard) return;

      const card = await fetchCleanWishlistCard(root, handle);
      const button = card.querySelector('[data-clean-product-wishlist]');

      if (button) {
        updateCleanWishlistButton(button, true);
      }

      grid.appendChild(card);
      initCleanProductCardWishlists(card);
      updateCleanWishlistEmptyState(root);
    };

    const renderCleanWishlist = async (root) => {
      const grid = root.querySelector('[data-clean-wishlist-grid]');

      if (!grid) return;

      if (typeof Storage === 'undefined') {
        setCleanWishlistStatus(root, 'Wishlist storage is not available in this browser.');
        updateCleanWishlistEmptyState(root);
        return;
      }

      const wishlistItems = getCleanWishlistItems();

      grid.replaceChildren();
      updateCleanWishlistCount(wishlistItems);

      if (wishlistItems.length === 0) {
        setCleanWishlistStatus(root);
        updateCleanWishlistEmptyState(root);
        return;
      }

      setCleanWishlistStatus(root, 'Loading wishlist products...');

      try {
        const cards = await Promise.all(
          wishlistItems.map((handle) =>
            fetchCleanWishlistCard(root, handle).catch((error) => {
              console.error(error);
              return null;
            }),
          ),
        );

        const fragment = document.createDocumentFragment();

        cards.forEach((card) => {
          if (!card) return;

          const button = card.querySelector('[data-clean-product-wishlist]');

          if (button) {
            updateCleanWishlistButton(button, true);
          }

          fragment.appendChild(card);
        });

        grid.appendChild(fragment);
        initCleanProductCardWishlists(grid);
        setCleanWishlistStatus(root);
        updateCleanWishlistEmptyState(root);

        if (!grid.querySelector('.clean-product-card')) {
          setCleanWishlistStatus(root, 'Unable to load saved products right now.');
        }
      } catch (error) {
        console.error(error);
        setCleanWishlistStatus(root, 'Unable to load saved products right now.');
        updateCleanWishlistEmptyState(root);
      }
    };

    const initCleanWishlistPage = (root = document) => {
      root.querySelectorAll('[data-clean-main-wishlist]').forEach((wishlistRoot) => {
        if (wishlistRoot.dataset.cleanWishlistReady === 'true') return;

        wishlistRoot.dataset.cleanWishlistReady = 'true';
        renderCleanWishlist(wishlistRoot);

        document.addEventListener('updatewishlistmail', (event) => {
          const handle = event.detail?.handle?.trim();

          if (handle) {
            removeCleanWishlistCard(wishlistRoot, handle);
          }
        });

        document.addEventListener('addwishlistitem', (event) => {
          const handle = event.detail?.handle?.trim();

          if (handle) {
            appendCleanWishlistCard(wishlistRoot, handle).catch((error) => {
              console.error(error);
              setCleanWishlistStatus(wishlistRoot, 'Unable to add that product right now.');
            });
          }
        });

        window.addEventListener('storage', (event) => {
          if (event.key === cleanWishlistStorageKey) {
            renderCleanWishlist(wishlistRoot);
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanWishlistPage(), { once: true });
    } else {
      initCleanWishlistPage();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanWishlistPage(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-mobile-menu-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCleanMobileMenuPages = (scope = document) => {
      scope.querySelectorAll('[data-clean-mobile-menu-page]').forEach((menuPage) => {
        if (menuPage.dataset.cleanMobileMenuInitialized === 'true') return;

        menuPage.dataset.cleanMobileMenuInitialized = 'true';

        menuPage.querySelectorAll('[data-clean-mobile-menu-toggle]').forEach((control) => {
          const panel = document.getElementById(control.getAttribute('aria-controls'));
          if (!panel) return;

          control.setAttribute('aria-expanded', 'false');
          panel.hidden = true;

          control.addEventListener('click', () => {
            const willExpand = control.getAttribute('aria-expanded') !== 'true';
            control.setAttribute('aria-expanded', String(willExpand));
            panel.hidden = !willExpand;
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeCleanMobileMenuPages(), { once: true });
    } else {
      initializeCleanMobileMenuPages();
    }

    document.addEventListener('shopify:section:load', (event) => initializeCleanMobileMenuPages(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-mobile-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let cleanMobileCartItemCount =
      Number.parseInt(document.querySelector('.clean-mobile-nav [data-clean-cart-count]')?.textContent || '0', 10) || 0;

    const updateCleanMobileCartCount = (count) => {
      const safeCount = Number.isFinite(Number(count)) ? Math.max(0, Number(count)) : 0;

      document.querySelectorAll('.clean-mobile-nav [data-clean-cart-count]').forEach((badge) => {
        badge.textContent = String(safeCount);
        badge.hidden = safeCount === 0;
      });
    };

    const syncCleanMobileCartCount = (cart) => {
      if (cart && typeof cart.item_count !== 'undefined') {
        cleanMobileCartItemCount = Number(cart.item_count || 0);
      }

      updateCleanMobileCartCount(cleanMobileCartItemCount);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => syncCleanMobileCartCount(), { once: true });
    } else {
      syncCleanMobileCartCount();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.clean-mobile-nav')) syncCleanMobileCartCount();
    });
    document.addEventListener('clean:cart:updated', (event) => syncCleanMobileCartCount(event.detail?.cart));
    document.addEventListener('cart-update', (event) => syncCleanMobileCartCount(event.detail));
    document.addEventListener('cart:updated', (event) => syncCleanMobileCartCount(event.detail?.cart || event.detail));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-occasion-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeOccasionCards = (section) => {
      if (section.dataset.cleanOccasionInitialized === 'true') return;

      const tabs = Array.from(section.querySelectorAll('[data-clean-occasion-tab]'));
      const panelsMount = section.querySelector('[data-clean-occasion-panels]');
      const panelsTemplate = section.querySelector('[data-clean-occasion-panels-template]');
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const desktopQuery = window.matchMedia('(min-width: 768px)');
      const panelCarousels = new Map();
      let panels = [];
      let panelObserver;

      const activateTab = (tab, moveFocus = false) => {
        hydratePanels();
        const activeIndex = tab.dataset.cleanOccasionTab;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('clean-occasion-cards__tab--active', isActive);
          item.setAttribute('aria-selected', String(isActive));
          item.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.cleanOccasionPanel === activeIndex;
          panel.classList.toggle('clean-occasion-cards__panel--active', isActive);
          panel.hidden = !isActive;
          if (isActive) {
            panelCarousels.get(panel)?.reset();
          }
        });

        tab.scrollIntoView({
          behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center',
        });
        if (moveFocus) tab.focus();
      };

      const setupPanelCarousel = (panel) => {
        const track = panel.querySelector('[data-clean-occasion-track]');
        const previous = panel.querySelector('[data-clean-occasion-previous]');
        const next = panel.querySelector('[data-clean-occasion-next]');
        if (!track || !previous || !next) return;

        const cards = Array.from(track.querySelectorAll('.clean-occasion-cards__card'));
        const visibleCards = 3;
        let currentIndex = 0;

        const maximumIndex = () => Math.max(0, cards.length - visibleCards);

        const updateButtons = () => {
          previous.disabled = currentIndex <= 0;
          next.disabled = currentIndex >= maximumIndex();
        };

        const scrollToIndex = (index) => {
          currentIndex = Math.min(Math.max(index, 0), maximumIndex());
          const targetCard = cards[currentIndex];
          if (!targetCard) return;

          track.scrollTo({
            left: targetCard.offsetLeft,
            behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
          });
          updateButtons();
        };

        const reset = () => {
          currentIndex = 0;
          track.scrollTo({ left: 0, behavior: 'auto' });
          updateButtons();
        };

        previous.addEventListener('click', () => scrollToIndex(currentIndex - 1));
        next.addEventListener('click', () => scrollToIndex(currentIndex + 1));

        panelCarousels.set(panel, { reset });
        updateButtons();
      };

      function hydratePanels() {
        if (section.dataset.cleanOccasionPanelsHydrated === 'true' || !panelsMount || !panelsTemplate) return;

        panelsMount.append(panelsTemplate.content.cloneNode(true));
        panels = Array.from(panelsMount.querySelectorAll('[data-clean-occasion-panel]'));
        panels.forEach(setupPanelCarousel);
        section.dataset.cleanOccasionPanelsHydrated = 'true';
        panelObserver?.disconnect();
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          activateTab(tabs[nextIndex], true);
        });
      });

      if (desktopQuery.matches || section.dataset.designMode === 'true' || !('IntersectionObserver' in window)) {
        hydratePanels();
      } else {
        panelObserver = new IntersectionObserver(
          (entries) => {
            if (entries.some((entry) => entry.isIntersecting)) hydratePanels();
          },
          { rootMargin: '200px 0px' },
        );
        panelObserver.observe(section);
      }

      desktopQuery.addEventListener('change', () => {
        if (desktopQuery.matches) hydratePanels();
        panelCarousels.forEach((carousel) => carousel.reset());
      });
      section.dataset.cleanOccasionInitialized = 'true';
    };

    const initializeAllOccasionCards = (container = document) => {
      container.querySelectorAll('[data-clean-occasion-cards]').forEach(initializeOccasionCards);
    };

    initializeAllOccasionCards();
    document.addEventListener('shopify:section:load', (event) => initializeAllOccasionCards(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-pincode-modal"]) return;
  try {
    
  (() => {
    if (window.cleanPincodeLocationReady) return;

    const modal = document.querySelector('[data-clean-pincode-modal]');
    if (!modal) return;

    window.cleanPincodeLocationReady = true;

    const storageKey = 'clean_last_pincode';
    const districtStorageKey = 'clean_last_pincode_district';
    const autoOpenDelayMs = 2_000;
    const autoOpenRetryMs = 5_000;
    const autoOpenMaxAttempts = 6;
    const mobileSheetMedia = window.matchMedia('(max-width: 767px)');
    const form = modal.querySelector('#clean-delivery-localization-form');
    const panel = modal.querySelector('[data-clean-pincode-panel]');
    const input = modal.querySelector('[data-clean-pincode-input]');
    const status = modal.querySelector('[data-clean-pincode-status]');
    const applyButton = modal.querySelector('[data-clean-pincode-apply]');
    const clearButton = modal.querySelector('[data-clean-pincode-clear-input]');
    const removeButton = modal.querySelector('[data-clean-pincode-remove]');
    const countryCodeInput = modal.querySelector('[data-clean-country-code-input]');
    const returnToInput = form.elements.namedItem('return_to');
    const countryToggle = modal.querySelector('[data-clean-country-toggle]');
    const countrySummaryToggle = modal.querySelector('[data-clean-country-summary-toggle]');
    const countrySummaryFlag = countrySummaryToggle.querySelector('[data-clean-country-flag]');
    const countrySummaryName = modal.querySelector('[data-clean-country-summary-name]');
    const countryPicker = modal.querySelector('[data-clean-country-picker]');
    const countrySearch = modal.querySelector('[data-clean-country-search]');
    const countryOptions = [...modal.querySelectorAll('[data-clean-country-option]')];
    const countryGroupLabels = [...modal.querySelectorAll('[data-clean-country-group-label]')];
    const countryEmpty = modal.querySelector('[data-clean-country-empty]');
    const locationDivider = modal.querySelector('[data-clean-location-divider]');
    const locationField = modal.querySelector('[data-clean-location]');
    const selectedCountryCodeElement = modal.querySelector('[data-clean-selected-country-code]');
    const selectedCountryNameElement = modal.querySelector('[data-clean-selected-country-name]');
    const defaultApplyLabel = applyButton.textContent.trim();
    const currentCountryCode = modal.dataset.cleanCurrentCountryCode || 'IN';
    const currentCountryName = modal.dataset.cleanCurrentCountryName || 'India';
    const currentPageIsProduct = modal.dataset.cleanProductPage === 'true';
    const countryCollectionHandles = Object.freeze({
      AE: 'send-gifts-to-uae',
      AU: 'send-gifts-to-australia',
      CA: 'send-gifts-to-canada',
      DE: 'send-gifts-to-germany',
      ES: 'send-gifts-to-spain',
      FR: 'send-gifts-to-france',
      GB: 'send-gifts-to-uk',
      HK: 'send-gifts-to-hong-kong',
      NL: 'send-gifts-to-netherlands',
      NZ: 'send-gifts-to-new-zealand',
      SA: 'send-gifts-to-ksa',
      SG: 'send-gifts-to-singapore',
      US: 'send-gifts-to-usa',
    });
    const defaultLocalizationReturnTo =
      returnToInput instanceof HTMLInputElement
        ? returnToInput.value
        : `${window.location.pathname}${window.location.search}`;
    let bitset = '';
    let indexRequest;
    let opener;
    let anchorTrigger;
    let closeTimer;
    let busy = false;
    let modalOpenedThisPage = false;
    let autoOpenAttempts = 0;
    let selectedCountryCode = currentCountryCode;
    let selectedCountryName = currentCountryName;
    let pointerStartedInsidePanel = false;
    let pointerStartedInsideCountryPicker = false;
    let countryPickerOpener;
    const districtRequests = new Map();

    const normalizePincode = (value) =>
      String(value || '')
        .replace(/\D/g, '')
        .slice(0, 6);

    const isCompletePincode = (value) => /^\d{6}$/.test(value);

    const submitLocalizationForm = async () => {
      try {
        await window.GiftechLiquidStateBridge?.prepareLocalization(
          form,
          selectedCountryCode,
          selectedCountryCode === 'IN' ? readSavedPincode() : '',
        );
      } catch (error) {
        setBusy(false);
        setStatus('Delivery preference could not be synchronized. Please try again.', 'error');
        return;
      }
      // Read the browser URL so variant and attribution survive a market change.
      // Stale market parameters must not undo this explicit selection.
      const selectedReturnTo = new URL(returnToInput?.value || window.location.pathname, window.location.origin);
      const browserUrl = new URL(window.location.href);
      browserUrl.searchParams.forEach((value, key) => {
        if (!['country', 'currency'].includes(key)) selectedReturnTo.searchParams.set(key, value);
      });
      selectedReturnTo.searchParams.delete('country');
      selectedReturnTo.searchParams.delete('currency');
      if (returnToInput) returnToInput.value = `${selectedReturnTo.pathname}${selectedReturnTo.search}`;
      window.CleanDisplayCurrencyBootstrap?.captureInitialPreference?.();
      const isLocalPreview =
        !window.GiftechLiquidStateBridge && ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

      if (isLocalPreview) {
        const localizationUrl = new URL(modal.dataset.cleanLocalizationUrl);
        const requestedReturnTo =
          returnToInput instanceof HTMLInputElement && /^\/(?!\/)/.test(returnToInput.value)
            ? returnToInput.value
            : `${window.location.pathname}${window.location.search}`;
        const returnToUrl = new URL(requestedReturnTo, window.location.origin);
        const previewThemeId = String(window.Shopify?.theme?.id || '');

        if (localizationUrl.protocol === 'https:') {
          form.action = localizationUrl.href;
        }

        if (returnToInput instanceof HTMLInputElement) {
          if (/^\d+$/.test(previewThemeId)) {
            returnToUrl.searchParams.set('preview_theme_id', previewThemeId);
          }

          returnToInput.value = `${returnToUrl.pathname}${returnToUrl.search}`;
        }
      }

      HTMLFormElement.prototype.submit.call(form);
    };

    const countryFlag = (countryCode) => {
      const normalizedCode = String(countryCode || '').toUpperCase();
      if (!/^[A-Z]{2}$/.test(normalizedCode)) return normalizedCode;

      return [...normalizedCode].map((character) => String.fromCodePoint(127397 + character.charCodeAt(0))).join('');
    };

    const countryFlagUrl = (countryCode) => {
      const normalizedCode = String(countryCode || '').toLowerCase();
      const template = modal.dataset.cleanCountryFlagUrlTemplate || '';

      return /^[a-z]{2}$/.test(normalizedCode) ? template.replace('__country_code__', normalizedCode) : '';
    };

    const renderCountryFlag = (flag, countryCode) => {
      const normalizedCode = String(countryCode || '').toUpperCase();
      const image = flag.querySelector('img');
      const flagUrl = countryFlagUrl(normalizedCode);

      flag.dataset.countryCode = normalizedCode;
      if (image && flagUrl) {
        image.src = flagUrl;
        return;
      }

      flag.textContent = countryFlag(normalizedCode);
    };

    const syncCountryFlags = (root = document) => {
      root.querySelectorAll('[data-clean-country-flag]').forEach((flag) => {
        renderCountryFlag(flag, flag.dataset.countryCode);
      });
    };

    const readSavedPincode = () => {
      try {
        const savedPincode = normalizePincode(localStorage.getItem(storageKey));
        return isCompletePincode(savedPincode) ? savedPincode : '';
      } catch (error) {
        return '';
      }
    };

    const writeSavedPincode = (pincode) => {
      try {
        if (pincode) {
          const previousPincode = normalizePincode(localStorage.getItem(storageKey));
          localStorage.setItem(storageKey, pincode);
          if (previousPincode !== pincode) localStorage.removeItem(districtStorageKey);
        } else {
          localStorage.removeItem(storageKey);
          localStorage.removeItem(districtStorageKey);
        }
      } catch (error) {}
    };

    const readSavedDistrict = () => {
      try {
        return String(localStorage.getItem(districtStorageKey) || '').trim();
      } catch (error) {
        return '';
      }
    };

    const writeSavedDistrict = (district) => {
      try {
        if (district) {
          localStorage.setItem(districtStorageKey, district);
        } else {
          localStorage.removeItem(districtStorageKey);
        }
      } catch (error) {}
    };

    const titleCaseDistrict = (value) =>
      String(value || '')
        .toLowerCase()
        .replace(/\b\w/g, (character) => character.toUpperCase())
        .replace(/\s+/g, ' ')
        .trim();

    const resolveDistrictForPincode = async (pincode) => {
      if (!isCompletePincode(pincode)) return '';
      if (districtRequests.has(pincode)) return districtRequests.get(pincode);

      const controller = new AbortController();
      const timeoutId = window.setTimeout(() => controller.abort(), 5_000);
      const request = fetch(`https://api.postalpincode.in/pincode/${pincode}`, {
        signal: controller.signal,
      })
        .then(async (response) => {
          if (!response.ok) return '';

          const payload = await response.json();
          const entry = Array.isArray(payload) ? payload[0] : payload;
          if (!entry || entry.Status !== 'Success' || !Array.isArray(entry.PostOffice) || !entry.PostOffice.length) {
            return '';
          }

          const office =
            entry.PostOffice.find((item) => String(item.DeliveryStatus || '').toLowerCase() === 'delivery') ||
            entry.PostOffice[0];

          return titleCaseDistrict(office.District || office.Block || office.Division || office.Name || '');
        })
        .catch(() => '')
        .finally(() => {
          window.clearTimeout(timeoutId);
          districtRequests.delete(pincode);
        });

      districtRequests.set(pincode, request);
      return request;
    };

    const ensureDistrictForPincode = async (pincode) => {
      if (!isCompletePincode(pincode)) {
        writeSavedDistrict('');
        return '';
      }

      const cachedDistrict = readSavedDistrict();
      if (cachedDistrict) return cachedDistrict;

      const district = await resolveDistrictForPincode(pincode);
      if (district && readSavedPincode() === pincode) {
        writeSavedDistrict(district);
        syncTriggers(pincode, district);
      }
      return district;
    };

    const syncTriggers = (pincode = readSavedPincode(), district = readSavedDistrict()) => {
      const isIndia = currentCountryCode === 'IN';
      const indiaDeliveryValue = [isIndia ? district : '', isIndia ? pincode : ''].filter(Boolean).join(' - ');

      document.querySelectorAll('[data-clean-pincode-trigger]').forEach((trigger) => {
        const label = trigger.querySelector('[data-clean-pincode-trigger-label]');
        if (!label) return;

        const showsCountryOnly = trigger.dataset.cleanPincodeCountryOnly === 'true';
        const showsCountryCodeOnly = trigger.dataset.cleanPincodeCodeOnly === 'true';
        const deliveryValue = showsCountryCodeOnly
          ? currentCountryCode
          : showsCountryOnly
            ? isIndia && pincode
              ? `${currentCountryName} — ${indiaDeliveryValue}`
              : currentCountryName
            : isIndia
              ? indiaDeliveryValue
              : currentCountryName;
        const hasDeliveryLocation = showsCountryCodeOnly || showsCountryOnly || !isIndia || Boolean(pincode);
        const flag = trigger.querySelector('[data-clean-country-flag]');
        const defaultLabel = label.dataset.defaultLabel || 'Where to deliver?';
        const prompt = label.querySelector('[data-clean-pincode-trigger-prompt]');
        const saved = label.querySelector('[data-clean-pincode-trigger-saved]');
        const value = label.querySelector('[data-clean-pincode-trigger-value]');

        if (flag) {
          renderCountryFlag(flag, currentCountryCode);
        }

        if (prompt && saved && value) {
          prompt.textContent = defaultLabel;
          prompt.hidden = hasDeliveryLocation;
          saved.hidden = !hasDeliveryLocation;
          value.textContent = deliveryValue;
        } else {
          label.textContent = deliveryValue || defaultLabel;
        }
        trigger.dataset.hasPincode = String(hasDeliveryLocation);
        trigger.setAttribute(
          'aria-label',
          showsCountryCodeOnly
            ? `Delivery country ${currentCountryName}. Change delivery country.`
            : hasDeliveryLocation
              ? `Delivery location ${deliveryValue}. Change delivery location.`
              : 'Choose delivery location',
        );

        if (isIndia && trigger.dataset.cleanPincodePrefetchReady !== 'true') {
          trigger.dataset.cleanPincodePrefetchReady = 'true';
          trigger.addEventListener('pointerenter', () => loadIndex().catch(() => {}), { once: true, passive: true });
          trigger.addEventListener('focus', () => loadIndex().catch(() => {}), {
            once: true,
          });
        }
      });
    };

    const setStatus = (message = '', type = '') => {
      status.textContent = message;
      status.classList.toggle('clean-pincode-modal__status--error', type === 'error');
      status.classList.toggle('clean-pincode-modal__status--success', type === 'success');
    };

    const closeCountryPicker = ({ restoreFocus = false } = {}) => {
      modal.dataset.cleanCountryPickerOpen = 'false';
      countryPicker.hidden = true;
      countryToggle.setAttribute('aria-expanded', 'false');
      countrySummaryToggle.setAttribute('aria-expanded', 'false');
      countrySearch.value = '';
      countryOptions.forEach((option) => {
        option.hidden = false;
      });
      countryGroupLabels.forEach((label) => {
        label.hidden = false;
      });
      countryEmpty.hidden = true;
      if (restoreFocus) countryPickerOpener?.focus();
    };

    const setCountryPickerOpen = (open) => {
      if (!open) {
        closeCountryPicker();
        return;
      }

      countryPicker.hidden = false;
      modal.dataset.cleanCountryPickerOpen = 'true';
      countryToggle.setAttribute('aria-expanded', 'true');
      countrySummaryToggle.setAttribute('aria-expanded', 'true');
      if (!mobileSheetMedia.matches) {
        window.requestAnimationFrame(() => countrySearch.focus());
      }
    };

    const getCountryCollectionReturnTo = (countryCode) => {
      const collectionHandle = countryCollectionHandles[countryCode];
      const collectionsUrl = String(modal.dataset.cleanCollectionsUrl || '').replace(/\/+$/, '');
      const collectionUrl = collectionHandle && collectionsUrl ? `${collectionsUrl}/${collectionHandle}` : '';

      return /^\/(?!\/)/.test(collectionUrl) ? collectionUrl : '';
    };

    const selectCountry = (countryCode, countryName, { closePicker = true, prefetchIndex = true } = {}) => {
      selectedCountryCode = countryCode;
      selectedCountryName = countryName;
      countryCodeInput.value = countryCode;
      selectedCountryCodeElement.textContent = countryCode;
      selectedCountryNameElement.textContent = countryName;
      countrySummaryName.textContent = countryName;
      locationField.dataset.cleanInternational = String(countryCode !== 'IN');
      locationDivider.hidden = countryCode !== 'IN';
      locationField.hidden = countryCode !== 'IN';

      if (returnToInput instanceof HTMLInputElement) {
        returnToInput.value = currentPageIsProduct
          ? defaultLocalizationReturnTo
          : getCountryCollectionReturnTo(countryCode) || defaultLocalizationReturnTo;
      }

      const selectedFlag = countryToggle.querySelector('[data-clean-country-flag]');
      renderCountryFlag(selectedFlag, countryCode);
      renderCountryFlag(countrySummaryFlag, countryCode);

      countryOptions.forEach((option) => {
        option.setAttribute('aria-selected', String(option.dataset.countryCode === countryCode));
      });

      if (countryCode === 'IN') {
        input.value = readSavedPincode();
        if (prefetchIndex) {
          loadIndex().catch(() => {
            setStatus('Pincode validation is temporarily unavailable. Please try again.', 'error');
          });
        }
      } else {
        setStatus();
      }

      if (closePicker) closeCountryPicker();
      updateControls();
    };

    const updateControls = () => {
      const pincode = normalizePincode(input.value);
      if (input.value !== pincode) input.value = pincode;

      const isIndia = selectedCountryCode === 'IN';
      input.disabled = busy || !isIndia;
      clearButton.hidden = !isIndia || !pincode;
      removeButton.hidden = !isIndia || !readSavedPincode();
      applyButton.disabled = busy || (isIndia && Boolean(pincode) && !isCompletePincode(pincode));
    };

    const setBusy = (nextBusy) => {
      busy = nextBusy;
      clearButton.disabled = busy;
      removeButton.disabled = busy;
      countryToggle.disabled = busy;
      countrySearch.disabled = busy;
      countryOptions.forEach((option) => {
        option.disabled = busy;
      });
      applyButton.textContent =
        busy && selectedCountryCode !== 'IN'
          ? selectedCountryCode === currentCountryCode
            ? currentPageIsProduct
              ? 'Refreshing...'
              : 'Opening gifts...'
            : 'Updating prices...'
          : busy && !normalizePincode(input.value)
            ? 'Applying...'
            : busy
              ? 'Checking...'
              : defaultApplyLabel;
      updateControls();
    };

    const consumeIndex = () => {
      const payload = window.CleanPincodeIndex;

      if (!payload || payload.version !== 1 || payload.bitCount !== 1_000_000 || typeof payload.data !== 'string') {
        throw new Error('The pincode index payload is invalid.');
      }

      bitset = window.atob(payload.data);
      if (bitset.length * 8 !== payload.bitCount) {
        bitset = '';
        throw new Error('The pincode index size is invalid.');
      }

      window.CleanPincodeIndex = undefined;
      return bitset;
    };

    const loadIndex = () => {
      if (bitset) return Promise.resolve(bitset);
      if (indexRequest) return indexRequest;

      if (window.CleanPincodeIndex) {
        try {
          return Promise.resolve(consumeIndex());
        } catch (error) {
          window.CleanPincodeIndex = undefined;
        }
      }

      indexRequest = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = modal.dataset.cleanPincodeIndexUrl;
        script.async = true;
        script.dataset.cleanPincodeIndexLoader = 'true';
        script.addEventListener(
          'load',
          () => {
            try {
              resolve(consumeIndex());
            } catch (error) {
              reject(error);
            }
          },
          { once: true },
        );
        script.addEventListener('error', () => reject(new Error('The pincode index could not be loaded.')), {
          once: true,
        });
        document.head.append(script);
      }).catch((error) => {
        indexRequest = undefined;
        document.querySelector('[data-clean-pincode-index-loader]')?.remove();
        throw error;
      });

      return indexRequest;
    };

    const isKnownPincode = (pincode) => {
      if (!bitset || !isCompletePincode(pincode)) return false;

      const numericPincode = Number(pincode);
      const byte = bitset.charCodeAt(numericPincode >> 3);
      return Boolean(byte & (1 << (numericPincode & 7)));
    };

    window.CleanPincodeLookup = Object.freeze({
      isKnown: async (value) => {
        const pincode = normalizePincode(value);
        if (!isCompletePincode(pincode)) return false;

        await loadIndex();
        return isKnownPincode(pincode);
      },
    });
    document.dispatchEvent(new CustomEvent('clean:pincode:lookup-ready'));

    const flushSavedPincode = async () => {
      try {
        await window.GiftechLiquidStateBridge?.flushPreference?.();
        return true;
      } catch (error) {
        setBusy(false);
        setStatus('Delivery preference could not be synchronized. Please try again.', 'error');
        return false;
      }
    };

    const dispatchSavedPincode = (pincode) => {
      document.dispatchEvent(
        new CustomEvent('clean:pincode:saved', {
          detail: { pincode, country: selectedCountryCode, source: 'header' },
        }),
      );
      document.querySelectorAll('[data-clean-zipcode-validator]').forEach((validator) => {
        validator.dispatchEvent(
          new CustomEvent('clean:pincode:apply', {
            detail: { pincode, country: selectedCountryCode, source: 'header' },
          }),
        );
      });
    };

    const closeModal = () => {
      window.clearTimeout(closeTimer);
      closeCountryPicker();

      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
        document.body.classList.remove('clean-pincode-modal-open');
        opener?.focus();
      }
    };

    const isVisibleTrigger = (trigger) => {
      if (!(trigger instanceof HTMLElement)) return false;

      const bounds = trigger.getBoundingClientRect();
      const styles = window.getComputedStyle(trigger);
      return bounds.width > 0 && bounds.height > 0 && styles.display !== 'none' && styles.visibility !== 'hidden';
    };

    const resolvePopoverAnchor = (preferredTrigger) => {
      if (isVisibleTrigger(preferredTrigger) && preferredTrigger.closest('[data-clean-header]')) {
        return preferredTrigger;
      }

      const headerSelectors = [
        '.clean-header__desktop.is-sticky .clean-header__desktop-sticky [data-clean-pincode-trigger]',
        '.clean-header__desktop:not(.is-sticky) .clean-header__desktop-full [data-clean-pincode-trigger]',
        '.clean-header__mobile.is-sticky [data-clean-pincode-trigger]',
        '.clean-header__mobile:not(.is-sticky) [data-clean-pincode-trigger]',
      ];

      for (const selector of headerSelectors) {
        const trigger = document.querySelector(selector);
        if (isVisibleTrigger(trigger)) return trigger;
      }

      return isVisibleTrigger(preferredTrigger) ? preferredTrigger : undefined;
    };

    const clearPopoverPosition = () => {
      modal.style.removeProperty('--clean-pincode-popover-top');
      modal.style.removeProperty('--clean-pincode-popover-left');
      modal.style.removeProperty('--clean-pincode-popover-arrow-left');
    };

    const positionPopover = () => {
      if (!modal.open || mobileSheetMedia.matches) return;

      anchorTrigger = resolvePopoverAnchor(anchorTrigger || opener);
      if (!anchorTrigger) {
        clearPopoverPosition();
        return;
      }

      const bounds = anchorTrigger.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth;
      const panelWidth = Math.min(360, viewportWidth - 24);
      const margin = 12;
      const anchorCenter = bounds.left + bounds.width / 2;
      const panelLeft = Math.min(Math.max(anchorCenter - 24, margin), viewportWidth - panelWidth - margin);
      const arrowLeft = Math.min(Math.max(anchorCenter - panelLeft - 7, 14), panelWidth - 28);

      modal.style.setProperty('--clean-pincode-popover-top', `${Math.round(bounds.bottom + 10)}px`);
      modal.style.setProperty('--clean-pincode-popover-left', `${Math.round(panelLeft)}px`);
      modal.style.setProperty('--clean-pincode-popover-arrow-left', `${Math.round(arrowLeft)}px`);
    };

    const openModal = (trigger, { prefetchIndex = true, focusInput = true } = {}) => {
      window.clearTimeout(closeTimer);
      modalOpenedThisPage = true;
      opener = trigger;
      anchorTrigger = resolvePopoverAnchor(trigger);
      input.value = readSavedPincode();
      setStatus();
      selectCountry(currentCountryCode, currentCountryName, { prefetchIndex });
      setBusy(false);

      if (typeof modal.showModal === 'function') {
        if (!modal.open) modal.showModal();
      } else {
        modal.setAttribute('open', '');
        modal.setAttribute('aria-modal', 'true');
      }

      positionPopover();
      document.body.classList.add('clean-pincode-modal-open');
      if (trigger?.dataset.cleanPincodeOpenCountryPicker === 'true') {
        setCountryPickerOpen(true);
      } else if (focusInput && !mobileSheetMedia.matches) {
        window.requestAnimationFrame(() => {
          if (selectedCountryCode === 'IN') {
            input.focus();
            input.select();
          } else {
            countrySummaryToggle.focus();
          }
        });
      }
    };

    const tryAutoOpen = () => {
      if (currentCountryCode !== 'IN' || modalOpenedThisPage || readSavedPincode() || modal.open) return;

      if (document.hidden) {
        document.addEventListener('visibilitychange', tryAutoOpen, { once: true });
        return;
      }

      const activeElement = document.activeElement;
      const visitorIsEditing = activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      const anotherDialogIsOpen = document.querySelector('dialog[open]:not([data-clean-pincode-modal])');
      const currencySelectorIsOpen = document.querySelector('[data-clean-display-currency-open="true"]');

      if (currencySelectorIsOpen) {
        window.setTimeout(tryAutoOpen, autoOpenRetryMs);
        return;
      }

      if ((visitorIsEditing || anotherDialogIsOpen) && autoOpenAttempts < autoOpenMaxAttempts) {
        autoOpenAttempts += 1;
        window.setTimeout(tryAutoOpen, autoOpenRetryMs);
        return;
      }

      if (visitorIsEditing || anotherDialogIsOpen) return;

      openModal(undefined, { prefetchIndex: false, focusInput: false });
    };

    const scheduleAutoOpen = () => {
      if (
        currentCountryCode !== 'IN' ||
        modal.dataset.cleanPincodeAutoOpen !== 'true' ||
        modalOpenedThisPage ||
        readSavedPincode()
      ) {
        return;
      }

      window.setTimeout(() => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(tryAutoOpen, { timeout: 2_000 });
        } else {
          tryAutoOpen();
        }
      }, autoOpenDelayMs);
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-clean-pincode-trigger]');
      if (trigger) {
        openModal(trigger);
        return;
      }

      if (event.target.closest('[data-clean-pincode-close]')) {
        closeModal();
        return;
      }

      const countryOption = event.target.closest('[data-clean-country-option]');
      if (countryOption) {
        selectCountry(countryOption.dataset.countryCode, countryOption.dataset.countryName);
      }
    });

    countryToggle.addEventListener('click', () => {
      countryPickerOpener = countryToggle;
      setCountryPickerOpen(countryPicker.hidden);
    });

    countrySummaryToggle.addEventListener('click', () => {
      countryPickerOpener = countrySummaryToggle;
      setCountryPickerOpen(countryPicker.hidden);
    });

    countrySearch.addEventListener('input', () => {
      const query = countrySearch.value.trim().toLocaleLowerCase();
      let visibleOptions = 0;

      countryOptions.forEach((option) => {
        const searchableValue = `${option.dataset.countryName} ${option.dataset.countryCode}`.toLocaleLowerCase();
        option.hidden = Boolean(query) && !searchableValue.includes(query);
        if (!option.hidden) visibleOptions += 1;
      });

      countryGroupLabels.forEach((label) => {
        label.hidden = Boolean(query);
      });
      countryEmpty.hidden = visibleOptions !== 0;
    });

    input.addEventListener('input', () => {
      input.value = normalizePincode(input.value);
      setStatus();
      updateControls();
    });

    clearButton.addEventListener('click', () => {
      input.value = '';
      setStatus();
      updateControls();
      if (!mobileSheetMedia.matches) input.focus();
    });

    removeButton.addEventListener('click', async () => {
      writeSavedPincode('');
      input.value = '';
      syncTriggers('');
      dispatchSavedPincode('');
      if (!(await flushSavedPincode())) return;
      setStatus('Saved pincode removed.', 'success');
      updateControls();
      if (!mobileSheetMedia.matches) input.focus();
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (selectedCountryCode !== 'IN') {
        writeSavedPincode('');
        dispatchSavedPincode('');
        if (!(await flushSavedPincode())) return;

        if (selectedCountryCode === currentCountryCode) {
          if (getCountryCollectionReturnTo(selectedCountryCode)) {
            setBusy(true);
            setStatus(
              currentPageIsProduct
                ? `Refreshing delivery options for ${selectedCountryName}...`
                : `Opening gifts for delivery to ${selectedCountryName}...`,
            );
            await submitLocalizationForm();
            return;
          }

          syncTriggers('');
          setStatus(`Delivery country set to ${selectedCountryName}.`, 'success');
          closeTimer = window.setTimeout(closeModal, 300);
          return;
        }

        setBusy(true);
        setStatus(`Updating prices for delivery to ${selectedCountryName}...`);
        await submitLocalizationForm();
        return;
      }

      const pincode = normalizePincode(input.value);

      if (!pincode) {
        writeSavedPincode('');
        dispatchSavedPincode('');
        if (!(await flushSavedPincode())) return;

        if (selectedCountryCode !== currentCountryCode) {
          setBusy(true);
          setStatus('Updating delivery country to India...');
          await submitLocalizationForm();
          return;
        }

        syncTriggers('');
        setStatus('Delivery country set to India.', 'success');
        closeTimer = window.setTimeout(closeModal, 300);
        return;
      }

      if (!isCompletePincode(pincode)) {
        setStatus('Enter a six-digit Indian pincode.', 'error');
        updateControls();
        if (!mobileSheetMedia.matches) input.focus();
        return;
      }

      setBusy(true);
      setStatus('Checking pincode...');

      try {
        await loadIndex();

        if (!isKnownPincode(pincode)) {
          setStatus('Enter a valid Indian pincode.', 'error');
          return;
        }

        writeSavedPincode(pincode);
        dispatchSavedPincode(pincode);
        if (!(await flushSavedPincode())) return;
        syncTriggers(pincode);
        if (currentCountryCode === 'IN') {
          void ensureDistrictForPincode(pincode);
        }

        if (selectedCountryCode !== currentCountryCode) {
          setStatus('Updating prices for delivery within India...');
          await submitLocalizationForm();
          return;
        }

        setStatus(`Delivery location set to ${pincode}.`, 'success');
        closeTimer = window.setTimeout(closeModal, 450);
      } catch (error) {
        setStatus('Pincode validation is temporarily unavailable. Please try again.', 'error');
      } finally {
        setBusy(false);
      }
    });

    modal.addEventListener(
      'pointerdown',
      (event) => {
        const path = event.composedPath();
        pointerStartedInsidePanel = path.includes(panel);
        pointerStartedInsideCountryPicker = path.includes(countryPicker);
      },
      true,
    );

    modal.addEventListener('pointercancel', () => {
      pointerStartedInsidePanel = false;
      pointerStartedInsideCountryPicker = false;
    });

    modal.addEventListener('click', (event) => {
      const path = event.composedPath();
      const startedInsidePanel = pointerStartedInsidePanel;
      const startedInsideCountryPicker = pointerStartedInsideCountryPicker;
      pointerStartedInsidePanel = false;
      pointerStartedInsideCountryPicker = false;

      if (
        !countryPicker.hidden &&
        !startedInsideCountryPicker &&
        !path.includes(countryPicker) &&
        !path.includes(countryToggle) &&
        !path.includes(countrySummaryToggle)
      ) {
        closeCountryPicker();
      }

      if (event.target === modal && !startedInsidePanel && !path.includes(panel)) closeModal();
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !countryPicker.hidden) {
        event.preventDefault();
        event.stopPropagation();
        closeCountryPicker({ restoreFocus: true });
      }
    });

    modal.addEventListener('cancel', (event) => {
      if (countryPicker.hidden) return;

      event.preventDefault();
      closeCountryPicker({ restoreFocus: true });
    });

    modal.addEventListener('close', () => {
      document.body.classList.remove('clean-pincode-modal-open');
      clearPopoverPosition();
      setStatus();
      opener?.focus();
    });

    document.addEventListener('clean:header:rendered', () => {
      syncCountryFlags();
      syncTriggers();
      anchorTrigger = resolvePopoverAnchor(opener);
      positionPopover();
    });
    document.addEventListener('clean:zipcode:change', () => syncTriggers());
    window.addEventListener('pageshow', () => syncTriggers());
    window.addEventListener('resize', () => {
      anchorTrigger = resolvePopoverAnchor(opener);
      positionPopover();
    });
    window.addEventListener(
      'scroll',
      () => {
        if (!modal.open || mobileSheetMedia.matches) return;
        anchorTrigger = resolvePopoverAnchor(opener);
        positionPopover();
      },
      { passive: true },
    );
    mobileSheetMedia.addEventListener('change', () => {
      if (!mobileSheetMedia.matches) {
        anchorTrigger = resolvePopoverAnchor(opener);
        positionPopover();
      }
    });
    window.addEventListener('storage', (event) => {
      if (event.key === storageKey || event.key === districtStorageKey) syncTriggers();
    });

    syncCountryFlags();
    const initialPincode = readSavedPincode();
    syncTriggers(initialPincode);
    if (currentCountryCode === 'IN' && initialPincode && !readSavedDistrict()) {
      void ensureDistrictForPincode(initialPincode);
    }
    if (document.readyState === 'complete') {
      scheduleAutoOpen();
    } else {
      window.addEventListener('load', scheduleAutoOpen, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-product-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanWishlistStorageKey = 'wishlistItem';

    const getCleanWishlistItems = () => {
      try {
        const items = JSON.parse(localStorage.getItem(cleanWishlistStorageKey) || '[]');
        return Array.isArray(items) ? items.filter((item) => typeof item === 'string' && item.trim()) : [];
      } catch (error) {
        return [];
      }
    };

    const setCleanWishlistItems = (items) => {
      const cleanItems = Array.from(new Set(items.filter((item) => typeof item === 'string' && item.trim())));

      try {
        localStorage.setItem(cleanWishlistStorageKey, JSON.stringify(cleanItems));
        return getCleanWishlistItems();
      } catch (error) {
        console.error(error);
        return getCleanWishlistItems();
      }
    };

    const updateCleanWishlistCount = (items) => {
      document.querySelectorAll('[data-wishlist-count]').forEach((count) => {
        count.textContent = String(items.length);
      });
    };

    const updateCleanWishlistButton = (button, isActive) => {
      button.setAttribute('aria-pressed', String(isActive));
      button.setAttribute('aria-label', isActive ? 'Remove from wishlist' : 'Add to wishlist');
    };

    const updateCleanWishlistButtonsByHandle = (handle, isActive, root = document) => {
      root.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
        if (button.dataset.cleanProductWishlistHandle?.trim() === handle) {
          updateCleanWishlistButton(button, isActive);
        }
      });
    };

    const initCleanProductCardWishlists = (root = document) => {
      root.querySelectorAll('[data-clean-product-wishlist]').forEach((button) => {
        if (button.dataset.cleanProductWishlistReady === 'true') return;

        button.dataset.cleanProductWishlistReady = 'true';

        const handle = button.dataset.cleanProductWishlistHandle?.trim();

        if (!handle || typeof Storage === 'undefined') {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          return;
        }

        updateCleanWishlistButton(button, getCleanWishlistItems().includes(handle));

        button.addEventListener('click', () => {
          const wishlistItems = getCleanWishlistItems();
          const isActive = wishlistItems.includes(handle);
          const nextWishlistItems = isActive
            ? wishlistItems.filter((item) => item !== handle)
            : wishlistItems.concat(handle);
          const confirmedWishlistItems = setCleanWishlistItems(nextWishlistItems);
          const isConfirmedActive = confirmedWishlistItems.includes(handle);

          updateCleanWishlistButtonsByHandle(handle, isConfirmedActive);
          updateCleanWishlistCount(confirmedWishlistItems);

          document.dispatchEvent(
            new CustomEvent(isConfirmedActive ? 'addwishlistitem' : 'updatewishlistmail', {
              detail: { handle },
              bubbles: true,
            }),
          );
        });
      });

      updateCleanWishlistCount(getCleanWishlistItems());
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCleanProductCardWishlists(), { once: true });
    } else {
      initCleanProductCardWishlists();
    }

    document.addEventListener('shopify:section:load', (event) => initCleanProductCardWishlists(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-seo-content"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-clean-seo-content]').forEach((section) => {
    if (section.dataset.cleanSeoContentReady === 'true') return;

    const toggle = section.querySelector('.clean-seo-content__toggle');
    const expandedContent = section.querySelector('.clean-seo-content__expanded');
    const ellipsis = section.querySelector('.clean-seo-content__ellipsis');

    if (!toggle || !expandedContent) return;

    section.dataset.cleanSeoContentReady = 'true';
    toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      toggle.textContent = isExpanded ? 'Read more' : 'Read less';
      expandedContent.hidden = isExpanded;
      if (ellipsis) ellipsis.hidden = !isExpanded;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const desktopQuery = window.matchMedia('(min-width: 768px)');

    const setupTestimonials = (carousel) => {
      if (carousel.dataset.cleanTestimonialsInitialized === 'true') return;

      const track = carousel.querySelector('[data-clean-testimonials-track]');
      const previousButton = carousel.querySelector('[data-clean-testimonials-prev]');
      const nextButton = carousel.querySelector('[data-clean-testimonials-next]');

      if (!track || !previousButton || !nextButton) return;

      carousel.dataset.cleanTestimonialsInitialized = 'true';

      const getStep = () => {
        const card = track.querySelector('.clean-testimonials__card');
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;

        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      };

      const updateReadMore = () => {
        track.querySelectorAll('.clean-testimonials__card').forEach((card) => {
          const quote = card.querySelector('.clean-testimonials__quote');
          const button = card.querySelector('[data-clean-testimonials-read-more]');

          if (!quote || !button) return;

          const wasExpanded = card.classList.contains('is-expanded');

          card.classList.remove('is-expanded');
          card.classList.remove('has-overflow');

          const quoteCrop = parseFloat(window.getComputedStyle(quote).getPropertyValue('--clean-testimonials-quote-crop')) || quote.clientHeight;
          const hasOverflow = quote.scrollHeight > quoteCrop + 1;

          card.classList.toggle('has-overflow', hasOverflow);

          if (wasExpanded && hasOverflow) {
            card.classList.add('is-expanded');
            button.setAttribute('aria-expanded', 'true');
            button.textContent = 'Show less';
          } else {
            button.setAttribute('aria-expanded', 'false');
            button.textContent = 'Read more';
          }
        });
      };

      const updateButtons = () => {
        if (!desktopQuery.matches) {
          previousButton.disabled = true;
          nextButton.disabled = true;
          return;
        }

        const maxScroll = track.scrollWidth - track.clientWidth - 1;
        previousButton.disabled = track.scrollLeft <= 1;
        nextButton.disabled = track.scrollLeft >= maxScroll;
      };

      previousButton.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextButton.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.querySelectorAll('[data-clean-testimonials-read-more]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = button.closest('.clean-testimonials__card');
          if (!card) return;

          const isExpanded = card.classList.toggle('is-expanded');

          button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
          button.textContent = isExpanded ? 'Show less' : 'Read more';
          updateButtons();
        });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', () => {
        updateReadMore();
        updateButtons();
      });

      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener('change', () => {
          updateReadMore();
          updateButtons();
        });
      } else if (desktopQuery.addListener) {
        desktopQuery.addListener(() => {
          updateReadMore();
          updateButtons();
        });
      }

      updateReadMore();
      updateButtons();
    };

    const init = (root = document) => {
      root.querySelectorAll('[data-clean-testimonials-carousel]').forEach(setupTestimonials);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clean-trending-today"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTrendingToday = (section) => {
      if (section.dataset.cleanTrendingInitialized === 'true') return;

      const track = section.querySelector('[data-clean-trending-track]');
      const dots = Array.from(section.querySelectorAll('[data-clean-trending-dot]'));
      const pageStarts = Array.from(section.querySelectorAll('.clean-trending-today__slide--page-start'));

      if (!track || !dots.length) return;

      const setActivePage = (pageIndex) => {
        const boundedPageIndex = Math.min(Math.max(pageIndex, 0), dots.length - 1);

        dots.forEach((dot, index) => {
          const isActive = index === boundedPageIndex;
          dot.classList.toggle('clean-trending-today__dot--active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const getActivePage = () => {
        if (!pageStarts.length) return 0;

        return pageStarts.reduce((closestIndex, slide, index) => {
          const closestDistance = Math.abs(pageStarts[closestIndex].offsetLeft - track.scrollLeft);
          const slideDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
          return slideDistance < closestDistance ? index : closestIndex;
        }, 0);
      };

      let scrollFrame;
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => setActivePage(getActivePage()));
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const pageIndex = Number(dot.dataset.pageIndex);
          const pageStart = pageStarts[pageIndex];
          if (!pageStart) return;

          setActivePage(pageIndex);
          track.scrollTo({
            left: pageStart.offsetLeft,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        });
      });

      section.dataset.cleanTrendingInitialized = 'true';
    };

    const initializeAllTrendingToday = (container = document) => {
      container.querySelectorAll('[data-clean-trending-today]').forEach(initializeTrendingToday);
    };

    initializeAllTrendingToday();
    document.addEventListener('shopify:section:load', (event) => initializeAllTrendingToday(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
